const messagesTR = {
    code: "tr",
    messages: {
        cache: {
            management: "Cache Yönetimi",
            createNew: "Yeni Cache Oluştur",
            keySearchPlaceholder: "Key ara (wildcard destekli: *chat*, chat*, *chat)",
            type: "Cache Tipi",
            actorType: "Aktör Tipi",
            selectAutomation: "Otomasyon Seç",
            selectChatbot: "Chatbot Seç",
            selectUser: "Kullanıcı Seç",
            clearFilters: "Filtreleri Temizle",
            deleteSelected: "Seçilileri Sil",
            extendSelected: "Seçililerin Süresini Uzat",
            makeSelectedNeverExpire: "Seçilileri Süresiz Yap",
            deleteAllActorCaches: "Bu Aktörün Tüm Cache'lerini Sil",
            emptyState: "Henüz cache bulunmuyor",
            editCache: "Cache Düzenle",
            key: "Cache Key",
            keyPlaceholder: "Örnek: user_session_123",
            value: "Cache Value",
            stringValuePlaceholder: "String değer",
            dataType: "Data Type",
            validityDuration: "Geçerlilik Süresi",
            neverExpire: "Hiçbir zaman expire olmasın",
            specifyDuration: "Süre belirt",
            specifyDate: "Tarih belirt",
            minutes: "Dakika",
            hours: "Saat",
            days: "Gün",
            update: "Güncelle",
            create: "Oluştur",
            bulkExtend: "Toplu Süre Uzatma",
            bulkExtendInfo: "{count} cache'in geçerlilik süresi uzatılacak.",
            newValidityDuration: "Yeni Geçerlilik Süresi",
            extend: "Uzat",
            keyLabel: "Anahtar",
            valueLabel: "Değer",
            typeLabel: "Tip",
            createdBy: "Oluşturan",
            createdAt: "Oluşturulma Tarihi",
            updatedBy: "Güncelleyen",
            expiresAt: "Sona Erme Tarihi",
            actions: "İşlemler",
            edit: "Düzenle",
            extendDuration: "Süre Uzat",
            makeNeverExpire: "Süresiz Yap",
            loadError: "Cache listesi yüklenemedi",
            updateSuccess: "Cache güncellendi",
            createSuccess: "Cache oluşturuldu",
            saveError: "Cache kaydedilemedi",
            deleteCache: "Cache Sil",
            confirmDelete: "Evet, Sil",
            deleteSuccess: "Cache silindi",
            extendSuccess24h: "Cache süresi 24 saat uzatıldı",
            extendError: "Cache süresi uzatılamadı",
            deleteActorCaches: "Aktör Cache'lerini Sil",
            deleteActorCachesConfirm:
                '"{actor}" aktörünün tüm cache\'lerini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
            confirmDeleteAll: "Evet, Tümünü Sil",
            countDeleted: "{count} cache silindi",
            bulkDelete: "Toplu Silme",
            bulkDeleteConfirm: "{count} cache silinecek. Emin misiniz?",
            bulkMakeNeverExpire: "Toplu Süresiz Yapma",
            bulkMakeNeverExpireConfirm: "{count} cache'in süresi kaldırılacak. Emin misiniz?",
            makeNeverExpireSuccess: "Cache süresiz yapıldı",
            makeNeverExpireError: "Cache süresiz yapılamadı",
            bulkExtendError: "Cache süreleri uzatılamadı",
            bulkExtendSuccess: "{count} cache süresi uzatıldı",
            bulkMakeNeverExpireSuccess: "{count} cache süresiz yapıldı",
            deleteCacheConfirm: '"{key}" cache\'ini silmek istediğinizden emin misiniz?',
            selectedCount: "{count} cache seçildi",
            valueTitle: "Cache Değeri: {key}",
            never: "Asla",
            automation: "Otomasyon",
            chatbot: "Chatbot",
            user: "Kullanıcı",
            api: "API",
            all: "Tümü",
            public: "Public",
            private: "Private",
        },
        common: {
            cancel: "İptal",
            save: "Kaydet",
            yes: "Evet",
            no: "Hayır",
            create: "Oluştur",
            delete: "Sil",
            edit: "Düzenle",
            add: "Ekle",
            back: "Geri",
            active: "Aktif",
            inactive: "Pasif",
        },
        zoho: {
            SETTING_GROUP: "Ayarlar",
            usermapping: "Kullanıcı Eşleme",
        },
        youtubeChannel: {
            youtubeIntegration: "YouTube Entegrasyonu",
            deleteYoutubeChannelInfo: "Bu YouTube kanalını silmek istediğinize emin misiniz?",
            youtubeChannels: "YouTube Kanalları",
            title: "YouTube Comments",
            channelName: "Kanal Adı",
            channelDetail: "Kanal Detayı",
            channelDetailDesc: "YouTube kanalınızı yönetin",
            youtubeChannel: "YouTube Kanalı",
            status: "Durum",
            active: "Aktif",
            inactive: "Pasif",
            detail: "Detay",
            visibility: "Görünürlük",
            videos: "Videolar",
            comments: "Yorumlar",
            visibilitySettings: "Görünürlük Ayarları",
            visibilityDescription: "Bu kanalı hangi kullanıcı ve departmanların görebileceğini ayarlayın",
            users: "Kullanıcılar",
            departments: "Departmanlar",
            owners: "Sahipler",
            selectUsers: "Kullanıcı seçin",
            selectDepartments: "Departman seçin",
            selectOwners: "Sahip seçin",
            deleteChannel: "Kanalı Sil",
            deleteChannelDescription: "Bu YouTube kanalını silmek istediğinize emin misiniz?",
            channelUpdatedSuccess: "Kanal başarıyla güncellendi",
            failedUpdateChannel: "Kanal güncellenirken hata oluştu",
            connectedSuccess: "YouTube hesabı başarıyla bağlandı",
            failedToCreateChannel: "Kanal oluşturulurken hata oluştu",
            requiredChannel: "Kanal adı gerekli",
            oauthTimeout: "Yetkilendirme zaman aşımına uğradı",
            all: "Tümü",
            new: "Yeni",
            replied: "Yanıtlandı",
            resolved: "Çözüldü",
            searchComments: "Yorumlarda ara",
            noCommentsFound: "Yorum bulunamadı",
            replies: "yanıt",
            like: "Beğen",
            reply: "Yanıtla",
            replyToComment: "Yoruma Yanıt Ver",
            writeYourReply: "Yanıtınızı yazın",
            pleaseEnterReply: "Lütfen bir yanıt girin",
            replySuccess: "Yanıt başarıyla gönderildi",
            errorSendingReply: "Yanıt gönderilirken hata oluştu",
            statusUpdated: "Durum güncellendi",
            errorUpdatingStatus: "Durum güncellenirken hata oluştu",
            errorFetchingComments: "Yorumlar getirilirken hata oluştu",
            commentLiked: "Yorum beğenildi",
            errorLikingComment: "Yorum beğenilirken hata oluştu",
            noVideosFound: "Video bulunamadı",
            errorFetchingVideos: "Videolar getirilirken hata oluştu",
            refresh: "Yenile",
            loadMore: "Daha Fazla Yükle",
            ensureYouTubeAccount: "Bir Google/YouTube hesabınız olduğundan emin olun",
            ensureYouTubeChannel: "YouTube kanalınız olduğundan emin olun",
            permissionDesc: "Supsis'in YouTube yorumlarınıza erişmesine izin vermeniz gerekmektedir.",
            connectToYouTube: "YouTube'a Bağlan",
            views: "görüntüleme",
            likes: "beğeni",
            sync: "Senkronize Et",
            commentsSynced: "Yorumlar senkronize edildi",
            errorSyncingComments: "Yorumlar senkronize edilirken hata oluştu",
            pending: "Beklemede",
            rejected: "Reddedildi",
            moderation: "Moderasyon",
            publish: "Yayınla",
            holdForReview: "İncelemeye Al",
            reject: "Reddet",
            rejectAndBan: "Reddet ve Yasakla",
            moderationSuccess: "Moderasyon işlemi başarılı",
            errorModeration: "Moderasyon işlemi başarısız",
            videoDetail: "Video Detayı",
            duration: "Süre",
            showMore: "Daha fazla göster",
            showLess: "Daha az göster",
            loadingVideo: "Video yükleniyor...",
            videoNotFound: "Video bulunamadı",
            goBack: "Geri Dön",
            errorLoadingVideo: "Video yüklenirken hata oluştu",
            videosSynced: "Videolar senkronize edildi",
            errorSyncingVideos: "Videolar senkronize edilirken hata oluştu",
            selectVideo: "Video seçin",
            allVideos: "Tüm Videolar",
            selectCommentToPreview: "Önizleme için bir yorum seçin",
            viewDetails: "Detayları Gör",
            published: "Yayında",
            heldForReview: "İncelemede",
        },
        googleBusiness: {
            title: "Google Business Reviews",
            channels: "Google Business Kanalları",
            channelName: "Kanal Adı",
            channelDetails: "Kanal Detayları",
            connectToGoogleBusiness: "Google Business'a Bağlan",
            ensureGoogleAccount: "Bir Google hesabınız olduğundan emin olun",
            ensureBusinessProfile: "Google Business Profile hesabınız olduğundan emin olun",
            permissionDesc: "Supsis'in Google Business yorumlarınıza erişmesine izin vermeniz gerekmektedir.",
            requiredChannel: "Kanal adı gerekli",
            failedToCreateChannel: "Kanal oluşturulurken hata oluştu",
            connectedSuccess: "Google Business hesabı başarıyla bağlandı",
            oauthTimeout: "Yetkilendirme zaman aşımına uğradı",
            deleteChannelInfo: "Bu Google Business kanalını silmek istediğinize emin misiniz?",
            deleteChannel: "Kanalı Sil",
            deleteChannelDescription: "Bu Google Business kanalını silmek istediğinize emin misiniz?",
            detail: "Detay",
            visibility: "Görünürlük",
            locations: "Lokasyonlar",
            reviews: "Yorumlar",
            accountInfo: "Hesap Bilgileri",
            accountName: "Hesap Adı",
            accountId: "Hesap ID",
            status: "Durum",
            enabled: "Aktif",
            disabled: "Pasif",
            save: "Kaydet",
            channelUpdated: "Kanal başarıyla güncellendi",
            errorUpdatingChannel: "Kanal güncellenirken hata oluştu",
            visibilityDescription: "Bu kanalı hangi kullanıcı ve departmanların görebileceğini ayarlayın",
            visibleToUsers: "Kullanıcılar için Görünür",
            visibleToDepartments: "Departmanlar için Görünür",
            selectUsers: "Kullanıcı seçin",
            selectDepartments: "Departman seçin",
            visibilityUpdated: "Görünürlük ayarları güncellendi",
            errorUpdatingVisibility: "Görünürlük ayarları güncellenirken hata oluştu",
            sync: "Senkronize Et",
            refresh: "Yenile",
            locationsSynced: "Lokasyonlar senkronize edildi",
            errorSyncingLocations: "Lokasyonlar senkronize edilirken hata oluştu",
            errorFetchingLocations: "Lokasyonlar getirilirken hata oluştu",
            noLocationsFound: "Lokasyon bulunamadı",
            selectLocation: "Lokasyon seçin",
            allLocations: "Tüm Lokasyonlar",
            allRatings: "Tüm Puanlar",
            all: "Tümü",
            new: "Yeni",
            replied: "Yanıtlandı",
            resolved: "Çözüldü",
            noReviewsFound: "Yorum bulunamadı",
            noComment: "Yorum metni yok",
            selectReviewToPreview: "Önizleme için bir yorum seçin",
            yourReply: "Yanıtınız",
            reply: "Yanıtla",
            updateReply: "Yanıtı Güncelle",
            replyToReview: "Yoruma Yanıt Ver",
            writeYourReply: "Yanıtınızı yazın",
            pleaseEnterReply: "Lütfen bir yanıt girin",
            replySuccess: "Yanıt başarıyla gönderildi",
            errorSendingReply: "Yanıt gönderilirken hata oluştu",
            statusUpdated: "Durum güncellendi",
            errorUpdatingStatus: "Durum güncellenirken hata oluştu",
            errorFetchingReviews: "Yorumlar getirilirken hata oluştu",
        },
        googlePlay: {
            title: "Google Play Reviews",
            channels: "Google Play Kanalları",
            channelName: "Kanal Adı",
            channelDetails: "Kanal Detayları",
            connectToGooglePlay: "Google Play'e Bağlan",
            ensureGoogleAccount: "Bir Google hesabınız olduğundan emin olun",
            ensurePlayConsole: "Google Play Console hesabınız olduğundan emin olun",
            permissionDesc: "Supsis'in Google Play yorumlarınıza erişmesine izin vermeniz gerekmektedir.",
            requiredChannel: "Kanal adı gerekli",
            failedToCreateChannel: "Kanal oluşturulurken hata oluştu",
            connectedSuccess: "Google Play hesabı başarıyla bağlandı",
            oauthTimeout: "Yetkilendirme zaman aşımına uğradı",
            deleteChannelInfo: "Bu Google Play kanalını silmek istediğinize emin misiniz?",
            deleteChannel: "Kanalı Sil",
            deleteChannelDescription: "Bu Google Play kanalını silmek istediğinize emin misiniz?",
            detail: "Detay",
            visibility: "Görünürlük",
            apps: "Uygulamalar",
            reviews: "Yorumlar",
            status: "Durum",
            enabled: "Aktif",
            disabled: "Pasif",
            save: "Kaydet",
            channelUpdated: "Kanal başarıyla güncellendi",
            errorUpdatingChannel: "Kanal güncellenirken hata oluştu",
            visibilityDescription: "Bu kanalı hangi kullanıcı ve departmanların görebileceğini ayarlayın",
            visibleToUsers: "Kullanıcılar için Görünür",
            visibleToDepartments: "Departmanlar için Görünür",
            selectUsers: "Kullanıcı seçin",
            selectDepartments: "Departman seçin",
            visibilityUpdated: "Görünürlük ayarları güncellendi",
            errorUpdatingVisibility: "Görünürlük ayarları güncellenirken hata oluştu",
            addApp: "Uygulama Ekle",
            refresh: "Yenile",
            noAppsFound: "Uygulama bulunamadı",
            packageName: "Paket Adı",
            appName: "Uygulama Adı",
            appNamePlaceholder: "Örn: Uygulamam",
            iconUrl: "İkon URL",
            fillRequiredFields: "Lütfen zorunlu alanları doldurun",
            appAdded: "Uygulama başarıyla eklendi",
            errorAddingApp: "Uygulama eklenirken hata oluştu",
            syncReviews: "Yorumları Senkronize Et",
            reviewsSynced: "Yorumlar senkronize edildi",
            errorSyncingReviews: "Yorumlar senkronize edilirken hata oluştu",
            removeApp: "Uygulamayı Kaldır",
            removeAppConfirm:
                "{name} uygulamasını kaldırmak istediğinize emin misiniz? İlgili tüm yorumlar da silinecektir.",
            appRemoved: "Uygulama kaldırıldı",
            errorRemovingApp: "Uygulama kaldırılırken hata oluştu",
            errorFetchingApps: "Uygulamalar getirilirken hata oluştu",
            selectApp: "Uygulama seçin",
            allApps: "Tüm Uygulamalar",
            allRatings: "Tüm Puanlar",
            all: "Tümü",
            new: "Yeni",
            replied: "Yanıtlandı",
            resolved: "Çözüldü",
            noReviewsFound: "Yorum bulunamadı",
            noComment: "Yorum metni yok",
            selectReviewToPreview: "Önizleme için bir yorum seçin",
            yourReply: "Yanıtınız",
            reply: "Yanıtla",
            updateReply: "Yanıtı Güncelle",
            replyToReview: "Yoruma Yanıt Ver",
            writeYourReply: "Yanıtınızı yazın (max 350 karakter)",
            pleaseEnterReply: "Lütfen bir yanıt girin",
            replyTooLong: "Yanıt 350 karakterden uzun olamaz",
            replySuccess: "Yanıt başarıyla gönderildi",
            errorSendingReply: "Yanıt gönderilirken hata oluştu",
            statusUpdated: "Durum güncellendi",
            errorUpdatingStatus: "Durum güncellenirken hata oluştu",
            errorFetchingReviews: "Yorumlar getirilirken hata oluştu",
            deviceInfo: "Cihaz Bilgileri",
            device: "Cihaz",
            appVersion: "Uygulama Sürümü",
            manufacturer: "Üretici",
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "Google Drive Kanalları",
            googleDriveIntegration: "Google Drive Entegrasyonu",
            channelName: "Kanal Adı",
            channelInfo: "Kanal Bilgileri",
            channelSettings: "Kanal Ayarları",
            connectedAccount: "Bağlı Hesap",
            storageQuota: "Depolama Alanı",
            connectToGoogleDrive: "Google Drive'a Bağlan",
            ensureGoogleAccount: "Bir Google hesabınız olduğundan emin olun",
            ensureGoogleDriveAccess: "Google Drive erişiminiz olduğundan emin olun",
            permissionDesc: "Supsis'in Google Drive dosyalarınıza erişmesine izin vermeniz gerekmektedir.",
            requiredChannel: "Kanal adı gerekli",
            failedToCreateChannel: "Kanal oluşturulurken hata oluştu",
            connectedSuccess: "Google Drive hesabı başarıyla bağlandı",
            oauthTimeout: "Yetkilendirme zaman aşımına uğradı",
            deleteGoogleDriveChannelInfo: "Bu Google Drive kanalını silmek istediğinize emin misiniz?",
            deleteChannel: "Kanalı Sil",
            deleteChannelDescription: "Bu Google Drive kanalını silmek istediğinize emin misiniz?",
            driveExplorer: "Drive Gezgini",
            myDrive: "Drive'ım",
            sharedDrives: "Paylaşılan Drive'lar",
            searchFiles: "Dosya ara...",
            noSharedDrives: "Paylaşılan drive bulunamadı",
            noFiles: "Dosya bulunamadı",
            loadMore: "Daha Fazla Yükle",
            filesSelected: "dosya seçildi",
            downloadToSupsis: "Supsis'e İndir",
            fileDownloaded: "Dosya başarıyla indirildi",
            errorLoadingFiles: "Dosyalar yüklenirken hata oluştu",
            errorLoadingDrives: "Drive'lar yüklenirken hata oluştu",
            errorSearching: "Arama yapılırken hata oluştu",
            errorDownloading: "Dosya indirilirken hata oluştu",
            fileName: "Dosya Adı",
            fileSize: "Boyut",
            modifiedTime: "Değiştirilme Tarihi",
            selectFile: "Dosya Seç",
            selectFileFromGoogleDrive: "Google Drive'dan dosya seçin",
            selectChannel: "Kanal Seç",
            noChannelsAvailable: "Erişilebilir Google Drive kanalı bulunamadı",
            selectedFiles: "Seçili Dosyalar",
            upload: "Yükle",
            selectUploadMethod: "Dosya yükleme işlemini seçiniz:",
            uploadFromComputer: "Bilgisayardan Yükle",
            downloadingFiles: "Dosyalar indiriliyor...",
            myChannel: "Benim",
            manageWhoCanAccess: "Bu kanala kimlerin erişebileceğini yönetin",
            download: "İndir",
            openInNewTab: "Yeni Sekmede Aç",
            openInGoogleDrive: "Google Drive'da Aç",
            fileType: "Dosya Türü",
            owner: "Sahibi",
            previewNotAvailable: "Bu dosya türü için önizleme yapılamıyor",
            byocTitle: "Kendi Google Cloud Credentials'ınızı Kullanın",
            byocDescription:
                "Google Drive entegrasyonu için kendi Google Cloud Console'unuzdan OAuth client credentials oluşturmanız gerekmektedir.",
            clientId: "OAuth Client ID",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "Client ID gerekli",
            clientSecret: "OAuth Client Secret",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "Client Secret gerekli",
            redirectUriCopied: "Redirect URI kopyalandı",
            setupGuideTitle: "Kurulum Rehberi (tıklayarak açın)",
            setupStep1: "Google Cloud Console'a gidin ve yeni bir proje oluşturun veya mevcut projenizi seçin.",
            setupStep2: "APIs & Services > Credentials bölümüne gidin.",
            setupStep3:
                '"+ CREATE CREDENTIALS" > "OAuth client ID" seçin. Application type olarak "Web application" seçin.',
            setupStep4: "Authorized redirect URIs bölümüne aşağıdaki URL'yi ekleyin:",
            setupStep5: 'APIs & Services > Library bölümünden "Google Drive API"yi etkinleştirin.',
            setupStep6: "Client ID ve Client Secret değerlerini kopyalayıp yukarıdaki alanlara yapıştırın.",
        },
        appStore: {
            title: "App Store Reviews",
            channels: "App Store Kanalları",
            channelName: "Kanal Adı",
            channelDetails: "Kanal Detayları",
            connectToAppStore: "App Store'a Bağlan",
            credentials: "API Kimlik Bilgileri",
            credentialsHelp: "App Store Connect API kimlik bilgilerinizi girin. API anahtarı oluşturmak için:",
            issuerId: "Issuer ID",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "Key ID",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "Private Key (.p8 dosya içeriği)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "Bu alan zorunludur",
            validateCredentials: "Kimlik Bilgilerini Doğrula",
            credentialsValid: "Kimlik bilgileri geçerli",
            credentialsInvalid: "Geçersiz kimlik bilgileri",
            pleaseValidateFirst: "Lütfen önce kimlik bilgilerinizi doğrulayın",
            failedToCreateChannel: "Kanal oluşturulurken hata oluştu",
            connectedSuccess: "App Store hesabı başarıyla bağlandı",
            deleteChannelInfo: "Bu App Store kanalını silmek istediğinize emin misiniz?",
            deleteChannel: "Kanalı Sil",
            deleteChannelDescription: "Bu App Store kanalını silmek istediğinize emin misiniz?",
            detail: "Detay",
            visibility: "Görünürlük",
            apps: "Uygulamalar",
            reviews: "Yorumlar",
            status: "Durum",
            enabled: "Aktif",
            disabled: "Pasif",
            save: "Kaydet",
            channelUpdated: "Kanal başarıyla güncellendi",
            errorUpdatingChannel: "Kanal güncellenirken hata oluştu",
            visibilityDescription: "Bu kanalı hangi kullanıcı ve departmanların görebileceğini ayarlayın",
            visibleToUsers: "Kullanıcılar için Görünür",
            visibleToDepartments: "Departmanlar için Görünür",
            selectUsers: "Kullanıcı seçin",
            selectDepartments: "Departman seçin",
            visibilityUpdated: "Görünürlük ayarları güncellendi",
            errorUpdatingVisibility: "Görünürlük ayarları güncellenirken hata oluştu",
            syncApps: "Uygulamaları Senkronize Et",
            refresh: "Yenile",
            noAppsFound: "Uygulama bulunamadı",
            appsAutoFetch:
                "Uygulamalar App Store Connect'ten otomatik olarak çekilir. Listeyi yenilemek için 'Uygulamaları Senkronize Et' butonuna tıklayın.",
            appsSynced: "Uygulamalar başarıyla senkronize edildi",
            errorSyncingApps: "Uygulamalar senkronize edilirken hata oluştu",
            syncReviews: "Yorumları Senkronize Et",
            reviewsSynced: "Yorumlar senkronize edildi",
            errorSyncingReviews: "Yorumlar senkronize edilirken hata oluştu",
            errorFetchingApps: "Uygulamalar getirilirken hata oluştu",
            selectApp: "Uygulama seçin",
            allApps: "Tüm Uygulamalar",
            all: "Tümü",
            new: "Yeni",
            replied: "Yanıtlandı",
            resolved: "Çözüldü",
            noReviewsFound: "Yorum bulunamadı",
            noComment: "Yorum metni yok",
            anonymous: "Anonim",
            selectReviewToPreview: "Önizleme için bir yorum seçin",
            yourReply: "Yanıtınız",
            reply: "Yanıtla",
            edit: "Düzenle",
            delete: "Sil",
            editReply: "Yanıtı Düzenle",
            replyToReview: "Yoruma Yanıt Ver",
            writeYourReply: "Yanıtınızı yazın",
            pleaseEnterReply: "Lütfen bir yanıt girin",
            replySuccess: "Yanıt başarıyla gönderildi",
            errorSendingReply: "Yanıt gönderilirken hata oluştu",
            deleteResponse: "Yanıtı Sil",
            deleteResponseConfirm: "Bu yanıtı silmek istediğinize emin misiniz?",
            responseDeleted: "Yanıt başarıyla silindi",
            errorDeletingResponse: "Yanıt silinirken hata oluştu",
            statusUpdated: "Durum güncellendi",
            errorUpdatingStatus: "Durum güncellenirken hata oluştu",
            errorFetchingReviews: "Yorumlar getirilirken hata oluştu",
            territory: "Bölge",
            region: "Bölge",
        },
        chatWindow: {
            descending: "Azalan",
            ascending: "Artan",
            filterTable: "Filtrele",
            switchToLiveSupportMode: "Canlı Destek Moduna Geç",
            switchToLiveSupportModeConfirmation:
                "Bu kişiyi görüntülemek için canlı destek moduna geçmek istiyor musunuz?",
            thereIsNoChatContent: "Sohbet içeriği bulunmuyor.",
            thereIsNoChatContentDsc: "Bu kısımda sohbet içeriğini görebilir ve mesaj gönderebilirsiniz.",
            interactions: "Etkileşimler:",
            departments: "Departmanlar",
            channels: "Kanallar",
            date: "Tarih",
            lastChatStatus: "Son Sohbet Durumu",
            all: "Tümü",
            queued: "Sıraya alındı",
            open: "Açık",
            closed: "Kapalı",
            private: "Özel",
            chatbot: "Sohbet robotu",
            lostMissed: "Kayıp / Kaçırılan",
            interaction: "Etkileşim",
            myActiveInbox: "Aktif Gelen Kutum",
            activeQueueInbox: "Aktif + Kuyruktakiler",
            chatbotActiveInbox: "Chatbot Aktif Kutusu",
            myDepartmentsActiveInbox: "Departmanlarım Kutusu",
            notInteractedYesterday: "Dün Kaçan Kutusu",
            queueInbox: "Kuyruktakiler",
            whatsappActiveInbox: "Whatsapp Kutusu",
            socialMediaActiveInbox: "Sosyal Medya Kutusu",
            missedThisMonth: "Bu Ayki Kaçan Kutusu",
            chooseAFileOrDragItHere: "Bir dosya seçin veya buraya sürükleyin!",
            watching: "İzleniyor",
            selectFilter: "Filtre Seç",
            clearAll: "Hepsini temizle",
            me: "Ben",
            today: "Bugün",
            yesterday: "Dün",
            thisWeek: "Bu Hafta",
            lastWeek: "Geçen Hafta",
            last7Days: "Son 7 Gün",
            last30Days: "Son 30 Gün",
            thisMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last24h: "Son 24 Saat",
            custom: "Özel",
            startMessage: "Mesaj Başlat",
            goToAgentReport: "Temsilci Raporuna Git",
            agentDetail: "Temsilci Detay",
            agentList: "Temsilci Listesi",
            selectedFilter: "Seçilen Filtre",
            groupBy: "Grupla",
            owner: "Sahip",
            none: "Grup Yok",
            agent: "Temsilci",
            department: "Departman",
            tag: "Etiket",
            website: "Website",
            channel: "Kanal",
            platform: "Platform",
            answerStatus: "Yanıt Durumu",
            sortBy: "Sırala",
            lastPostAbove: "Son Mesaj Üstte",
            newChatsAbove: "Yeni Chatler Üstte",
            oldChatsAbove: "Eski Chatler Üstte",
            live: "Canlı",
            systemStatus: "Sistem Durumu",
            refresh: "Yenile",
            close: "Kapat",
            totalCustomers: "Toplam Müşteri",
            totalAnswered: "Toplam Yanıtlanan",
            waitingAnswer: "Yanıt Bekleyen",
            totalAgentInChat: "Sohbetteki Toplam Temsilci",
            onlineAgentCount: "Çevrimiçi Temsilci Sayısı",
            totalCustomer: "Toplam Müşteri",
            answered: "Yanıtlanan",
            unanswered: "Yanıtlanmayan",
            noContactWasFoundMatchingTheCurrentFilters: "Mevcut filtrelere uygun bir kişi bulunamadı.",
            you: "Sen",
            others: "Diğerleri",
            queue: "Kuyruk",
            chatbotContact: "Chatbot",
            closedContact: "Kapalı",
            myInteractions: "Benim Etkileşimlerim",
            special: "Özel",
            allInteractions: "Tüm kişiler",
            waiting: "Bekleyen",
            departmentToWhichItIsAffiliated: "Bağlandığı Departman",
            hiddenChatsWarning: "Bu listede göremediğiniz {count} adet chat vardır",
            clickToSeeDetails: "Detayları görmek için tıklayın",
            viewDetails: "Detayları Gör",
            hiddenChatsDetails: "Görünmeyen Chat Detayları",
            totalHiddenChats: "Toplam Gizli Chat",
            examples: "Örnekler",
            reasons: {
                visitorNotFound: "Ziyaretçi bulunamadı",
                noChannelAccess: "Kanala erişim izniniz yok",
                ownedByOtherNotChannelOwner: "Başka kullanıcının sahipliğinde (Kanal sahibi değilsiniz)",
                ownedByOtherNoChannel: "Başka kullanıcının sahipliğinde (Kanalsız)",
                noOwnerAdminOnly: "Sahipsiz chat (Sadece admin ve kanal sahipleri görebilir)",
            },
        },
        chat: {
            inbox: "Gelen Kutusu",
            layouts: {
                chat: "Sohbet Görünümü",
                table: "Tablo Görünümü",
                kanban: "Kanban Görünümü",
            },
            filters: {
                allContacts: "Tüm Kişiler",
                myInbox: "Gelen Kutum",
                myContacts: "Kişilerim",
                missed: "Kaçanlar",
                unanswered: "Cevapsızlar",
                unassigned: "Atanmamışlar",
                chatbot: "Chatbot",
            },
            groups: {
                views: "Görünümler",
                customFilters: "Özel Filtreler",
                team: "Takım",
                contacts: "Kişiler",
                system: "Sistem",
            },
            sidebar: {
                tabScreen: "Tab Ekranı",
                search: "Ara",
                addNewFilter: "Yeni filtre ekle",
                edit: "Düzenle",
                showInTable: "Table Modda Göster",
                showInKanban: "Kanban Modda Göster",
                rename: "Yeniden Adlandır",
                makePublic: "Public Yap",
                makePrivate: "Private Yap",
                moveToTop: "En Yukarı Al",
                moveToBottom: "En Aşağı Gönder",
                delete: "Sil",
                renameFilterTitle: "Filtre Yeniden Adlandır",
                filterNamePlaceholder: "Filtre adını girin",
                positionUpdateError: "Pozisyon güncellenirken hata oluştu",
                filterNameEmpty: "Filtre adı boş olamaz",
                filterNameUpdated: "Filtre adı güncellendi",
                filterNameUpdateError: "Filtre adı güncellenirken hata oluştu",
                filterVisibilityUpdateError: "Filtre görünürlüğü güncellenirken hata oluştu",
                filterMadePrivate: "Filtre private yapıldı",
                filterMadePublic: "Filtre public yapıldı",
                filterMovedToTop: "Filtre en yukarı taşındı",
                filterMovedToBottom: "Filtre en aşağı gönderildi",
                filterMoveError: "Filtre taşınırken hata oluştu",
                onlyCreatorOrRootCanDeletePublic:
                    "Sadece oluşturan kullanıcı veya root kullanıcı public filtreleri silebilir",
                deleteFilterTitle: "Filtreyi Sil",
                deleteFilterConfirm: '"{name}" filtresini silmek istediğinizden emin misiniz?',
                deleteFilterOk: "Sil",
                deleteFilterCancel: "İptal",
                filterDeleted: "Filtre silindi",
                filterDeleteError: "Filtre silinirken hata oluştu",
                websiteAnalytics: "Website Analytics",
            },
            gridContactList: {
                emptyConversationsTitle: "Gösterilecek Sohbet Bulunamadı",
                emptyConversationsDescription:
                    "Henüz aktif bir sohbetiniz yok. Müşteri sayfasından yeni bir sohbet başlatabilirsiniz.",
                markAsUnanswered: "Cevaplanmadı Olarak İşaretle",
                markAsAnswered: "Cevaplandı Olarak İşaretle",
                removeVIP: "VIP İşaretini Kaldır",
                markAsVIP: "VIP Olarak İşaretle",
                markAsRead: "Okundu Olarak İşaretle",
                markAsUnread: "Okunmadı Olarak İşaretle",
                closeChat: "Sohbeti Kapat",
                markedAsAnswered: "Cevaplandı olarak işaretlendi",
                markedAsUnanswered: "Cevaplanmadı olarak işaretlendi",
                operationFailed: "İşlem başarısız oldu",
                markedAsVIP: "VIP olarak işaretlendi",
                vipRemoved: "VIP işareti kaldırıldı",
                markedAsUnread: "Okunmadı olarak işaretlendi",
                markedAsRead: "Okundu olarak işaretlendi",
                confirmCloseChat: "Sohbeti sonlandırmak istediğinize emin misiniz?",
                chatClosed: "Sohbet kapatıldı",
            },
            tableContactList: {
                editFilter: "Filtre Düzenle",
                chatStatus: "Sohbet Durumu",
                grouping: "Gruplama",
                allContacts: "Tüm Kişiler",
                groupNone: "Yok",
                groupTag: "Etiket",
                groupDepartment: "Departman",
                groupChannel: "Kanal",
                groupPlatform: "Platform",
                groupOwner: "Sahip",
                groupUsers: "Katılımcılar",
                groupAnswerStatus: "Cevap Durumu",
                statusAll: "Tümü",
                statusOpen: "Açık",
                statusClosed: "Kapalı",
                statusUnknown: "Bilinmiyor",
                copyLabel: "Kopya",
                filterCreatedSuccess: "Filtre başarıyla oluşturuldu",
                filterCreatedNameDuplicate:
                    '"{createName}" ismi zaten kullanılıyordu. Filtre "{filterName}" olarak oluşturuldu.',
                filterCreateFailed: "Filtre oluşturulamadı",
                filterCreateError: "Filtre oluşturulurken bir hata oluştu.",
                platformSupsis: "Supsis",
                platformEmail: "Email",
                platformWhatsapp: "WhatsApp",
                platformWeb: "Web",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Meta Leads",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "Cevaplanmış",
                answerStatusUnanswered: "Cevaplanmamış",
            },
            kanbanContactList: {
                filterHide: "Filtreleri Gizle",
                filterAdd: "Filtre Ekle",
                broadcast: "Broadcast",
                broadcastSelectPlaceholder: "Broadcast seçin...",
                loading: "Yükleniyor...",
                broadcastNotFound: "Broadcast bulunamadı",
                broadcastTitle: "Başlık",
                broadcastDate: "Tarih",
                broadcastStatus: "Durum",
                broadcastProgress: "İlerleme",
                refresh: "Yenile",
                kanbanLoading: "Kanban yükleniyor...",
                deletedUser: "Silinmiş Kullanıcı",
                unowned: "Sahipsizler",
                activeInChat: "Aktif (Sohbette)",
                newInQueue: "Yeni (Kuyrukta)",
                agentDown: "Temsilci Düştü",
                closed: "Kapandı",
                blocked: "Engellenmiş",
                unblocked: "Engellenmemiş",
                groupsLoadError: "Gruplar yüklenirken hata oluştu",
                dataLoadError: "Veriler yüklenirken hata oluştu",
                broadcastsLoadError: "Broadcastler yüklenirken hata oluştu",
                dataRefreshed: "Veriler yenilendi",
                refreshError: "Yenileme sırasında hata oluştu",
                unknownContact: "Bilinmeyen Kişi",
                assigned: "Atanmamış",
                platformMobile: "Mobil",
                broadcastStatusCreated: "Oluşturuldu",
                broadcastStatusScheduled: "Zamanlandı",
                broadcastStatusQueued: "Kuyrukta",
                broadcastStatusRunning: "Gönderiliyor",
                broadcastStatusCompleted: "Tamamlandı",
                broadcastStatusFailed: "Başarısız",
                broadcastStatusCancelled: "İptal Edildi",
                metaLeadNewLead: "Yeni Lead",
                metaLeadInitialContact: "İlk İletişim",
                metaLeadNeedsAssessment: "İhtiyaç Değerlendirme",
                metaLeadProposalSent: "Teklif Gönderildi",
                metaLeadProposalReview: "Teklif İncelemesi",
                metaLeadNegotiation: "Müzakere",
                metaLeadDecisionStage: "Karar Aşaması",
                metaLeadClosure: "Kapanış",
                metaLeadFollowUp: "Takip",
                broadcastSent: "Gönderildi",
                broadcastDelivered: "Teslim Edildi",
                broadcastRead: "Okundu",
                broadcastFailed: "Başarısız",
                broadcastEdited: "Düzenlendi",
                broadcastDeleted: "Silindi",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "Broadcast",
                triggerTypeAutomation: "Otomasyon",
                emptyGroup: "Bu grupta contact yok",
                loadMore: "Daha fazla yükle...",
                groupSelectTitle: "Gruplama Alanı Seç",
                searchPlaceholder: "Ara...",
                categoryBasic: "Temel",
                categoryDemographic: "Demografik",
                categoryTags: "Etiket & Kategori",
                categoryMeta: "Meta Leads",
                categoryBroadcast: "Broadcast",
                categoryOther: "Diğer",
                fieldAnswerStatus: "Cevap Durumu",
                fieldLastConversationStatus: "Sohbet Durumu",
                fieldOwner: "Sahip",
                fieldUsers: "Katılımcılar",
                fieldChannel: "Kanal",
                fieldPlatform: "Platform",
                fieldCountry: "Ülke",
                fieldCity: "Şehir",
                fieldBrowser: "Tarayıcı",
                fieldPreferredLang: "Dil",
                fieldTags: "Etiketler",
                fieldDepartment: "Departman",
                fieldMetaLeadStatus: "Lead Durumu",
                fieldMetaLeadAdName: "Reklam Adı",
                fieldMetaLeadAdsetName: "Reklam Seti",
                fieldMetaLeadCampaignName: "Kampanya",
                fieldMetaLeadFormName: "Form Adı",
                fieldMetaLeadPlatform: "Meta Platform",
                fieldLastBroadcastStatus: "Broadcast Durumu",
                fieldLastBroadcastReason: "Broadcast Nedeni",
                fieldBlockedSnapshot: "Engel Durumu",
                fieldLastTriggerType: "Tetikleme Tipi",
                fieldZohoLeadStatus: "Zoho Lead Durumu",
                fieldZohoLeadSource: "Zoho Lead Kaynağı",
                broadcastTriggerSuccess: "Broadcast mesajına cevap verdi!",
                broadcastTriggerWaiting: "Cevap bekleniyor...",
                unknownUser: "Bilinmeyen Kişi",
                unread: "Okunmadı",
                platformIg: "Instagram",
                platformFb: "Facebook",
            },
            gridContactListToolBar: {
                chatStatus: "Sohbet Durumu",
                sortBy: "Sıralama",
                all: "Tümü",
                open: "Açık",
                closed: "Kapalı",
                allStatus: "Hepsi",
                lastActivity: "Son Aktivite",
                createdAt: "Oluşturulma",
                unknown: "Bilinmiyor",
            },
            chatCloseSettings: {
                selectPhone: "Telefon Seçin",
                selectPhoneDescription: "{number} numarasını hangi telefon ile aramak istiyorsunuz?",
                call: "Ara",
                unnamedChannel: "İsimsiz Kanal",
                typeVisitorName: "Ziyaretçi adını yazın...",
                webphoneCall: "Webphone ile Ara",
                hideSystemMessages: "Sistem Mesajlarını Gizle",
                chatbotDebugMode: "Chatbot Hata Ayıklama Modu",
                createTask: "Görev Oluştur",
                showProfile: "Profili Göster",
                sendCapiEvent: "CAPI Event Gönder",
                noPhoneNumber: "Aranacak numara bulunamadı",
                noWebphoneChannel: "Webphone kanalı bulunamadı",
                webphoneCalling: "Webphone ile {number} aranıyor...",
                unknown: "Bilinmeyen",
                channelTypeKirmiziSantral: "Kırmızı Santral",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "Web Telefon",
                platformWeb: "Web",
                platformWhatsapp: "WhatsApp",
                platformWhatsappBusiness: "WhatsApp Business",
                platformInstagram: "Instagram",
                platformInstagramV2: "Instagram V2",
                platformMessenger: "Messenger",
                platformTelegram: "Telegram",
                platformTrendyol: "Trendyol",
                platformEmail: "E-posta",
                platformSms: "SMS",
                vipCustomerTooltip: "★ VIP Müşteri",
            },
            contactDetail: {
                removeVIPTooltip: "VIP işaretini kaldır",
                markAsVIPTooltip:
                    "VIP Olarak İşaretle (VIP olarak işaretlenen kullanıcı, sohbetlerde her zaman en üstte görüntülenecektir).",
                customerOwnership: "Müşteri Sahipliği",
                ownershipDescription: "Müşteri sahipliği verildiği zaman sadece sahibi ve fulladminler görebilir",
                unowned: "Sahipsiz",
                assignToMe: "Bana Ata",
                removeOwnership: "Sahipliğini Kaldır",
                dragPlaceholder: "Buraya taşınacak",
                currentConversationDepartment: "Mevcut Konuşma Departmanı",
                pastInteractionDepartments: "Geçmiş Etkileşim Departmanları",
                createdAt: "Oluşturma Tarihi",
                updatedAt: "Güncellenme Tarihi",
                zohoSync: "Zoho Senkronizasyonu",
                zohoSyncQuestion: "Kişi değişiklik işlemlerini Zoho'da da yapmak istiyor musunuz?",
                basicInfo: "Kişi Bilgileri",
                loginInfo: "Kişi Form Bilgileri",
                profileFields: "Profil Alanları",
                systemInfo: "Sistem Bilgileri",
            },
            contactDetailItem: {
                removeOwnership: "Sahipliği Kaldır",
                assignOwnershipToMe: "Sahipliği Bana Ata",
                vipCustomer: "VIP Müşteri",
                contentCopiedSuccess: "İçerik başarıyla kopyalandı!",
                invalidEmail: "Geçersiz e-posta adresi!",
                invalidValue: "Geçersiz değer!",
            },
            filtersSection: {
                addFilter: "Filtre Ekle",
                all: "Hepsi",
                open: "Açık",
                closed: "Kapalı",
                relevance: "Öne Çıkanlar",
                lastActivityNewest: "En Yeni Aktivite",
                lastActivityOldest: "En Eski Aktivite",
                noParticipant: "Katılımcısı Olmayan",
                ownershipFilter: "Sahiplik Filtresi",
                metaReferral: "Meta Referral",
                userStatus: "Kullanıcı Durumu",
                unowned: "Sahipsiz",
                fromAds: "Reklamdan Gelenler",
                notFromAds: "Reklamdan Gelmeyenler",
                blockedUsers: "Engellenmiş Kullanıcılar",
                unblockedUsers: "Engellenmemiş Kullanıcılar",
                unread: "Okunmamış",
                read: "Okunmuş",
                yes: "Evet",
                no: "Hayır",
                answered: "Yanıtlanmış",
                unanswered: "Yanıtlanmamış",
                active: "Aktif",
                lost: "Kayıp",
                new: "Yeni",
                chatbot: "Chatbot",
                closedStatus: "Kapalı",
                platform: "Platform",
                channel: "Kanal",
                department: "Departman",
                tag: "Etiket",
                participant: "Katılımcı",
                ownership: "Sahiplik",
                lastActivityTime: "Son Aktivite Zamanı",
                fullName: "Ad Soyad",
                email: "Email",
                phone: "Telefon",
                vipCustomer: "VIP Customer",
                hasVIP: "Olanlar",
                noVIP: "Olmayanlar",
                operatingSystem: "İşletim Sistemi",
                browser: "Tarayıcı",
                ipAddress: "IP Adresi",
                visitingPage: "Ziyaret Edilen Sayfa",
                adInteraction: "Reklam Etkileşimi",
                blockedStatus: "Engellenme Durumu",
                connectionTime: "Bağlantı Zamanı",
                createdAt: "Oluşturma Tarihi",
                updatedAt: "Güncellenme Tarihi",
                readStatus: "Okunma Durumu",
                missedChat: "Kaçan Sohbet",
                answerStatus: "Yanıt Durumu",
                lastConversationStatus: "Son Sohbet Durumu",
                lastTriggerState: "Son Tetikleyici Durum",
                type: "Tür",
                name: "İsim",
                enterTriggerName: "Tetikleyici ismi girin...",
                zohoInfo: "Zoho Bilgisi",
                id: "ID",
                enterContactOrLeadId: "Contact veya Lead ID girin...",
                broadcastMessage: "Toplu Mesaj",
                today: "Bugün",
                yesterday: "Dün",
                thisWeek: "Bu Hafta",
                lastWeek: "Geçen Hafta",
                last7Days: "Son 7 Gün",
                last30Days: "Son 30 Gün",
                thisMonth: "Bu Ay",
                lastMonth: "Geçen Ay",
            },
            filterChip: {
                operator: "Operatör:",
                enterText: "Metin girin...",
                enterNumber: "Sayı girin...",
                type: "Tür",
                value: "Değer",
                enterValue: "Değer girin...",
                addFilter: "Filtre Ekle",
                equals: "Eşittir",
                contains: "İçerir",
                startsWith: "İle Başlayan",
                endsWith: "İle Biten",
                greaterThan: "Büyüktür",
                lessThan: "Küçüktür",
                greaterThanOrEqual: "Büyük Eşittir",
                lessThanOrEqual: "Küçük Eşittir",
                between: "Arasında",
                custom: "Custom",
                select: "Seçin",
            },
            filterPanel: {
                backToChat: "Chat görünümüne dön",
                publicFilter: "Herkese Açık Filtre",
                privateFilter: "Özel Filtre",
                editFilterName: "Filtre adını düzenle",
                contactsFound: " kişi bulundu",
                enterFilterName: "Filtre adını girin",
                filterSuggestions: "Filtre Önerileri",
                private: "Özel",
                public: "Genel",
                createFilter: "Filtre Oluştur",
                update: "Güncelle",
                changeToPublic: "Change to Public",
                changeToPrivate: "Change to Private",
                clearSearch: "Aramayı temizle",
                previous: "Geri",
                next: "İleri",
                searchTerm: "Arama Terimi:",
                whichFieldToSearch: "Hangi alanda aramak istersiniz?",
                contactId: "Kişi ID",
                conversationId: "Sohbet ID",
                noSearchAllFields: "Hayır, tüm alanlarda ara",
                yesSearchOnlyField: "Evet, sadece {field} ara",
                search: "Ara",
                allFields: "Tüm Alanlar",
                fullname: "Full name",
                email: "Email",
                whatsappNumber: "WhatsApp Numarası",
                phone: "Phone",
                conversationIdField: "Conversation ID",
                searchAllFieldsPlaceholder: "Tüm alanlarda aramak istediğinizi buraya yazın",
                searchFullnamePlaceholder: "Ad Soyad ile aramak istediğinizi buraya yazın",
                searchEmailPlaceholder: "Email ile aramak istediğinizi buraya yazın",
                searchWhatsappPlaceholder: "WhatsApp ile aramak istediğinizi buraya yazın",
                searchPhonePlaceholder: "Telefon ile aramak istediğinizi buraya yazın",
                searchContactIdPlaceholder: "Aramak istediğiniz kişinin ID'sini buraya yazın",
                searchConversationIdPlaceholder: "Aramak istediğiniz sohbetin ID'sini buraya yazın",
                searchPlaceholder: "Ara",
                edited: " (Düzenlenmiş)",
                unnamedFilter: "Adsız Filtre",
                all: "Hepsi",
                open: "Açık",
                closed: "Kapalı",
                unknown: "Bilinmiyor",
                filterUpdatedSuccess: "Filtre başarıyla güncellendi",
                filterUpdatedDescription: '"{name}" filtresi güncellendi.',
                filterUpdateFailed: "Filtre güncellenemedi",
                filterUpdateError: "Filtre güncellenirken bir hata oluştu.",
                filterSavedSuccess: "Filtre başarıyla kaydedildi",
                filterSavedDescription:
                    '"{createName}" ismi zaten kullanılıyordu. Filtre "{filterName}" olarak oluşturuldu.',
                filterCreatedDescription: '"{filterName}" filtresi oluşturuldu.',
                filterSaveFailed: "Filtre kaydedilemedi",
                filterSaveError: "Filtre kaydedilirken bir hata oluştu.",
                aiFilterCreatedSuccess: "AI Filtresi başarıyla oluşturuldu",
                aiFilterCreatedDescription:
                    '"{createName}" ismi zaten kullanılıyordu. Filtre "{filterName}" olarak oluşturuldu ve uygulandı.',
                aiFilterCreatedApplied: '"{filterName}" filtresi oluşturuldu ve uygulandı.',
                aiFilterCreateFailed: "Filtre oluşturulamadı",
                aiFilterCreateError: "AI filtresi oluşturulurken bir hata oluştu.",
                phoneDetected: "Telefon Numarası Tespit Edildi",
                emailDetected: "E-posta Adresi Tespit Edildi",
                idFormatDetected: "ID Formatı Tespit Edildi",
                contactIdDetected: "Kişi ID'si Tespit Edildi",
                conversationIdDetected: "Sohbet ID'si Tespit Edildi",
                searchMode: "Arama Modu",
                phoneDetectedMessage:
                    "Girdiğiniz değer bir telefon numarasına benziyor. Sadece telefon numarası alanında aramak ister misiniz?",
                emailDetectedMessage:
                    "Girdiğiniz değer bir e-posta adresine benziyor. Sadece e-posta alanında aramak ister misiniz?",
                idFormatDetectedMessage: "Girdiğiniz değer bir ID formatına benziyor. Hangi alanda aramak istersiniz?",
                phoneField: "telefon numarası alanında",
                emailField: "e-posta alanında",
                contactIdField: "kişi ID alanında",
                conversationIdFieldName: "sohbet ID alanında",
                idField: "ID alanında",
                deleteFilter: "Filtreyi Sil",
                deleteFilterConfirm: '"{name}" filtresini silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
                delete: "Sil",
                cancel: "İptal",
                filterDeletedSuccess: "Filtre başarıyla silindi",
                filterDeletedDescription: '"{name}" filtresi silindi.',
                filterDeleteFailed: "Filtre silinemedi",
                filterDeleteError: "Filtre silinirken bir hata oluştu.",
                visibilityUpdatedSuccess: "Görünürlük başarıyla güncellendi",
                visibilityUpdatedDescription: 'Filtre "{visibility}" olarak ayarlandı.',
                visibilityUpdateFailed: "Görünürlük güncellenemedi",
                visibilityUpdateError: "Filtre güncellenirken bir hata oluştu.",
                publicVisibility: "herkese açık",
                privateVisibility: "özel",
            },
            contactList: {
                noContactsFound: "Kişi bulunamadı",
                unknownContact: "Bilinmeyen Kişi",
                unknown: "Bilinmiyor",
                fullName: "Ad Soyad",
                platform: "Platform",
                email: "Email",
                phone: "Telefon",
                tags: "Etiketler",
                status: "Durum",
                lastActivity: "Son Aktivite",
                answerStatus: "Yanıt Durumu",
                channel: "Kanal",
                owner: "Sahip",
                vip: "VIP",
                connectionTime: "Bağlantı Zamanı",
                unread: "Okunmamış",
                departments: "Departmanlar",
                operatingSystem: "İşletim Sistemi",
                browser: "Tarayıcı",
                countryCity: "Ülke - Şehir",
                ipAddress: "IP Adresi",
                visitingPage: "Ziyaret Edilen Sayfa",
                lastConversationDate: "Son Konuşma Tarihi",
                blockedStatus: "Engelleme Durumu",
                lastConversationParticipants: "Son Konuşma Katılımcıları",
                preferredLanguage: "Tercih Edilen Dil",
                createdAt: "Oluşturulma Tarihi",
                updatedAt: "Güncellenme Tarihi",
                broadcastStatus: "Broadcast Durumu",
                broadcastAnswer: "Broadcast Yanıtı",
                zohoContactId: "Zoho Contact ID",
                zohoLeadId: "Zoho Lead ID",
                profileFields: "Profil Alanları",
                closed: "Kapalı",
                open: "Açık",
                unknownStatus: "Bilinmiyor",
                answered: "Yanıtlandı",
                unanswered: "Yanıtlanmadı",
                unreadStatus: "Okunmadı",
                readStatus: "Okundu",
                vipStatus: "VIP",
                normal: "Normal",
                blocked: "Engelli",
                today: "Today",
                yesterday: "Yesterday",
                enqueued: "Kuyrukta",
                sent: "Gönderildi",
                delivered: "Teslim Edildi",
                read: "Okundu",
                deleted: "Silindi",
                failed: "Başarısız",
                replied: "Yanıtladı",
                notReplied: "Yanıtlamadı",
                jsonProperty: "JSON Property",
                jsonCopiedSuccess: "JSON içerik başarıyla kopyalandı!",
            },
        },
        form: {
            title: {
                titleSettings: "Başlık Ayarları",
                fullNameSettings: "Tam Ad Ayarları",
                emailSettings: "E-posta Ayarları",
                addressSettings: "Adres Ayarları",
                phoneSettings: "Telefon Ayarları",
                datePickerSettings: "Tarih Seçici Ayarları",
                shortTextSettings: "Kısa Metin Ayarları",
                longTextSettings: "Uzun Metin Ayarları",
                dropDownListSettings: "Açılır Liste Ayarları",
                singleChoiceSettings: "Tek Seçim Ayarları",
                multipleSelectionSettings: "Çoklu Seçim Ayarları",
                numberSettings: "Sayı Ayarları",
                hourSettings: "Saat Ayarları",
                spinnerSettings: "Spinner Ayarları",
                sendSettings: "Gönderme Ayarları",
                starRatingSettings: "Yıldız Derecelendirme Ayarları",
                ratingScaleSettings: "Derecelendirme Ölçeği Ayarları",
                separationElementSettings: "Ayırma Elemanı Ayarları",
                fileUploadSettings: "Dosya Yükleme Ayarları",
                imageSettings: "Resim Ayarları",
            },
            lineColor: "Çizgi Rengi",
            separatorColorInfo: "Ayırma elemanının rengini seçin veya girin (örn. #RRGGBB)",
            separatorHeight: "Ayırma Elemanı Yüksekliği",
            separatorHeightInfo: "Ayırma elemanının yüksekliğini girin",
            bottomSpace: "Altındaki Boşluk",
            bottomSpaceInfo: "Ayırma elemanının altına boşluk ekleyin",
            topSpace: "Üstündeki Boşluk",
            topSpaceInfo: "Ayırma elemanının üstüne boşluk ekleyin",
            sideSpace: "Yan Boşluk",
            sideSpaceInfo: "Ayırma elemanının sağına ve soluna boşluk ekleyin",
            onlyImageUpload: "Sadece Resim Yükleyebilirsiniz!",
            imageSizeLimit: "Resminizin Boyutu En Fazla 5MB Olmalıdır!",
            image: "Görsel",
            size: "Boyut",
            width: "Genişlik",
            height: "Yükseklik",
            imageAlignment: "Görüntü Hizalama",
            wide: "Geniş",
            small: "Küçük",
            textAlignment: "Metin Hizalama",
            chooseHorizontalAlignment: "Bu başlığın yatay olarak nasıl hizalanacağını seçin.",
            headerSize: "Başlık Boyutu",
            addSmallTextBelowHeader: "Başlığın altına daha küçük bir metin ekle",
            subHeaderText: "Alt Başlık Metni",
            subLabel1: "Alt Etiket(1)",
            subLabel2: "Alt Etiket(2)",
            validPhoneNumber: "Lütfen geçerli bir telefon numarası girin",
            masked: "Maskelenmiş",
            copyField: "Alanı Kopyala",
            copyFieldDescription: "Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun",
            enterQuestion: "Bir soru girin",
            notRequired: "Zorunlu Değil",
            addDescriptionBelowField: "Alanının altına kısa bir açıklama ekleyin",
            setDefault: "Varsayılan olarak ayarla",
            pleaseSelect: "Lütfen Seçim Yapınız",
            placeholder: "Yer tutucu",
            required: "Zorunlu",
            fieldEmptyError: "Bu alan boşsa formun gönderilmesine izin vermeyin",
            subLabels: "Alt Etiketler",
            addressLine1: "Adres Satırı 1",
            addressLine2: "Adres Satırı 2",
            postalCode: "Posta Kodu",
            stateProvince: "İl / Eyalet",
            chooseLabelAlignment: "Etiket metninin yatay olarak nasıl hizalanacağını seçin",
            right: "SAĞ",
            left: "SOL",
            top: "ÜST",
            labelAlignment: "Etiket Hizalama",
            fieldLabel: "Alan Etiketi",
            read: "Okundu",
            itemsPerPage: "öğe/sayfa",
            downloadAllDataAsPDF: "Tüm Veriyi PDF Olarak İndir",
            downloadAllDataAsExcel: "Tüm Veriyi Excel Olarak İndir",
            downloadSelectedDataAsPDF: "Seçili Veriyi PDF Olarak İndir",
            downloadSelectedDataAsExcel: "Seçili Veriyi Excel Olarak İndir",
            selectItemToViewDetails: "Detayları görmek için bir öğe seçin.",
            deleteFormConfirm:
                "Bu formu sildiğiniz takdirde, forma ait tüm veriler kalıcı olarak silinecektir. Devam etmek istediğinizden emin misiniz?",
            redicetFormAnswer: "FORM CEVAPLARINI YÖNLENDİRİN",
            redicetFormAnswerDesc:
                "Form cevaplarını ticket sistemine yönlendirirken, form içerisinde kullanıcıdan telefon numarası veya e-posta adresi talep etmeye özen gösteriniz. Bu bilgiler, kullanıcı ile daha hızlı ve etkin iletişim kurabilmek için önemlidir.",
            redicetFormAnswerDesc2: "Form cevapları ticket olarak sisteme yönlendirilir",
            rediectAnswersToTicket: "Gelen Cevapları Ticket Yönlendir",
            errorTicketMode: "Bilet modu güncellenirken hata oluştu:",
            formView: "Formu Görüntüle",
            formEdit: "Formu Güncelle",
            totalResponse: "Toplam Yanıt",
            totalUnreadResponse: "Toplam Okunmamış Yanıt",
            totalReadResponse: "Toplam Okunmuş Yanıt",
            totalArchivedResponse: "Toplam Arşivlenmiş Yanıt",
            singleChoice: "Tek Seçenek",
            _delete: "Sil",
            inbox: "Gelen Kutusu",
            edit: "Düzenle",
            forms: "Formlar",
            formsDesc: "Formlarınızı buradan yönetebilirsiniz.",
            createaForm: "Form Oluştur",
            allForms: "Tüm Formlar",
            formPublish: {
                shareFast: "HIZLI PAYLAŞ",
                shareFastDesc: "Doğrudan form bağlantısı ve sosyal paylaşım",
                add: "EKLE",
                addDesc: "Çeşitli web sayfası yerleştirme seçenekleri",
                assignForm: "FORMU ATA",
                assignFormDesc: "Formlarınızı başkalarına atayın",
                emails: "E-POSTALAR",
                emailsDesc: "Hatırlatmalar ve anlık paylaşım",
                prefill: "PREFILL",
                prefillDesc: "Formlarınızı önceden doldurun",
                pdf: "PDF",
                pdfDesc: "Doldurulabilir PDF dosyasını indirin",
                platforms: "PLATFORMLAR",
                platformsDesc: "Üçüncü taraf yayınlama seçenekleri",
                linkToYour: "FORMUNUZUN BAĞLANTI ADRESİ",
                linkToYourDesc: "Formunuz güvenli bir şekilde yayınlandı ve bu adreste kullanıma hazır.",
                shareWithLink: "BAĞLANTI İLE PAYLAŞ",
                publicForm: "Herkese Açık Form",
                copyLink: "BAĞLANTIYI KOPYALA",
                openInNewTab: "YENİ SEKMEDE AÇ",
                linkCopied: "Link Kopyalandı",
                codeCopied: "Kod Kopyalandı",
                iframe: "İframe",
                iframeDesc: "Formunu sayfanıza iFrame ile ekleyin",
                openWindow: "AÇILIR PENCERE",
                openWindowDesc: "Bir açılır pencere formuna bağlantı verin",
                formAddDesc: "Bu pasajı kopyalayıp kodunuza yapıştırın ve formunuzu web sitenize yerleştirin.",
            },
            formSettings: {
                enterNameForm: "Bu form için bir isim girin",
                selectStatusForm: "Formunuzun durumunu seçin",
                disabled: "Devre Dışı",
                disableSpecifiedTime: "Belirtilen bir zamanda ya da yanıt limitine ulaşıldığında devre dışı bırak",
                disableFormResponse: "Form Yanıtı limitine ulaşıldığında devre dışı bırak",
                pageShownAfterForm: "Form gönderildikten sonra gösterilen sayfa",
                formNotFound: "Form bulunamadı.",
                errorLoadingform: "Form yüklenirken bir hata oluştu.",
                formUpdated: "Form başlığı başarıyla güncellendi.",
                formErrorUpdated: "Form başlığı güncellenirken bir hata oluştu",
                formSettings: "FORM AYARLARI",
                changeFormStateAndProperties: "Form durumu ve özelliklerini değiştirin",
                title: "Başlık",
                newFormSettings: "Yeni Form Ayarları",
                formStatus: "Form Durumu",
                activateOrDeactivate: "Formunuzu etkinleştirin, devre dışı bırakın veya koşullu olarak etkinleştirin",
                effective: "ETKİN",
                yourFromIsVisible: "Formunuz şu anda görünür durumda ve form yanıtı alabiliyor",
                emails: "E-POSTALAR",
                emailsDesc: "Otomatik yanıtlayıcı e-postalar ve bildirim e-postaları gönderin",
                conditions: "KOŞULLAR",
                conditionsDesc: "Form girişlerine göre eylemleri tetikleyen koşullu mantık bölüm",
                thankYouPage: "TEŞEKKÜR SAYFASI",
                thankYouPageDesc: "Form gönderildikten sonra gösterilen sayfa",
                integretions: "ENTEGRASYONLAR",
                integretionsDesc: "Formunuzu diğer uygulamalara bağlayın",
            },
            clickToDeleteYourLogo: "Logonuzu silmek için tıklayın",
            create: "Oluştur",
            settings: "Ayarlar",
            load: "Yayınla",
            insertFormField: "Yeni Alanı Ekle",
            addYourLogo: "Logonuzu Ekleyin",
            surveyElements: {
                surveyElements: "Anket Elemanları",
                dataTable: "Veri Tablosu",
                starRating: "Yıldız Değerlendirme",
                evaluationScale: "Değerlendirme Ölçeği",
            },
            pageElements: {
                pageElements: "Sayfa Elemanları",
                separationElement: "Ayırma Elemanı",
                partitionCollapse: "Bölüm Daraltma",
                pageBreak: "Sayfa Sonu",
            },
            basicElements: {
                basicElements: "Temel Elemanlar",
                shortText: "Kısa Metin",
                longText: "Uzun Metin",
                paragraph: "Paragraf",
                dropDownList: "Açılır Liste",
                singleChoice: "Tekli Seçim",
                multipleSelection: "Çoklu Seçim",
                number: "Numara",
                image: "Resim",
                fileUpload: "Dosya Yükle",
                hour: "Saat",
                spinner: "Değer Değiştirici",
                send: "Gönder",
            },
            formElements: {
                formElements: "Form Elemanları",
                title: "Başlık",
                fullName: "Tam Ad",
                email: "E-Posta",
                address: "Adres",
                phone: "Telefon",
                datePicker: "Tarih",
                appointment: "Randevu",
                signature: "İmza",
                productList: "Ürün Listesi",
            },
            startWithaBlankForm: "Boş bir formla başlayın",
            startFromScratch: "Sıfırdan Başla",
            createOrTransferaForm: "Veri toplamaya başlamak için bir form oluşturun veya aktarın",
            createForm: "Form Oluşturun",
            trashBin: "Çöp Kutusu",
            formAutomations: "Form Otomasyonları",
            trashBinList: {
                title: "Çöp Kutusu",
                description: "Silinen formlarınız burada listelenmektedir",
                loading: "Silinmiş formlar yükleniyor...",
                restore: "Geri Yükle",
                permanentDelete: "Kalıcı Sil",
                delete: "Sil",
                emptyTitle: "Çöp kutusu boş",
                emptyDescription: "Silinmiş form bulunmamaktadır",
                totalResponses: "Toplam Cevap",
                unread: "Okunmamış",
                read: "Okunmuş",
                archived: "Arşivlenmiş",
                restoreConfirmDescription:
                    "Bu formu geri yüklemek istediğinize emin misiniz? Form ve tüm verileri aktif formlar listesine eklenecektir.",
                deleteConfirmDescription:
                    "Bu formu kalıcı olarak silmek istediğinize emin misiniz? Bu işlem geri alınamaz ve form ile ilişkili tüm veriler silinecektir.",
                deletedToday: "Bugün silindi",
                deletedYesterday: "Dün silindi",
                deletedDaysAgo: "{count} gün önce silindi",
                deletedWeeksAgo: "{weeks} hafta önce silindi",
                deletedMonthsAgo: "{months} ay önce silindi",
                restoreSuccess: "Form başarıyla geri yüklendi",
                restoreError: "Form geri yüklenirken bir hata oluştu",
                deleteSuccess: "Form kalıcı olarak silindi",
                deleteError: "Form silinirken bir hata oluştu",
            },
        },
        automation: {
            deleteAutomationsTitle: "Otomasyonları Sil",
            deleteAutomationsConfirmation:
                "{count} otomasyonu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            automationsMoveError: "Otomasyonlar taşınırken hata oluştu",
            noAutomationToMove: "Taşınacak otomasyon bulunamadı",
            deleteCategoryConfirmation:
                '"{categoryName}" kategorisini silmek istediğinizden emin misiniz? Bu kategorideki otomasyonlar "{generalCategory}" kategorisine taşınacak.',
            automationsMovedToCategory: '{count} otomasyon "{categoryName}" kategorisine taşındı',
            automationImportedSuccessfully: "{name} otomasyonu başarıyla içeri aktarıldı",
            automationPasteError: "Otomasyon yapıştırılırken hata oluştu",
            invalidAutomationExport: "Panoda geçerli bir Supsis otomasyon export'u bulunamadı",
            invalidAutomationJSON: "Panoda geçerli bir otomasyon JSON'u bulunamadı",
            clipboardNotSupported: "Bu tarayıcıda pano erişimi desteklenmiyor",
            automationJSONCopyError: "Otomasyon kopyalanırken hata oluştu",
            automationCopiedToClipboardFallback: "Otomasyon JSON olarak panoya kopyalandı (fallback method)",
            automationCopiedToClipboard:
                "Otomasyon JSON olarak panoya kopyalandı. Başka müşteri panelinde Ctrl+V ile yapıştırabilirsiniz.",
            automationCopyError: "Otomasyon kopyalanırken hata oluştu",
            automationCopied: "Otomasyon kopyalandı",
            automationMoveError: "Otomasyon taşınırken hata oluştu",
            automationMovedToCategory: 'Otomasyon "{categoryName}" kategorisine taşındı',
            categoryDeletedSuccessfully: "Kategori başarıyla silindi",
            categoryDeleteError: "Kategori silinirken hata oluştu",
            automationsDeleteError: "Otomasyonlar silinirken hata oluştu",
            automationsDeletedSuccessfully: "{count} otomasyon başarıyla silindi",
            categoryUpdatedSuccessfully: "Kategori güncellendi",
            categoryUpdateError: "Kategori güncellenirken hata oluştu",
            categorySaveError: "Kategori kaydedilirken hata oluştu",
            categoryCreatedSuccessfully: "Kategori oluşturuldu. Otomasyonları bu kategoriye sürükleyebilirsiniz.",
            categoryNameAlreadyExists: "Bu isimde bir kategori zaten mevcut",
            categoryNameRequired: "Kategori adı boş olamaz",
            moveAllAutomations: "Tüm Otomasyonları Taşı",
            deleteAutomations: "{count} otomasyon silindi",
            selectedAutomations: "{count} otomasyon seçildi",
            pasteInfoMessage:
                "Panoda kopyaladığınız otomasyon tespit edildi! Hemen <strong>Ctrl+V</strong> ile yapıştırarak yeni otomasyon oluşturun.",
            categoryName: "Kategori Adı",
            categoryNamePlaceholder: "Kategori adını girin",
            editCategory: "Kategoriyi Düzenle",
            deleteCategory: "Kategoriyi Sil",
            createCategory: "Kategori Ekle",
            publishAutomation: "Yayında",
            unpublishAutomation: "Durduruldu",
            timerAutomation: "Zamanlamalı",
            eventAutomation: "Olay",
            deleteAutomation: "Otomasyonu Sil",
            changeCategory: "Kategoriyi Değiştir",
            copyAutomation: "Otomasyonu Kopyala",
            copyAutomationAsJSON: "JSON Olarak Kopyala",
            emptyCategoryMessage: "Otomasyonları buraya sürükleyerek kategoriye ekleyebilirsiniz",
            newAutomation: "Yeni Otomasyon",
            whenFormSubmitted: "Bir form gönderildiğinde",
            taskCreated2: "Görev Oluşturuldu",
            waitingTaskCreation: "Görev Oluşturulmasını Bekliyor...",
            calendarEventCreated: "Takvimde etkinlik oluşturulduğunda",
            calendarEventUpdated: "Takvimde etkinlik güncellendiğinde",
            calendarEventDeleted: "Takvimde etkinlik silindiğinde",
            reservationCreated: "Rezervasyon oluşturulduğunda",
            reservationDateChanged: "Rezervasyon tarihi değiştiğinde",
            reservationDeleted: "Rezervasyon silindiğinde",
            chatLost: "Chat kaybedildiğinde",
            webchatCompleted: "Webden gelen chat tamamlanınca",
            instagramCompleted: "Instagram kanalından gelen chat tamamlanınca",
            messengerCompleted: "Messenger kanalından gelen chat tamamlanınca",
            whatsappCompleted: "Whatsapp kanalından gelen chat tamamlanınca",
            telegramCompleted: "Telegram kanalından gelen chat tamamlanınca",
            chatAssignedToAgent: "Chat bir temsilciye atandığında",
            profileButtonClicked: "Profilden otomasyon butonuna tıklandığında",
            operatedTask: "Çalıştırılan Görev",
            totalAutomations: "Toplam {count} otomasyon",
            totalAutomationsWithHidden: "Toplam {total} otomasyon ({visible} tanesi görüntülenebilir)",
            tableSelection: "Tablo Seçimi",
            selectTable: "Tablo Seçin",
            whichTableAutomationAddRecords:
                "Automasyonu hangi tabloya kayıt eklendiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            whichTableAutomationUpdateRecords:
                "Automasyonu hangi tablodaki bir kayıt güncellendiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            whichTableAutomationDeletedRecords:
                "Automasyonu hangi tablodan bir kayıt silindiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            whichTableAutomationClickRecords:
                "Automasyonu hangi tablodaki bir kayıt üzerindeki otomasyon düğmesine tıklandığında çalıştırmak istiyorsunuz? Lütfen seçim yapınız.",
            selectAtLeastOneField: "En az bir alan seçilmelidir",
            generalCategory: "Genel",
            configureTrackFields: "Takip Alanlarını Yapılandır",
            configureMessageFilter: "Mesaj Filtresi Yapılandır",
            makeFreeTier: "Ücretsiz Tier Yap",
            revertFreeTier: "Normal Tier Yap",
            webhook: "Webhook",
            system: "Sistem",
            freeTierTooltip: "Bu otomasyon ücretsiz tier kapsamındadır. Otomasyon kullanımı kotanızdan düşülmez.",
            freeTierBadge: "Ücretsiz Tier",
            trackFieldsLabel: "Takip Edilecek Alanlar",
            trackFieldsSelectPlaceholder: "En az bir alan seçilmezse tüm alanlar takip edilecektir",
            selectFieldPlaceholder: "Alan seçiniz",
            tableMustBeSelectedFirst: "Önce otomasyona bağlı tablo seçilmelidir",
            fieldsLoadError: "Alanlar yüklenirken hata oluştu",
            trackFieldsUpdated: "Takip edilecek alanlar güncellendi",
            updateError: "Güncelleme sırasında hata oluştu",
            automationMadeFreeTier: "Otomasyon ücretsiz tier yapıldı",
            makeFreeTierError: "Ücretsiz tier yapılırken hata oluştu",
            automationRevertedToNormalTier: "Otomasyon normal tier yapıldı",
            revertFreeTierError: "Normal tier yapılırken hata oluştu",
            wrongPassword: "Yanlış şifre!",
            configLoadError: "Yapılandırma yüklenirken hata oluştu",
            messageFilterConfigUpdated: "Mesaj filtresi yapılandırması güncellendi",
            freeTierPasswordPrompt: "Ücretsiz tier yapmak için şifreyi giriniz:",
            planStatus: "Plan Durumu",
            scheduled: "Planlanmış",
            completed: "Tamamlandı",
            cancelled: "İptal Edildi",
            startTest: "Teste Başla",
            unpublish: "Yayından Kaldır",
            whenMessagePicked: "Sohbet arayüzü üzerinden bir mesaj seçildiğinde",
            whenTaskCompleted: "Bir görev tamamlandığında",
            whenTaskDeleted: "Bir görev silindiğinde",
            whenTaskAssigneeChanged: "Bir görev atanan kişi değiştirildiğinde",
            whenTaskPriorityChanged: "Bir görev önceliği değiştirildiğinde",
            whenTaskDueDateChanged: "Bir görevin son tarihi değiştirildiğinde",
            whenTaskStatusChanged: "Bir görev durumu değiştirildiğinde",
            whenTaskArchived: "Bir görev arşivlendiğinde",
            whenTagAdded: "Göreve bir etiket eklendiğinde",
            whenTagRemovedTask: "Bir etiket görevden kaldırıldığında",
            whenTagChecklist: "Bir görev kontrol listesi tamamlandığında",
            whenReminderActivated: "Bir hatırlatıcı etkinleştirildiğinde",
            whenTicketCreated: "Ticket Oluşturulduğunda",
            whenTicketStageChanged: "Bir ticket aşaması değiştirildiğinde",
            whenTicketAssigneeChanged: "Bir ticket atayıcısı değiştirildiğinde",
            whenTicketClosed: "Bir ticket kapatıldığında",
            whenTicketUpdated: "Bir ticket güncellendiğinde",
            whenVoiceAgentCallStarted: "Bir yapay zeka araması başladığında",
            whenVoiceAgentCallEnded: "Bir yapay zeka araması bitiğinde",
            whenVoiceAgentCallAnalyzed: "Bir yapay zeka araması analiz edildiğinde",
            autoPlanAndTaskHistory: "Otomasyon Planı ve Görev Geçmişi",
            automation: "Otomasyon",
            botScenario: "Bot Senaryosu",
            nameSurname: "Ad Soyad",
            phone164: "*E164 formatında giriniz. Örneğin: 905396667744",
            whichWpChannels: "Hangi Whatsapp Kanallarına Eklensin?",
            findContact: "İletişim Bulun",
            findContacts: "İletişimleri Bulun",
            offsetDesc: "İlk N kişiyi atlayın. Varsayılan değer '0'. Kişiler arasında ilerlemek için bunu kullanın.",
            limitDesc:
                "Ofsetten sonra döndürülecek maksimum kişi sayısı. Varsayılan değer '10'. Sayfalandırmak için bunu kullanın",
            contact: "Kişi",
            selectAction: "Aksiyon Seç",
            addMethod: "Yöntem Ekleme",
            selectField: "Alan Seç",
            schedulerRunningPlanEx: "Zamanlayıcı Çalışma Planı Örneği",
            schedulerPlanner: "Zamanlayıcı Planlayıcı",
            taskCreated: "Görev Oluşturuldu mu?",
            taskStatus: "Görev Durumları",
            terminateReason: "Sonlanma Nedeni",
            taskDuration: "Görev Süresi",
            taskWakeUpCount: "Görev Uyandırma Sayısı",
            completedAt: "Tamamlandı",
            cancelledAt: "İptal Edildi",
            nextRunAt: "Bir Sonraki Çalıştırma",
            configSchedulerAuto: "Otomasyon için Zamanlayıcıyı Yapılandırma",
            saveChanges: "Değişiklikleri Kaydet",
            catchAllWebhooks: "Bu URL'den Tüm Webhook'ları Yakala",
            webhookDataExPreview: "Webhook Veri Örneği Önizlemesi (istek gönderdikten sonra gösterilecektir)",
            webhookUrlCopied: "Webhook URL'si panoya kopyalandı",
            selectAnBlock: "Bir Block Seçin",
            dataFormats: "Veri Formatları",
            whenRecordCreated: "Bir kayıt oluşturulduğunda",
            whenRecordUpdated: "Bir kayıt güncellendiğinde",
            whenRecordDelete: "Bir kayıt silindiğinde",
            whenRecordAutomation: "Bir kayıt otomasyonu düğmesine tıklandığında",
            whenWebhookTriggered: "Bir web kancası tetiklendiğinde",
            whenChatCreated: "Bir sohbet oluşturulduğunda",
            whenChatClosed: "Bir sohbet kapatıldığında",
            whenChatRated: "Bir sohbet derecelendirildiğinde",
            whenNewContactCreated: "Yeni bir kişi oluşturulduğunda",
            whenContactUpdate: "Bir kişi güncellendiğinde",
            whenContactPropUpdate: "Bir kişi özelliği güncellendiğinde",
            whenNewTagAdded: "Yeni bir etiket eklendiğinde",
            whenTagRemoved: "Bir etiket kaldırıldığında",
            whenNewEmailReceived: "Yeni bir e-posta alındığında",
            whenNewTaskCreated: "Yeni bir görev oluşturulduğunda",
            whenNewMetaleadCreated: "Yeni bir meta-lider oluşturulduğunda",
            whenNewAgentCreated: "Yeni bir müşteri temsilcisi oluşturulduğunda",
            whenAgentOnline: "Bir müşteri temsilcisi çevrimiçi olduğunda",
            whenAgentOffline: "Bir müşteri temsilcisi çevrimdışı olduğunda",
            whenAgentStatusChanged: "Bir müşteri temsilcisinin durumu değiştiğinde",
            whenAgentLogin: "Bir müşteri temsilcisi giriş yaptığında",
            whenNewInvoiceCreated: "Yeni bir fatura oluşturulduğunda",
            whenNewWpReceived: "Yeni bir WhatsApp mesajı alındığında",
            whenNewReservationCreated: "Yeni bir rezervasyon oluşturulduğunda",
            whenNewChatbotReceived: "Yeni bir chatbot mesajı alındığında",
            chatWebhookAutomation: "Webhook Tetiklendiğinde Bir Otomasyon Çalıştır",
            createAnEventAutomation: "Bir Olay Tabanlı Otomasyon Oluşturun",
            automationName: "Otomasyon Adı",
            supsisObject: "Supsis Objesi",
            selectModule: "Model Seç",
            bodyType: "Gövde Türü",
            selectBodyType: "Gövde Türü Seç",
            selectMethod: "Method Seç",
            trigger: "Tetikleyici",
            published: "Yayınlandı",
            createdAt: "Oluşturuldu",
            action: "Eylem",
            type: "Tür",
            view: "Görüntüle",
            createTimerAutomation: "Zamanlayıcı Otomasyonu Oluştur",
            createEventBasedAutomation: "Olay Tabanlı Otomasyonu Oluştur",
            createWebhookAutomation: "Webhook Otomasyonu Oluştur",
            automationsCouldNotBeDeleted: "Otomasyonlar Silinemedi",
            timerAutomationCreatedSuccessfully: "Zamanlayıcı Otomasyonu Başarıyla Oluşturuldu",
            eventAutomationCreatedSuccessfully: "Olay Otomasyonu Başarıyla Oluşturuldu",
            webhookAutomationCreatedSuccessfully: "Webhook Otomasyonu Başarıyla Oluşturuldu",
            automationsCouldNotBeFetched: "Otomasyonlar Alınamadı",
            automationPublishedStateUpdatedSuccessfully: "Otomasyon Yayın Durumu Başarıyla Güncellendi",
            automationPublishedStateCouldNotBeUpdated: "Otomasyon Yayın Durumu Güncellenemedi",
            automations: "Otomasyonlar",
            allAutomations: "Tüm Otomasyonlar",
            scheduledAutomations: "Zamanlanmış Otomasyonlar",
            eventBasedAutomations: "Etkinlik Tabanlı Otomasyonlar",
            buttonAutomations: "Buton Otomasyonları",
            webhookAutomations: "Webhook Otomasyonları",
            analytics: "Analiz",
            insights: "İstatistikler",
            trash: "Çöp Kutusu",
            sandboxPage: {
                title: "Otomasyon Silinen Senaryolar",
                description:
                    "İşlem yapılmayan geri yüklenmeyen otomasyonlar 30 gün içinde sistem tarafından silinecektir",
                emptyState: "Çöp sepetinde silinen otomasyon bulunmuyor",
                unnamedAutomation: "İsimsiz Otomasyon",
                restore: "Geri Yükle",
                timerAutomation: "Zamanlayıcı Otomasyonu",
                eventAutomation: "Olay Otomasyonu",
                webhook: "Webhook",
                buttonAutomation: "Buton Otomasyonu",
                tableButtonAutomation: "Tablo Buton Otomasyonu",
                chatbotAutomation: "Chatbot Otomasyonu",
                unknown: "Bilinmiyor",
                user: "Kullanıcı",
                restoreConfirmTitle: "Otomasyonu Geri Yüklemek İstediğinize Emin Misiniz?",
                restoreConfirmContent: "{name} otomasyonu geri yüklenecek.",
                restoreSuccess: "Otomasyon geri yüklendi",
                restoreFailed: "Geri yükleme başarısız oldu",
                loadError: "Silinen otomasyonlar yüklenirken hata oluştu",
            },
            insightsPage: {
                title: "Otomasyon İstatistikleri",
                selectAutomation: "Otomasyon Seçin",
                dateRange: "Tarih Aralığı",
                datePlaceholderStart: "Başlangıç",
                datePlaceholderEnd: "Bitiş",
                lastWeek: "Son Hafta",
                lastMonth: "Son Ay",
                last3Months: "Son 3 Ay",
                statusFilter: "Durum Filtresi",
                statusScheduled: "Planlanmış",
                statusRunning: "Çalışıyor",
                statusWaitingReply: "Yanıt Bekliyor",
                statusDone: "Tamamlandı",
                statusFailed: "Başarısız",
                statusCancelled: "İptal Edildi",
                clearFilters: "Filtreleri Temizle",
                refreshData: "Verileri Yenile",
                activeFilters: "Aktif Filtreler:",
                totalTasks: "Toplam Görevler",
                executedTasks: "Yürütülen Görevler",
                successRate: "Başarı Oranı",
                successfulTasks: "Başarılı Görevler",
                avgDuration: "Ortalama Süre",
                avgWorkDuration: "Ortalama Çalışma Süresi",
                activeTasks: "Aktif Görevler",
                runningNow: "Şu Anda Çalışıyor",
                dailyTaskExecution: "Günlük Görev Çalıştırma",
                statusDistribution: "Durum Dağılımı",
                durationDistribution: "Süre Dağılımı",
                terminateReasons: "Sonlandırma Nedenleri",
                automationPerformance: "Otomasyon Performansı",
                view: "Görüntüle",
                automationName: "Otomasyon Adı",
                executionCount: "Çalıştırma Sayısı",
                actions: "İşlemler",
                totalTasksLegend: "Toplam Görevler",
                successfulLegend: "Başarılı",
                failedLegend: "Başarısız",
                taskCount: "Görev Sayısı",
                ms: "ms",
                sec: "sn",
                min: "dk",
                hour: "sa",
                automationsLoadError: "Otomasyonlar listelenirken bir hata oluştu",
                insightsLoadError: "İstatistikleri alırken bir hata oluştu",
            },
            settingsWidget: {
                viewActivityLogs: "Hareket Loglarını Gör",
                activityLogsTitle: "Hareket Logları",
                activityLogsEmpty: "Henüz hareket kaydı bulunmuyor",
                activityLogsLoadError: "Hareket logları yüklenirken bir hata oluştu",
                exportedToClipboard: "Otomasyon panoya kopyalandı",
                settings: "Ayarlar",
            },
            enablePreFilters: "Ön Filtreleri Etkinleştir",
            preFilterDescription:
                "Ön filtreler, otomasyonun hangi durumlarda çalışacağını belirlemenizi sağlar. Etkinleştirdiğinizde sadece belirlediğiniz koşullara uyan olaylar için otomasyon tetiklenecektir.",
            preFilters: "Ön Filtreler",
            executionRules: "Çalışma Kuralları",
            preFilterInfo:
                "Ön filtreler ile otomasyonun hangi durumlarda çalışacağını belirleyebilirsiniz. Sadece belirlediğiniz koşullara uyan olaylar için otomasyon tetiklenecektir.",
            preFiltersSaved: "Ön filtreler başarıyla kaydedildi",
            preFiltersSaveError: "Ön filtreler kaydedilirken hata oluştu",
            configurePreFilters: "Ön Filtreleri Yapılandır",
            preFiltersConfiguration: "Ön Filtre Yapılandırması",
            executionPrivacyTitle: "Çalıştırma Yetkisi",
            executionPrivacyDescription:
                "Bu otomasyonu hangi kullanıcılar veya departmanlar çalıştırabilir? Boş bırakırsanız tüm kullanıcılar çalıştırabilir.",
            executionPrivacyPublic: "Tüm kullanıcılar bu otomasyonu çalıştırabilir",
            configureExecutionPrivacy: "Çalıştırma Yetkisini Ayarla",
            executionPrivacyConfiguration: "Çalıştırma Yetkisi Yapılandırması",
            executionPrivacySaved: "Çalıştırma yetkisi başarıyla kaydedildi",
            executionPrivacySaveError: "Çalıştırma yetkisi kaydedilirken hata oluştu",
            editDescription: "Açıklamayı Düzenle",
            addDescription: "Açıklama ekle...",
            descriptionPlaceholder: "Otomasyon açıklamasını girin...",
            descriptionSaved: "Açıklama başarıyla kaydedildi",
            descriptionSaveError: "Açıklama kaydedilirken hata oluştu",
            permissions: {
                title: "Erişim Yetkileri",
                mode: "Yetki Modu",
                publicMode: "Herkese Açık",
                customMode: "Özel",
                publicModeDesc: "Tüm kullanıcılar bu otomasyona erişebilir ve düzenleyebilir.",
                customModeDesc: "Sadece belirlenen kullanıcılar ve departmanlar bu otomasyona erişebilir.",
                confirmPublicMode: "Herkese Açık Moda Geç",
                confirmPublicModeDesc:
                    "Bu işlem sonrasında tüm kullanıcılar bu otomasyona erişebilecektir. Devam etmek istiyor musunuz?",
                addUser: "Kullanıcı Ekle",
                addDepartment: "Departman Ekle",
                selectUser: "Kullanıcı seçin",
                selectDepartment: "Departman seçin",
                add: "Ekle",
                targetHeader: "Kullanıcı/Departman",
                matrixInfo: "Her kullanıcı veya departman için izin vermek istediğiniz yetkileri işaretleyin.",
                noTargetsAdded: "Henüz kullanıcı veya departman eklenmedi. Yetki vermek için yukarıdan ekleyin.",
                confirmRemoveTarget: "Yetkiyi Kaldır",
                confirmRemoveTargetDesc:
                    "Bu kullanıcı veya departmanın yetkilerini kaldırmak istediğinize emin misiniz?",
                saveSuccess: "Erişim yetkileri başarıyla kaydedildi",
                saveError: "Erişim yetkileri kaydedilirken hata oluştu",
                unknownUser: "Bilinmeyen Kullanıcı",
                unknownDepartment: "Bilinmeyen Departman",
                noReadAccess: "Bu otomasyona erişim yetkiniz bulunmamaktadır.",
                usersTab: "Kullanıcılar",
                departmentsTab: "Departmanlar",
                authorizedUsers: "Yetkili Kullanıcılar",
                otherUsers: "Diğer Kullanıcılar",
                authorizedDepartments: "Yetkili Departmanlar",
                otherDepartments: "Diğer Departmanlar",
                cannotChangeOwnPermission: "Kendi yetkinizi değiştiremezsiniz",
                you: "Siz",
                customPermissionDefined: "Bu kullanıcı için özel yetki tanımlanmış",
                customPermission: "Özel Yetki",
                grantPermission: "Yetki Ver",
                revokePermission: "Yetkiyi Kaldır",
                applyToOthers: "Diğer Otomasyonlara Uygula",
                applyToOthersDesc: "Bu yetki ayarlarını seçeceğiniz diğer otomasyonlara uygulayın",
                applyToOthersTitle: "Yetki Ayarlarını Diğer Otomasyonlara Uygula",
                applyToOthersWarning:
                    "Seçilen otomasyonların mevcut yetki ayarları bu otomasyonun ayarlarıyla değiştirilecektir.",
                selectAll: "Tümünü Seç",
                deselectAll: "Tümünün Seçimini Kaldır",
                selectedCount: "{count} otomasyon seçildi",
                applyToSelected: "Seçilenlere Uygula",
                noAutomationsFound: "Otomasyon bulunamadı",
                searchPlaceholder: "Otomasyon veya kategori ara...",
                applySuccess: "{count} otomasyona yetki ayarları başarıyla uygulandı",
                applyFailed: "{count} otomasyona yetki ayarları uygulanamadı",
                applyError: "Yetki ayarları uygulanırken hata oluştu",
                groups: {
                    basic: "Temel",
                    flow: "Akış",
                    meta: "Bilgiler",
                    publish: "Yayın",
                    actions: "İşlemler",
                    plan: "Plan",
                    filter: "Filtre",
                },
                scopes: {
                    read: "Görüntüle",
                    readDesc: "Otomasyonu görüntüleme yetkisi",
                    flowUpdate: "Akışı Düzenle",
                    flowUpdateDesc: "Otomasyon bloklarını ekleme, çıkarma ve düzenleme yetkisi",
                    metaUpdate: "Bilgileri Düzenle",
                    metaUpdateDesc: "Otomasyon adı, açıklaması ve kategorisini düzenleme yetkisi",
                    publish: "Yayınla",
                    publishDesc: "Otomasyonu yayınlama ve yayından kaldırma yetkisi",
                    delete: "Sil",
                    deleteDesc: "Otomasyonu silme yetkisi",
                    duplicate: "Kopyala",
                    duplicateDesc: "Otomasyonu kopyalama yetkisi",
                    planView: "Planları Gör",
                    planViewDesc: "Otomasyon çalışma planlarını görme yetkisi",
                    planCancel: "Plan İptal",
                    planCancelDesc: "Zamanlanmış planları iptal etme yetkisi",
                    reschedule: "Yeniden Planla",
                    rescheduleDesc: "Otomasyonu yeniden planlama yetkisi",
                    prefilterUpdate: "Filtre Düzenle",
                    prefilterUpdateDesc: "Ön filtre yapılandırmasını düzenleme yetkisi",
                },
            },
            makePublicExecution: "Herkese Açık Yap",
            makePublicExecutionConfirmTitle: "Bu otomasyonu herkese açık yapmak istediğinize emin misiniz?",
            makePublicExecutionConfirmContent: "Bu işlem sonrasında tüm temsilciler bu otomasyonu çalıştırabilecektir.",
            madePublicExecution: "Otomasyon herkese açık hale getirildi",
            blocks: {
                ADD_TO_SEGMENT: "SEGMENTE EKLE",
                REMOVE_FROM_SEGMENT: "SEGMENTTEN KALDIR",
                START_POINT: "BAŞLANGIÇ NOKTASI",
                AI_ASSISTANT: "YAPAY ZEKA ASISTAN",
                FEEDBACK_AI_ASSISTANT: "Asistana Bilgi Ver",
                INSERT_TO_SYSTEM_PROMPT: "Sistem Promptuna Mesaj Ekle",
                BOT_RESPONSE: "BOT'UN YANITI",
                AI_CALL: "YAPAY ZEKA ARAMA",
                TAVILY_WEB_SEARCH: "WEB ARAMA",
                AI_BOT_RESPONSE: "YZ YANIT (GPT-4o)",
                AI_CLASSIFICATION: "YZ SINIFLANDIR",
                AI_MENU_FLOW: "Hazır Menü Flow",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATFORM",
                DEFAULT_FALLBACK: "VARSAYILAN AKSİ DURUM",
                DEFAULT_TIMEOUT: "VARSAYILAN Zaman Aşımı",
                AI_FUNCTIONS: "YZ FONKSIYON",
                FILTER: "FİLTRE",
                FLOW: "AKIŞ",
                ATTACHMENT_INPUT: "DOSYA GİRİŞİ",
                USER_INPUT: "KULLANICI GİRİŞİ",
                GO_TO_STEP: "ADIM'A GİT",
                WEBHOOK: "WEBHOOK",
                SEND_JSON_RESPONSE: "WEBHOOK YANIT GÖNDER",
                RUN_JAVASCRIPT: "JAVASCRIPT ÇALIŞTIR",
                SET_ATTRIBUTE: "ÖZELLİK AYARLA",
                QUESTION: "SORU",
                CLOSE_CHAT: "SOHBETİ KAPAT",
                CREATE_TICKET: "TICKET OLUŞTUR",
                TICKET_UPDATE: "TICKET GÜNCELLE",
                TRANSFER_CHAT: "SOHBETİ AKTAR",
                TRANSFER_TO_CHATBOT: "CHATBOTA YÖNLENDİR",
                TAG_CHAT: "ETIKET EKLE",
                REMOVE_TAG: "ETIKET SIL",
                SET_DEPARTMENT: "DEPARTMANA AYARLA",
                SEND_TRANSCRIPT: "TRANSKRİPT GÖNDER",
                SEND_SMS: "SMS GONDER",
                SEND_MAIL: "MAIL GONDER",
                CREATE_EVENT: "ETKİNLİK OLUŞTUR",
                CREATE_RESERVATION: "REZERVASYON OLUŞTUR",
                RESERVATION_OPEN_URL: "Rezervasyon Ekranı Görüntüle",
                RESERVATION_SELECT_DAY: "Rezervasyon günü seç",
                RESERVATION_EVENT_LIST: "Müşteri Rezervasyon Listesi",
                RESERVATION_SELECT_TIME: "Rezervasyon saati seç",
                CREATE_TASK: "GÖREV OLUŞTUR",
                UPDATE_TASK: "GÖREV GÜNCELLE",
                CACHE_WRITE: "CACHE YAZ",
                CACHE_READ: "CACHE OKU",
                CACHE_EXTEND: "CACHE SÜRESİNİ UZAT",
                CACHE_DELETE: "CACHE SİL",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY ÜRÜNLERİ GÖSTER",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY ÜRÜN VARLIĞI",
                SHOPIFY_ORDER_STATUS: "MAĞAZA SİPARİŞ DURUMU",
                AKINON_SHOW_PRODUCTS: "AKINON ÜRÜN GÖSTER",
                AKINON_FIND_PRODUCT: "AKINON ÜRÜN BUL",
                AKINON_ORDER_STATUS: "AKINON SİPARİŞ DURUMU",
                AKINON_SELECT_ORDER: "AKINON SİPARİŞ SEÇ",
                AKINON_SELECT_SIZE: "AKINON BEDEN SEÇ",
                AKINON_FIND_NEAREST_STOCK: "MAĞAZA STOK GÖSTER",
                AKINON_FIND_NEAREST_STORES: "YAKIN MAĞAZALARI GÖSTER",
                AKINON_SHOW_DISCOUNT_CODES: "İNDİRİM KODU GÖSTER",
                IDEASOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
                IDEASOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
                IDEASOFT_GET_MEMBER_INFO: "ÜYE DETAY GETİR",
                TSOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
                TSOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
                TICIMAX_V2_SELECT_ORDER: "Sipariş Seç",
                TICIMAX_V2_ORDER_STATUS: "Sipariş Durum Çek",
                IKAS_GET_MEMBER_INFO: "Uye Detay Getir",
                IKAS_SELECT_ORDER: "Sipariş Seç",
                IKAS_ORDER_STATUS: "Sipariş Durum Çek",
                META_SEND_CAPI_EVENT: "CAPI EVENT GÖNDER",
                GET_LOCATION: "KONUM AL",
                FALLBACK: "AKSİ DURUM",
                TIMEOUT: "ZAMAN AŞIMI",
                SUCCESS: "BAŞARILI",
                FAILURE: "BAŞARISIZ",
                PROBEL_SELECT_BRANCH: "Branş Seç",
                PROBEL_SELECT_CLINIC: "Poliklinik Seç",
                PROBEL_SELECT_DAY: "Randevu Günü Seç",
                PROBEL_SELECT_HOUR: "Randevu Saati Seç",
                PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
                PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
                PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
                PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
                PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
                SUPPRESSION_ADD: "Kullanıcı Engelle",
                SUPPRESSION_REMOVE: "Kullanıcı Engel Kaldır",
                SEND_WP_BUSINESS_MESSAGE: "WHATSAPP MESAJ GÖNDER",
                MESSENGER_SEND_MESSAGE: "Messenger Mesaj Gönder",
                INSTAGRAM_SEND_MESSAGE: "Instagram Mesaj Gönder",
                INSTAGRAM_COMMENT_REPLY: "Yorumu Yanıtla",
                INSTAGRAM_COMMENT_DELETE: "Yorumu Sil",
                INSTAGRAM_COMMENT_SHOW: "Yorumu Göster",
                INSTAGRAM_COMMENT_HIDE: "Yorumu Gizle",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "Yoruma DM Yanıt",
                ASSIGN_OWNER: "Sahiplik Atama",
                YOUTUBE_REPLY_COMMENT: "Yorumu Yanıtla",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Yorum Durumunu Güncelle",
                YOUTUBE_SET_MODERATION_STATUS: "Yorum Moderasyon Durumunu Ayarla",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Yorumu Yanıtla",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Yorum Durumunu Güncelle",
                GOOGLE_PLAY_REPLY_REVIEW: "Yorumu Yanıtla",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Yorum Durumunu Güncelle",
                APP_STORE_REPLY_REVIEW: "Yorumu Yanıtla",
                APP_STORE_UPDATE_REVIEW_STATUS: "Yorum Durumunu Güncelle",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Yorum Yanıtını Sil",
                LOOP: "Döngü",
                LOOP_NEXT: "Sıradaki Veri",
                LOOP_BREAK: "Döngüyü Durdur",
                LOOP_CONTINUE: "Sıradakine Geç",
                LOOP_FINISH: "Döngü Bitti",
                REPLY_TRENDYOL_QUESTION: "Trendyol Soru Cevapla",
                SLEEP: "Uyu ve Bekle",
                NOOP: "Hiçbirşey Yapma",
                CATCH_WEBHOOK: "Webhook Yakala",
                TERMINATE_AUTOMATION: "Otomasyon Sonlandı",
                CREATE_CONTACT: "Kişi Kartı Oluştur",
                UPDATE_CONTACT: "Kişi Güncelle",
                FIND_CONTACTS: "Kişileri Bul",
                FIND_CONTACT: "Kişi Bul",
                FIND_CHATS: "Görüşmeleri Bul",
                FIND_CHAT: "Görüşme Bul",
                WAIT_FOR: "Mesaj Bekle",
                STRING_FORMAT: "Yazıyı Formatla",
                NUMBER_FORMAT: "Sayıları Formatla",
                DATE_FORMAT: "Tarihleri Formatla",
                RECORDS_FROM_CSV: "CSV Kayıt Topla",
                MESSAGE_RECEIVED: "Mesaj Geldi",
                ASK_AI: "Yapay Zeka",
                OPENROUTER_RESPONSE: "OpenRouter AI Cevabı",
                OPENAI_RESPONSE: "OpenAI ile Cevap Üret",
                GOOGLE_AI_RESPONSE: "Google AI ile Cevap Üret",
                ANTHROPIC_RESPONSE: "Anthropic ile Cevap Üret",
                MISTRAL_RESPONSE: "Mistral ile Cevap Üret",
                AZURE_RESPONSE: "Azure ile Cevap Üret",
                BEDROCK_RESPONSE: "AWS Bedrock ile Cevap Üret",
                COHERE_RESPONSE: "Cohere ile Cevap Üret",
                XAI_RESPONSE: "xAI ile Cevap Üret",
                DEEPINFRA_RESPONSE: "DeepInfra ile Cevap Üret",
                TOGETHER_RESPONSE: "Together ile Cevap Üret",
                FIREWORKS_RESPONSE: "Fireworks ile Cevap Üret",
                SILICONFLOW_RESPONSE: "SiliconFlow ile Cevap Üret",
                PARASAIL_RESPONSE: "Parasail ile Cevap Üret",
                NEBIUS_RESPONSE: "Nebius ile Cevap Üret",
                ALIBABA_RESPONSE: "Alibaba ile Cevap Üret",
                XIAOMI_RESPONSE: "Xiaomi ile Cevap Üret",
                SAMBANOVA_RESPONSE: "SambaNova ile Cevap Üret",
                MOONSHOT_RESPONSE: "Moonshot ile Cevap Üret",
                MINIMAX_RESPONSE: "MiniMax ile Cevap Üret",
                NVIDIA_RESPONSE: "NVIDIA ile Cevap Üret",
                TABLE_CREATE_RECORD: "Kayıt Oluştur",
                TABLE_DELETE_RECORD: "Kayıt Sil",
                TABLE_UPDATE_RECORD: "Kayıt Güncelle",
                TABLE_FIND_RECORD: "Kayıt Bul",
                TABLE_FIND_RECORDS: "Kayıt Listele",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Kayıt Bul (Telefon ile)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Kayıta Dosya Ekle",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Özel Alana Resim Yükle",
                ZOHO_CREATE_RECORD: "Zoho Kayıt Oluştur",
                GET_SUPSIS_RECORD_BY_ID: "Kayıt Al",
                SHOW_WIDGET: "Widget Görüntüle",
                GOOGLE_DRIVE_UPLOAD_FILE: "Dosya Yükle",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "Dosya İndir",
                GOOGLE_DRIVE_GET_FILE_INFO: "Dosya Bilgisi Al",
                GOOGLE_DRIVE_DELETE_FILE: "Dosya Sil",
                FALLIMENTO: "BAŞARISIZ",
                OPENAI_WEB_SEARCH: "WEB ARAMA (OPENAI)",
                OPEN_AI: "OPEN_AI",
                PLATTFORM_FLOW: "PLATFORM AKIŞI",
                PUNTO_INICIO: "BAŞLANGIÇ NOKTASI",
                SUCCESSO: "BAŞARILI",
                autoForwardToOwnerForce: "Otomatik Temsilciye Yönlendir (Chatbot aktif olsa bile)",
            },
            openrouterResponse: "OpenRouter AI Cevabı",
            selectProvider: "Provider Seçin",
            modelName: "Model",
            modelHint: "Örn: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "Sistem Talimatları (Opsiyonel)",
            systemInstructionsPlaceholder: "AI'a nasıl davranması gerektiğini söyleyin...",
            promptPlaceholder: "AI'a sormanız gereken soruyu yazın...",
            advancedSettings: "Gelişmiş Ayarlar",
            temperatureHint: "Düşük değerler daha tutarlı, yüksek değerler daha yaratıcı cevaplar üretir (0-2)",
            maxTokens: "Max Tokens",
            maxTokensHint: "Üretilecek maksimum token sayısı",
            maxTokensPlaceholder: "Varsayılan: Model limiti",
            selectChannel: "Kanal Seçin (Opsiyonel)",
            autoSelectChannel: "Otomatik seç",
            archivingDate: "Arşivleme Tarihi",
            automationPublishedStateUpdatedSupdatedSuccessfully: "Otomasyon yayılama durumu başarıyla güncellendi",
            automationsCouldNouldNotBeFetched: "Otomasyonlar getirilemedi",
            automazioni: "Otomasyonlar",
            cancelado: "İptal Edildi",
            webhookAutomationCutomationCreatedSuccessfully: "Webhook otomasyonu başarıyla oluşturuldu",
        },
        tables: {
            widgetName: "Widget Adı",
            enterWidgetName: "Widget adını giriniz",
            renameWidget: "Widget'ı Yeniden Adlandır",
            assistantCapabilities: "Asistan Yetenekleri",
            addNewFieldsToTable: "Tabloya yeni alanlar ekleyebilir",
            editExistingFields: "Mevcut alanları düzenleyebilir",
            deleteUnnecessaryFields: "İhtiyaç duyulmayan alanları silebilir",
            filterRecords: "Kayıtları filtreleyebilir",
            groupRecords: "Kayıtları gruplandırabilir",
            hideFieldsCapability: "Alanları gizleyebilir",
            createConditionalFormatting: "Koşullu renklendirme oluşturabilir",
            createCalculationFormulas: "Hesaplama formülleri oluşturabilir",
            createSampleRecords: "Örnek kayıtlar oluşturabilir",
            examplePrompt: "Örnek: Bu tabloya müşteri bilgileri için Ad, Soyad, E-posta ve Telefon alanları ekle...",
            supsisAssistantTables: "Supsis Asistan: Tablolar",
            supsisAssistantWritePrompt: "Supsis Asistan'a ne yapmak istediğinizi anlatın",
            supsisAssistantExamplePrompt:
                "Toplantı takibi yapmak için bir tablo oluştur. Toplantı konusu, tarih, katılımcılar, sorumlu kişi, alınan kararlar, takip aksiyonları gibi alanlar olsun.",
            sendSupsisAssistant: "Supsis Asistan'a İlet",
            examplePromptsTitle: "Örnek İstekler:",
            examplePrompts: {
                addCustomerInfoFields: "Bu tabloya müşteri bilgileri için Ad, Soyad, E-posta ve Telefon alanları ekle.",
                addOrderFields:
                    "Siparişler tablosuna Ürün Adı, Miktar, Birim Fiyat, Toplam Tutar ve Sipariş Tarihi alanları ekle.",
                addBirthDateField: "Bu tabloya Doğum Tarihi alanı ekle ve tarih formatını DD/MM/YYYY şeklinde ayarla.",
                updateStatusField:
                    "Durumu alanını güncelle, dropdown tipi yap ve Beklemede, İşleniyor, Tamamlandı, İptal seçenekleri olsun.",
                replaceAddressFields:
                    "Adres alanını sil ve yerine Adres Satırı 1, Adres Satırı 2, İlçe, İl ve Posta Kodu alanları ekle.",
                alignTextFields:
                    "Tüm yazı alanlarını orta hizalı yap ve metinlerin maksimum uzunluğunu 100 karakter ile sınırla.",
                addAutoIncrementID: "Otomatik artan bir ID alanı ekle, ürün için prefix olarak PRD- kullansın.",
                addTotalAmountFormula:
                    "Toplam tutar alanını formül olarak ekle, miktar ve birim fiyatın çarpımını hesaplasın.",
                createActiveCustomersFilter: "Sadece aktif müşterileri görmek için bir filtre oluştur.",
                filterRecentUsers: "Son 30 gün içinde kayıt olan kullanıcıları filtrele.",
                groupByStatus: "Durum sütununa göre kayıtları gruplandır.",
                hideAllExceptDeliveryAndOrderNo: "Teslim Tarihi ve Sipariş No dışındaki tüm alanları gizle.",
                colorCodeOrders:
                    "Gecikmiş siparişleri kırmızı, bugün teslim edilecekleri sarı, tamamlananları yeşil renklendir.",
                highlightHighPaymentRecords: "Ödeme tutarı 1000 TL üzerinde olan kayıtları mor ile vurgula.",
                groupAndHighlightUnpaidOrders: "Sipariş tarihine göre grupla ve ödemesi yapılmayanları kırmızı göster.",
                createSampleRecords: "Bu tabloya 10 adet örnek kayıt oluştur.",
                addSampleRecordsForAliAndAhmet: "Müşteri adı Ali ve Ahmet olan 5 adet örnek kayıt ekle.",
                createRandomSampleOrders: "20 adet örnek sipariş kaydı oluştur ve durumları rastgele belirle.",
                hrCandidateTracking:
                    "HR süreçlerimiz için Aday takip yazılımı yapmak istiyorum (ATS). Bir ATS'de olması gereken herşey olsun. Türkçe isimlendirme kullan.",
                crmModuleCreation:
                    "Müşteri ilişkileri yönetimi (CRM) için gerekli olan tüm modülleri oluştur. Müşteri bilgileri, görüşme kayıtları ve fırsat yönetimi olsun.",
                realEstatePortfolioManagement:
                    "Emlak portföy yönetimi sistemi kurmak istiyorum. Gayrimenkul bilgileri, müşteri talepleri ve satış takibi yapılabilsin.",
                schoolManagementSystem:
                    "Okul yönetim sistemi için öğrenci, öğretmen ve ders programı takibi yapmak istiyorum. Türkçe alanlar kullan.",
                projectManagementSystem:
                    "Proje yönetimi sistemi oluşturmak istiyorum. Görevler, ekip üyeleri, zaman takibi ve raporlama özellikleri olsun.",
                inventoryAndWarehouseManagement:
                    "Stok ve depo yönetimi için bir sistem kurmak istiyorum. Ürün giriş-çıkışları, stok seviyeleri ve tedarikçi takibi yapılabilsin.",
                serviceAndMaintenanceTracking:
                    "Servis ve bakım takip sistemi istiyorum. Müşteri cihazları, bakım geçmişi ve teknisyen atamaları yapılabilsin.",
                restaurantManagementSystem:
                    "Restoran yönetim sistemi kurmak istiyorum. Masa takibi, sipariş yönetimi, mutfak ekranı ve hesap işlemleri olsun.",
            },
            createAppWithSupsisAssistant: "Supsis Asistan ile Uygulama Oluştur",
            noWidgets: "Henüz widget eklenmemiş",
            widgetLoadError: "Widget yüklenemedi",
            createDashboardSupsisAssistant: "Supsis Asistan ile Dashboard Oluştur",
            youtubeDesc: "Panonuza Youtube videoları yerleştirin",
            iframeDesc: "Panonuza harici web içeriği yerleştirin",
            countdownDesc: "Önemli son tarihleri takip etmek için geri sayım sayacı ekleyin",
            countdown: "Geri Sayım",
            textDesc: "Panonuza özel metin içeriği ekleyin",
            numbersDesc: "Tüm sayı sütunlarında hızlı bir genel bakış elde edin",
            numbers: "Sayılar",
            addWidget: "Widget Ekle",
            graphDesc: "Tablolarınızdaki verileri görsel olarak göstermek için grafik widget'ı oluşturun",
            graph: "Grafik",
            suggested: "Önerilen",
            otherTables: "Diğer Tablolar",
            noTablesFound: "Tablo bulunamadı",
            renameView: "Görünümü İsimlendir",
            enterNewViewName: "Yeni Görünüm Adı Gir",
            viewNameRequired: "Görünüm adı zorunludur.",
            viewRenamedSuccess: "Görünüm başarıyla yeniden adlandırıldı.",
            viewRenameError: "Görünüm yeniden adlandırılırken bir hata oluştu.",
            deleteView: "Görünümü Sil",
            confirmDeleteView: "Bu görünümü silmek istediğinize emin misiniz?",
            viewDuplicatedSuccess: "Görünüm başarıyla çoğaltıldı.",
            viewDuplicateError: "Görünüm çoğaltılırken bir hata oluştu.",
            duplicateView: "Görünümü Çoğalt",
            confirmDuplicateView: "Bu görünümü çoğaltmak istediğinize emin misiniz?",
            viewDeletedSuccess: "Görünüm başarıyla silindi.",
            viewDeleteError: "Görünüm silinirken bir hata oluştu.",
            creationDate: "Oluşturulma Tarihi",
            today: "Bugün",
            month: "Ay",
            week: "Hafta",
            day: "Gün",
            table: "Tablo",
            kanban: "Kanban",
            calendar: "Takvim",
            colorBy: "Renk Alanı",
            startDateField: "Başlangıç Tarihi Alanı",
            endDateField: "Bitiş Tarihi Alanı (İsteğe Bağlı)",
            eventCardFields: "Etkinlik Kartı Alanları",
            selectColorField: "Renk Alanını Seç",
            selectStartDateField: "Başlangıç Tarihi Alanını Seç",
            cancel: "İptal",
            save: "Kaydet",
            kanbanNotAvailable: "Kanban Görünümü Kullanılamıyor",
            needDropdownField:
                "Kanban görünümünü kullanmak için tablonuzda en az bir statik açılır liste alanına ihtiyacınız var. Tablo ayarlarından yeni bir alan ekleyebilir veya mevcut bir alanı düzenleyebilirsiniz.",
            notAvailable: "Takvim Görünümü Kullanılamıyor",
            needDateField:
                "Takvim görünümünü kullanmak için tablonuzda en az bir tarih alanına ihtiyacınız var. Tablo ayarlarından yeni bir alan ekleyebilir veya mevcut bir alanı düzenleyebilirsiniz.",
            switchToTable: "Tablo Görünümüne Geç",
            operator: "Operatör",
            conditionalColor: "Koşullu Renk",
            groupField: "Grup Alanı",
            selectDirection: "Yön Seç",
            showEmptyGroups: "Boş Grupları Göster",
            clearGrouping: "Grup Temizle",
            applyGrouping: "Grup Uygula",
            sortDirection: "Sıralama Yönü",
            downloadSelectedRecords: "Seçilmiş Kayıtları İndir",
            downloadSelected: "Seçilenleri İndir",
            downloadSelectedWithCount: "Seçilenleri İndir ({count})",
            downloadThisPage: "Bu Sayfayı İndir",
            downloadAll: "Tümünü İndir",
            downloadRecords: "Kayıtları İndir",
            downloadRecordsSettings: "Kayıtları İndir - Ayarlar",
            recordLimitExceededTooltip: "Kayıt limiti doldu. Kayıt içeri aktarmak için plan yükseltmeniz gerekiyor.",
            zebraMode: "Zebra Mod",
            viewName: "Görünüm Adı",
            enterViewName: "Görünüm Adı Gir",
            enterDesc: "Açıklama Gir",
            runWebhookAutomation: "Webhook Otomasyonunu Çalıştır",
            downloadAllRecords: "Tüm Kayıtları İndir",
            deleteRecords: "Kayıtları Sil",
            editRecords: "Kayıtları Güncelle",
            duplicateRecords: "Kayıtları Çoğalt",
            selected: "Seçilen",
            sureDeleteRecords: "kayıtları silmek istediğinizden emin misiniz?",
            selectedRecordSucs: "Seçilen kayıtlar başarıyla silindi.",
            errorDeletingRecords: "Kayıtlar silinirken bir hata oluştu.",
            sureCopyRecords: "kayıtları kopyalamak istediğinizden emin misiniz?",
            copyRecords: "Kayıtları Kopyala",
            recordsCopiedSucs: "Seçilen kayıtlar başarıyla kopyalandı.",
            recordsCopiedError: "Seçilen kayıtlar kopyalanırken bir hata oluştu.",
            viewSucsCreated: "Görünüm başarıyla oluşturuldu.",
            editMultipleRecords: "Birden Fazla Kaydı Düzenleme",
            importRecords: "Kayıtları içeri Aktar",
            importHasStarted:
                "İçeri aktarım başladı. Verilerinizin büyüklüğüne göre birkaç dakika sürebilir. Lütfen bekleyin...",
            anErrorImport: "İçeri aktarım sırasında bir hata oluştu.",
            recordCreated: "Kayıt Oluştur",
            recordUpdated: "Kayıt Güncelle",
            recordDeleted: "Kayıt Sil",
            noAutomationDefined: "Henüz otomasyon tanımlanmamış",
            nameTheAutomationAdd: "Bu tabloya kayıt eklendiğinde çalışacak otomasyona isim veriniz:",
            nameTheAutomationUpdate: "Bu tablodaki bir kayıt güncellendiğinde çalışacak otomasyona isim veriniz:",
            nameTheAutomationDelete: "Bu tablodan bir kayıt silindiğinde çalışacak otomasyona isim veriniz:",
            editField: "Alanı Düzenle",
            sort: "Sırala",
            sortAscending: "Sırala A-Z",
            sortDescending: "Sırala Z-A",
            clearSort: "Sıralamayı Kaldır",
            markAsIdentifierField: "Kimlik Alanı Olarak İşaretle",
            runAI: "Yapay Zekayı Çalıştır",
            ascending: "Yükselen",
            descending: "Alçalan",
            createField: "Alan Oluştur",
            insertBefore: "Önce Ekle",
            insertAfter: "Sonra Ekle",
            goToRelatedAuto: "İlgili Otomasyona Git",
            permission: "İzin",
            lockField: "Alanı Kilitle",
            hideField: "Alanı Gizle",
            deleteField: "Alanı Sil",
            createNewField: "Yeni Alan Oluştur",
            watchVideo: "Videoyu İzle",
            uploadError: "Yükleme Hatası",
            updateError: "Güncelleme Hatası",
            invalidValue: "Geçersiz değer. Lütfen doğru formatı kullanın.",
            errorUpdatingRecord: "Kayıt güncellenirken hata oluştu.",
            errorCreatingView: "Görünüm oluşturulurken bir hata oluştu.",
            datetimeOptions: "Tarih Saati Seçenekleri",
            numberOptions: "Numara Seçenekleri",
            currencyOptions: "Döviz Opsiyonları",
            dropdownOptions: "Açılır Seçenekler",
            automationButtonOptions: "Otomasyon Butonu Seçenekleri",
            defaultLabel: "Varsayılan Etiket",
            disableWhenClicked: "Tıklandığında Devre Dışı Bırak",
            fieldSucsCreate: "Alan Başarıyla Oluşturuldu",
            fieldCreatingFailed: "Alan oluşturulurken bir hata oluştu",
            fieldSucsUpdate: "Alan Başarıyla Güncellendi",
            fieldUpdatingFailed: "Alan Güncellenirken bir hata oluştu",
            showAll: "Tümümü Göster",
            hideAll: "Tümünü Gizle",
            searchFields: "Arama Alanı",
            firstRowHeader: "İlk Satır Başlık İçerir",
            seperatorCharacter: "Ayırıcı Karakter",
            comma: "Virgül",
            semicolan: "Noktalı Virgül",
            tableFieldOrFileColumns: "Tablo Alanı / Dosya Sütunları Eşleme",
            exampleResultPreview: "Örnek Sonuç Önizlemesi",
            errorProcessingFile: "Dosya işlenirken bir hata oluştu",
            newView: "Yeni Görünüm",
            createViewaFiltering:
                "Ana Tabloyu değiştirmeden filtreleme, sıralama ve alanları gizlemeye devam etmek için Görünümler oluşturun.",
            pleaseUpdateSelected: "Lütfen seçilen kayıtlar için güncellemek istediğiniz alanı seçin.",
            pleaseSelectedNewValue: "Lütfen seçilen alan için yeni değeri girin.",
            selectedMenuItem: "Seçilen menü öğesi:",
            deleteTable: "Tabloyu Sil",
            sureDeleteTable: "Bu tabloyu silmek istediğinizden emin misiniz?",
            deleteTableSucs: "Tablo başarıyla silindi.",
            deleteTableError: "Tablo silinirken hata oluştu:",
            editTable: "Tabloyu Düzenle",
            tables: "Tablolar",
            tableName: "Tablo Adı",
            description: "Açıklama",
            createTable: "Tablo Oluştur",
            createNewTable: "Yeni Tablo Oluştur",
            allTables: "Tüm Tablolar",
            myTables: "Benim Tablolarım",
            myFavorites: "Favorilerim",
            errorCreatingTable: "Tablo oluşturulurken hata oluştu:",
            customerTable: "Müşteri Tablosu",
            customerTableDesc: "Varsayılan müşteri tablosu",
            leadTracking: "Lead Takip",
            leadTrackingDesc: "Potansiyel müşteri izleme tablosu",
            todoList: "Yapılacaklar Listesi",
            todoListDesc: "Görevlerin takibi için liste",
            approvalReq: "Onay İsteği",
            approvalReqDesc: "Onay taleplerinin yönetimi",
            eventSchedule: "Etkinlik Takvimi",
            eventScheduleDesc: "Yaklaşan etkinlikleri planlama",
            inventoryList: "Envanter Listesi",
            inventoryListDesc: "Ürün stoklarını takip eder",
            bookingForm: "Rezervasyon Formu",
            bookingFormDesc: "Rezervasyonların takibi",
            bugTracker: "Hata Takipçisi",
            bugTrackerDesc: "Yazılım hatalarını izleme",
            employeeDirectory: "Çalışan Rehberi",
            employeeDirectoryDesc: "Çalışan bilgilerini içerir",
            errorPullTable: "Tablo verilerini çekerken hata oluştu.",
            newRecordSucs: "Yeni kayıt başarıyla oluşturuldu.",
            failedNewRecord: "Yeni kayıt oluşturulamadı:",
            newRecordCreateError: "Yeni kayıt oluşturulurken bir hata oluştu.",
            recordCount: "Kayıt Sayısı",
            increaseLimit: "Limit Artışı",
            newRecord: "Yeni Kayıt",
            imports: "İçe Aktar",
            exports: "Dışa Aktar",
            download: "İndir",
            automateYourData: "Verilerinizi Otomatikleştirin",
            recordUpdatedSucs: "Kayıt Başarıyla Güncellendi",
            failedToUpdateRecord: "Kayıt Güncellenemedi",
            recordUpdatingError: "Kayıt güncellenirken hata oluştu",
            mainTable: "Ana Tablo",
            filter: "Filtre",
            hideFields: "Alanları Gizle",
            saveAsView: "Görünüm Olarak Kaydet",
            search: "Ara",
            create: "Oluştur",
            left: "Sol",
            center: "Orta",
            right: "Sağ",
            selectTimezone: "Saat dilimini seçin",
            createFieldSucs: "Alan başarıyla oluşturuldu.",
            failedCreateField: "Alan Oluşturulamadı:",
            createFieldError: "Alan oluşturulurken bir hata oluştu.",
            addCondition: "Koşul Ekle",
            applyFilter: "Filtre Uygula",
            fieldType: "Alan Türü",
            alignment: "Hizalama",
            blankTable: "Boş Tablo",
            templates: "Şablonlar",
            timezone: "Zaman Dilimi",
            timeFormat: "Zaman Formatı",
            includeTime: "Zaman Dahil",
            decimalFormat: "Ondalık Biçim",
            currencySymbol: "Para Birimi Sembolü",
            mode: "Mod",
            statics: "Statik",
            dynamic: "Dinamik",
            multipleSelection: "Çoklu Seçim",
            addOption: "Seçenek Ekle",
            text: "Metin",
            longText: "Uzun Metin",
            number: "Numara",
            currency: "Para Birimi",
            datetime: "Tarih & Zaman",
            dropdown: "Açılır Liste",
            checkbox: "Onay Kutusu",
            email: "E-posta",
            phone: "Telefon",
            file: "Dosya",
            image: "Resim",
            video: "Video",
            audio: "Ses",
            color: "Renk",
            automationButton: "Otomasyon Butonu",
            upload: "Yükle",
            permissions: {
                title: "Tablo Gizlilik Ayarları",
                mode: "Yetkilendirme Modu",
                publicMode: "Genel",
                customMode: "Özel",
                publicModeDesc: "Bu modda tüm kullanıcılar tabloya tam erişime sahiptir.",
                customModeDesc: "Bu modda sadece belirli kullanıcılar ve departmanlar tabloya erişebilir.",
                confirmPublicMode: "Genel Moda Geç",
                confirmPublicModeDesc:
                    "Genel moda geçerseniz tüm özel yetkilendirmeler silinecektir. Devam etmek istiyor musunuz?",
                addUser: "Kullanıcı Ekle",
                addDepartment: "Departman Ekle",
                selectUser: "Kullanıcı seçin",
                selectDepartment: "Departman seçin",
                add: "Ekle",
                matrixInfo:
                    "Kullanıcılar ve departmanlar için yetkileri aşağıdaki matristen yönetebilirsiniz. İşaretli kutuları yetkili anlamına gelir.",
                targetHeader: "Kullanıcı / Departman",
                noTargetsAdded: "Henüz kullanıcı veya departman eklenmemiş",
                confirmRemoveTarget: "Hedefi Kaldır",
                confirmRemoveTargetDesc: "Bu kullanıcı/departmanı yetkilerden kaldırmak istediğinize emin misiniz?",
                saveSuccess: "Yetkilendirme ayarları başarıyla kaydedildi",
                saveError: "Yetkilendirme ayarları kaydedilirken hata oluştu",
                unknownUser: "Bilinmeyen Kullanıcı",
                unknownDepartment: "Bilinmeyen Departman",
                noPermission: "Bu işlem için yetkiniz bulunmamaktadır",
                groups: {
                    basic: "Temel Yetkiler",
                    record: "Kayıt Yetkileri",
                    view: "Görünüm Yetkileri",
                    page: "Sayfa Yetkileri",
                    field: "Alan Yetkileri",
                    widget: "Widget Yetkileri",
                    importExport: "İçe/Dışa Aktarım",
                },
                scopes: {
                    tableRead: "Görüntüleme",
                    tableReadDesc: "Tabloyu görüntüleyebilir",
                    tableMetaEdit: "Tablo Düzenleme",
                    tableMetaEditDesc: "Tablo adı, kategori ve açıklamasını düzenleyebilir",
                    recordCreate: "Kayıt Oluşturma",
                    recordCreateDesc: "Yeni kayıt oluşturabilir",
                    recordUpdate: "Kayıt Güncelleme",
                    recordUpdateDesc: "Mevcut kayıtları güncelleyebilir",
                    recordDelete: "Kayıt Silme",
                    recordDeleteDesc: "Kayıtları silebilir",
                    viewCreate: "Görünüm Oluşturma",
                    viewCreateDesc: "Yeni görünüm oluşturabilir",
                    viewUpdate: "Görünüm Güncelleme",
                    viewUpdateDesc: "Mevcut görünümleri güncelleyebilir",
                    viewDelete: "Görünüm Silme",
                    viewDeleteDesc: "Görünümleri silebilir",
                    pageRead: "Sayfa Görüntüleme",
                    pageReadDesc: "Özel sayfaları görüntüleyebilir",
                    pageCreate: "Sayfa Oluşturma",
                    pageCreateDesc: "Yeni sayfa oluşturabilir",
                    pageUpdate: "Sayfa Güncelleme",
                    pageUpdateDesc: "Mevcut sayfaları güncelleyebilir",
                    pageDelete: "Sayfa Silme",
                    pageDeleteDesc: "Sayfaları silebilir",
                    fieldCreate: "Alan Oluşturma",
                    fieldCreateDesc: "Yeni alan oluşturabilir",
                    fieldUpdate: "Alan Güncelleme",
                    fieldUpdateDesc: "Mevcut alanları güncelleyebilir",
                    fieldDelete: "Alan Silme",
                    fieldDeleteDesc: "Alanları silebilir",
                    widgetCreate: "Widget Oluşturma",
                    widgetCreateDesc: "Yeni widget oluşturabilir",
                    widgetUpdate: "Widget Güncelleme",
                    widgetUpdateDesc: "Mevcut widget'ları güncelleyebilir",
                    widgetDelete: "Widget Silme",
                    widgetDeleteDesc: "Widget'ları silebilir",
                    bulkImport: "Toplu İçe Aktarım",
                    bulkImportDesc: "Toplu kayıt içe aktarabilir",
                    export: "Dışa Aktarım",
                    exportDesc: "Kayıtları dışa aktarabilir",
                },
            },
            trashBin: "Çöp Kutusu",
            pasteInfoDetected:
                "Panoda kopyaladığınız tablo tespit edildi! Hemen Ctrl+V ile yapıştırarak yeni tablo oluşturun.",
            addCategory: "Kategori Ekle",
            editCategory: "Kategoriyi Düzenle",
            deleteCategory: "Kategoriyi Sil",
            moveAllTables: "Tüm Tabloları Taşı",
            dragTablesToCategory: "Tabloları buraya sürükleyerek kategoriye ekleyebilirsiniz",
            deleteProtectionActive: "Silme koruması aktif",
            copyTable: "Tabloyu Kopyala",
            copyAsJSON: "JSON Olarak Kopyala",
            changeCategory: "Kategori Değiştir",
            turnOffDeleteProtection: "Silme Korumasını Kapat",
            turnOnDeleteProtection: "Silme Korumasını Aç",
            privacySettings: "Gizlilik Ayarları",
            categoryName: "Kategori Adı",
            categoryNamePlaceholder: "Kategori adını girin",
            categoryUpdate: "Güncelle",
            categoryCreate: "Oluştur",
            categoryNameRequired: "Kategori adı boş olamaz",
            categoryAlreadyExists: "Bu isimde bir kategori zaten mevcut",
            categoryCreated: "Kategori oluşturuldu. Tabloları bu kategoriye sürükleyebilirsiniz.",
            categorySaveError: "Kategori kaydedilirken hata oluştu",
            categoryUpdated: "Kategori güncellendi",
            categoryUpdateError: "Kategori güncellenirken hata oluştu",
            deleteCategoryConfirm: "Kategoriyi Sil",
            deleteCategoryConfirmContent:
                '"{name}" kategorisini silmek istediğinizden emin misiniz? Bu kategorideki tablolar "Genel" kategorisine taşınacak.',
            categoryDeleted: "Kategori silindi",
            categoryDeleteError: "Kategori silinirken hata oluştu",
            tableMovedToCategory: 'Tablo "{name}" kategorisine taşındı',
            tableMoveError: "Tablo taşınırken hata oluştu",
            tableProtectedWarning: "Bu tablo silme koruması ile korunmaktadır. Silmek için önce korumasını kaldırın.",
            deleteProtectionEnabled: "Silme koruması aktif edildi",
            deleteProtectionDisabled: "Silme koruması kapatıldı",
            protectionUpdateError: "Koruma durumu güncellenirken hata oluştu",
            tableCopied: "Tablo kopyalandı",
            tableCopyError: "Tablo kopyalanırken hata oluştu",
            tableJsonCopied:
                "Tablo JSON olarak panoya kopyalandı. Başka müşteri panelinde Ctrl+V ile yapıştırabilirsiniz.",
            tableJsonCopiedFallback: "Tablo JSON olarak panoya kopyalandı (fallback method)",
            tableJsonCopyError: "Tablo JSON olarak kopyalanırken hata oluştu",
            clipboardNotSupported: "Bu tarayıcıda clipboard erişimi desteklenmiyor",
            noValidTableJson: "Panoda geçerli bir tablo JSON'u bulunamadı",
            noValidSupsisExport: "Panoda geçerli bir Supsis tablo export'u bulunamadı",
            tableImported: '"{name}" tablosu başarıyla içeri aktarıldı',
            tablePasteError: "Tablo yapıştırılırken hata oluştu",
            noTablesToMove: "Taşınacak tablo bulunamadı",
            tablesMovedToCategory: '{count} tablo "{name}" kategorisine taşındı',
            tablesMoveError: "Tablolar taşınırken hata oluştu",
            noPermissionEditPrivacy: "Bu tablonun gizlilik ayarlarını düzenleme yetkiniz bulunmamaktadır",
            sandboxTitle: "Tablo Silinen Senaryolar",
            sandboxDesc: "Silinen tablolarınız çöp sepetinde 30 gün bekledikten sonra otomatik olarak silinir",
            sandboxEmpty: "Çöp sepetinde silinen tablo bulunmuyor",
            unnamedTable: "İsimsiz Tablo",
            restore: "Geri Yükle",
            permanentlyDelete: "Kalıcı Olarak Sil",
            unknown: "Bilinmiyor",
            user: "Kullanıcı",
            restoreTableConfirm: "Tabloyu Geri Yüklemek İstediğinize Emin Misiniz?",
            restoreTableContent: "{name} tablosu geri yüklenecek.",
            tableRestored: "Tablo geri yüklendi",
            restoreFailed: "Geri yükleme başarısız oldu",
            permanentlyDeleteConfirm: "Tabloyu Kalıcı Olarak Silmek İstediğinize Emin Misiniz?",
            permanentlyDeleteContent: "{name} tablosu kalıcı olarak silinecek. Bu işlem geri alınamaz.",
            yesPermanentlyDelete: "Evet, Kalıcı Olarak Sil",
            tablePermanentlyDeleted: "Tablo kalıcı olarak silindi",
            permanentDeleteFailed: "Kalıcı silme başarısız oldu",
            deletedTablesLoadError: "Silinen tablolar yüklenirken hata oluştu",
            ascendente: "Artan",
            calendarSettings: "Takvim Ayarları",
            centro: "Orta",
            colore: "Renk",
            colour: "Renk",
            company: "Şirket",
            createFailed: "Modül oluşturulamadı",
            createSuccess: "Modül başarıyla oluşturuldu",
            destra: "Sağ",
            dinamico: "Dinamik",
            discendente: "Azalan",
            dynamisch: "Dinamik",
            failCreateField: "Alan oluşturma başarısız:",
            failToUpdateRecord: "Kayıt güncellenemedi",
            immagine: "Görsel",
            individual: "Bireysel",
            izquierda: "Sol",
            priority_high: "Yüksek",
            priority_highest: "En Yüksek",
            priority_low: "Düşük",
            priority_lowest: "En Düşük",
            priority_medium: "Orta",
            rechts: "Sağ",
            selectEndDateField: "Bitiş Tarihi Alanını Seçin",
            semicolon: "Noktalı Virgül",
            separatorCharacter: "Ayırıcı Karakter",
            sinistra: "Sol",
            statica: "Statik",
            tabelle: "Tablolar",
        },
        modules: {
            kanbanSettings: {
                title: "Ayarlar",
                column: "Kolon Ayarları",
                selectField: "Bir alan seçin",
                selectFieldPlaceholder: "Bir alan seçin",
                card: "Kart Ayarları",
                selectFields: "Kartta gösterilecek alanları seçin",
                cancel: "İptal",
                save: "Kaydet",
                kanban: "Kanban Ayarları",
            },
            createFailed: "Modül oluşturma başarısız",
            createSuccess: "Modül başarıyla oluşturuldu",
            updateSuccess: "Modül başarıyla güncellendi",
            updateFailed: "Modül güncelleme başarısız",
            moduleDeletedSuccessfully: "Modül başarıyla silindi.",
            deleteModuleTitle: "Modülü Sil",
            deleteModuleContent: "Bu modülü silmek istediğinizden emin misiniz?",
            modules: "Modüller",
            relations: "İlişkiler",
            modulesSettings: "Modül Ayarları",
            displayName: "Görünen İsim",
            description: "Açıklama",
            table: "Tablo",
            menuApiSettings: "Menü ve API Ayarları",
            icon: "İkon",
            save: "Kaydet",
            exampleIcon: "Örn: extension, home",
            newModule: "Yeni Modül Oluştur",
            newRelation: "Yeni İlişki Oluştur",
            editModule: "Modülü Düzenle",
            editRelation: "İlişkiyi Düzenle",
            moduleName: "Modül Adı",
            apiName: "API Adı",
            type: "Tür",
            apiAccess: "API Erişimi",
            actions: "Aksiyonlar",
            module: "Modül",
            relation: "İlişki",
            moduleRelationName: "Modül/İlişki Adı",
            moduleRelationTable: "Modül/İlişki Tablosu",
            settings: "Ayarlar",
            showInMainMenu: "Ana Menüde Göster",
            apiEnabled: "API Etkin",
            createModule: "Modül Oluştur",
            relationType: "İlişki Türü",
            relationTypeTableToTable: "Tablodan Tabloya",
            relationTypeTableToStandart: "Tablodan Standart Modüle",
            relationTypeStandartToTable: "Standart Modülden Tabloya",
            fromColumn: "Kaynak",
            toColumn: "Hedef",
            apiDoc: "API Dokümantasyonu",
            standartModule: "Standart Modül",
            customTable: "Özel Tablo",
            localField: "İlişkilendirilecek Alan",
            showingRemoteFieldInList: "Listede Uzak Alanı Göster",
            relationSettings: "İlişki Ayarları",
            remoteField: "Uzak Alan",
            localFieldType: "Yerel Alan Türü",
            standart: "Standart",
            custom: "Özel",
            contact: "Kişi",
            viewRecord: "Aç",
            recordDetail: "Kayıt Detayı",
            recordNotFound: "Kayıt veya tablo bilgisi bulunamadı",
            relatedLists: "İlgili Listeler",
            recordViewer: "Kayıt Görüntüleyici",
            priority_high: "Yüksek",
            priority_highest: "En Yüksek",
            priority_low: "Düşük",
            priority_lowest: "En Düşük",
            priority_medium: "Orta",
        },
        plans: {
            manageWithChatbot: "Chatbot ile Yönetim",
            manageInbox: "Gelen Kutusu Yönetin",
            commentManagement: "Yorumları Yönetin",
            privateReplyMessage: "Yorumlara Özel'den Yanıt",
            mentionTicket: "Etkileri Ticket'a Dönüştürün",
            week: "Hafta",
            readyContents: "Hazır İçerikler",
            webhookIntegration: "Webhook Entegrasyonu",
            businessChannel: "Whatsapp Business Kanalı",
            confirmationFeature: "Yetkilendirme Özelliği",
            specialReporting: "Özel Rapolama",
            aiAssistant: "Yapay Zeka Asistan",
            flexibleBilling: "Esnek Faturalandırma",
            automaticReservation: "Otomatik Rezervasyon",
            taskManagement: "Görev Yönetimi",
            calendarIntegration: "Takvim Entegrasyonu",
            activeChatbot: "Aktif Chatbot",
            smsIntegration: "SMS Entegrasyonu",
            mailIntegration: "Mail Entegrasyonu",
            startChatWithVisitor: "Ziyaretçi ile Chat Başlatma",
            whatsappManaging: "Whatsapp Yönetimi",
            automaticChatbotButton: "Otomatik Buton/Chatbot",
            personalizedBroadcasts: "Kişiselleştirilmiş Yayın Mesajları",
            chatWithNonContacts: "Kayıtlı Olmayan Numaralarla Mesajlaşma",
            broadcastMessaging: "Toplu Mesaj Gönderme",
            perBroadcast: "Toplu Mesaj Başına",
            extraPricePerMessage: "Mesaj Başına Ek Ücret",
            smartTrigger: "Akıllı Tetikleyici",
            telegramIntegration: "Telegram Entegrasyonu",
            instagramIntegration: "Instagram Entegrasyonu",
            ticketFeature: "Ticket Sistemi",
            storage: "Depolama",
            onePanelManagement: "Tek Panelden Yönetim",
            isolatedDatabaseConnection: "İzole Veritabanı Bağlantısı",
            removeLogo: "Supsis Logo Kaldırma",
            chatBaloonCustomization: "Chat balonu özelleştirme",
            chatAndNotifications: "Chat Ve Bildirimler",
            unlimited: "Sınırsız",
            specialCustomerSupport: "Özel Müşteri Desteği",
            softwareSupport: "Yazılım Desteği",
            standardSupport: "Standart Destek",
            teamChatIntegration: "Takım Konuşması Entegrasyonu",
            fileAndVoiceShare: "Dosya ve Ses Paylaşımı",
            instantVisitor: "Anlık Ziyaretçi Takibi",
            detailedReporting: "Detaylı Raporlama",
            normalreporting: "Normal Raporlama",
            noExtraCosts: "Ek Maliyet Gerektirmez",
            accessibleToAllAgents: "Tüm Temsilciler İçin Erişim",
            dataSecurity: "Veri Güvenliği",
            autoTranslate: "Otomatik Çeviri",
            chatbotVersionHistory: "Chatbot Sürüm Geçmişi",
            chatbotStory: "Chatbot Hikayesi",
            freeAgent: "Ücretsiz Temsilci",
            stableAgentCount: "Sabit Temsilci Sayısı",
            stableChannelCount: "Sabit Kanal Sayısı",
            chipPlans: "Uygun Fiyatlı Planlar",
            generalPlan: "Genel Plan",
            specialPlan: "Özel Plan",
            currentPlan: "Mevcut Plan",
            selected: "Seçildi",
            popular: "Popüler",
            trialPkg: "Deneme Paketi",
            support: "7/24 Destek",
            flexiblePricing: "Esnek Fiyatlandırma",
            rightToCancel: "İstenilen Gün Paket İptali",
            unlimitedCBScenario: "Sınırsız Chatbot Senaryosu",
            freeFirstScenario: "Ücretsiz İlk Senaryo",
            unlimitedLearn: "Sınırsız Chatbot Eğitimi",
            allPlatformIntegration: "Tüm Platformlarla Entegrasyon",
            detailedReports: "Detaylı Rapor",
            aiSupport: "Yapay Zeka Desteği",
            creativeAI: "Hızlı ve Gerçekçi AI Chat Asistanı",
            unlimitedSession: "Aynı Anda Sınırsız Oturum",
            assistantFromWebsite: "Web Siteden Asistan Oluşturma",
            assistantFromDoc: "Dökümandan Chatbot Oluşturma",
            mobileApp: "Mobil Uygulama",
            commentManage: "Manage Comments",
        },
        messenger: {
            channel: "Messenger Kanalı",
            manageChannel: "Messenger Kanalını Yönet",
            channelDetail: "Messenger Detayı",
            integrationTitle: "Messenger Entegrasyonu",
            deleteDesc: "Messenger kanalını silmek istediğinizden emin misiniz?",
            channels: "Messenger Kanalları",
            connectMessenger: "Messenger'a Bağlan",
            detail: "Detay",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            commentsettings: "Yorum Yönetimi",
            commentSettingsTitle: "Messenger Yorum Yönetimi",
            commentSettingsDesc: "Messenger yorumlarınızı yönetin",
            adoptimization: "Reklam Optimizasyonu",
        },
        instagram: {
            brand: "Marka",
            questions: "Sorular",
            channel: "Instagram Kanalı",
            detail: "Detay",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            commentsettings: "Yorum Yönetimi",
            commentSettingsTitle: "Instagram Yorum Yönetimi",
            commentSettingsDesc: "Instagram yorumlarınızı yönetin",
            commentSettingsTicket: "Gelen yorumların sistemde ticket olarak kaydedilmesini sağlar.",
            commentSettingsChatbot: "Kanala gelen yorumların hangi chatbot senaryosuna yönlendirileceğini seçiniz.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Tüm Instagram Kanallarını Göster",
            showAllLinkedinChannels: "Tüm Linkedin Kanallarını Göster",
            showAllTelegramChannels: "Tüm Telegram Kanallarını Göster",
            adoptimization: "Reklam Optimizasyonu",
        },
        calendar: {
            calendars: "Takvimler",
            calendarsDesc: "Program çakışmalarını önleyin.",
            generalAvailability: "Genel Müsaitlik Durumu",
            generalAvailabilityDesc: "Randevular için düzenli olarak müsait olduğunuz zamanları belirtin.",
            appointDuration: "Randevu süresi",
            appointDurationDesc: "Her randevu ne kadar sürmelidir?",
            customDuration: "Özel Süre",
            description: "Açıklama",
            descriptionDesc:
                "Hizmetinizi açıklayan bir not ekleyin. Eklediğiniz not, rezervasyon sayfanızda ve onay e-postalarında görünecektir.",
            resForm: "Rezervasyon Formu",
            resFormDesc: "Kişilerin randevu almak için kullanacağı formu özelleştirin.",
            addField: "Alan Ekle",
            addAnItem: "Bir Öğe Ekleyin",
            saveItem: "Öğeyi Kaydet",
            planningTimeframe: "Planlama Zaman Aralığı",
            planningTimeframeDesc: "Randevu alınabilecek zaman aralığını sınırlayın.",
            availableAtMoment: "Şuanda Müsait",
            startAndEndDate: "Başlangıç ve bitiş tarihleri",
            maxNumberAppoint: "En fazla kaç gün sonrası randevu alınabileceği",
            howLongMinAppoint: "Randevunun başlangıcından minimum ne kadar süre önce randevu alınabileceği",
            planingIntervalStartEnd: "Planlama aralığı başlangıç ve bitiş tarihleri",
            startTime: "Başlangıç Zamanı",
            done: "Bitti",
            never: "Asla",
            receivedAppointInterval: "Alınmış Randevu Aralığı",
            receivedAppointIntervalDesc: "Takviminizde görünecek alınmış randevuları yönetin.",
            interimTime: "Ara zaman",
            interimTimeDesc: "Toplantı aralıklarının arasına zaman ekleyin",
            dayMaxRes: "Günlük maksimum rezervasyon sayısı",
            dayMaxResDesc: "Tek bir günde kabul edilebilecek, alınmış randevu sayısını sınırlandırın",
            customize: "Özel Ayarla",
            noAvatar: "Avatar Yok",
            organizationName: "Organizasyon Adı",
            enterFullAdress: "Tam adresi girin",
            noCoverPhoto: "Kapak fotoğraf yok",
            enterAboutInfo: "Hakkında bilgilerini girin",
            service: "Servis",
            deleteService: "Hizmeti Sil",
            enterGoogleMapsUrl: "Google Maps URL'sini girin",
            enterLatitude: "Enlem girin",
            enterLongitude: "Boylam girin",
            enterNumber: "Telefon numarasını girin",
            uploadAvatar: "Avatar Yükle",
            teamMemberDeleteError: "Ekip üyesi silinirken hata oluştu:",
            setupBookingWebsite: "Rezervasyon Website'sini Kur",
            bookingLandingPageBuilder: "Rezervasyon Açılış Sayfası Oluşturucu",
            coverPhoto: "Kapak Fotoğrafı",
            enterOrganizationName: "Organizasyon adını girin",
            about: "Hakkında",
            services: "Hizmetler",
            deleteServices: "Hizmeti Sil",
            selectReservationPlan: "Rezervasyon Planı Seç",
            addNewService: "Yeni Servis Ekle",
            addNewMember: "Yeni Üye Ekle",
            fullAddress: "Tam Adres",
            latitude: "Enlem",
            longitude: "Boylam",
            contactDetails: "İletişim Bilgileri",
            emailAddress: "E-posta Adresi",
            enterEmail: "E-posta adresini girin",
            websiteURL: "Websitesi URL",
            enterWebsiteURL: "Websitesi URL'sini girin",
            reservationPolicy: "Rezervasyon Politikası",
            enterResPolicy: "Rezervasyon politikasını girin",
            workingHours: "Çalışma Saatleri",
            selectEndHour: "Bitiş Saatini Seçin",
            addNewHour: "Yeni Saat Ekle",
            updateMemberInfo: "Üye Bilgilerini Güncelle",
            errorRecevingData: "Veri alınırken hata oluştu:",
            anonymService: "İsimsiz Hizmet",
            unknownPlan: "Bilinmeyen Plan",
            errorCreatingMockPage: "Mock sayfa oluşturulurken hata oluştu:",
            failedToCreateBookingPage: "Rezervasyon sayfası oluşturulamadı",
            fileSizeToolLarge: "Dosya boyutu çok büyük",
            errorLoadingTheLogo: "Logo yüklenirken hata oluştu:",
            failedToLoadLogo: "Logo yüklenemedi",
            errorUpdating: "Güncellenirken hata oluştu:",
            failedToUpdate: "Güncellenemedi",
            newMember: "Yeni Üye",
            errorLoadingAvatar: "Avatar yüklenirken hata oluştu:",
            avatarFailedToLoad: "Avatar yüklenemedi",
            teamMemberSuccessfullyDeleted: "Ekip üyesi başarıyla silindi",
            teamMemberNotDelete: "Ekip üyesi silinemedi",
            yesDelete: "Evet, Sil",
            sureResDelete: "Bu rezervasyonu silmek istediğinizden emin misiniz?",
            resDetails: "Rezervasyon Detayları",
            infoPersonMakingRes: "Rezervasyon Yapan Kişinin Bilgileri",
            appointmentProgram: "Randevu Programı",
            goToAppointSettings: "Randevu Programı Ayarlara Git",
            resPlanCreateSuccess: "Rezervasyon planı başarıyla oluşturuldu",
            pleaseEnterTitle: "Lütfen başlık giriniz",
            sureContinueSaving: "Kaydetmeden devam etmek istediğinize emin misiniz ?",
            appointProgram: "RADEVU PROGRAMI",
            everyMonth: "Her ayın",
            firstEveryMonth: "Her ayın ilk",
            dayOf: "Günü",
            notRepeat: "Tekrarlamaz",
            daily: "Hergün",
            weely: "Haftada bir",
            monthly: "Ayda bir",
            annualy: "Yılda bir",
            custom: "Özel",
            eventSaved: "Etkinlik Kaydediliyor",
            createAppoint: "Randevu Oluştur",
            calendarSetting: "Takvim Ayarları",
            notAuthezord: "Bu işlemi yapmaya yetkiniz yok",
            notAuthorizedToPerformOperation: "Bu işlemi gerçekleştirmek için yetkiniz bulunmamaktadır.",
            reservationWebPage: "Rezervasyon Web Sayfası",
            reservationBuilder: "Rezervasyon Websitesi",
            reservationPrograms: "Rezervasyon Programları",
            automations: "Otomasyonlar",
            addReservationProgram: "Rezervasyon Programı Ekle",
            resPlanError: "Rezervasyon planları alınırken hata oluştu:",
            resDeleteSure: "Bu rezervasyon programını silmek istediğinize emin misiniz?",
            resDeleteSuccess: "Rezervasyon programı başarıyla silindi.",
            resDeleteError: "Rezervasyon programı silinirken hata oluştu:",
            unkownUser: "Bilinmeyen Kullanıcı",
            eventNotFound: "Etkinlik Bulunamadı",
            reservations: "Rezervasyonlar",
            events: "Etkinlikler",
            upcoming: "Yaklaşan",
            past: "Geçmiş",
            setting: "Ayarlar",
            delete: "Sil",
            cancel: "Vazgeç",
            save: "Kaydet",
            close: "Kapat",
            deleteRepeatEvent: "Düzenli etkinliği silin",
            thisEvent: "Bu etkinlik",
            thisAndOtherEvent: "Bu ve takip eden etkinlikler",
            allEvent: "Tüm etkinlikler",
            ok: "Tamam",
            googleCalendarLink: "Google Takvime Ekle",
            yahooCalendarLink: "Yahoo Takvime Ekle",
            subject: "Konu",
            visitor: "Ziyaretçi",
            allDay: "All Day",
            title: "Başlık",
            deleteEvent: "Etkinliği Sil",
            deleteEvents: "Etkinlikleri Sil",
            deleteEventsSure: "Bu takvime ait etkinlikleri silmek istediğinize emin misiniz?",
            deleteEventConfirm: "Etkinliği silmek istediğinize emin misinz?",
            notEmptyTitle: "Başlık boş bırakılamaz!",
            tasks: "Görevler",
            googleConnect: "Google Entegrasyonu",
            googleDisconnect: "Google Entegrasyon Bağlantısını Kaldır",
            sure: "Emin misin?",
            disconnectGoogleSure: "Google bağlantısını kaldırmak istediğinden emin misin?",
            yes: "Evet",
            no: "Hayır",
            customRepeat: "Özel Yineleme",
            recurrenceFrequency: "Yineleme Sıklığı:",
            repeatDays: "Şu günlerde yinele:",
            thisDate: "Şu Tarihte:",
            recurrenceCount: "Yinelenme sayısı:",
            end: "Bitiş",
            event: "Etkinlik",
            newCalendar: "Yeni Takvim Oluştur",
            changeColor: "Renk Değiştir",
            addCalendar: "Takvim Ekle",
            nameCalendar: "Takvim Adı",
            change: "Değiştir",
            deleteCalendar: "Delete Calandar",
            deleteCalendarSure: "Takvimi silmek istediğinize emin misiniz?",
            notEmptyCalendarName: "Takvim adı boş olamaz",
            myEvents: "Etkinliklerim",
            everyoneEvents: "Tüm Etkinlikler",
            haveEvent: " temsilcisine ait etkinlikler",
            goCalendar: " Takvime Git",
            goReservation: " Rezervasyon Oluştur",
            agents: " Temsilciler",
            today: "Bugün",
            month: "Ay",
            week: "Hafta",
            day: "Gün",
            list: "Liste",
            annually: "Yıllık",
            appointmentDuration: "Randevu Süresi",
            appointmentSchedule: "Randevu Takvimi",
            calendari: "Takvimler",
            customise: "Özelleştir",
            enterOrganisationName: "Organizasyon Adını Girin",
            goToAppointmentSettings: "Randevu Ayarlarına Git",
            infoPersonMakingReservation: "Rezervasyonu Yapan Kişi Bilgileri",
            planningIntervalStartEnd: "Planlama Aralığı Başlangıç ve Bitiş",
            reservationDetails: "Rezervasyon Detayları",
            sureReservationDelete: "Bu rezervasyonu silmek istediğinize emin misiniz?",
            teamMemberNotDeleted: "Takım üyesi silinemedi",
            weekly: "Haftalık",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Ayar",
            waitDayFromLastSend: "Son Gönderilen Mesajdan İtibaren Bekleme Günü Sayısı",
            automationRuleName: "Otomasyon Kuralı Adı",
            time: "Saat",
            year: "Yıl",
            month: "Ay",
            dayOfMonth: "Ayın Günü",
            day: "Gün",
            bySecond: "Saniyeye Göre",
            byMinute: "Dakikaye Göre",
            byHour: "Saate Göre",
            byWeekNo: "Hafta Sayısı",
            byYearDay: "Yılın Günü",
            byMonthDay: "Ayın Günü",
            byMonth: "Aya Göre",
            december: "Aralık",
            november: "Kasım",
            october: "Ekim",
            september: "Eylül",
            august: "Ağustos",
            july: "Temmuz",
            june: "Haziran",
            may: "Mayıs",
            april: "Nisan",
            march: "Mart",
            february: "Şubat",
            january: "Ocak",
            byWeekDay: "Güne Göre",
            interval: "Aralık",
            seconds: "Saniyelik",
            minutes: "Dakikalık",
            hourly: "Saatlik",
            daily: "Günlük",
            weekly: "Haftalık",
            monthly: "Aylık",
            yearly: "Yıllık",
            frequency: "Sıklık",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Şehir",
                country: "Ülke",
                phone: "Telefon",
                email: "E Posta",
                fullname: "Tam İsim",
                couponPercent: "Kupon %",
                lastOrderDate: "Son Sipariş",
                firstOrderDate: "İlk Sipariş",
                county: "ilçe",
                lastSource: "Son Kaynak",
                firstSource: "İlk Kaynak",
                lastPaymentType: "Son Ödeme Yöntemi",
                firstPaymentType: "İlk Ödeme Yöntemi",
                maxOrderAmount: "En Çok Sipariş Tutarı",
                minOrderAmount: "En Az Sipariş Tutarı",
                totalOrderAmount: "Toplam Sipariş Tutarı",
                totalOrderCount: "Toplam Sipariş Sayısı",
                usedCouponAmount: "Kupon Miktarı",
                usedCouponCount: "Kupon Sayısı",
                tookDayFromLastOrder: "Son Siparişten Geçen Gün",
                isCouponUser: "Kupon kullanıcısı?",
            },
            createAutomation: "Otomasyon Oluştur",
            previous: "Önceki",
            createAutomationDesc: "Mesaj otomasyonununuzu oluşturun ve yönetin",
            newTicimaxChannel: "Yeni Ticimax Kanalı",
            connextToTicimaxXml: "Ticimax XML Servisine Bağlan",
            connectTicimax: "Ticimax'a Bağlan",
            examplePreview: "Örnek Önizleme",
            completeAutomationRule: "Otomasyon Kuralını Tamamla",
            configureMessage: "Mesajı Yapılandır",
            automationTimer: "Otomasyon Zamanlayıcı",
            findTargetMembers: "Hedef Kişileri Bul",
            createAutomationRule: "Otomasyon Kuralı Oluştur",
            action: "Aksiyon",
            status: "Durum",
            triggeredUserCount: "Tetiklenmiş kullanıcı sayısı",
            nextScheduled: "Sonraki Tetikleme",
            automationRules: "Otomasyon Kuralları",
            apply: "Uygula",
            searchAMember: "Bir kişi ara",
            segmentedMembersDesc: "Segmente edilmiş kişilerinizi listeleyin ve otomatize edin",
            manageVisibilityDesc: "Kanalı kimlerin görebileceğini yönet",
            xmlOrderListURL: "XML sipariş listesi URL",
            manageIntegrationDesc: "Ticimax entegrasyonunuzu yönetin",
            detail: "Detay",
            ticimaxChannelsTitle: "Ticimax Kanalları",
            ticimaxDetail: "Ticimax Detay",
            settingsGroup: "Ayarlar",
            visibility: "Görünürlük",
            members: "Kişiler",
            automation: "Otomasyon",
            integrationChannel: "Entegrasyon Kanalı",
            channelUpdated: "Kanal Başarıyla Güncellendi",
            channelUpdateFailed: "Kanal Güncellemesi Başarısız",
            timerRule: "Timer Rule",
        },
        notification: {
            taskArchive: "Görev arşivlendiğinde bildirim gönderilir.",
            taskComplet: "Tamamlanmış görev kapatıldığında bildirim gönderilir.",
            adjustNow: "Şimdi ayarla",
            taskStatusChanged: "Görev durumu güncellendiğinde.",
            chatAssignedMe: "Bir sohbet bana atandığında.",
            ticketAssignedMe: "Bir ticket bana atandığında.",
            myChatClosed: "Sahip olduğum bir sohbet kapatıldığında",
            contactOwner: "Chat sahibi değiştiğinde, sahip atama yapıldığında veya sahiplik kaldırıldığında.",
            tagActionsToVisitor: "Bir ziyaretçiye etiket eklendiğinde veya kaldırıldığında",
            ticketCreated: "Ziyaretçi veya sohbet botu bir bilet oluşturduğunda.",
            notesActions: "Bir müşteriye not eklendiğinde veya kaldırıldığında.",
            visitorProfileUpdated: "Ziyaretçi profili güncellendiğinde.",
            chatStartedByAnyPlatform: "Herhangi bir kanaldan sohbet başlatıldığında",
            userActions: "Kullanıcı oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            departmentActions: "Departman oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            settingsActions: "Ayarlar oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            integrationsActions: "Entegrasyon kanalı oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            loginFormActions: "Giriş formu güncellendiğinde veya etkinleştirildiğinde",
            bannedWordActions: "Yasaklı kelime oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            emailActions: "E-posta hesabı oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            preparedContentActions: "Hazır içerik oluşturulduğunda, güncellendiğinde veya silindiğinde",
            tagActions: "Etiket oluşturulunca, güncellenince veya silinince",
            welcomeMessageActions: "Hoş geldiniz mesajı oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            webhookActions: "Web kancası oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            billingEvents: "Fatura oluştuğunda veya durumu güncellendiğinde.",
            systemStatus: "Canlı destek sistemi durumu güncellendiğinde.",
            reservationMessageCrud: "Rezervasyon oluştuğunda, güncellendiğinde veya silindiğinde.",
            ipAddressWhiteListEvents: "İzin verilen ip adresi eklendiğinde, güncellendiğinde veya silindiğinde.",
            autoRebalanceEvents:
                "Otomatik bakiye yüklemesi tamamlandığında, başarısız olduğunda veya devre dışı bırakıldığında.",
            automationActions: "Otomasyon İşlemleri",
            automationCreated: "{user} kullanıcısı {automation} adlı otomasyonu oluşturdu.",
            automationDeleted: "{user} kullanıcısı {automation} adlı otomasyonu sildi.",
            automationRestored: "{user} kullanıcısı {automation} adlı otomasyonu çöp sepetinden çıkardı.",
            automationPublished: "{user} kullanıcısı {automation} adlı otomasyonu yayınladı.",
            automationUnpublished: "{user} kullanıcısı {automation} adlı otomasyonu yayından kaldırdı.",
            automationUpdated: "{user} kullanıcısı {automation} adlı otomasyonu güncelledi.",
            automationCreatedNotification: "Otomasyon oluşturulduğunda.",
            automationDeletedNotification: "Otomasyon silindiğinde.",
            automationRestoredNotification: "Otomasyon çöp sepetinden çıkarıldığında.",
            automationPublishedNotification: "Otomasyon yayınlandığında.",
            automationUnpublishedNotification: "Otomasyon yayından kaldırıldığında.",
            automationUpdatedNotification: "Otomasyon güncellendiğinde.",
            formDeleted: '{user} kullanıcısı "{formName}" (ID: {formId}) adlı formu sildi.',
            formDeletedPermanent: '{user} kullanıcısı "{formName}" (ID: {formId}) adlı formu kalıcı olarak sildi.',
            formRestored: '{user} kullanıcısı "{formName}" (ID: {formId}) adlı formu çöp sepetinden geri çıkardı.',
            formCreated: '{user} kullanıcısı "{formName}" adlı formu oluşturdu.',
            formUpdated: '{user} kullanıcısı "{formName}" adlı formu güncelledi.',
            formDownloaded: '{user} kullanıcısı "{formName}" (ID: {formId}) adlı formun verilerini indirdi.',
            userRoleChanged:
                '{actor} kullanıcısı "{userName}" kullanıcısının rolünü "{oldRoleName}" yerine "{newRoleName}" olarak değiştirdi.',
            userPasswordChanged: '{actor} kullanıcısı "{userName}" kullanıcısının şifresini değiştirdi.',
            userEmailChanged:
                '{actor} kullanıcısı "{userName}" kullanıcısının email adresini "{oldEmail}" yerine "{newEmail}" olarak değiştirdi.',
            userNameChanged:
                '{actor} kullanıcısı "{userName}" kullanıcısının adını "{oldName}" yerine "{newName}" olarak değiştirdi.',
            userPhoneChanged:
                '{actor} kullanıcısı "{userName}" kullanıcısının telefon numarasını "{oldPhone}" yerine "{newPhone}" olarak değiştirdi.',
            userDisabled: '{actor} kullanıcısı "{userName}" kullanıcısını devre dışı bıraktı.',
            userEnabled: '{actor} kullanıcısı "{userName}" kullanıcısını aktif hale getirdi.',
            roleUpdated: '{actor} kullanıcısı "{roleName}" rolünü güncelledi.',
            taskWorkflowUpdated: '{actor} kullanıcısı "{workflowTitle}" iş akışını güncelledi.',
            taskWorkflowPipelineStageAdded:
                '{actor} kullanıcısı "{workflowTitle}" iş akışına "{stageName}" aşaması ekledi.',
            taskWorkflowPipelineStageUpdated:
                '{actor} kullanıcısı "{workflowTitle}" iş akışındaki "{stageName}" aşamasını güncelledi.',
            taskWorkflowPipelineStageDeleted:
                '{actor} kullanıcısı "{workflowTitle}" iş akışından "{stageName}" aşamasını sildi.',
            driveFolderCreated: '{actor} kullanıcısı "{folderName}" klasörünü oluşturdu.',
            driveFolderDeleted: '{actor} kullanıcısı "{folderName}" klasörünü sildi.',
            driveFolderRenamed: '{actor} kullanıcısı "{oldName}" klasörünü "{newName}" olarak yeniden adlandırdı.',
            driveFileAdded: '{actor} kullanıcısı "{fileName}" dosyasını ekledi.',
            driveFileDeleted: '{actor} kullanıcısı "{fileName}" dosyasını sildi.',
            taskModuleRulesEnabled: '{actor} kullanıcısı "{workflowTitle}" iş akışı için görev kurallarını aktif etti.',
            taskModuleRulesDisabled:
                '{actor} kullanıcısı "{workflowTitle}" iş akışı için görev kurallarını devre dışı bıraktı.',
            taskModuleRulesRuleAdded: '{actor} kullanıcısı "{workflowTitle}" iş akışına "{ruleName}" kuralını ekledi.',
            taskModuleRulesRuleDeleted:
                '{actor} kullanıcısı "{workflowTitle}" iş akışından "{ruleName}" kuralını sildi.',
            taskModuleRulesRuleUpdated:
                '{actor} kullanıcısı "{workflowTitle}" iş akışında "{ruleName}" kuralını güncelledi.',
            taskModuleRulesRuleEnabled:
                '{actor} kullanıcısı "{workflowTitle}" iş akışında "{ruleName}" kuralını aktif etti.',
            taskModuleRulesRuleDisabled:
                '{actor} kullanıcısı "{workflowTitle}" iş akışında "{ruleName}" kuralını devre dışı bıraktı.',
            contactModuleRulesEnabled: "{actor} kişi modülü kurallarını aktif etti.",
            contactModuleRulesDisabled: "{actor} kişi modülü kurallarını devre dışı bıraktı.",
            contactModuleRulesRuleAdded: '{actor} kişi modülüne "{ruleName}" kuralını ekledi.',
            contactModuleRulesRuleUpdated: '{actor} kişi modülündeki "{ruleName}" kuralını güncelledi.',
            contactModuleRulesRuleDeleted: '{actor} kişi modülünden "{ruleName}" kuralını sildi.',
            contactModuleRulesRuleEnabled: '{actor} kişi modülündeki "{ruleName}" kuralını aktif etti.',
            contactModuleRulesRuleDisabled: '{actor} kişi modülündeki "{ruleName}" kuralını devre dışı bıraktı.',
            developerTokenChanged: "{actor} geliştirici erişim tokenini güncelledi.",
            tableCreated: '{actor} kullanıcısı "{tableName}" tablosunu oluşturdu.',
            tableDeleted: '{actor} kullanıcısı "{tableName}" tablosunu sildi.',
            tableRestored: '{actor} kullanıcısı "{tableName}" tablosunu çöp sepetinden çıkardı.',
            tablePermanentlyDeleted: '{actor} kullanıcısı "{tableName}" tablosunu çöp sepetinden sildi.',
            tableFieldAdded: '{actor} kullanıcısı "{tableName}" tablosuna "{fieldName}" alanını ekledi.',
            tableFieldUpdated: '{actor} kullanıcısı "{tableName}" tablosundaki "{fieldName}" alanını güncelledi.',
            tableFieldDeleted: '{actor} kullanıcısı "{tableName}" tablosundan "{fieldName}" alanını sildi.',
            tableViewAdded: '{actor} kullanıcısı "{tableName}" tablosuna "{viewName}" görünümünü ekledi.',
            tableViewUpdated: '{actor} kullanıcısı "{tableName}" tablosundaki "{viewName}" görünümünü güncelledi.',
            tableViewDeleted: '{actor} kullanıcısı "{tableName}" tablosundan "{viewName}" görünümünü sildi.',
            tablePageAdded: '{actor} kullanıcısı "{tableName}" tablosuna "{pageName}" sayfasını ekledi.',
            tablePageUpdated: '{actor} kullanıcısı "{tableName}" tablosundaki "{pageName}" sayfasını güncelledi.',
            tablePageDeleted: '{actor} kullanıcısı "{tableName}" tablosundan "{pageName}" sayfasını sildi.',
            tableWidgetAdded:
                '{actor} kullanıcısı "{tableName}" tablosundaki "{pageName}" sayfasına "{widgetTitle}" ({widgetType}) widget\'ı ekledi.',
            tableWidgetUpdated:
                '{actor} kullanıcısı "{tableName}" tablosundaki "{pageName}" sayfasındaki "{widgetTitle}" ({widgetType}) widget\'ını güncelledi.',
            tableWidgetDeleted:
                '{actor} kullanıcısı "{tableName}" tablosundaki "{pageName}" sayfasından "{widgetTitle}" ({widgetType}) widget\'ını sildi.',
            tablePermissionChanged: '{actor} kullanıcısı "{tableName}" tablosunun gizlilik ayarlarını güncelledi.',
            tableDataDownloaded: '{actor} kullanıcısı "{tableName}" tablosundan {recordCount} kayıt indirdi.',
            tableDataImported: '{actor} kullanıcısı "{tableName}" tablosuna {successCount}/{recordCount} kayıt ekledi.',
            tableDataBatchUpdated:
                '{actor} kullanıcısı "{tableName}" tablosunda {recordCount} kaydın "{fieldName}" alanını toplu güncelledi.',
            tableDataBatchDeleted: '{actor} kullanıcısı "{tableName}" tablosundan {recordCount} kaydı toplu sildi.',
            contactDataDownloaded: "{actor} kullanıcısı {contactCount} kişi verisini indirdi.",
            contactBatchUpdated: "{actor} kullanıcısı {contactCount} kişi için toplu {action} işlemi yaptı.",
            chatDataDownloaded: "{actor} kullanıcısı {chatCount} sohbet geçmişini indirdi.",
            chatDataDownloadedWithVisitor: '{actor} kullanıcısı "{visitorName}" ile olan sohbet geçmişini indirdi.',
            visitorTagAdded: "{actor} {visitorName} kullanıcısına {tagNames} etiketini ekledi.",
            visitorTagRemoved: "{actor} {visitorName} kullanıcısından {tagNames} etiketini kaldırdı.",
            unknownVisitor: "Bilinmeyen Kişi",
            tagsLabel: "Etiketler",
            webAppCreated: '{actor} kullanıcısı "{appName}" ({appSlug}) web uygulamasını oluşturdu.',
            webAppUpdated: '{actor} kullanıcısı "{appName}" ({appSlug}) web uygulamasını güncelledi.',
            webAppDeleted: '{actor} kullanıcısı "{appName}" ({appSlug}) web uygulamasını sildi.',
            webTabCreated: '{actor} kullanıcısı "{tabName}" web sekmesini {placement} ekledi.',
            webTabUpdated: '{actor} kullanıcısı "{tabName}" web sekmesini güncelledi.',
            webTabDeleted: '{actor} kullanıcısı "{tabName}" ({placement}) web sekmesini sildi.',
            moduleCreated: '{actor} kullanıcısı "{moduleName}" {moduleType} oluşturdu.',
            moduleUpdated: '{actor} kullanıcısı "{moduleName}" {moduleType} güncelledi.',
            moduleDeleted: '{actor} kullanıcısı "{moduleName}" {moduleType} sildi.',
            relationCreated: '{actor} kullanıcısı "{relationName}" ilişkisini oluşturdu.',
            relationUpdated: '{actor} kullanıcısı "{relationName}" ilişkisini güncelledi.',
            voiceAgentCreated: '{actor} kullanıcısı "{agentName}" ({agentId}) ses agentını oluşturdu.',
            voiceAgentUpdated: '{actor} kullanıcısı "{agentName}" ({agentId}) ses agentını güncelledi.',
            voiceAgentDeleted: '{actor} kullanıcısı "{agentName}" ({agentId}) ses agentını sildi.',
            voiceAgentPhoneNumberInboundAgentChanged:
                '{actor} kullanıcısı {phoneNumber} numarasının gelen çağrı agentını "{agentName}" olarak değiştirdi.',
            voiceAgentPhoneNumberOutboundAgentChanged:
                '{actor} kullanıcısı {phoneNumber} numarasının giden çağrı agentını "{agentName}" olarak değiştirdi.',
            voiceAgentBatchCallCreated:
                '{actor} kullanıcısı "{batchCallName}" toplu aramasını oluşturdu ({taskCount} kişi).',
            voiceAgentKnowledgeBaseCreated: '{actor} kullanıcısı "{knowledgeBaseName}" bilgi tabanını oluşturdu.',
            voiceAgentKnowledgeBaseDeleted: '{actor} kullanıcısı "{knowledgeBaseName}" bilgi tabanını sildi.',
            webTabCreatedNotification: "Web sekmesi oluşturulduğunda.",
            webTabUpdatedNotification: "Web sekmesi güncellendiğinde.",
            webTabDeletedNotification: "Web sekmesi silindiğinde.",
            moduleCreatedNotification: "Modül veya ilişki oluşturulduğunda.",
            moduleUpdatedNotification: "Modül veya ilişki güncellendiğinde.",
            moduleDeletedNotification: "Modül veya ilişki silindiğinde.",
            relationCreatedNotification: "İlişki oluşturulduğunda.",
            relationUpdatedNotification: "İlişki güncellendiğinde.",
            voiceAgentCreatedNotification: "Ses agenti oluşturulduğunda.",
            voiceAgentUpdatedNotification: "Ses agenti güncellendiğinde.",
            voiceAgentDeletedNotification: "Ses agenti silindiğinde.",
            voiceAgentPhoneNumberInboundAgentChangedNotification:
                "Telefon numarasının gelen çağrı agenti değiştirildiğinde.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification:
                "Telefon numarasının giden çağrı agenti değiştirildiğinde.",
            voiceAgentBatchCallCreatedNotification: "Toplu arama oluşturulduğunda.",
            voiceAgentKnowledgeBaseCreatedNotification: "Bilgi tabanı oluşturulduğunda.",
            voiceAgentKnowledgeBaseDeletedNotification: "Bilgi tabanı silindiğinde.",
            formDeletedNotification: "Form silindiğinde.",
            formRestoredNotification: "Form çöp sepetinden geri çıkarıldığında.",
            formCreatedNotification: "Form oluşturulduğunda.",
            formUpdatedNotification: "Form güncellendiğinde.",
            formDownloadedNotification: "Form verileri indirildiğinde.",
            userRoleChangedNotification: "Kullanıcı rolü değiştiğinde.",
            userPasswordChangedNotification: "Kullanıcı şifresi değiştiğinde.",
            userEmailChangedNotification: "Kullanıcı email adresi değiştiğinde.",
            userNameChangedNotification: "Kullanıcı adı değiştiğinde.",
            userPhoneChangedNotification: "Kullanıcı telefon numarası değiştiğinde.",
            userDisabledNotification: "Kullanıcı devre dışı bırakıldığında veya aktif edildiğinde.",
            roleUpdatedNotification: "Rol güncellendiğinde.",
            taskWorkflowUpdatedNotification: "İş akışı güncellendiğinde.",
            taskWorkflowPermanentlyDeletedNotification: "İş akışı çöp sepetinden silindiğinde.",
            taskWorkflowPipelineStageAddedNotification: "İş akışına yeni aşama eklendiğinde.",
            taskWorkflowPipelineStageUpdatedNotification: "İş akışındaki aşama güncellendiğinde.",
            taskWorkflowPipelineStageDeletedNotification: "İş akışından aşama silindiğinde.",
            driveFolderCreatedNotification: "Drive klasörü oluşturulduğunda.",
            driveFolderDeletedNotification: "Drive klasörü silindiğinde.",
            driveFolderRenamedNotification: "Drive klasörü yeniden adlandırıldığında.",
            driveFileAddedNotification: "Drive'a dosya eklendiğinde.",
            driveFileDeletedNotification: "Drive'dan dosya silindiğinde.",
            taskModuleRulesEnabledNotification: "Görev kuralları aktif edildiğinde.",
            taskModuleRulesDisabledNotification: "Görev kuralları devre dışı bırakıldığında.",
            taskModuleRulesRuleAddedNotification: "İş akışına yeni kural eklendiğinde.",
            taskModuleRulesRuleDeletedNotification: "İş akışından kural silindiğinde.",
            taskModuleRulesRuleUpdatedNotification: "İş akışında kural güncellendiğinde.",
            taskModuleRulesRuleEnabledNotification: "İş akışında kural aktif edildiğinde.",
            taskModuleRulesRuleDisabledNotification: "İş akışında kural devre dışı bırakıldığında.",
            contactModuleRulesEnabledNotification: "Kişi modülü kuralları aktif edildiğinde.",
            contactModuleRulesDisabledNotification: "Kişi modülü kuralları devre dışı bırakıldığında.",
            contactModuleRulesRuleAddedNotification: "Kişi modülüne yeni kural eklendiğinde.",
            contactModuleRulesRuleUpdatedNotification: "Kişi modülündeki kural güncellendiğinde.",
            contactModuleRulesRuleDeletedNotification: "Kişi modülünden kural silindiğinde.",
            contactModuleRulesRuleEnabledNotification: "Kişi modülündeki kural aktif edildiğinde.",
            contactModuleRulesRuleDisabledNotification: "Kişi modülündeki kural devre dışı bırakıldığında.",
            developerTokenChangedNotification: "Geliştirici erişim tokenini güncellendiğinde.",
            tableCreatedNotification: "Yeni tablo oluşturulduğunda.",
            tableDeletedNotification: "Tablo silindiğinde.",
            tableRestoredNotification: "Tablo çöp sepetinden çıkarıldığında.",
            tablePermanentlyDeletedNotification: "Tablo çöp sepetinden silindiğinde.",
            tableFieldAddedNotification: "Tabloya yeni alan eklendiğinde.",
            tableFieldUpdatedNotification: "Tablodaki alan güncellendiğinde.",
            tableFieldDeletedNotification: "Tablodan alan silindiğinde.",
            tableViewActionsNotification: "Tablo görünümü eklendiğinde, güncellendiğinde veya silindiğinde.",
            tablePageActionsNotification: "Tablo sayfası eklendiğinde, güncellendiğinde veya silindiğinde.",
            tableWidgetActionsNotification: "Tablo sayfasına widget eklendiğinde, güncellendiğinde veya silindiğinde.",
            tablePermissionChangedNotification: "Tablo gizlilik ayarları güncellendiğinde.",
            tableDataDownloadedNotification: "Tablo verileri indirildiğinde.",
            tableDataImportedNotification: "Tabloya toplu kayıt eklendiğinde.",
            tableDataBatchUpdatedNotification: "Tabloda toplu güncelleme yapıldığında.",
            tableDataBatchDeletedNotification: "Tablodan toplu kayıt silindiğinde.",
            contactBatchUpdatedNotification: "Kişiler toplu güncellendiğinde.",
            chatDataDownloadedNotification: "Sohbet geçmişi indirildiğinde.",
            webAppCreatedNotification: "Web uygulaması oluşturulduğunda.",
            webAppUpdatedNotification: "Web uygulaması güncellendiğinde.",
            webAppDeletedNotification: "Web uygulaması silindiğinde.",
            formActions: "Form oluşturulduğunda, güncellendiğinde veya silindiğinde.",
            userInfoActions:
                "Kullanıcı bilgileri, rolleri, şifresi, email adresi, adı, telefonu, durumu gibi bilgiler değiştiğinde.",
            roleActions: "Roller güncellendiğinde.",
            driveActions: "Drive klasör ve dosya işlemleri.",
            developerActions: "Geliştirici erişim tokenini güncellendiğinde.",
            contactModuleRulesActions:
                "Kişi modülü kuralları aktif/devre dışı bırakıldığında, yeni kural eklendiğinde, güncellendiğinde, silindiğinde veya kural aktif/devre dışı bırakıldığında.",
            tableActions:
                "Tablo oluşturulduğunda, tabloya alan eklendiğinde, alan güncellendiğinde ve alan silindiğinde.",
            taskAssignedMe: "Bir görev bana atandığında.",
            workflowCreated: "İş akışı oluşturulduğunda.",
            workflowDeleted: "İş akışı silindiğinde.",
            createdTask: "Görev oluşturulduğunda",
            deletedTask: "Görev silindiğinde.",
            chatbotStoryCrud: "Chatbot hikayesi oluşturuldu, güncellendi veya silindi",
            chatbotForwardAgent: "Chatbot, bir sohbeti bir ajana yönlendirir",
            userSegmentCrud: "Kullanıcı segmenti oluşturuldu, güncellendi veya silindi",
            chatbotCreditLow: "Chatbot kredisi düşük olduğunda",
            automationTaskCreditLow: "Otomasyon görevi kredisi %90 dolduğunda",
            automationTaskCreditDone: "Otomasyon görevi kredisi bittiğinde",
            wpCreditLow: "WhatsApp kredisi 100TL'nin altına indiğinde.",
            wpCustomerGroupCrud: "WhatsApp müşteri grubu oluştuğunda, güncellendiğinde veya silindiğinde.",
            wpBroadcastMessageStatus:
                "WhatsApp toplu mesaj gönderimine başlandığında, tamamlandığında veya iptal edildiğinde.",
            wpTemplateMesssageCrud: "WhatsApp şablon mesajı oluştuğunda, güncellendiğinde veya silindiğinde.",
            whatsappQrChannelStatusUpdated: "WhatsApp QR kanalı bağlantı durumu güncellendiğinde.",
            wabaSupsisPartnerRemove: "Whatsapp Business API V2 partner kaldırıldığında.",
            wabaSupsisAccountDeleted: "Whatsapp Business API V2 hesabı silindiğinde.",
            wabaSupsisAccountViolation: "Whatsapp Business API V2 hesap ihlali tespit edildiğinde.",
            wabaSupsisAdAccountLinked: "Whatsapp Business API V2 reklam hesabı bağlandığında.",
            wabaSupsisAuthIntlPriceEligibilityUpdate:
                "Whatsapp Business API V2 uluslararası fiyat uygunluk güncellemesi yapıldığında.",
            wabaSupsisDisabledUpdate: "Whatsapp Business API V2 devre dışı bırakma güncellemesi yapıldığında.",
            wabaSupsisMmLiteTermsSigned: "Whatsapp Business API V2 MM Lite şartları imzalandığında.",
            wabaSupsisPartnerAdded: "Whatsapp Business API V2 partner eklendiğinde.",
            wabaSupsisPartnerAppInstalled: "Whatsapp Business API V2 partner uygulaması yüklendiğinde.",
            wabaSupsisPartnerAppUninstalled: "Whatsapp Business API V2 partner uygulaması kaldırıldığında.",
            wabaSupsisPartnerClientCertificationStatusUpdate:
                "Whatsapp Business API V2 partner müşteri sertifikasyon durumu güncellendiğinde.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate:
                "Whatsapp Business API V2 birincil konum ülkesi güncellendiğinde.",
            wabaSupsisVolumeBasedPricingTierUpdate:
                "Whatsapp Business API V2 hacim bazlı fiyatlandırma seviyesi güncellendiğinde.",
            wabaSupsisMessageTemplateComponentsUpdate:
                "Whatsapp Business API V2 mesaj şablonu bileşenleri güncellendiğinde.",
            wabaSupsisMessageTemplateStatusUpdate: "Whatsapp Business API V2 mesaj şablonu durumu güncellendiğinde.",
            wabaSupsisTemplateCategoryUpdate: "Whatsapp Business API V2 şablon kategorisi güncellendiğinde.",
            activityTypeLabels: {
                "chat-assign": "Bir sohbet bana atandığında",
                "ticket-assign": "Bir ticket bana atandığında",
                "task-assign": "Bir görev bana atandığında",
                "task-complet": "Bir görev tamamlandığında",
                "chat-close-own": "Sahip olduğum bir sohbet kapatıldığında",
                "tag-actions-to-visitor": "Bir kişiye etiket eklendiğinde veya kaldırıldığında",
                "create-ticket":
                    "Ziyaretçi veya chatbot bir ticket oluşturduğunda. Ayrıca, sohbetten çevrimdışı mesaj gönderildiğinde",
                "note-actions-to-visitor": "Bir kişiye not eklendiğinde veya kaldırıldığında",
                "visitor-profile-updates": "Ziyaretçi profili güncellendiğinde",
                "chat-start": "Herhangi bir platformda kişi veya temsilci tarafından sohbet başlatıldığında",
                "user-crud": "Kullanıcı oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "department-crud": "Departman oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "settings-crud": "Ayarlar oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "integration-channel-crud": "Entegrasyon kanalı oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "login-form-crud": "Giriş formu güncellendiğinde, etkinleştirildiğinde veya devre dışı bırakıldığında",
                "banned-word-crud": "Yasaklı kelime oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "email-account-crud": "E-posta hesabı oluşturulduğunda veya silindiğinde",
                "prepared-content-crud": "Hazır içerik oluşturulduğunda veya silindiğinde",
                "role-crud": "Rol oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "tag-crud": "Etiket oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "welcome-message-crud": "Hoş geldiniz mesajı oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "webhook-crud": "Webhook oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "automation-created": "Otomasyon oluşturulduğunda",
                "automation-deleted": "Otomasyon silindiğinde",
                "automation-restored": "Otomasyon çöp sepetinden çıkarıldığında",
                "automation-published": "Otomasyon yayınlandığında",
                "automation-unpublished": "Otomasyon yayından kaldırıldığında",
                "automation-updated": "Otomasyon güncellendiğinde",
                "billing-events": "Faturalama olayları",
                "task-workflow-crud": "Görev iş akışı oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "task-crud": "Görev oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "system-status": "Sistem çevrimiçi veya çevrimdışı durum değişiklikleri",
                "chatbot-story-crud": "Chatbot hikayesi oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "chatbot-forward-chat": "Chatbot bir sohbeti temsilciye yönlendirdiğinde",
                "chatbot-user-segment-crud": "Kullanıcı segmenti oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "chatbot-credit-low": "Chatbot kredisi düşük olduğunda",
                "whatsapp-credit-low": "WhatsApp kredisi düşük olduğunda",
                "whatsapp-customer-group-crud":
                    "WhatsApp müşteri grubu oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "whatsapp-broadcast-message-crud":
                    "WhatsApp toplu mesaj gönderildiğinde, tamamlandığında veya iptal edildiğinde",
                "whatsapp-template-message-crud":
                    "WhatsApp şablon mesajı oluşturulduğunda, güncellendiğinde veya silindiğinde",
                "waba-supsis-partner-remove": "Whatsapp Business API V2 partner kaldırıldığında",
                "waba-supsis-account-deleted": "Whatsapp Business API V2 hesabı silindiğinde",
                "waba-supsis-account-violation": "Whatsapp Business API V2 hesap ihlali tespit edildiğinde",
                "waba-supsis-ad-account-linked": "Whatsapp Business API V2 reklam hesabı bağlandığında",
                "waba-supsis-auth-intl-price-eligibility-update":
                    "Whatsapp Business API V2 uluslararası fiyat uygunluk güncellemesi yapıldığında",
                "waba-supsis-disabled-update": "Whatsapp Business API V2 devre dışı bırakma güncellemesi yapıldığında",
                "waba-supsis-mm-lite-terms-signed": "Whatsapp Business API V2 MM Lite şartları imzalandığında",
                "waba-supsis-partner-app-installed": "Whatsapp Business API V2 partner uygulaması yüklendiğinde",
                "waba-supsis-partner-app-uninstalled": "Whatsapp Business API V2 partner uygulaması kaldırıldığında",
                "waba-supsis-partner-client-certification-status-update":
                    "Whatsapp Business API V2 partner müşteri sertifikasyon durumu güncellendiğinde",
                "waba-supsis-business-primary-location-country-update":
                    "Whatsapp Business API V2 birincil konum ülkesi güncellendiğinde",
                "waba-supsis-volume-based-pricing-tier-update":
                    "Whatsapp Business API V2 hacim bazlı fiyatlandırma seviyesi güncellendiğinde",
                "waba-supsis-message-template-components-update":
                    "Whatsapp Business API V2 mesaj şablonu bileşenleri güncellendiğinde",
                "waba-supsis-message-template-status-update":
                    "Whatsapp Business API V2 mesaj şablonu durumu güncellendiğinde",
                waba_supsis_partner_remove: "Whatsapp Business API V2 partner kaldırıldı",
                waba_supsis_account_deleted: "Whatsapp Business API V2 hesabı silindi",
                waba_supsis_account_violation: "Whatsapp Business API V2 hesap ihlali tespit edildi",
                waba_supsis_ad_account_linked: "Whatsapp Business API V2 reklam hesabı bağlandı",
                waba_supsis_auth_intl_price_eligibility_update:
                    "Whatsapp Business API V2 uluslararası fiyat uygunluk güncellemesi",
                waba_supsis_disabled_update: "Whatsapp Business API V2 devre dışı bırakma güncellemesi",
                waba_supsis_mm_lite_terms_signed: "Whatsapp Business API V2 MM Lite şartları imzalandı",
                waba_supsis_partner_added: "Whatsapp Business API V2 partner eklendi",
                waba_supsis_partner_app_installed: "Whatsapp Business API V2 partner uygulaması yüklendi",
                waba_supsis_partner_app_uninstalled: "Whatsapp Business API V2 partner uygulaması kaldırıldı",
                waba_supsis_partner_client_certification_status_update:
                    "Whatsapp Business API V2 partner müşteri sertifikasyon durumu güncellendi",
                waba_supsis_business_primary_location_country_update:
                    "Whatsapp Business API V2 birincil konum ülkesi güncellendi",
                waba_supsis_volume_based_pricing_tier_update:
                    "Whatsapp Business API V2 hacim bazlı fiyatlandırma seviyesi güncellendi",
                waba_supsis_message_template_components_update:
                    "Whatsapp Business API V2 mesaj şablonu bileşenleri güncellendi",
                waba_supsis_message_template_status_update: "Whatsapp Business API V2 mesaj şablonu durumu güncellendi",
                waba_supsis_template_category_update: "Whatsapp Business API V2 şablon kategorisi güncellendi",
                waba_supsis_PARTNER_REMOVE: "Whatsapp Business API V2 partner kaldırıldı",
                waba_supsis_ACCOUNT_DELETED: "Whatsapp Business API V2 hesabı silindi",
                "form-created": "Form oluşturulduğunda",
                "form-updated": "Form güncellendiğinde",
                "form-deleted": "Form silindiğinde",
                "form-restored": "Form geri çıkarıldığında",
                "form-downloaded": "Form indirildiğinde",
                "user-role-changed": "Kullanıcı rolü değiştiğinde",
                "user-password-changed": "Kullanıcı şifresi değiştiğinde",
                "user-email-changed": "Kullanıcı email adresi değiştiğinde",
                "user-name-changed": "Kullanıcı adı değiştiğinde",
                "user-phone-changed": "Kullanıcı telefonu değiştiğinde",
                "user-disabled": "Kullanıcı devre dışı/aktif edildiğinde",
                "role-updated": "Rol güncellendiğinde",
                "task-workflow-updated": "İş akışı güncellendiğinde",
                "task-workflow-restored": "İş akışı çöp sepetinden çıkarıldığında",
                "task-workflow-permanently-deleted": "İş akışı çöp sepetinden silindiğinde",
                "task-workflow-pipeline-stage-added": "İş akışına aşama eklendiğinde",
                "task-workflow-pipeline-stage-updated": "İş akışı aşaması güncellendiğinde",
                "task-workflow-pipeline-stage-deleted": "İş akışı aşaması silindiğinde",
                "drive-folder-created": "Drive klasörü oluşturulduğunda",
                "drive-folder-deleted": "Drive klasörü silindiğinde",
                "drive-folder-renamed": "Drive klasörü yeniden adlandırıldığında",
                "drive-file-added": "Drive'a dosya eklendiğinde",
                "drive-file-deleted": "Drive'dan dosya silindiğinde",
                "task-module-rules-enabled": "Görev kuralları aktif edildiğinde",
                "task-module-rules-disabled": "Görev kuralları devre dışı bırakıldığında",
                "task-module-rules-rule-added": "İş akışına kural eklendiğinde",
                "task-module-rules-rule-deleted": "İş akışından kural silindiğinde",
                "task-module-rules-rule-updated": "İş akışında kural güncellendiğinde",
                "task-module-rules-rule-enabled": "İş akışında kural aktif edildiğinde",
                "task-module-rules-rule-disabled": "İş akışında kural devre dışı bırakıldığında",
                "contact-module-rules-enabled": "Kişi modülü kuralları aktif edildiğinde",
                "contact-module-rules-disabled": "Kişi modülü kuralları devre dışı bırakıldığında",
                "contact-module-rules-rule-added": "Kişi modülüne kural eklendiğinde",
                "contact-module-rules-rule-updated": "Kişi modülündeki kural güncellendiğinde",
                "contact-module-rules-rule-deleted": "Kişi modülünden kural silindiğinde",
                "contact-module-rules-rule-enabled": "Kişi modülündeki kural aktif edildiğinde",
                "contact-module-rules-rule-disabled": "Kişi modülündeki kural devre dışı bırakıldığında",
                "developer-token-changed": "Geliştirici tokenı güncellendiğinde",
                "table-created": "Tablo oluşturulduğunda",
                "table-deleted": "Tablo silindiğinde",
                "table-restored": "Tablo çöp sepetinden çıkarıldığında",
                "table-permanently-deleted": "Tablo çöp sepetinden silindiğinde",
                "table-field-added": "Tabloya alan eklendiğinde",
                "table-field-updated": "Tablodaki alan güncellendiğinde",
                "table-field-deleted": "Tablodan alan silindiğinde",
                "table-view-added": "Tabloya görünüm eklendiğinde",
                "table-view-updated": "Tablodaki görünüm güncellendiğinde",
                "table-view-deleted": "Tablodan görünüm silindiğinde",
                "table-page-added": "Tabloya sayfa eklendiğinde",
                "table-page-updated": "Tablodaki sayfa güncellendiğinde",
                "table-page-deleted": "Tablodan sayfa silindiğinde",
                "table-widget-added": "Tablo sayfasına widget eklendiğinde",
                "table-widget-updated": "Tablo sayfasındaki widget güncellendiğinde",
                "table-widget-deleted": "Tablo sayfasından widget silindiğinde",
                "table-privacy-changed": "Tablo gizlilik ayarları güncellendiğinde",
                "web-app-created": "Web uygulaması oluşturulduğunda",
                "web-app-updated": "Web uygulaması güncellendiğinde",
                "web-app-deleted": "Web uygulaması silindiğinde",
                "web-tab-created": "Web sekmesi oluşturulduğunda",
                "web-tab-updated": "Web sekmesi güncellendiğinde",
                "web-tab-deleted": "Web sekmesi silindiğinde",
                "module-created": "Modül oluşturulduğunda",
                "module-updated": "Modül güncellendiğinde",
                "module-deleted": "Modül silindiğinde",
                "relation-created": "İlişki oluşturulduğunda",
                "relation-updated": "İlişki güncellendiğinde",
                "voice-agent-created": "Ses agenti oluşturulduğunda",
                "voice-agent-updated": "Ses agenti güncellendiğinde",
                "voice-agent-deleted": "Ses agenti silindiğinde",
                "voice-agent-phone-number-inbound-agent-changed":
                    "Telefon numarası gelen çağrı agenti değiştirildiğinde",
                "voice-agent-phone-number-outbound-agent-changed":
                    "Telefon numarası giden çağrı agenti değiştirildiğinde",
                "voice-agent-batch-call-created": "Toplu arama oluşturulduğunda",
                "voice-agent-knowledge-base-created": "Bilgi tabanı oluşturulduğunda",
                "voice-agent-knowledge-base-deleted": "Bilgi tabanı silindiğinde",
                "table-data-downloaded": "Tablo verileri indirildiğinde",
                "table-data-imported": "Tabloya toplu veri aktarıldığında",
                "table-data-batch-updated": "Tablo verileri toplu güncellendiğinde",
                "table-data-batch-deleted": "Tablo verileri toplu silindiğinde",
                "contact-batch-updated": "Kişiler toplu güncellendiğinde",
                "chat-data-downloaded": "Sohbet geçmişi indirildiğinde",
            },
            mobileApp: "Mobil Uygulama",
            webPanel: "Web Paneli",
            notifications: "Bildirimler",
            whatsappActions: "Cüzdan Aksiyonları",
            chatbotActions: "Chatbot Aksiyonları",
            companyActions: "Şirket Aksiyonları",
            crmActions: "CRM Aksiyonları",
            basicActions: "Temel Aksiyonlar",
            notificationSettingsDesc:
                "Hangi bildirimleri almak istediğinizi ve bunları nerede almak istediğinizi seçin.",
            noNotificationDesc2:
                "Burada takip ettiğiniz işler, adaylar ve yetenek havuzlarıyla ilgili tüm bildirimler görüntülenecektir. Bildirimleri ayarları düzenleyerek ayarlayabilirsiniz.",
            noNotificationTitle2: "Henüz bildirim yok.",
            noNotificationTitle1: "Bildirim yok. Sessizliğin tadını çıkarın.",
            adjustSettings: "Ayarları düzenle",
            showAll: "Tümünü göster",
            showOnlyUnread: "Sadece okunmayanları göster",
            mailWasSent: "Mail Gönderildi.",
            mailAdressRemoved: "Mail adresi kaldırıldı.",
            chatbotPublished: "Chatbotun <b>{version}</b> versiyonu <b>{user}</b> tarafından yayınlandı.",
            chatbotDeleted: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından silindi.",
            chatbotRestored: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından çöp sepetinden çıkarıldı.",
            settingsUpdatedWoDetail: "Ayarlar <b>{user}</b> tarafından güncellendi.",
            noActivityDesc: "Şu anda sistemde herhangi bir hareket bulunmuyor. Birkaç olayın gerçekleşmesi gerekiyor",
            noActivityTitle: "Henüz hareket yok",
            actionType: "Hareket Tipi",
            dateBetween: "Zaman aralığı",
            selectActor: "Kullanıcı Seçimi",
            activities: "Hareketler",
            chatbotCreated: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından oluşturuldu.",
            taskAddedTags: "<b>{user}</b> bu göreve (<b>{taskTitle}</b>) şu etiketleri ekledi: <b>{tags}</b>",
            taskStageChanged:
                "<b>{task}</b> görevinin <b>{oldStage}</b> olan durumu <b>{user}</b> tarafından <b>{newStage}</b> olarak değiştirildi.",
            taskCreated: "<b>{task}</b> görevi <b>{user}</b> tarafından oluşturuldu.",
            contactPropRemoved: "<b>{prop}</b> ziyaretçi bilgisi <b>{user}</b> tarafından kaldırıldı.",
            contactPropAdded: "<b>{prop}</b> ziyaretçi bilgisi <b>{user}</b> tarafından oluşturuldu.",
            userRemoved: "<b>{oldUser}</b> kullanıcısı <b>{user}</b> tarafından silindi",
            loginFormUpdated: "Ziyaretçi giriş formu <b>{user}</b> tarafından güncellendi.",
            loginFormDeactivated: "Ziyaretçi giriş formu <b>{user}</b> tarafından devre dışı bırakıldı.",
            loginFormActivated: "Ziyaretçi giriş formu <b>{user}</b> tarafından aktif edildi.",
            invoiceRefunded: "İade işlemi <b>{user}</b> tarafından yapıldı.",
            paymentMethodAdded: "Yeni bir ödeme yöntemi <b>{user}</b> tarafından eklendi.",
            invoicePaymentFailed: "Fatura ödeme işlemi <b>{user}</b> tarafından kabul edilmedi.",
            invoicePaymentReceived: "Fatura ödeme işlemi <b>{user}</b> tarafından kabul edildi.",
            planStarted: "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>({altTitle})</b> aboneliğini başlattı.",
            planStartedAgent:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({details} Temsilci)</b> aboneliğini başlattı.",
            planStartedChatbot:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({chatbot} Session)</b> aboneliğini başlattı.",
            planStartedWhatsapp:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsapp} Whatsapp Channels)</b> aboneliğini başlattı.",
            planStartedWhatsappApi:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsappApi} Whatsapp Business Channels)</b> aboneliğini başlattı.",
            PlanCanceled: "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>({altTitle})</b> aboneliğini iptal etti.",
            planCanceledAgent:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({details} Temsilci)</b> aboneliğini iptal etti.",
            planCanceledChatbot:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({chatbot} Session)</b> aboneliğini iptal etti.",
            planCanceledWhatsapp:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsapp} Whatsapp Channels)</b> aboneliğini iptal etti.",
            planCanceledWhatsappApi:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsappApi} Whatsapp Business Channels)</b>  aboneliğini iptal etti.",
            invoiceCreated: "Fatura <b>{user}</b> tarafından oluşturuldu.",
            billingAddressUpdated: "Adres bilgileri <b>{user}</b> tarafından güncellendi",
            taskWorkflowDeleted: "<b>{workflow}</b> iş akışı <b>{user}</b> tarafından silindi.",
            taskWorkflowRestored: "<b>{workflow}</b> iş akışı <b>{user}</b> tarafından çöp sepetinden çıkarıldı.",
            taskWorkflowPermanentlyDeleted:
                "<b>{workflow}</b> iş akışı <b>{user}</b> tarafından çöp sepetinden silindi.",
            whatsappBroadcastFailed: "<b>{title}</b> başlıklı toplu mesaj gönderimi başarısız oldu.",
            whatsappBroadcastCancelled: "<b>{title}</b> başlıklı toplu mesajın gönderimi iptal edildi.",
            whatsappBroadcastCompleted:
                "<b>{title}</b> başlıklı toplu mesaj <b>{numbers}</b> kişiye başarıyla gönderildi.",
            whatsappBroadcastCreated:
                "<b>{title}</b> başlıklı toplu mesaj <b>{user}</b> tarafından <b>{numbers}</b> kişiye gönderildi.",
            ticketAssigned: "<b>{user2}</b> kisisine <b>{user1}</b> tarafından ticket atandı.",
            userLoggenIn: "<b>{user}</b> SUPSIS'e giriş yaptı.",
            chatJoined: "<b>{visitor}</b> ile olan görüşmeye <b>{agent}</b> katıldı.",
            chatForwarded:
                "<b>{visitor}</b> ile olan görüşme <b>{user}</b> tarafından <b>{agent}</b> temsilcisine aktarıldı. ",
            chatAssigned:
                "<b>{visitor}</b> ile olan görüşme sistem tarafından <b>{agent}</b> temsilcisine yönlendirildi.",
            customerGroupUpdated: "<b>{group}</b> isimli grup <b>{user}</b> tarafından güncellendi.",
            customerGroupRemoved: "<b>{group}</b> isimli grup <b>{user}</b> tarafından silindi.",
            customerGroupAdded: "<b>{group}</b> isimli grup <b>{user}</b> tarafından oluşturuldu.",
            contentRemoved: "<b>{content}</b> hazır içeriği <b>{user}</b> tarafından kaldırıldı.",
            contentAdded: "<b>{content}</b> hazır içeriği <b>{user}</b> tarafından eklendi.",
            channelVisibilityChanged:
                "<b>{channel}</b> entegrasyon kanalının görünürlüğü <b>{user}</b> tarafından değiştirildi.",
            channelForwardConfigUpdated:
                '{actor} kullanıcısı "{channelName}" {channelType} kanal yönlendirme yapılandırmasını güncelledi.',
            channelZohoConfigUpdated:
                '{actor} kullanıcısı "{channelName}" {channelType} Zoho entegrasyon yapılandırmasını güncelledi.',
            taskDeleted: "<b>{task}</b> görevi <b>{user}</b> tarafından silindi.",
            taskCompleted: "<b>{task}</b> görevi <b>{user}</b> tarafından tamamlandı.",
            taskArchived: "<b>{user}</b> tarafından, <b>{task}</b> görevi arşivlendi.",
            userRemovedToDepartment:
                "<b>{user2}</b> kullanıcısı <b>{user1}</b> tarafından <b>{department}</b> departmanından çıkarıldı.",
            userAddedToDepartment:
                "<b>{user2}</b> kullanıcısı <b>{user1}</b> tarafından <b>{department}</b> departmanına eklendi.",
            mailAddressAdded: "<b>{email}</b> mail adresi <b>{user}</b> tarafından eklendi",
            settingUpdate: "<b>{user}</b> tarafından güncellendi:",
            taskWFlowCreated: "<b>{Wflow}</b> iş akışı <b>{user}</b> tarafından oluşturuldu.",
            bannedWordRemoved: "<b>{bWord}</b> yasaklı kelimesi <b>{user}</b> tarafından silindi.",
            bannedWordCreated: "<b>{bWord}</b> yasaklı kelimesi <b>{user}</b> tarafından eklendi.",
            taskPriorityUpdated:
                "<b>{user}</b> kullanıcısı <b>{taskTitle}</b> görev önceliğini <b>{oldPriority}</b> seviyesinden <b>{newPriority}</b> seviyesine değiştirdi",
            welcomeMessageRemoved: "<b>{welcome}</b> karşılama mesajı <b>{user}</b> tarafından silindi.",
            welcomeMessageAdded: "<b>{welcome}</b> karşılama mesajı <b>{user}</b> tarafından oluşturuldu.",
            tagRemoved: "<b>{tag}</b> etiketi <b>{user}</b> tarafından kaldırıldı.",
            tagAdded: "<b>{tag}</b> etiketi <b>{user}</b> tarafından eklendi.",
            roleRemoved: "<b>{role}</b> rolü <b>{user}</b> tarafından kaldırıldı.",
            roleAdded: "<b>{role}</b> rolü <b>{user}</b> tarafından eklendi.",
            departmentRemoved: "<b>{department}</b> departmanı <b>{user}</b> tarafından silindi.",
            departmentAdded: "<b>{department}</b> departmanı <b>{user}</b> tarafından eklendi.",
            triggerUpdated: "Bir tetikleyici <b>{user}</b> tarafından güncellendi.",
            triggerRemoved: "Bir tetikleyici <b>{user}</b> tarafından kaldırıldı.",
            triggerAdded: "Yeni bir tetikleyici <b>{user}</b> tarafından oluşturuldu.",
            webhookRemoved: "<b>{user1}</b> ait webhook, <b>{user2}</b> tarafından kaldırıldı.",
            webhookAdded: "<b>{user1}</b> tarafından eklenen webhook, <b>{user2}</b> tarafından eklendi.",
            webhookUpdated: '{actor} kullanıcısı "{webhookName}" webhook\'unu güncelledi ({webhookUrl}).',
            chatClosed: "<b>{visitor}</b> ile olan konuşma <b>{agent}</b> tarafından sonlandırıldı.",
            chatOwnerUpdated:
                "<b>{agent}</b> temsilcisi <b>{visitor}</b> ziyaretcisini <b>{oldOwner}</b> temsilcisinden <b>{newOwner}</b> temsilcisine sahip olarak atadı.",
            customerOwnershipRemoved:
                "<b>{actor}</b>, <b>{visitor}</b> isimli müşteriyi sahipliğini <b>{oldOwner}</b> iken sahipsiz yaptı.",
            customerOwnershipAssigned:
                "<b>{actor}</b>, <b>{visitor}</b> isimli müşterinin sahiplik durumunu sahipsizden <b>{newOwner}</b> olarak atadı.",
            customerOwnershipReassigned:
                "<b>{actor}</b>, <b>{visitor}</b> isimli müşterisinin sahiplik durumunu <b>{oldOwner}</b> sahipken <b>{newOwner}</b> olarak atadı.",
            chatOpenedByAgent:
                "<b>{visitor}</b> ile bir <b>{platform}</b> konuşması <b>{agent}</b> tarafından başlatıldı.",
            chatOpenedByVisitor: "Bir <b>{platform}</b> konuşması <b>{visitor}</b> tarafından başlatıldı.",
            channelRemoved: "<b>{channel}</b> kanalı <b>{agent}</b> tarafından silindi.",
            userAdded: "<b>{newAgent}</b> isimli temsilci <b>{agent}</b> tarafından oluşturuldu.",
            visitorUnblocked: "<b>{visitor}</b> isimli ziyaretçinin engeli <b>{agent}</b> tarafından kaldırıldı.",
            visitorBlocked: "<b>{visitor}</b> isimli ziyaretçi <b>{agent}</b> tarafından engellendi.",
            userStatusChanged:
                "<b>{name}</b> isimli temsilci <b>{oldStatus}</b> olan durumunu <b>{newStatus}</b> olarak değiştirdi.",
            channelCreated: "<b>{channel}</b> isimli kanal <b>{name}</b> tarafından oluşturuldu.",
            reservationCreatedPlan:
                "<b>{name}</b> Kullanıcıs, <b>{title}</b> adlı randevuyu <b>{date}</b> tarihine planladı.",
            reservationUpdatedPlan: "<b>{name}</b> Kullanıcısı, <b>{title}</b> randevusunu güncelledi.",
            reservationDeletedPlan: "<b>{name}</b> Kullanıcısı, <b>{title}</b> adlı randevuyu sildi.",
            reservationCreated:
                "<b>{name}</b> Kullanıcısı ve <b>{visitor}</b> ziyaretçisi ile <b>{date}</b> tarihine randevu oluşturuldu.",
            reservationDeleted:
                "<b>{name}</b> Kullanıcısı ve <b>{visitor}</b> ziyaretçisi arasında planlanan <b>{date}</b> tarihli randevu iptal edilmiştir.",
            taskCrud: "Görev oluşturuldu, güncellendi veya silindi",
            taskWorkflowCrud: "Task workflow is created, updated or deleted",
            userLoggedIn: "<b>{user}</b> logged into SUPSIS.",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Yeni",
                visitor: "Kişi",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Otomasyon",
                table: "Tablo",
                module: "Modül",
                message: "Mesaj",
            },
            calendar: "Takvim",
            soundSettings: "Sesli Bildirimler",
            allNotificationSettings: "Bildirim Ayarları",
            allAuditLogs: "Denetim Günlükleri",
            allNotifications: "Tüm Bildirimler",
            allActivities: "Tüm Aktiviteler",
            workFlow: "İş akışı",
            editTask: "Görev düzenle",
            tasks: "Görevler",
            todo: "Yapılacaklar",
            tapTo: "'{prefix}' işlemleri için ⇥ basın",
            newUsers: "Yeni ⇥ Kullanıcı",
            newTags: "Yeni ⇥ Etiket",
            newRole: "Yeni ⇥ Rol",
            newTrigger: "Yeni ⇥ Tetikleyici",
            newDepartment: "Yeni ⇥ Departman",
            newTicket: "Yeni ⇥ Etiketleri",
            jumpSettings: "Git ⇥ Ayarlar",
            jumpIntegrations: "Git ⇥ Entegrasyonlar",
            jumpTeam: "Git ⇥ Takım",
            jumpUsers: "Git ⇥ Kullanıcılar",
            jumpReport: "Git ⇥ Rapor",
            timingSettings: "Zamanlama ayarları",
            exampleVisitorMail: "Ziyaretçi@mail.com",
            languageAndRegion: "Dil ve Bölge",
            theme: "Tema",
            appearance: "Görünüş - Görünüm",
            color: "Renk",
            background: "Arkaplan",
            smart: "Akıllı",
            teamChat: "Takım Konuşması",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot Eğitimi",
            chatbotUserSegments: "Chatbot Kullanıcı Segmentleri",
            chatbotIntegration: "Chatbot Entegrasyon",
            chatbotEntities: "Chatbot Varlıklar",
            chatbotIntegrationWebHook: "Chatbot WebHook Entegrasyon",
            chatbotArchive: "Chatbot Arşiv",
            chatbotTemplatesAI: "Chatbot Yapay Zeka Şablonları",
            chatbotTemplates: "Chatbot Şablonları",
            chatbotReportsOverall: "Chatbot Genel Raporlar",
            chatbotReportsAllChats: "Chatbot Tüm Sohbetleri Raporlar",
            chatbotReportsRatingDistribution: "Chatbot Raporlarının Derecelendirme Dağılımı",
            chatbotReportsPaidChats: "Chatbot Reports Paid Chats",
            chatbotReportsBusiestPeriod: "Chatbot En Yoğun Dönemi",
            chatbotTemplatesAllMessages: "Chatbot Şablonları Tüm Mesajlar",
            chatbotTemplatesAvarage: "Chatbot Şablonları Ortalaması",
            chatbotTemplatesPopularity: "Chatbot Şablonlarının Popülerliği",
            chatbotTemplatesAllUser: "Chatbot Şablonları Tüm Kullanıcı",
            ticket: "Destek Talepleri",
            archives: "Arşiv",
            tags: "Etiketler",
            offlineSupportRequests: "Offline Support Requests",
            roles: "Roller",
            users: "Kullanıcılar",
            subjects: "Departmanlar",
            contents: "Hazır İçerikler",
            welcomeMessages: "Sistem Mesajları",
            catalog: "Katalog",
            bannedWords: "Yasaklı Kelimeler",
            bannedVisitors: "Yasaklı Ziyaretciler",
            application: "Uygulama",
            mails: "Mailler",
            visitors: "Ziyaretciler",
            integrationsWebhook: "Webhook Entegrasyonu",
            billing: "Fatura",
            reportNew: "Yeni Rapor",
            integrations: "Entegrasyonlar",
            chatbotStory: "Chatbot Hikayeler",
            searchPlaceHolder: "Ara, Git yada Ekle...",
            searchAreaTitle: "Supsis'te Ara",
            searchAreaDesc1: "Herşeyi arayabilirsin. Sadece",
            searchAreaDesc2: "ya da",
            searchAreaDesc3: "yaz veya herhangi bir şey ara.",
            navigateBtn: "Gezin",
            selectBtn: "Seç",
            cancelBtn: "İptal",
            integration: {
                shouldByInstaPack:
                    "Instagram kanalı oluşturmak için Instagram paketi satın almalısınız. Uygun fiyatları paketlere hemen ulaşabilirsiniz.",
                createInstaLimitMax: "Instagram kanal oluşturma limitine ulaştınız. Maximun",
                createInstaContinue:
                    "Instagram Kanalı oluşturabilirsiniz. Devam etmek için paketinizi yükseltin yada Instagram kanalarınızdan bir kaçını siliniz.",
                privatePolicy: "Özel Politika",
                termsAndCondition: "Şartlar ve Koşullar",
                readAndAgree: "Okudum ve kabul ediyorum",
                shouldByMessengerPack:
                    "Messenger kanalı oluşturmak için Messenger paketi satın almalısınız. Uygun fiyatları paketlere hemen ulaşabilirsiniz.",
                createMessengerLimitMax: "Messenger kanal oluşturma limitine ulaştınız. Maximun",
                createMessengerContinue:
                    "Messenger Kanalı oluşturabilirsiniz. Devam etmek için paketinizi yükseltin yada Messenger kanalarınızdan bir kaçını siliniz.",
                selectMessengerAccount: "Messenger Hesabını Seçin",
                forwardLiveAgents: "👉 İleri Canlı Temsilciler",
                allDepartments: "Tüm Depertmanlar",
                deleteAll: "Hepsini Sil",
                wpBusinessAPI: "Integrations - Whatsapp Business API Kanalları",
                wpV1: "Integrations - Multi Whatsapp Kanalları",
                instagram: "Integrations - Instagram",
                instagramContactList: "Integrations - Instagram Kişi Listesi",
                mail: "Integrations - Mail",
                whatsapp: "Integrations - Whatsapp",
                whatsappContactList: "Integrations - Whatsapp Kişi Listesi",
                wpBCRequests: "Integrations - Whatsapp Toplu Mesaj İstekleri",
                wpBCCustomerGroups: "Integrations - Whatsapp Toplu Müşteri Grupları",
                wpBCTemplates: "Integrations - Whatsapp Toplu Message Şablonları",
                chatbot: "Integrations - ChatBot",
                allSections: "Tüm Bölümler",
                createInstaInstaLimitMax: "Instagram kanalı oluşturma sınırına ulaştınız.",
                createMessengerMessengerLimitMax: "Messenger kanalı oluşturma sınırına ulaştınız.",
                directClientsForward: "👉 Doğrudan Temsilciye Yönlendir",
                shouldByByMessengerPack:
                    "Messenger kanalı oluşturmak için bir paket satın almalısınız. Uygun fiyatlı paketlere hemen ulaşabilirsiniz.",
                wpBCRichieste: "Entegrasyonlar - Toplu WhatsApp Mesaj İstekleri",
            },
            settings: {
                settings: "Ayarlar",
                features: "Ayarlar - Özellikler",
                languageAndRegion: "Ayarlar - Dil ve Bölge",
                bubbleSettings: "Ayarlar - Balon Ayarları",
                bubbleActions: "Ayarlar - Balon Eylemleri",
                themeSettings: "Ayarlar - Tema Ayarları",
                talkSettings: "Ayarlar - Konuşma Ayarları",
                visitorLoginForm: "Ayarlar - Ziyaretci Giriş Formu",
                visitorAttribute: "Ayarlar - Ziyaretci Özellikleri",
                autoAssign: "Ayarlar - Otomatik Atama",
                chatTimingSettings: "Ayarlar - Chat Zaman Ayarları",
                availability: "Ayarlar - Kullanılabilirlik",
                websiteIntegration: "Ayarlar - Website Entergasyon",
                developer: "Ayarlar - Geliştirici",
            },
            applicazione: "Uygulama",
            archivi: "Arşiv",
            audioSettings: "Ses Ayarları",
            chatbotArchiv: "Chatbot Arşivi",
            chatbotTemplatesAverage: "Ortalama Chatbot Şablonları",
            content: "Anlık İçerik",
            contenuti: "Anlık İçerikler",
            departments: "Departmanlar",
            emails: "E-postalar",
            fondo: "Arka Plan",
            forbiddenWords: "Yasaklı Kelimeler",
            integraciones: "Entegrasyonlar",
            integrationOperations: "Entegrasyon İşlemleri",
            integrazioni: "Entegrasyonlar",
            integrazioniWebhook: "Webhook Entegrasyonu",
            intelligent: "Akıllı",
            invoices: "Faturalar",
            kalender: "Takvim",
            mail: "Posta",
            mailMessages: "Posta Mesajları",
            navigation: "Navigasyon",
            newReport: "Yeni Rapor",
            newSection: "Yeni Bölüm",
            ruoli: "Roller",
            soggetti: "Departmanlar",
            tag: "Etiket",
            topics: "Konular",
            utenti: "Kullanıcılar",
            visitatori: "Ziyaretçiler",
            webhookIntegration: "Webhook Entegrasyonu",
            workflow: "İş Akışı",
        },
        mail: {
            errorStatus: "Hata Durumu",
            mailSendErrorTitle: "Gönderilemeyenler",
            mailSendErrorDescription: "Gönderilemeyen toplam E-Posta",
            fixGrammarTitle: "Dil Bilgisi Düzeltme",
            expandTextTitle: "Metin Genişletme",
            summaryTitle: "Özet",
            changeToneTitle: "Ton Değiştirme",
            translationTitle: "Çeviri",
            replyTitle: "Yanıt",
            customRequestTitle: "Özel İstek Yanıtı",
            viewMode: "Görünüm Modu",
            singleView: "Tek Görünüm",
            splitView: "Bölünmüş Görünüm",
            folders: "Klasörler",
            sendError: "Mail gönderimi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
            visitorCreationError: "Ziyaretçi oluşturma hatası. Lütfen daha sonra tekrar deneyiniz.",
            onlyImageAllowed: "Yalnızca görsel dosyaları yükleyebilirsiniz.",
            imageFileTooLarge: "Görsel dosyası çok büyük. Maksimum boyut 10MB olmalıdır.",
            imageUploaded: "Görsel başarıyla yüklendi.",
            imageUploadError: "Görsel yükleme sırasında bir hata oluştu.",
            mailAiAssistant: {
                aiCreateSummarized: "AI Özet Oluştur",
                aiSentimentAnalysis: "AI Duygu Analizi",
                contentRequired: "Bu özelliği kullanmak için e-posta içeriği gerekli",
                grammarFixed: "Dil bilgisi düzeltildi",
                aiError: "AI asistanı bir hata ile karşılaştı",
                contentExpanded: "E-posta içeriği genişletildi",
                emailSummarized: "E-posta özetlendi",
                toneChanged: "Ton {tone} olarak değiştirildi",
                emailTranslated: "E-posta {language} diline çevrildi",
                replyGenerated: "Otomatik yanıt oluşturuldu",
                contentUpdated: "İçerik güncellendi",
                contentRebuilt: "İçerik yeniden oluşturuldu",
                contentRebuildFailed: "İçerik yeniden oluşturulamadı",
                customRequestEmpty: "Lütfen bir istek girin",
                customRequestApplied: "Özel istek içeriği uygulandı",
                loadingText: "AI Çalışıyor",
                loadingDescription: "Metin analiz ediliyor, lütfen bekleyin...",
                aiTitle: "E-posta Yapay Zeka Asistanı",
                aiDescription: "E-postanızı geliştirmek, düzenlemek ve analiz etmek için AI araçları",
                emptyContentTitle: "E-posta İçeriği Bulunamadı",
                emptyContentDescription: "Yapay zeka özelliklerini kullanabilmek için bir e-posta içeriği gereklidir.",
                limitedAccessDescription: "E-posta içeriği olmadığından sadece sınırlı özellikler gösterilmektedir.",
                resultEmotions: "Tespit Edilen Duygular",
                analysisDescription: "Analiz Açıklaması",
                recommendationsList: "İyileştirme Önerileri",
                mailSummarize: "E-posta Özeti",
                aiResponse: "AI Tarafından Oluşturuldu",
                rebuild: "Yeniden Oluştur",
                applyText: "Metni Uygula",
                specialRequest: "Özel İstek",
                specialRequestPlaceholder: "Özel talimatlarınızı buraya girin...",
                sendRequest: "İstek Gönder",
                fixGrammarTitle: "Dil Bilgisini Düzelt",
                fixGrammardescription: "Yazım hatalarını ve dilbilgisi sorunlarını otomatik olarak düzeltir",
                expandTextTitle: "Metni Genişlet",
                expandTextDescription: "Metninizi daha kapsamlı ve ayrıntılı hale getirir",
                changeToneTitle: "Tonu Değiştir",
                changeToneDescription: "Metnin tonunu ve üslubunu istediğiniz tarza dönüştürür",
                changeTone_ProfessionalTitle: "Profesyonel",
                changeTone_ProfessionalDescription: "İş ortamı için resmi ve profesyonel bir ton",
                changeTone_FriendlyTitle: "Arkadaşça",
                changeTone_FriendlyDescription: "Sıcak ve samimi bir yaklaşım",
                changeTone_CasualTitle: "Günlük",
                changeTone_CasualDescription: "Rahat ve gündelik bir konuşma tonu",
                changeTone_FormalTitle: "Resmi",
                changeTone_FormalDescription: "Son derece resmi ve kurumsal bir üslup",
                changeTone_ConfidentTitle: "Özgüvenli",
                changeTone_ConfidentDescription: "Güçlü ve etkileyici bir ifade tarzı",
                translateTitle: "Çeviri Yap",
                translateDescription: "Metninizi farklı dillere çevirir",
                generateReplyTitle: "Yanıt Oluştur",
                generateReplyDescription: "Alınan e-postaya uygun otomatik bir yanıt oluşturur",
                customPromptTitle: "Özel İstek",
                customPromptDescription: "Özel talimatlarınıza göre e-posta içeriği oluşturur",
            },
            searchEmail: "Mail Ara...",
            emailAttachments: "Ekler ({count})",
            signatureMessage: "Mail imzanız mevcut. İmzanızı mail içeriğine eklemek ister misiniz?",
            emailSubject: "E-posta konusu",
            takeItBack: "Geri Al",
            fastForward: "İleri Al",
            addEmoji: "Emoji Ekle",
            addLink: "Link Ekle",
            bold: "Kalın",
            italic: "İtalik",
            underline: "Altı Çizili",
            fontFamily: "Yazı Tipi",
            textColor: "Metin Rengi",
            stringFormats: "Metin Formatları",
            alignLeft: "Sola Hizala",
            alignRight: "Sağa Hizala",
            alignCenter: "Ortala",
            normalText: "Normal metin",
            participantList: "{first}, {second}, {third} +{remaining} kişi",
            noMailFound: "Hiç mail bulunamadı",
            selectedMail: "{count} mail seçildi",
            recipientEmailAddress: "Alıcı e-posta adresi",
            CCreceivers: "CC Alıcılar",
            BCCreceivers: "BCC Alıcılar",
            emptyStateMessage: "Mail seçin veya yeni mail oluşturun",
            broadcastCreatedSuccess: "Yayın başarıyla oluşturuldu",
            confirmArchive: "Bu yayını arşivlemek istediğinize emin misiniz?",
            archive: "Arşivle",
            cancel: "İptal",
            archiveSuccess: "Yayın başarıyla arşivlendi",
            archiveError: "Yayını arşivlerken hata oluştu",
            empty: "Boş",
            summerDiscounts: "Yaz İndirimleri",
            opportunities: "Fırsatlar",
            newMailTemplateCreated: "Yeni E-posta Şablonu Oluştur.",
            dateRange: "Tarih Aralığı",
            templateName: "Şablon Adı",
            category: "Kategori",
            templateUpdateSucs: "Şablon başarıyla güncellendi.",
            templateUpdateError: "Şablon güncellenirken bir hata oluştu.",
            marketing: "Marketing",
            operational: "Operasyonel",
            custom: "Özel",
            pleaseEnterTemplateName: "Lütfen şablon adını girin",
            pleaseEnterTemplateSubject: "Lütfen şablon konusunu girin",
            pleaseSelectTemplateCategories: "Lütfen şablon kategorisini seçin",
            representMails: "Temsilci Mailleri",
            otherRepresentMails: "Diğer temsilcilerin mail adresine gelen ve giden e-postaları takip edebilirsiniz.",
            signatureAutoAdd: "İmza otomatik ekleme durumu başarıyla değiştirildi",
            autoAdd: "Otomatik Ekleme",
            forwardEmailAddSucs: "Forward eposta adresi başarıyla eklendi.",
            errorAddingForwardEmail: "Forward eposta adresi eklenirken bir hata oluştu.",
            mailAddForward: "Manuel Ekleme (ileri tamamlandı)",
            mailAddForwarding: "Manuel Ekleme (Yönlendirmeyi tamamladım)",
            broadcast: "Toplu e-mail",
            templates: "Şablonlar",
            inbox: "Gelen Kutusu",
            newMailArrived: "Yeni mail geldi.",
            mailSentSucs: "Mail başarıyla gönderildi.",
            representativeMails: "Temsilci Mailleri",
            composeNewEmail: "Yeni e-posta oluşturma",
            couldNotUserMail: "Kullanıcı maili olmadığı için mail gönderilemedi",
            mailAddressReq: "Mail Adresi Gereklidir.",
            emailAddressInvalid: "Mail adresi geçersiz.",
            departmentIsNotValid: "Departman geçerli değil",
            mailSendNotValid: "Posta adresinden gelen geçerli değil",
            routingSteps: "Yönlendirme Adımları",
            owner: "Sahibi",
            whereHeDirected: "Nereye Yönlendirdi",
            forwardingEmailAddress: "Yönlendirecek Eposta Adresi",
            deleteMailDesc: "Bu işlem geri alınamaz.",
            deleteMailTitle: "Bu mail adresini silmek istediğinize emin misiniz?",
            gmailForwardMail: "Gmail Mail İletme",
            senderMailAddressDesc: "Lütfen Gönderici Mail Adresi Girin",
            verified: "Doğrulandı",
            notForwarded: "Yönlendirilmedi",
            notVerified: "Doğrulanmadı",
            default: "Varsayılan",
            isVerified: "Doğrulanma",
            forwarding: "Yönlendirme",
            mailAdress: "Mail Adresi",
            addSenderAddress: "Gönderen Maili Ekle",
            outlookForward: "Microsoft (Outlook/Exchange) Yönlendirme",
            gmailForward: "Google(Gmail) Yönlendirme",
            senderMail: "Gönderen Mail",
            mailDetail: "Mail Detayı",
            mailNotFound: "Mail Bulunmuyor",
            mailSelecting: "Mail Seçimi",
            newMail: "Yeni E-Posta",
            myMails: "E-Postalarım",
            sent: "Gönderilen",
            departmentMails: "Departman E-Postaları",
            newTemplate: "Yeni Şablon",
            unread: "Okunmamış",
            unreply: "Yanıtlanmamış",
            reply: "Yanıtla",
            attachments: "Mail Ekleri",
            To: "Kime",
            From: "Kimden",
            FromName: "Gönderen Kişinin İsmi",
            placeHolders: "Yer Tutucular",
            attacheFiles: "Dosya Ekle",
            replyAll: "Tümünü Yanıtla",
            forward: "İlet",
            deleteThread: "Konuşmayı sil",
            markAsRead: "Okundu Olarak İşaretle",
            markAsAllRead: "Tümünü Okundu Olarak İşaretle",
            emailEditor: "E-Posta Düzenleyici",
            integrateYourMail: "E-Postanı Entegre Et",
            connect: "Bağlan",
            departmentMail: "Departman E-Posta",
            createMailAddress: "Mail Adresi Oluştur",
            createNewMail: "Yeni Mail Oluştur",
            canNotUserMail: "Kullanıcı e-postası olmadığı için e-posta gönderilemedi",
            createNewEmail: "Yeni E-posta Oluştur",
            ly: "Yanıtla",
            operativ: "Operasyonel",
            ply: "Yanıtla",
        },
        visitor: {
            ownership: "Sahiplik",
            tags: "Etiketler",
            visitors: "Ziyaretçiler",
            bannedVisitors: "Yasaklı Ziyaretçiler",
            profileFields: "Profil Alanları",
            downloadAll: "Tümünü İndir",
            saveAsCustomerGroup: "Müşteri Grubu Olarak Kaydet",
            filterResultMax5000: "Filtre sonucu maksimum 5000 kişi ile sınırlıdır",
            onlyContactsPhoneNumber: "Sadece telefon numarası olan kişiler gruba aktarılacaktır",
            enterGroupName: "Grup adını girin",
            showInColumns: "Sütünlarda Göster",
            sendMailSucs: "Mail Başarıyla Gönderildi",
            equal: "Eşit",
            notEqual: "Eşit değil",
            contains: "İçerir",
            notContains: "İçermez",
            startsWith: "İle Başlar",
            endWith: "İle Biter",
            saveSearchFavorite: "Aramayı favori olarak kaydet",
            editOrDeleteFavorite: "Favoriyi düzenle veya sil",
            mail: "Mail",
            visitorDetail: "Ziyaretçi Detayları",
            selectedUser: "{totalUsers} kullanıcıdan {selectedUser} tanesi seçildi",
            uncheck: "Tüm işaretleri kaldır",
            checkAll: "Tümünü işaretle",
            matchedUsers: "{chechkedCount} adet kullanıcı eşleşti",
            more: "Daha fazla",
            exportUsers: "Seçilen kullanıcıları dışa aktar",
            exportAllUsers: "Tüm kullanıcıları dışa aktar",
            addSegment: "Segment Ekle",
            deletedCheckedUser: "Seçilen kullanıcıları sil",
            deleteAllUser: "Tüm kullanıcıları sil",
            matchedFilter: "Tüm filtreleri eşleştir",
            visitor: "Ziyatretçisi",
            deleteUser: "Kullanıcıyı sil",
            userData: "Kullanıcı bilgileri",
            lastSession: "Kullanıcı Haraketleri",
            notUserData: "Kullanıcı haraketleri bulunamadı",
            segments: "Segmentler",
            addTag: "Etiket ekle",
            userChats: "Kullanıcı Konuşmaları",
            userMails: "Kullanıcı Mailleri",
            seeAll: "Hepsini gör",
            confirm: "Onayla",
            manageSegments: "Segment yönetimi",
            search: "Ara",
            manageTags: "Tag yönetimi",
            allAttributes: "Tüm özellikleri gör",
            noData: "Veri yok",
            noEmail: "Mail yok",
            noIpAddress: "IP adresi bulunamadı.",
            noWpNumber: "Numara bulunamadı.",
            filterName: "Filtre ismi...",
            matchedContacts: "{chechkedCount} adet bağlantı eşleşti",
            channelContacts: "Kanal kişileri",
            searchInAllFields: "Tüm Alanlar'da Ara",
            searchInName: "İsim'de Ara",
            importContacts: "Kişileri İçe Aktar",
            addNewContact: "Yeni Kişi Ekle",
            importContactsTitle: "Kişileri İçe Aktar",
            addSingleContactTitle: "Tekli Kişi Ekle",
            downloadRecordsSettings: "Kayıtları İndir - Ayarlar",
            excelExport: "Excel Dışa Aktarım",
            exportTotalRecords: "Toplam {total} kayıt",
            exportCancel: "İptal",
            whatsappContacts: "WhatsApp Kişileri",
            instagramContacts: "Instagram Kişileri",
            messengerContacts: "Messenger Kişileri",
            linkedinContacts: "LinkedIn Kişileri",
            telegramContacts: "Telegram Kişileri",
            metaLeadsContacts: "MetaLeads Kişileri",
            searchPlaceholderAll: "Tüm alanlarda aramak istediğinizi buraya yazın",
            searchPlaceholderFullname: "Ad Soyad ile aramak istediğinizi buraya yazın",
            searchPlaceholderEmail: "Email ile aramak istediğinizi buraya yazın",
            searchPlaceholderPhone: "Telefon ile aramak istediğinizi buraya yazın",
            searchPlaceholderWhatsapp: "WhatsApp ile aramak istediğinizi buraya yazın",
            searchPlaceholderDefault: "Ara",
            searchFieldAll: "Tüm Alanlar",
            searchFieldName: "İsim",
            searchFieldEmail: "Email",
            searchFieldPhone: "Telefon Numarası",
            searchFieldWhatsapp: "WhatsApp Numarası",
            searchModePhoneDetected: "Telefon Numarası Algılandı",
            searchModeEmailDetected: "Email Adresi Algılandı",
            searchModeNotPhone: "Bu Telefon Numarası Değil",
            searchModeNotEmail: "Bu Email Değil",
            searchMode: "Arama Modu",
            searchModePhoneMessage:
                '"{query}" telefon numarası olarak algılandı. Şu anda {field} alanındasınız. Telefon numarası alanında aramak ister misiniz?',
            searchModeEmailMessage:
                '"{query}" email adresi olarak algılandı. Şu anda {field} alanındasınız. Email alanında aramak ister misiniz?',
            searchModeNotPhoneMessage:
                '"{query}" telefon numarası formatında değil. Tüm alanlarda veya isim alanında aramak ister misiniz?',
            searchModeNotEmailMessage:
                '"{query}" email formatında değil. Tüm alanlarda veya isim alanında aramak ister misiniz?',
            unknownTag: "Bilinmeyen",
            noRecordsToDownload: "İndirilecek kayıt bulunamadı",
            excelCreatedSuccess: "Excel dosyası başarıyla oluşturuldu",
            exportCancelled: "Dışa aktarma iptal edildi",
            excelCreateError: "Excel dosyası oluşturulurken bir hata oluştu",
            yes: "Evet",
            no: "Hayır",
            unowned: "Sahipsiz",
            whatsappGroupCreatedSuccess: "Whatsapp müşteri grubu başarıyla oluşturuldu.",
            whatsappGroupCreateError: "Whatsapp müşteri grubu oluşturulurken bir hata oluştu.",
            mailGroupCreatedSuccess: "Mail müşteri grubu başarıyla oluşturuldu.",
            mailGroupCreateError: "Mail müşteri grubu oluşturulurken bir hata oluştu.",
            messageHistory: "Mesaj Geçmişi",
            pastConversations: "Geçmiş Sohbetler",
            defaultUser: "Kullanıcı",
            blockManagement: "Engelleme Yönetimi",
            vipCustomer: "VIP Müşteri",
            startChat: "Sohbet Başlat",
            createEvent: "Etkinlik Oluştur",
            createTask: "Görev Oluştur",
            selectTask: "Görev Seçiniz",
            webphoneCall: "Webphone ile Ara",
            capiEventSend: "CAPI Event Gönder",
            defaultName: "Ziyaretçi",
            notAvailable: "Yok",
            relatedList: "İlgili Listeler",
            adReferrals: "Reklam Etkileşimleri",
            calls: "Aramalar",
            generalInfo: "Genel Bilgiler",
            callHistory: "Arama Geçmişi",
            webTab: "Web Sekmesi",
            widgetUrlError: "Widget URL'si oluşturulamadı",
            deleteSuccess: "Ziyaretçi silme işlemi başarılı.",
            taskStatusUpdateSuccess: "Görev durumu başarıyla güncellendi",
            taskStatusUpdateError: "Görev durumu güncellenirken bir hata oluştu",
            copyToClipboard: "Panoya kopyalandı",
            noPhoneNumber: "Aranacak numara bulunamadı",
            webphoneCalling: "Webphone ile {phoneNumber} aranıyor...",
            deleteCheckedUser: "Delete Selected Users",
        },
        chatbotv2: {
            "T-Soft_Actions": "T-Soft Aksiyonları",
            "Ticimax-V2_Actions": "Ticimax Aksiyonları",
            YouTube_Actions: "YouTube Aksiyonları",
            Google_Business_Actions: "Google Business Aksiyonları",
            Google_Play_Actions: "Google Play Aksiyonları",
            App_Store_Actions: "App Store Aksiyonları",
            TSOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
            TSOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
            TICIMAX_V2_SELECT_ORDER: "Sipariş Seç",
            TICIMAX_V2_ORDER_STATUS: "Sipariş Durum Çek",
            Ikas_Actions: "Ikas Aksiyonları",
            IKAS_GET_MEMBER_INFO: "Uye Detay Getir",
            IKAS_SELECT_ORDER: "Sipariş Seç",
            IKAS_ORDER_STATUS: "Sipariş Durum Çek",
            META_SEND_CAPI_EVENT: "CAPI EVENT GÖNDER",
            META_SEND_CAPI_EVENTDesc:
                "Meta Conversions API (CAPI) kullanarak reklam optimizasyonu için conversion eventleri gönderir. Instagram ve Messenger reklamlarınızın performansını artırmanıza yardımcı olur.",
            CUSTOM_BLOCK: "Özel Blok",
            CUSTOM_BLOCKDesc:
                "Yapılandırılabilir parametrelerle özel JavaScript kodu çalıştırır. Marketplace'den paylaşılmış blokları kullanarak chatbotunuzu genişletin.",
            exampleOutput: "Örnek Çıktı",
            outputSchema: "Çıktı Şeması (JSON)",
            IDEASOFT_PRODUCT_SEARCH: "Ürün Arama",
            FEEDBACK_AI_ASSISTANTDesc:
                "Supsis AI Yapay Zeka Asistanı, müşteri hizmetleri ve iş süreçlerini optimize eden akıllı bir çözümdür. 7/24 hizmet sunarak müşteri sorularını otomatik yanıtlar, çok dilli destek sağlar ve WhatsApp, Instagram, Facebook gibi platformlarla entegre çalışır. Satış, pazarlama ve randevu planlama süreçlerini kolaylaştırırken, kişiselleştirilmiş deneyimler sunarak müşteri memnuniyetini artırır. Verimlilik ve maliyet tasarrufu sağlayan bu asistan, hızlı ve doğru bilgi akışıyla işletmelere modern ve etkili bir müşteri hizmeti çözümü sunar.",
            INSERT_TO_SYSTEM_PROMPTDesc:
                "Sistem Promptuna Mesaj Ekle bloğu, chatbotun sistem promptuna bir mesaj eklemesini sağlar. Sistem promptu, chatbotun kullanıcılarının mesajlarına yanıt verirken kullandığı bir metin dizisidir. Bu blok, chatbotun sistem promptuna bir mesaj ekleyerek, kullanıcıların mesajlarına daha iyi yanıt vermesini sağlar. Sistem promptuna mesaj eklemek, chatbotun kullanıcılarının mesajlarına daha iyi yanıt vermesini sağlar.",
            API_REQUESTDesc:
                "Bu blok, bir API'ye istek göndermek için kullanılan yapı ve parametreleri tanımlar. API İstek URL’si, verilerin hangi adrese gönderileceğini belirtirken, method kısmı (GET, POST, vb.) isteğin türünü belirler. Headers, kimlik doğrulama ve içerik tipi gibi başlık bilgilerini içerir, Body Type gönderilen verinin formatını tanımlar, ve Body kısmı ise API’ye gönderilecek ana veriyi içerir. Son olarak, Example Response API'den beklenen yanıtın örneğini gösterir. Bu blok, API entegrasyonlarını kolaylaştırarak, veri alışverişini otomatikleştirir.",
            BOT_RESPONSEDesc:
                "Bot’un Yanıtı bloğu, kullanıcıya metin, resim, dosya gibi farklı içerik türleriyle yanıt vererek etkileşimi artırır. Bu blok, düz metin mesajları (Yazı), rastgele seçilen metin varyantları (Rastgele Yazı), görseller (Resim) veya dosyalar (Dosya) göndermek için kullanılır. Ayrıca, butonlu yanıtlar sunarak kullanıcıya seçenekler sunar: Galeri, görsel ve açıklamalarla etkileşimli sunum yapar; Buton, seçenekler sunar ve tüm platformlarda kalıcıdır; Hızlı Cevap ise kullanıcının hızlı seçim yapmasını sağlar ve seçim sonrası kaybolur. Galeri, website platformunda sınırsız buton desteklerken, WhatsApp'ta yalnızca bir kart gönderilebilir. Instagram ve Messenger'da her galeri kartı ayrı mesaj olarak iletilir. Hızlı Cevap, Instagram ve Messenger'da 3'ten fazla buton sunar ve butonlar mesaj kutusu üzerinde görünür.",
            TAVILY_WEB_SEARCHDesc:
                "Web arama, yapay zeka destekli sistemler aracılığıyla çeşitli web sitelerinden bilgi almayı sağlar. Arama sorgusu girildiğinde, belirlenen arama derinliğine göre en alakalı sonuçlar taranarak kullanıcının ihtiyacına uygun bilgiler sunulur. Bu süreçte, ham içerik, görseller ve görsel açıklamaları da dahil edilerek daha kapsamlı bir bilgi aktarımı sağlanabilir. Ayrıca, elde edilen veriler özetlenerek veya doğrudan ham haliyle sunulabilir. Kullanıcılar, belirli alan adlarını dahil ederek arama sonuçlarını filtreleyebilir ve böylece en güvenilir kaynaklardan bilgiye ulaşabilir. Bu sayede, yapay zeka destekli web aramaları, hızlı ve doğru bilgi edinme sürecini optimize eder.",
            AI_BOT_RESPONSEDesc:
                "Bu sistem, yapay zekanın kullanıcı girdilerine ve belirlenen talimatlara göre kişiselleştirilmiş yanıtlar üretmesini sağlar; önceden hazırlanmış şablonlarla doğru ve kapsamlı cevaplar sunarken, kullanıcı geri bildirimlerini kaydedip gelecekteki yanıtları iyileştirmek için kullanır.",
            AI_CLASSIFICATIONDesc:
                "Yapay Zeka Sınıflandırma Bloğu, kullanıcı mesajlarını analiz ederek belirlenen kategorilere ayırır ve ilgili aksiyonları otomatik olarak tetikler. Otomatik sınıflandırma sayesinde mesaj içeriğine göre doğru yönlendirme yapılırken, esnek kategori yönetimi ile yeni kategoriler eklenebilir veya mevcutlar düzenlenebilir. Sınıflandırılan veriler, filtreleme işlemiyle ayrıştırılarak kullanıcı taleplerine en uygun aksiyonlar alınır. Ayrıca, Instagram mesaj ve yorumları da bu blok aracılığıyla sınıflandırılıp otomatik yanıtlar veya işlemler gerçekleştirilebilir.",
            DEFAULT_TIMEOUTDesc:
                "Varsayılan zaman aşımı, senaryo başlangıcında devreye girer ve yerel zaman aşımı süresinden kısa ise öncelikli olarak tetiklenir; yalnızca yerel zaman aşımını kullanmak için varsayılanı silmek gerekir. Zaman aşımı süresi, oturum süresini aşamaz ve birden fazla zaman aşımı, kullanıcı girişleriyle entegre şekilde kullanılabilir. Kullanıcıdan yanıt alınmadığında tetiklenen bu yapı, hatırlatma mesajları göndermek veya belirli akışları tekrar başlatmak için uygundur.",
            FILTERDesc:
                "Supsis Ai platformu, chatbotların kullanıcı verilerini özelleştirilmiş öznitelikler, kullanıcı bilgileri (isim, e-posta, telefon, dil, saat dilimi, cinsiyet vb.) ve ziyaretçi profil bilgileri (ülke, IP, referrer, ziyaret adresi vb.) gibi kriterlere göre filtrelemesine olanak tanır. Filtreleme işlemleri, 've' ve 'veya' operatörleri kullanılarak karmaşık koşullar oluşturmayı mümkün kılar; örneğin, çalışma saatleri içinde canlı destek sağlamak veya belirli ülke, telefon numarası veya ziyaret adresine göre özel yanıtlar vermek gibi senaryoları destekler. Bu özellikler, kullanıcı davranışlarını analiz ederek chatbotun daha kişiselleştirilmiş, hızlı ve etkili yanıtlar vermesini sağlar, böylece müşteri memnuniyetini artırır ve chatbotun verimliliğini optimize eder.",
            ATTACHMENT_INPUTDesc:
                "Dosya girişi, chatbotun kullanıcıdan aldığı ek dosyaları işleyerek güvenli bir şekilde saklamasını ve indirilebilir bir URL oluşturmasını sağlar; bu URL, e-posta veya WhatsApp gibi kanallar üzerinden paylaşılabilir. Kullanıcı yalnızca tanımlı bir dosya girişinde dosya gönderebilir; aksi halde sistem, yerel veya varsayılan 'Aksi Durum' akışına yönlendirir. Resim, ses, video, belge veya diğer ekler desteklenir ve her dosya türü için sistem otomatik olarak ilgili işlemi başlatarak gerektiğinde dosyayı ilgili birimlere yönlendirebilir.",
            USER_INPUTDesc:
                "Kullanıcı Girişi, chatbotun kullanıcıdan aldığı verileri işleyip doğrulamasını, kaydetmesini ve ilgili aksiyonları tetiklemesini sağlar. Global anahtar kelimeler her yerde geçerli olup, yerel anahtar kelimeler belirli adımlarda çalışır. Girdiler, regex ile doğrulanabilir ve kullanıcı profiline kaydedilebilir. Güven seviyesi, chatbotun girdilere nasıl yanıt vereceğini belirler. 'Bloğa Git' ve 'Mesaj Gönder' butonlarıyla, kullanıcılar belirli adımlara yönlendirilebilir veya chatbot ile mesajlaşabilir. Bu yapı, chatbotun kullanıcı etkileşimlerini daha verimli yönetmesine olanak tanır.",
            GO_TO_STEPDesc:
                "Adıma Git Aksiyonu, chatbot kullanıcılarını belirlenen adımlara yönlendiren bir mekanizmadır. Dinamik yönlendirme sayesinde, kullanıcı sorgularına veya tetiklenen aksiyonlara göre doğru akışa taşınmasını sağlar. Blok adı düzenleme, akışın anlaşılır olmasını ve bağlantıların kolay yönetilmesini sağlar. Kullanıcılar blok üzerinden veya blok içerisinden ad isimlerini düzenleyebilirler. 'Adıma Git' aksiyonu, özellikle karmaşık chatbot akışlarında geçişleri düzenlemek için kullanılır. Bloğa Git buton tipi de benzer şekilde çalışarak, belirlenen butona tıklayan kullanıcıları önceden tanımlanmış bloğa yönlendirir. Go To seçimi, butonun yönlendireceği bloğu belirleyerek kullanıcı deneyimini optimize eder.",
            WEBHOOKDesc:
                "Webhook Aksiyonu, chatbot ile dış sistemler arasında veri paylaşımını sağlar. Başarılı ve başarısız senaryolarla kullanıcı akışını yönlendirir. Başarılı senaryoda, veri başarıyla gönderildiğinde kullanıcı akışı devam eder, başarısız senaryoda ise hata mesajı gösterilir ve kullanıcı yeniden yönlendirilir. Webhook entegrasyonu, dış sistemlerle etkileşimi sağlar ve veri alışverişi yapar. Webhook’lar, chatbotun esnekliğini artırarak akışı zenginleştirir. Entegrasyon için, sistemdeki API dokümantasyonlarına uygun ayarlamalar yapılmalıdır.",
            SET_ATTRIBUTEDesc:
                "Özellik Ayarla bloğu, kullanıcıdan alınan verilerin profil kartına kaydedilmesini sağlar ve verileri statik, dinamik veya özel (special) olarak sınıflandırır. Statik veriler sabit değerler, dinamik veriler kullanıcı girdilerine göre değişen bilgiler kaydeder, özel veriler ise rastgele oluşturulan değerlerdir (örneğin rastgele sayı veya OTP). Kullanıcı ve ziyaretçi profil bilgileri toplanarak, kullanıcı etkileşimleri sırasında saklanır ve sonraki etkileşimlerde kullanılabilir. Bu blok, kullanıcı verilerini yönetmek ve daha kişisel, doğru yanıtlar sağlamak için faydalıdır.",
            ASSIGN_OWNERDesc:
                "Sahip Ata Bloğu, chatbot üzerinden mevcut bir sohbeti seçilen temsilciye atamak için kullanılır. Atama algoritması, temsilcilerin sahip olduğu kontak sayıları ve belirli tarih aralıklarına göre en uygun temsilciyi belirler. Ayrıca, yalnızca çevrimiçi olan temsilcilere atama yapılabilir ve belirli temsilciler atama havuzundan hariç tutulabilir. Bu süreç, Zoho CRM ile senkronize edilerek, atanan temsilcinin verileri CRM sistemine kaydedilir, böylece müşteri destek süreçleri daha verimli bir şekilde yönetilir.",
            QUESTIONDesc:
                "Soru bloğu, chatbotun kullanıcılara soru sormasını ve verilen yanıtları doğrulayıp işlemeyi sağlar. Kullanıcı doğru yanıtı verdiğinde başarılı senaryo tetiklenir ve akış devam eder. Yanlış yanıt verildiğinde ise başarısız senaryo devreye girer, kullanıcıya tekrar yanıt verme fırsatı sunulur. Ayrıca, kullanıcıdan alınan yanıtlar doğrulama parametreleri ile kontrol edilir ve doğru verilere profil kartında yer verilir. Örneğin, e-posta adresi doğrulaması yapılır ve doğru formatta girilen bilgi profil kartına kaydedilir. Hatalı yanıtlar durumunda kullanıcıya düzeltme fırsatı tanınır. Bu özellik, chatbotun kullanıcıyla etkileşimini daha kişisel ve doğru hale getirir.",
            TRANSFER_TO_CHATBOTDesc:
                "Chatbota Yönlendir bloğu, kullanıcıyı belirlenen farklı bir chatbot akışına yönlendirerek kişiselleştirilmiş bir deneyim sunar. Kullanıcılar bir akıştan diğerine geçiş yapabilir ve ihtiyaçlarına göre doğru senaryoya yönlendirilir. Senaryo seçimi yapılırken filtreleme ve etiketleme işlemleriyle, kullanıcıların özel niteliklerine göre doğru akışa geçiş sağlanır. Bu özellik, kullanıcı taleplerine esnek ve dinamik bir şekilde yanıt verir.",
            TAG_CHATDesc:
                "Etiket Ekle bloğu, kullanıcı etkileşimlerine göre profillere etiket ekleyerek segmentasyon ve chatbot filtrelemesi sağlar. Kullanıcı girdileri analiz edilerek doğru departmana yönlendirilir, ardından temsilci aktarımı gerçekleştirilir. Etiketler, müşteri destek ve satış süreçlerini optimize etmek için kullanılır.",
            REMOVE_TAGDesc:
                "Etiket Sil bloğu, kullanıcı profillerindeki gereksiz veya eski etiketleri kaldırarak chatbot analizlerinin güncel ve doğru olmasını sağlar. Etiketler otomatik olarak temizlenir, böylece segmentasyon ve veri yönetimi daha verimli hale gelir.",
            SET_DEPARTMENTDesc:
                "Departman Ayarla bloğu, kullanıcının ihtiyaçlarına göre doğru departmana otomatik veya manuel olarak yönlendirilmesini sağlar. Kullanıcı seçimleri veya sistemdeki verilere göre uygun departman belirlenir, etiket eklenerek segmentasyon yapılır ve gerektiğinde temsilciye aktarım gerçekleştirilir.",
            SEND_TRANSCRIPTDesc:
                "Transkript Gönder bloğu, kullanıcıyla yapılan sohbetin kaydını belirlenen e-posta adresine otomatik olarak ileterek destek ve analiz süreçlerine katkı sağlar. Gönderim, kullanıcı profil kartındaki e-posta adresine veya manuel girilen bir adrese yapılabilir.",
            SEND_SMSDesc:
                "SMS gönderim bloğu, Supsis'in Postacell veya başka bir SMS sağlayıcısı ile entegrasyonunu kullanarak otomatik ve kişiselleştirilmiş mesajlar göndermeyi sağlar. Kullanıcının profil kartındaki telefon numarası ve sistemde mevcut verilerle SMS içeriği dinamik olarak oluşturulabilir. Entegrasyon ve ek bilgiler için canlı destek veya info@supsis.com adresiyle iletişime geçilebilir.",
            SEND_MAILDesc:
                "Mail Gönder bloğu, chatbot aracılığıyla toplanan bilgileri kullanarak otomatik e-posta gönderimi sağlar. Kullanıcının profil kartındaki nitelikler baz alınarak kişiselleştirilmiş e-posta içerikleri oluşturulabilir. Mail başlığı ve içeriği dinamik olarak özelleştirilebilir, destek talepleri gibi süreçlerde hem kullanıcıya hem de ilgili ekiplere otomatik bilgilendirme yapılabilir. Supsis’in e-posta modülü, mevcut mail altyapılarıyla entegre çalışarak süreci kolaylaştırır.",
            CREATE_EVENTDesc:
                "Etkinlik Oluştur bloğu, chatbot üzerinden kullanıcıların takvimine otomatik etkinlik eklenmesini sağlar. Kullanıcının profil bilgilerinden alınan verilerle etkinlik başlığı, açıklaması ve süresi belirlenirken, etkinlik sahibi ve ek temsilciler atanabilir. Otomatik bildirimler sayesinde katılımcılar bilgilendirilir ve etkinlik detayları takvim entegrasyonları (Google Calendar, Microsoft Teams) ile yönetilebilir, böylece süreç hızlanır ve zaman yönetimi optimize edilir.",
            CREATE_RESERVATIONDesc:
                "Rezervasyon Oluştur bloğu, kullanıcıların profil kartındaki öznitelikler veya manuel girilen form verileri ile otomatik olarak rezervasyon işlemi başlatılmasını sağlar. Kullanıcıların profilindeki bilgiler, örneğin e-posta adresi, takvim etkinlikleri için kullanılabilir ve etkinlik detayları da bu öznitelikler üzerinden çekilebilir. Bu blok, rezervasyon formu aracılığıyla kullanıcıdan alınan bilgileri, diğer bloklarla etkileşime girerek düzenler ve rezervasyon işlemini başlatır. Bu sayede süreç daha hızlı ve kişiselleştirilmiş hale gelir.",
            RESERVATION_OPEN_URLDesc:
                "Rezervasyon Ekranı Görüntüle bloğu, kullanıcıya belirlediğiniz rezervasyon takvimi üzerinden mevcut randevuları listeler. Kullanıcı, bu ekran aracılığıyla takvimdeki uygun randevuları görüntüleyebilir. Ayrıca, belirlediğiniz süre seçenekleri (örneğin 5 dakika, 15 dakika, 30 dakika) üzerinden randevu süresi seçilebilir. Bu özellik yalnızca web site chatbotlarında çalışır ve kullanıcıya kolaylıkla rezervasyon seçenekleri sunar.",
            RESERVATION_SELECT_DAYDesc:
                "Rezervasyon Günü Seç bloğu, kullanıcıya haftalık rezervasyon günleri seçimi sunar ve seçilen rezervasyon günü, sistemde kaydedilir. Kullanıcının profil kartındaki öznitelikler üzerinden ilgili bilgiler otomatik olarak çekilir ve rezervasyon günü belirlenir. Bu blok, butonlar aracılığıyla kullanıcıya seçenekler sunarak, kullanıcıyı uygun rezervasyon gününe yönlendirir. Bu süreç, kullanıcıya özel bilgilerle kişiselleştirilir ve etkinlik takvimine entegre edilir.",
            RESERVATION_EVENT_LISTDesc:
                "Müşteri Rezervasyon Listesi, kullanıcıların e-posta bilgileri ile ilişkilendirilmiş rezervasyon verilerini hızlı ve verimli bir şekilde sunar. Bu işlem, belirli bir müşterinin e-posta adresi aracılığıyla yapılır ve o e-posta adresine bağlı olan tüm rezervasyonlar liste halinde kullanıcıya sunulur.",
            RESERVATION_SELECT_TIMEDesc:
                "Rezervasyon Saati Seç bloğu, kullanıcıya seçilen rezervasyon günü için müsait saatleri sunar. Kullanıcı, önceki adımda seçilen gün üzerinden uygun saatlerden birini seçer. Bu blok, Rezervasyon Günü Seç bloğundan alınan verilerle, o gün için müsait olan saatleri sıralar ve kullanıcıya seçenekler sunar. Seçilen rezervasyon saati, sistemde kaydedilerek, kullanıcıya ait profil bilgileri ve nitelikler üzerinden uygun bir şekilde entegre edilir.",
            CREATE_TASKDesc:
                "Görev Oluştur bloğu, kullanıcıların taleplerine göre Görev Yönetim Modülüne otomatik veya manuel olarak görev eklenmesini sağlar. Görev başlığı, açıklaması, aciliyet seviyesi, iş akışı ve pipeline (kolon) belirlenerek ilgili temsilcilere atanır. Kullanıcının profil kartındaki bilgilerle kişiselleştirilen görevler, sistem içi ve e-posta bildirimleriyle ilgili kişilere iletilir. Google Calendar ve Microsoft Teams entegrasyonları sayesinde süreç kolayca takip edilir. Örneğin, bir müşteri ek bilgi talep ettiğinde, chatbot otomatik olarak satış sürecinde 'İletişim Beklemede' kolonunda bir görev oluşturur ve ilgili temsilciyi bilgilendirir.",
            GET_LOCATIONDesc:
                "Konum Al Modülü, chatbotun kullanıcılardan coğrafi konum bilgisi toplamasına olanak tanır. Kullanıcıdan konum bilgisi alırken, özel bir mesaj gösterilir ve konum enlem (latitude) ve boylam (longitude) bilgileri profil kartına kaydedilir. Kullanıcı, konumunu manuel olarak adres girerek veya harita üzerinden seçerek paylaşabilir. Bu özellik, özellikle e-ticaret, lojistik ve teslimat gibi sektörlerde kullanılarak kullanıcı deneyimini kişiselleştirir. Örneğin, bir e-ticaret chatbotu, teslimat adresi almak için bu modu kullanarak, kullanıcıdan konum bilgisi alıp işlemi tamamlayabilir.",
            SUPPRESSION_ADDDesc:
                "Engelleme bloğu, kullanıcının belirlenen platformda (WhatsApp, Web Visitor, Instagram, Messenger) engellenmesini sağlar. Engellenecek kullanıcı değeri özniteliklerden otomatik çekilebilir veya manuel girilebilir. Engelleme inbound (mesaj alımı), outbound (mesaj gönderimi) veya her ikisi için uygulanabilir. Örneğin, WhatsApp üzerinden rahatsızlık veren bir kullanıcıyı engellemek için platform olarak 'WhatsApp' seçilir, kullanıcı telefon numarası belirlenir ve hem inbound hem de outbound engelleme aktif hale getirilir.",
            SUPPRESSION_REMOVEDesc:
                "Engel Kaldırma bloğu, daha önce engellenmiş bir kullanıcıyı belirlediğiniz platformda (WhatsApp, Web, Instagram vb.) ve engelleme için kullanılan değeri (telefon numarası, kullanıcı ID’si gibi) kullanarak engelini kaldırır. Kullanıcının engelinin kaldırılacağı değer, profil kartındaki özniteliklerden otomatik olarak çekilebilir. Bu sayede, engel kaldırma işlemi hızlı ve otomatik bir şekilde yapılır.",
            SEND_WP_BUSINESS_MESSAGEDesc:
                "WhatsApp Mesaj Gönder bloğu, WhatsApp Business API kullanarak kullanıcılara kişiselleştirilmiş mesajlar gönderilmesini sağlar. Bu aksiyon tetiklendiğinde, belirlenen şablon üzerinden WhatsApp kanalıyla mesaj gönderimi yapılır. Mesajın içeriği, kullanıcıya özel hale getirilmek için profil kartındaki öznitelikler ve manuel girdilerle doldurulabilir. Gönderilecek numara, manuel olarak girilebileceği gibi, kullanıcı bilgileri üzerinden de otomatik alınabilir. Şablonlar, WhatsApp Business API’de onaylanmış formatlar olup, mevcut şablonlardan seçilebilir ya da yeni şablon oluşturulabilir. Şablon içindeki değişkenler kullanılarak kişiselleştirilmiş mesajlar oluşturulabilir. Ayrıca, mesajlara medya dosyaları (JPEG, PNG vb.) da eklenebilir. Bu blok, kampanya mesajları, destek talepleri veya özel bildirimler gibi senaryolarla kullanıcıya otomatik mesaj gönderimi sağlar.",
            MESSENGER_SEND_MESSAGEDesc:
                "Bu blok, CHATBOT'un Messenger üzerinden mesaj göndermesine olanak tanır. CHATBOT, belirli bir alıcıya metin, resim veya diğer medya türlerini içeren mesajlar gönderebilir.",
            INSTAGRAM_SEND_MESSAGEDesc:
                "Bu blok, CHATBOT'un Instagram platformu üzerinden doğrudan mesaj göndermesine olanak tanır. CHATBOT, belirli bir kullanıcıya metin veya medya içeren mesajlar iletebilir.",
            INSTAGRAM_COMMENT_REPLYDesc:
                "Bu blok, bir Instagram gönderisine yapılan bir yoruma yanıt vermek için kullanılır. CHATBOT, belirli bir yoruma yanıt vererek etkileşimde bulunabilir.",
            INSTAGRAM_COMMENT_DELETEDesc:
                "Bu blok, bir Instagram gönderisinde yer alan bir yorumu silmek için kullanılır. CHATBOT, istenmeyen veya uygunsuz yorumları kaldırabilir.",
            INSTAGRAM_COMMENT_SHOWDesc:
                "Bu blok, bir Instagram gönderisinde yer alan bir yorumu görüntülemek için kullanılır. CHATBOT, belirli bir yorumu inceleyebilir ve diğer kullanıcıların görüşlerini görebilir.",
            INSTAGRAM_COMMENT_HIDEDesc:
                "Bu blok, bir Instagram gönderisinde yer alan bir yorumu gizlemek için kullanılır. CHATBOT, belirli bir yorumu görünmez hale getirerek, takipçilerinin o yorumu görmesini engelleyebilir.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc:
                "Bu blok, bir Instagram gönderisine yapılan bir yoruma özel mesaj (DM) ile yanıt vermek için kullanılır. CHATBOT, yorum yapan kişiye özel bir yanıt göndererek daha kişisel bir iletişim kurabilir.",
            TABLE_CREATE_RECORDDesc:
                "Bu blok, belirli bir tablonun içine yeni bir kayıt ekler. Kullanıcıdan alınan bilgiler veya sistemdeki diğer öznitelikler kullanılarak, yeni bir kayıt oluşturulur ve bu kayıt ilgili tabloya eklenir. Yeni bir kayıt eklemek, örneğin yeni bir müşteri bilgisi veya ürün kaydı oluşturmak gibi işlemler için kullanılır. ",
            TABLE_DELETE_RECORDDesc:
                "Bu blok, veri tablosunda yer alan bir kaydı siler. Kullanıcı, artık geçerli olmayan veya hatalı bir kaydı tablodan kaldırmak istediğinde bu blok devreye girer. Silinen kayıt, tablodan tamamen silinir ve geri alınamaz. Örneğin, bir müşterinin kaydını veya geçersiz bir siparişi silmek için bu işlem yapılır.",
            TABLE_UPDATE_RECORDDesc:
                "Bu blok, tablodaki bir kaydın içeriğini günceller. Kullanıcı, var olan bir kayıttaki bilgileri değiştirmek istediğinde bu blok kullanılabilir. Örneğin, bir müşteri adresini veya ürün fiyatını güncellemek için bu işlem yapılır. Bu işlem, yalnızca belirtilen kaydı değiştirmekle sınırlıdır ve tablodaki diğer kayıtları etkilemez.",
            TABLE_FIND_RECORDDesc:
                "Bu blok, belirli bir kaydın veri tablosunda bulunmasını sağlar. Kullanıcı, tabloya kayıtlı belirli bir veriyi (örneğin, bir kullanıcı adı veya ürün ID'si) aramak istediğinde bu blok kullanılır. Bulma işlemi, kullanıcıların belirli bir kayda hızlıca ulaşmasını sağlar.",
            TABLE_FIND_RECORDSDesc:
                "Bu blok, tablodaki mevcut kayıtları kullanıcıya gösterir. Kullanıcı, tablodaki yer alan tüm kayıtları görmek istediğinde veya belirli kriterlere göre filtrelenmiş kayıtları görmek istediğinde bu blok kullanılır. Listeleme işlemi, verilerin sıralanması ve filtrelenmesi gibi işlemleri de içerebilir.",
            ADD_TO_SEGMENTDesc:
                "Segment Ekle Aksiyonu, kullanıcıları belirli adımlardan geçtikten sonra tanımlı segmentlere eklemeyi sağlar. Bu aksiyon, kullanıcı davranışlarını segmentlere ayırarak analiz yapmanıza ve özel raporlar oluşturmanıza yardımcı olur. Kullanıcılar, segment seçim çubuğu aracılığıyla uygun segmentlere eklenir ve yeni segmentler chatbot menüsünden oluşturulabilir. Örneğin, bir VIP müşteri özel bir kampanya sorgusu yaptığında, Segment Ekle aksiyonu ile kullanıcı VIP segmentine eklenir. Raporlama aracılığıyla segment raporları incelenerek kullanıcıların hangi segmentlere eklendiği ve taleplerine dair detaylı veriler elde edilebilir.",
            REMOVE_FROM_SEGMENTDesc:
                "Segmentten Çıkar Aksiyonu, kullanıcıları belirli segmentlerden çıkarmak için kullanılır. Bu aksiyon, segment güncellemelerini yaparak kullanıcıların segment bazında daha doğru analiz edilmesini sağlar. Kullanıcılar, segment seçim çubuğu üzerinden çıkarılacak segmenti seçtikten sonra otomatik olarak ilgili segmentten çıkarılır. Raporlama aracılığıyla segment güncellemeleri ve çıkarılan kullanıcıların analizleri yapılabilir, böylece segment değişimleri ve kullanıcı davranışları daha net bir şekilde takip edilebilir.",
            privateMessageDescription:
                "Gizli mesaj sadece temsilciler tarafından görüntülenebilir ve ziyaretçiler için gizli kalır.",
            PRIVATE_MESSAGE: "Gizli Mesaj",
            aiPrompt: "Yapay Zeka İsteği",
            variants: "Varyantlar",
            importSuccess: "Şablon başarıyla içe aktarıldı",
            importFailed: "Şablon içe aktarılırken bir hata oluştu",
            creatingBlank: "Boş bir ChatBOT oluşturuluyor...",
            untitledChatbot: "İsimsiz ChatBOT",
            errorCreating: "ChatBOT oluşturulurken hata oluştu",
            typeAutomationTitle: "Otomasyon başlığını yazın",
            typeStoryTitle: "Senaryo Başlığını Yazın",
            setUpYourChatbot: "Chatbot'unuzu Kurun",
            setUpYourChatbotDesc:
                "Chatbotunuzu verilerle eğitin, kullanıma hazır şablonlarımızı kullanın veya sıfırdan başlayın.",
            blankBot: "Boş Bot",
            blankBotDesc: "Daha sonra eğitebileceğiniz ve özelleştirebileceğiniz boş bir sohbet robotu oluşturun.",
            aiBotDesc: "RAG tabanlı akıllı chatbot oluşturun. Knowledge base ekleyin, LLM modelini seçin.",
            recommended: "Önerilen",
            websiteDesc: "Popüler kullanıcı sorularına yanıt almak için web sitenizin içeriğini tarayın.",
            yourNeedEnterYourOpenAi:
                "Web sitenizi tarayarak otomatik bir sohbet botu oluşturmak için OpenAI API anahtarınızı girmeniz gerekiyor.",
            createOpenAiKey: "Api Key Oluştur",
            aiKnowledge: "Yapay Zeka Bilgisi",
            modalUsage: "Modal Kullanımı",
            usedContentSources: "Kullanılan İçerik Kaynakları",
            websites: "Websiteler",
            articles: "Makaleler",
            faq: "SSS",
            files: "Dosyalar",
            functions: "Fonksiyonlar",
            settings: "Ayarlar",
            disableAi: "AI'yı Devre Dışı Bırak",
            enableAi: "Yapay Zekayı Etkinleştir",
            lastEdited: "Son Düzenlenen",
            state: "Durum",
            frequentlyAskedQuestions: "Sıkça Sorulan Sorular (SSS)",
            faqIsCreated: "SSS Oluşturuldu",
            selectKnowEnabled: "Seçilen bilgi tabanları etkinleştiriliyor...",
            selectKnowDisabled: "Seçilen bilgi tabanları devre dışı bırakılıyor...",
            selectKnowNotEnabled: "Seçilen bilgi tabanları etkinleştirilmemiştir.",
            selectKnowNotDisabled: "Seçilen bilgi tabanları devre dışı bırakılmaz.",
            answered: "Cevaplandı",
            addFile: "Dosya Ekle",
            fileDeleted: "Dosyalar silindi",
            fileDeletedFailed: "Dosyalar silinirken bir sorun oluştu",
            noFileAdded: "Dosya eklenmemiş",
            aiFunctions: "YZ Fonksiyonları",
            addFunction: "Foksiyon Ekle",
            aiFunctionCreateHint:
                "AI fonksiyon oluştururken Türkçe karakter kullanmayınız. Fonksiyon isimlerinde sadece İngilizce harfler, rakamlar ve alt çizgi kullanın.",
            builtInFunctionsTitle: "Ön Tanımlı Fonksiyonlar",
            builtInFunctionsDesc:
                "Bu fonksiyonlar, yapay zeka tarafından kullanılabilecek önceden tanımlanmış işlevlerdir.",
            builtInFunctionsOptionButtonsTitle: "Yapay Zeka Buttonlu Mesaj Gönderebilir",
            builtInFunctionsOptionButtonsDesc:
                "Yapay zekanın kullanıcıya tıklanabilir butonlar gösterebilmesini sağlar. Aktif olduğunda yapay zeka kullanıcıya seçenek butonları sunabilir.",
            builtInFunctionsCloseConversationTitle: "Yapay Zeka Görüşmeyi Sonlandırabilir",
            builtInFunctionsCloseConversationDesc:
                "Yapay zekanın uygun gördüğünde görüşmeyi sonlandırabilmesini sağlar. Aktif olduğunda yapay zeka konuşmayı kapatabilir.",
            builtInFunctionsTransferChatTitle: "Yapay Zeka Canlı Desteğe Aktarabilir",
            builtInFunctionsTransferChatDesc:
                "Yapay zekanın gerektiğinde görüşmeyi canlı desteğe aktarabilmesini sağlar. Aktif olduğunda yapay zeka görüşmeyi bir insan temsilciye transfer edebilir.",
            parameterCount: "Parametre Sayısı",
            auto: "Otomatik",
            Zoho_Actions: "Zoho Aksiyonları",
            File_Actions: "Dosya Aksiyonları",
            Google_Drive_Actions: "Google Drive Aksiyonları",
            Artificial_Intelligence: "Yapay Zeka",
            Cache_Actions: "Cache Aksiyonları",
            Data_Formatters: "Veri Formatlayıcıları",
            Messaging_Actions: "Mesajlaşma Aksiyonları",
            Ticket_Actions: "Ticket Aksiyonları",
            Task_Actions: "Görev Aksiyonları",
            Contact_Actions: "Kişi Aksiyonları",
            Calendar_Actions: "Takvim Aksiyonları",
            Loop_Actions: "Döngü Aksiyonları",
            usedByAI: "AI Kullanıyor",
            usedByAi: "AI tarafından kullanılan",
            notUsed: "Kullanılmıyor",
            saveAndClose: "Kaydet ve Kapat",
            contentPreview: "İçerik Önizleme",
            addContent: "İçerik Ekle",
            populerUserQuestion: "Popüler kullanıcı sorularına yanıt almak için web sitenizin içeriğini tarayın.",
            enterUrlAddress: "Bir URL adresi girin",
            sharingYourUrl:
                "URL'nizi paylaşarak, içeriğini paylaşmak için gerekli haklara sahip olduğunuzu onaylamış olursunuz.",
            pageSelected: "Seçilen Sayfalar",
            trainChatbot: "Sohbet robotunu eğitin",
            thereAreOnePages: "İçinde 1 sayfa var",
            categoryDesc: "kategori. Yapay zeka modelinizi eğitmek için hangisinin kullanılacağını seçin.",
            scarpOrAddContent:
                "AI Assist'in müşterilerinizin sorularına yanıt vermek için kullanabileceği içerikleri kazıyın veya ekleyin",
            noContentAdded: "İçerik Eklenmedi",
            howItWorks: "Nasıl Çalışır",
            editEntries: "Girdileri Düzenle",
            newEntries: "Yeni Girdiler",
            chatbotManagement: "Chatbot Yönetimi",
            chatbotScenarioList: "Chatbot Seneryo Listesi",
            exportDiagramToClipboard: "Diyagramı Panoya Aktar",
            exportDiagram: "Diyagramı Dışa Aktar",
            exportDiagramDescription:
                "Dışa aktarmak istediğiniz bileşenleri seçin. Bu veriler panoya kopyalanacak ve başka bir senaryoya aktarılabilecektir.",
            diagram: "Diyagram",
            diagramExportDesc: "Chatbot akış diyagramı (zorunlu)",
            aiSettings: "AI Ayarları",
            aiSettingsExportDesc: "Yapay zeka model ayarları, prompt ve parametreleri",
            aiFunctionsExportDesc: "Dışa aktarılacak AI fonksiyonlarını seçin",
            knowledgeBase: "Bilgi Tabanı",
            knowledgeBaseExportDesc: "Dışa aktarılacak bilgi tabanı türlerini seçin",
            webPages: "Web Sayfaları",
            noKnowledgeBase: "Dışa aktarılacak bilgi tabanı bulunamadı",
            selectAll: "Tümünü Seç",
            exportToClipboard: "Panoya Kopyala",
            exportSuccess: "Senaryo başarıyla panoya kopyalandı",
            exportError: "Dışa aktarma sırasında bir hata oluştu",
            exportDataFetchError: "Dışa aktarma verileri alınırken hata oluştu",
            model: "Model",
            topP: "Top P",
            toolChoice: "Araç Seçimi",
            prompt: "Prompt",
            selectedStory: "{count} Senaryo Seçildi",
            B2Cargo_Actions: "B2Cargo Aksiyonları",
            Holiday_Plus_Actions: "Holiday+ Aksiyonları",
            Meta_Actions: "Meta Aksiyonları",
            HOLIDAY_PLUS_GET_ROOMS: "ODALARI LISTELE",
            HOLIDAY_PLUS_GET_HOTELS: "OTELLERI LISTELE",
            ZOHO_CREATE_RECORD: "Zoho Kayıt Oluştur",
            B2CARGO_LOGIN_USER: "Kullanıcı Girişi",
            B2CARGO_PRODUCT_STATUS: "Ürün Durumu",
            didntSuppression: "Herhangi bir kısıtlama yapmadınız.",
            suppressionRemoved: "Kısıtlama Kaldırıldı",
            suppressionAdded: "Kısıtlama Eklendi",
            whatsappIntegrationTitle: "Whatsapp V1 ve Whatsapp V2 Entegrasyonu",
            whatsappApiIntegrationTitle: "Whatsapp Business API Entegrasyonu",
            ReadyTemplateBadge: "Hazır Şablon",
            readyTemplates: "Hazır Şablonlar",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Chatbot Logosu",
            chatbotName: "ChatBot Adı",
            ChatbotScenarioList: "Chatbot Senaryo Listesi",
            Scenario: "Senaryolar",
            allSecnario: "Tüm Chatbot Senaryoları",
            filters: {
                equal: "eşittir",
                not_equal: "eşit değildir",
                contain: "içerir",
                not_contain: "içermez",
                starts_with: "ile başlar",
                ends_with: "ile biter",
                empty: "boş ise",
                non_empty: "boş değil ise",
                longer_than: "daha uzunsa",
                shorter_than: "daha kısaysa",
                less_than: "küçükse",
                less_or_equal: "küçük veya eşit ise",
                greater_than: "büyükse",
                greater_or_equal: "büyük veya eşit ise",
            },
            planRequired: "{integratable} Plan Gerekmektedir.",
            noDefaultStoryTitle: "Varsayılan Hikaye",
            noDefaultStory: "Varsayılan hikayeniz bulunmamaktadır.\n Bu hikayeyi varsayılan yapmak ister misiniz?",
            noMessage: "Mesaj Yok",
            loading: "Yükleniyor",
            loadMore: "Daha fazla",
            hostname: "Host adı",
            allTemplates: "Tüm Şablonlar",
            allAITemplates: "Tüm Yapay Zeka Şablonları",
            templatesFromTheIndustry: "Sektörden Şablonlar",
            basicTemplate: "Temel Şablon",
            proTemplate: "Gelişmiş Şablon",
            goToStory: "hikayeye git",
            noResultFound: "Hiç bir sonuç bulunamadı",
            checkYourFilterCombination: "Filtre kombinasyonunu kontrol et",
            clearYourSearch: "aramayı temizle",
            andTryAgain: "ve yeniden dene",
            withBot: "& Bot",
            userWithBot: "Kullanıcı & Bot",
            chatDetail: "Sohbet Detayları",
            allUserDetail: "Tüm kullanıcı detaylarını görün",
            sessionData: "Oturum verileri",
            supsisChatWidget: "Supsis Sohbet Aracı",
            integratedWith: "Şunlarla entegredir : ",
            Users: "Kullanıcılar",
            user_id: "Kullanıcı ID",
            botStory: "Bot hikayesi",
            categories: "Kategoriler",
            worksWith: "İle çalışır",
            importBot: "Botu kullan",
            keyFeatures: "Ana Özellikler",
            importing: "ekleniyor",
            comingSoon: "Yakında Hizmetinizde",
            pickStory: "Hikaye seçin",
            conversationId: "Konuşma ID",
            integrateStoryWithSupsisWidget: "Supsis Widget'ını Chatbot Story ile Entegre Edin",
            integrateStoryWithWhatsapp: "Whatsapp'ı Chatbot Story ile Entegre Edin",
            integrateStoryWithInstagram: "Instagram'ı Chatbot Story ile Entegre Edin",
            install: "Yükle",
            attr: {
                owner: "Sahip",
                trendyol_question: "Ürün Sorusu",
                trendyol_question_id: "Ürün Soru ID",
                trendyol_product_id: "Ürün ID",
                trendyol_product: "Ürün Bilgileri",
                weekday: "Haftanın Günü",
                email: "E-posta",
                phone: "Telefon",
                language: "Dil",
                timezone: "Saat Dilimi",
                gender: "Cinsiyet",
                country: "Ülke",
                referrer: "Referrer",
                url: "Ziyaret Adresi",
                id: "ID",
                conversationId: "Konuşma ID",
                channelId: "Kanal ID",
                ip: "IP",
                last_seen: "Son Görülme",
                name: "İsim",
                user_id: "Kullanıcı numarası",
                department: "Departman",
                message: "Mesaj",
                akinon_brand: "Marka",
                akinon_order_id: "Sipariş Numarası",
                akinon_product_id: "Ürün Numarası",
                akinon_user_id: "Kullanıcı ID'si",
                akinon_user_name: "Kullanıcı Adı",
                akinon_user_email: "Kullanıcı E-Postası",
                akinon_invoice_url: "Fatura URL",
                akinon_order_status: "Sipariş Durumu",
                akinon_order_price: "Sipariş Fiyatı",
                akinon_shipper_name: "Kargo Firması Adı",
                akinon_product_size: "Ürün Bedeni",
                akinon_sku: "SKU",
                akinon_product_url: "Ürün URL",
                akinon_product_title: "Ürün Başlığı",
                akinon_product_image: "Ürün Resmi",
                akinon_product_stock: "Ürün Stoğu",
                akinon_order_date: "Sipariş Tarihi",
                akinon_track_number: "Kargo Takip Numarası",
                akinon_track_url: "Kargo Takip URL",
                akinon_latitude: "Enlem (Konum)",
                akinon_longitude: "Boylam (Konum)",
                ideasoft_user_id: "Üye Id",
                ideasoft_invoice_url: "Fatura Linki",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Sipariş Durumu",
                ideasoft_order_price: "Sipariş Tutarı",
                ideasoft_shipper_name: "Kargo Firması",
                ideasoft_product_size: "Ürün Bedeni",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Ürün Linki",
                ideasoft_product_title: "Ürün Başlığı",
                ideasoft_product_image: "Ürün Resmi",
                ideasoft_product_stock: "Ürün Stok",
                ideasoft_order_date: "Sipariş Tarihi",
                ideasoft_track_number: "Kargo Takip Numarası",
                ideasoft_track_url: "Kargo Takip URL",
                offline_mode: "Çevrimdışı Mod",
                available_agents: "Uygun Temsilciler",
                platform: "Platform",
                probel_sube_kodu: "Şube Kodu",
                probel_brans_adi: "Branş Adı",
                probel_brans_kodu: "Branş Kodu",
                probel_doktor_adi: "Doktor Adı",
                probel_doktor_kodu: "Doktor Kodu",
                probel_poliklinik_adi: "Poliklinik Adı",
                probel_poliklinik_kodu: "Poliklinik Kodu",
                probel_randevu_tarihi: "Randevu Tarihi",
                probel_date: "Randevu Tarihi",
                probel_randevu_saati: "Randevu Saati",
                probel_randevu_id: "Randevu ID",
                probel_hasta_token: "Hasta Token",
                probel_kimlik_tipi: "Kimlik Tipi",
                probel_kimlik_no: "Kimlik No",
                probel_hasta_adi: "Hasta Adı",
                probel_hasta_soyadi: "Hasta Soyadı",
                probel_hasta_cinsiyet: "Cinsiyet",
                probel_hasta_dogum_tarihi: "Doğum Tarihi",
                probel_hasta_telefon: "Telefon",
                hour: "Saat",
                segments: "Segments",
                ticket: "Etiket",
                tags: "Etiket",
                metaReferrals: "Meta Referrals",
                idleUserTime: "Kullanıcı Son Aksiyon (Saniye)",
                ai_class_result: "YZ Sınıf Sonuç",
                meta_comment_id: "Meta Yorum ID",
                meta_comment: "Meta Yorum",
                meta_post_id: "Meta Post ID",
                last_meta_post_id: "Son Meta Post ID",
                last_meta_post_caption: "Son Meta Post Başlığı",
                last_meta_post_type: "Son Meta Post Tipi",
                visitor_trigger_type: "Müşteri Tetiklenme Türü",
                visitor_trigger_name: "Müşteri Tetikleyici Adı",
                b2cargo_companyCode: "Firma Kodu",
                b2cargo_takipNo: "Ürün Takip No",
                b2cargo_takipseri: "Ürün Takip Seri",
                b2cargo_evrakdurum: "Ürün Durumu",
                b2cargo_teslimtar: "Teslim Tarihi",
                b2cargo_gonderen: "Gönderen Firma",
                b2cargo_aliciAdi: "Alıcı Firma",
                b2cargo_cikisIl: "Çıkış İl",
                b2cargo_varisIl: "Varış İl",
                b2cargo_teslim: "Teslim Durumu",
                b2cargo_urun: "Ürün Tipi",
                b2cargo_atfTarih: "ATF Tarih",
                b2cargo_palet: "Palet",
                b2cargo_koli: "Koli",
                b2cargo_kg: "Ürün Ağırlığı",
                b2cargo_desi: "Ürün Boyutu",
                b2cargo_zimmetno: "Zimmet No",
                b2cargo_varissube: "Varış Şube",
                b2cargo_atfDurum: "ATF Durum",
                holiday_plus_room_id: "Oda ID",
                holiday_plus_room_title: "Oda Adı",
                holiday_plus_room_description: "Oda Açıklaması",
                holiday_plus_room_size: "Oda Boyutu",
                holiday_plus_room_price: "Oda Fiyatı",
                holiday_plus_room_price_offer: "Oda İndirimi",
                holiday_plus_room_discount_price: "Oda İndirimli Fiyatı",
                holiday_plus_selected_hotel_id: "Seçilen Otel ID",
                holiday_plus_checkin: "Giriş Tarihi",
                holiday_plus_checkout: "Çıkış Tarihi",
                holiday_plus_child_count: "Çocuk Sayısı",
                holiday_plus_adult_count: "Yetişkin Sayısı",
                holiday_plus_child_dates: "Çocukların Yaşları",
                reservation_time: "Rezervasyon Saati",
                reservation_day: "Rezervasyon Günü",
            },
            storyList: "Hikaye Listesi",
            stories: "Hikayeler",
            templates: "Şablonlar",
            aitemplates: "Yapay Zeka Şablonlar",
            integrations: "Entegrasyonlar",
            all: "Tümü",
            installed: "Yüklenmiş Olanlar",
            uninstall: "Kaldır",
            remainingMessageDesc: "Kalan ücretsiz mesaj : ",
            openAISiteRoutingDescStart: "Bir Apikey almak için",
            openAISiteRoutingDescEnd: " bağlantısına tıklayabilirsiniz.",
            integrationOK: "Entegre edildi",
            chatWidget: "Supsis Sohbet Balonu",
            artificialIntelligence: "Yapay Zeka",
            integratePlatform: "Chatbot {integretable} ile entegre edilebilir.",
            integrateOpenAIWithChatbot: "Chat GPT-4o'ü Chatbot ile Entegre Edin",
            integrateChatBotWithChatGPT3: "ChatBot'un Chat GPT-4o ile Entegrasyonu",
            webhooks: "Web Kancaları",
            archive: "Arşiv",
            reports: "Raporlar",
            uncheckAll: "Tümünü bırak",
            userSegments: "Kullanıcı Segmentleri",
            blockMarket: "Blok Marketi",
            sandbox: "Çöp Kutusu",
            sandboxPage: {
                title: "Chatbot Silinen Senaryolar",
                description: "Silinen senaryolarınız çöp sepetinde 30 gün bekledikten sonra otomatik olarak silinir",
                emptyState: "Çöp sepetinde silinen senaryo bulunmuyor",
                unnamedScenario: "İsimsiz Senaryo",
                restore: "Geri Yükle",
                permanentlyDelete: "Kalıcı Olarak Sil",
                unknown: "Bilinmiyor",
                user: "Kullanıcı",
                restoreConfirmTitle: "Senaryoyu Geri Yüklemek İstediğinize Emin Misiniz?",
                restoreConfirmContent: "{story} senaryosu geri yüklenecek.",
                restoreSuccess: "Senaryo geri yüklendi",
                restoreError: "Geri yükleme başarısız oldu",
                permanentDeleteConfirmTitle: "Senaryoyu Kalıcı Olarak Silmek İstediğinize Emin Misiniz?",
                permanentDeleteConfirmContent: "Bu işlem geri alınamaz. Senaryo kalıcı olarak silinecek.",
                permanentDeleteSuccess: "Senaryo kalıcı olarak silindi",
                permanentDeleteError: "Silme işlemi başarısız oldu",
                loadError: "Silinen senaryolar yüklenirken hata oluştu",
            },
            customBlocks: "Özel Bloklar",
            createNewBlock: "Yeni Blok Oluştur",
            marketplace: "Market",
            myBlocks: "Bloklarım",
            importedBlocks: "İçe Aktarılan Bloklar",
            pendingApproval: "Onay Bekleyenler",
            searchBlocks: "Blok ara...",
            unknownBlock: "Bilinmeyen Blok",
            aiModelsComparison: "AI Model Karşılaştırması",
            aiModelsChangeModel: "Modeli değiştir",
            aiModelsRecommended: "Önerilen",
            aiModelsEconomic: "Ekonomik",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "OpenAI Vektörel Depolama ile chatbot'unuzu özel içeriklerinizle eğitebilirsiniz.",
            comingSoonStep1Title: "Dosyalarınızı Yükleyin",
            comingSoonStep1Desc: "PDF, Word, Excel, metin dosyaları veya diğer dökümanlarınızı sisteme ekleyin.",
            comingSoonStep2Title: "Otomatik İşleme",
            comingSoonStep2Desc: "Dosyalarınız OpenAI tarafından analiz edilir ve vektörel formata dönüştürülür.",
            comingSoonStep3Title: "Akıllı Yanıtlar",
            comingSoonStep3Desc: "Chatbot'unuz yüklediğiniz içeriklere dayalı olarak doğru ve anlamlı yanıtlar verir.",
            comingSoonTip:
                "İpucu: Daha fazla içerik ekledikçe chatbot'unuzun bilgi tabanı genişler ve daha kapsamlı yanıtlar verebilir.",
            comingSoonGotIt: "Anladım",
            imageProcessingSettings: {
                title: "Resim İşleme Ayarları",
                description: "Chatbot'a gönderilen resimlerin nasıl işleneceğini belirleyin.",
                processingMode: "İşleme Modu",
                processWithBlock: "Block ile İşle",
                processWithBlockDesc: "Resimleri yerel block akışına yönlendir",
                processWithAI: "AI ile İşle",
                processWithAIDesc: "Resimleri yapay zeka ile işle",
                fallbackBlock: "Fallback Block",
                fallbackBlockDesc: "Resim işlenirken hata durumunda yönlendirilecek block",
                fallbackBlockPlaceholder: "Fallback block seçin",
                directJumpBlock: "Direct Jump Block",
                directJumpBlockDesc: "Tüm resimleri doğrudan bu block'a yönlendir",
                directJumpBlockPlaceholder: "Direct jump block seçin (opsiyonel)",
                aiProcessingMode: "AI İşleme Modu",
                processIndividual: "Tek Tek İşle",
                processIndividualDesc: "Her resimi ayrı ayrı AI'ya gönder",
                processParallel: "Paralel İşle",
                processParallelDesc: "Belirli süre içindeki resimleri topla ve birlikte gönder",
                bufferTime: "Buffer Süresi (saniye)",
                bufferTimeDesc: "Resimlerin toplanması için beklenecek süre",
                saveSuccess: "Resim işleme ayarları başarıyla güncellendi",
                saveError: "Ayarlar kaydedilirken hata oluştu",
            },
            integration: "Entegrasyon",
            utility: "Araç",
            dataTransform: "Veri Dönüşümü",
            custom: "Özel",
            mostUsed: "En Çok Kullanılan",
            topRated: "En Yüksek Puan",
            newest: "En Yeni",
            uses: "kullanım",
            import: "İçe Aktar",
            imported: "İçe Aktarıldı",
            pending: "Beklemede",
            approved: "Onaylandı",
            rejected: "Reddedildi",
            unlist: "Listeden Kaldır",
            confirmDeleteBlock: "Bu bloğu silmek istediğinizden emin misiniz?",
            noBlocksCreated: "Henüz blok oluşturulmamış",
            publishBlock: "Bloğu Yayınla",
            blockPublished: "Blok başarıyla yayınlandı",
            blockUnlisted: "Blok listeden kaldırıldı",
            blockDeleted: "Blok silindi",
            cannotDeleteActiveBlock: "Kullanımda olan blok silinemez",
            noImportedBlocks: "İçe aktarılan blok yok",
            confirmRemoveImport: "Bu içe aktarımı kaldırmak istediğinizden emin misiniz?",
            remove: "Kaldır",
            importRemoved: "İçe aktarım kaldırıldı",
            creator: "Oluşturan",
            viewDetails: "Detayları Gör",
            approve: "Onayla",
            reject: "Reddet",
            noPendingBlocks: "Onay bekleyen blok yok",
            enterRejectionReason: "Ret sebebini girin",
            rejectBlock: "Bloğu Reddet",
            blockApproved: "Blok onaylandı",
            blockRejected: "Blok reddedildi",
            blockImported: "Blok başarıyla içe aktarıldı",
            parameters: "Parametreler",
            noParameters: "Parametre gerekmiyor",
            ratings: "Değerlendirmeler",
            writeReview: "Yorumunuzu yazın...",
            selectOrTypeCategory: "Kategori seçin veya yazın",
            changelogPlaceholder: "Değişiklik notunu girin (opsiyonel)",
            category: "Kategori",
            description: "Açıklama",
            tags: "Etiketler",
            submitRating: "Değerlendirmeyi Gönder",
            noRatings: "Henüz değerlendirme yok",
            latest: "En Son",
            pinned: "Sabitlenmiş",
            createBlock: "Blok Oluştur",
            basicInfo: "Temel Bilgiler",
            blockName: "Blok Adı",
            enterBlockName: "Blok adını girin",
            enterDescription: "Açıklama girin",
            icon: "İkon",
            addTags: "Etiket ekle",
            javascriptCode: "JavaScript Kodu",
            addParameter: "Parametre Ekle",
            parameterName: "Parametre adı (değişken)",
            parameterLabel: "Görünen etiket",
            parameterDescription: "Açıklama (yardım metni)",
            defaultValue: "Varsayılan değer",
            allowAutoUpdate: "Çalıştırma sırasında çıktı şemasını otomatik güncelle",
            visibility: "Görünürlük",
            allowedSiteIds: "İzinli Site ID'leri",
            enterSiteIds: "Site ID'lerini girin",
            saveDraft: "Taslak Kaydet",
            fillRequired: "Lütfen gerekli alanları doldurun",
            blockCreated: "Blok oluşturuldu",
            selectCustomBlock: "Özel Blok Seçin",
            selectCustomBlockDesc: "İçe aktardığınız bloklar arasından birini seçin",
            browseBlockMarket: "Blok Marketini Gez",
            outputPreview: "Çıktı Önizlemesi",
            blockNotFound: "Blok bulunamadı",
            pleaseSelectRating: "Lütfen bir puan seçin",
            ratingSubmitted: "Değerlendirme gönderildi",
            plans: "Planlar",
            chatBotPlans: "Chat Bot Planlar",
            addSegment: "Segment Ekle",
            addToSegment: "Segmente Ekle",
            removeFromSegment: "Segmentten Çıkar",
            plansVTippyContent:
                "Bu paket için ücretlendirme her ay başı yapılacaktır, iptal etmek istediğiniz süreçte kullanımınız ay başına kadar ücretlendirilecektir ve paketiniz bitecektir.<br><br>Paket değişiklikleri ertesi gün faturaya yansımaktadır. <br><br>Paket fiyatı KDV harici fiyatıdır.",
            segmentName: "Segment Adı",
            sameSegment: "Aynı isimde bir segment mevcut",
            usersInSegment: "Segmentteki Kullanıcılar",
            noUsersAdded: "Kullanıcı eklenmedi",
            updateSegment: "Segmenti Güncelle",
            newSegment: "Yeni Segment",
            queriesSelected: "sorguları seçildi",
            noBlocksFound: "Blok bulunamadı!",
            userQuery: "Kullanıcı Sorgusu",
            date: "Tarih",
            unmatched: "Eşleşmeyen",
            goToChat: "Sohbete Git",
            selectStory: "Hikaye Seç",
            selectBlock: "Blok Seç",
            training: "Bot Eğitimi",
            trainingAlert:
                "Bot eğitimi sayfasında yaptığınız değişikliklerin uygulanması için değişiklik yaptığınız senaryonun yeni versiyonunu yayınlamanız gerekmektedir.",
            unmatchedPhrases: "Eşleşmeyen İfadeler",
            ignored: "Önemsiz",
            story: "Hikaye",
            timePeriod: "Zaman Dilimi",
            wholeTimeSpan: "Tüm zamanlar",
            selectAStory: "Bir hikaye seçin",
            searchUserQuery: "Kullanıcı sorgusu ara",
            time: {
                today: "Bugün",
                yesterday: "Dün",
                last7: "Son 7 Gün",
                last30: "Son 30 Gün",
                "this-month": "Bu Ay",
                "last-month": "Geçen Ay",
                "last-3-month": "Son 3 Ay",
                "this-year": "Bu Yıl",
                "last-year": "Geçen Yıl",
                custom: "Farklı Bir Tarih Seç",
            },
            emailProvider: "E-mail sağlayıcı",
            triggerFromAnywhere: "Her yerden tetiklenebilir",
            editWebhook: "Webhook düzenle",
            newWebhook: "Yeni Webhook",
            webhookTitle: "Webhook Başlığı",
            webhookUrl: "Webhook URL'si",
            webhookToken: "WebHook Token",
            webhookUsername: "WebHook Kullanıcı adı",
            webhookPassword: "WebHook Parolası",
            allIntegrations: "Tüm Entegrasyonlar",
            integrateYourCBwithChatWidget: "Chatbotu Chat Widget ile entegre edin.",
            integrateYourCBwithChatGpt3: "Chatbot, GPT-4o ile entegre edilebilir. GPT-4o api key gerekli.",
            integrateYourCBwithWebHook: "ChatBot ve web hizmetleriniz arasında sohbet bilgilerini kolaylıkla iletin.",
            integrateYourCBwithIntegratable: "ChatBot ve {integratable} arasında sohbet bilgilerini kolaylıkla iletin.",
            addWebhook: "Webhook Ekle",
            editBlock: "Düzenle",
            moveBlock: "Taşı",
            copyBlock: "Kopyala",
            chatbot: "Chatbot",
            addFilter: "Filtre Ekle",
            addFilterGroup: "Filtre Grubu Ekle",
            clearFilter: "Filtreyi Temizle",
            in: "içinde",
            and: "ve",
            or: "veya",
            allStories: "Tüm Hikayeler",
            addBot: "Bot Oluştur",
            testBot: "Botu Test Et",
            publish: "Yayınla",
            editName: "Adı Düzenle",
            search: "Hikayenizde arayın…",
            typeMoreThan3Char: "En az 3 karakter girin ",
            expand: "Genişlet",
            expandAll: "Tümünü Genişlet",
            noMatchingItem: "Eşleşen öğe yok",
            hint: "İpucu",
            select: "Seç",
            navigate: "Gezin",
            dismiss: "Vazgeç",
            choseAttribute: "Filtre türünü seçin",
            selectReply: "Yanıt türünü seçin",
            preview: "Önizleme",
            draft: "Taslak",
            lastUpdate: "Son Güncelleme",
            published: "Yayınlandı",
            newStory: "Yeni Hikaye",
            updateStory: "Hikayeyi Güncelle",
            storyDescription: "Hikaye Açıklaması",
            storyTitle: "Hikaye Başlığı",
            deleteSingleBlock: "Tek Bloğu Sil",
            deleteWithChildren: "İç Dallanmalarla Birlikte Sil",
            startTestFromHere: "Testi Buradan Başlat",
            copyBlockId: "Blok ID'sini Kopyala",
            gotoLiveLink: "Buradan Canlı Link Oluştur",
            copyBlockIdSuccessfull: "Blok ID'sini Kopyalandı",
            collapse: "Daralt",
            collapseAll: "Tümünü Daralt",
            snDelay: "{delay} sn gecikme",
            blockUpdated: "Blok Güncellendi",
            addPayload: "Cevap Ekle",
            previewModeCaution:
                "Şuanda hikayenizin versiyonlarından birinin önizlemesini yapıyorsunuz. Önizleme modunda değişiklikleri kaydedemezsiniz!",
            enterText: "Buraya yazın...",
            trackpad: "Trackpad",
            navigation: "Navigasyon",
            navigationDesc:
                "Lütfen navigasyon modunuzu seçin. İzleme dörtgeni veya fare seçeneklerinden dilediğinizi seçebilirsiniz..",
            botSetting: "Bot Ayarı",
            botSettingDesc:
                "Lütfen güven seviyesini belirleyin. Bu, kullanıcı girişleriyle ilgili chatbot yorumlarının doğruluğunu tanımlayan 0 ile 100 arasında bir yüzdedir. ",
            languageSettingsDesc: "Lütfen Bot'un yanıt verdiği dilin tercih ettiğiniz dil olduğundan emin olun.",
            mouse: "Mouse",
            Interactions: "Etkileşimler",
            Actions: "Aksiyonlar",
            Supsis_Actions: "Supsis Aksiyonları",
            Table_Actions: "Tablo Aksiyonları",
            Shopify_Actions: "Shopify Aksiyonları",
            Akinon_Actions: "Akinon Aksiyonları",
            IdeaSoft_Actions: "Ideasoft Aksiyonları",
            START_POINT: "BAŞLANGIÇ NOKTASI",
            AI_ASSISTANT: "YAPAY ZEKA ASISTAN",
            FEEDBACK_AI_ASSISTANT: "ASISTANA BİLGİ VER",
            INSERT_TO_SYSTEM_PROMPT: "Sistem Promptuna Mesaj Ekle",
            API_REQUEST: "API İSTEK",
            BOT_RESPONSE: "BOT'UN YANITI",
            AI_CALL: "YAPAY ZEKA ARAMA",
            TAVILY_WEB_SEARCH: "WEB ARAMA (TAVILY)",
            OPENAI_WEB_SEARCH: "WEB ARAMA (OPENAI)",
            AI_BOT_RESPONSE: "YZ YANIT (GPT-4o)",
            AI_CLASSIFICATION: "YZ SINIFLANDIR",
            Templates: "Şablon Bloklar",
            AI_MENU_FLOW: "Hazır Menü Flow",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            RUN_JAVASCRIPT: "JAVASCRIPT ÇALIŞTIR",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "VARSAYILAN AKSİ DURUM",
            DEFAULT_TIMEOUT: "VARSAYILAN Zaman Aşımı",
            AI_FUNCTIONS: "YZ FONKSIYON",
            FILTER: "FİLTRE",
            addNewFilter: "Yeni filtre ekle",
            FLOW: "AKIŞ",
            ATTACHMENT_INPUT: "DOSYA GİRİŞİ",
            USER_INPUT: "KULLANICI GİRİŞİ",
            GO_TO_STEP: "ADIM'A GİT",
            WEBHOOK: "WEB HOOK",
            SET_ATTRIBUTE: "ÖZELLİK AYARLA",
            ASSIGN_OWNER: "Sahip Ata",
            QUESTION: "SORU",
            CLOSE_CHAT: "SOHBETİ KAPAT",
            CREATE_TICKET: "TICKET OLUŞTUR",
            TRANSFER_CHAT: "SOHBETİ AKTAR",
            TRANSFER_TO_CHATBOT: "CHATBOTA YÖNLENDİR",
            TAG_CHAT: "ETIKET EKLE",
            CACHE_WRITE: "CACHE YAZ",
            CACHE_READ: "CACHE OKU",
            CACHE_EXTEND: "CACHE SÜRESİNİ UZAT",
            CACHE_DELETE: "CACHE SİL",
            YOUTUBE_REPLY_COMMENT: "YOUTUBE YORUMA YANIT VER",
            YOUTUBE_UPDATE_COMMENT_STATUS: "YOUTUBE YORUM DURUMU GÜNCELLE",
            YOUTUBE_SET_MODERATION_STATUS: "YOUTUBE MODERASYON DURUMU AYARLA",
            GOOGLE_BUSINESS_REPLY_REVIEW: "GOOGLE BUSINESS YORUMA YANIT VER",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "GOOGLE BUSINESS YORUM DURUMU GÜNCELLE",
            GOOGLE_PLAY_REPLY_REVIEW: "GOOGLE PLAY YORUMA YANIT VER",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "GOOGLE PLAY YORUM DURUMU GÜNCELLE",
            APP_STORE_REPLY_REVIEW: "APP STORE YORUMA YANIT VER",
            APP_STORE_UPDATE_REVIEW_STATUS: "APP STORE YORUM DURUMU GÜNCELLE",
            APP_STORE_DELETE_REVIEW_RESPONSE: "APP STORE YORUM YANITI SİL",
            REMOVE_TAG: "ETIKET SIL",
            SET_DEPARTMENT: "DEPARTMANA AYARLA",
            SEND_TRANSCRIPT: "TRANSKRİPT GÖNDER",
            SEND_SMS: "SMS GONDER",
            SEND_MAIL: "MAIL GONDER",
            CREATE_EVENT: "ETKİNLİK OLUŞTUR",
            CREATE_RESERVATION: "REZERVASYON OLUŞTUR",
            RESERVATION_OPEN_URL: "Rezervasyon Ekranı Görüntüle",
            RESERVATION_SELECT_DAY: "Rezervasyon günü seç",
            RESERVATION_EVENT_LIST: "Müşteri Rezervasyon Listesi",
            RESERVATION_SELECT_TIME: "Rezervasyon saati seç",
            CREATE_TASK: "GÖREV OLUŞTUR",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY ÜRÜNLERİ GÖSTER",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY ÜRÜN VARLIĞI",
            SHOPIFY_ORDER_STATUS: "MAĞAZA SİPARİŞ DURUMU",
            AKINON_SHOW_PRODUCTS: "AKINON ÜRÜN GÖSTER",
            AKINON_FIND_PRODUCT: "AKINON ÜRÜN BUL",
            AKINON_ORDER_STATUS: "AKINON SİPARİŞ DURUMU",
            AKINON_SELECT_ORDER: "AKINON SİPARİŞ SEÇ",
            AKINON_SELECT_SIZE: "AKINON BEDEN SEÇ",
            AKINON_FIND_NEAREST_STOCK: "MAĞAZA STOK GÖSTER",
            AKINON_FIND_NEAREST_STORES: "YAKIN MAĞAZALARI GÖSTER",
            AKINON_SHOW_DISCOUNT_CODES: "İNDİRİM KODU GÖSTER",
            IDEASOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
            IDEASOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
            IDEASOFT_GET_MEMBER_INFO: "ÜYE DETAY GETİR",
            followingAttributesFilled: "Aşağıdaki niteliklerler dolu olarak gelecektir.",
            GET_LOCATION: "KONUM AL",
            FALLBACK: "AKSİ DURUM",
            TIMEOUT: "ZAMAN AŞIMI",
            SUCCESS: "BAŞARILI",
            FAILURE: "BAŞARISIZ",
            Probel_Actions: "Probel Aksiyonları",
            PROBEL_SELECT_BRANCH: "Branş Seç",
            PROBEL_SELECT_CLINIC: "Poliklinik Seç",
            PROBEL_SELECT_DAY: "Randevu Günü Seç",
            PROBEL_SELECT_HOUR: "Randevu Saati Seç",
            PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
            PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
            PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
            PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
            PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
            SUPPRESSION_ADD: "Kullanıcı Engelle",
            SUPPRESSION_REMOVE: "Kullanıcı Engel Kaldır",
            SEND_WP_BUSINESS_MESSAGE: "WHATSAPP MESAJ GÖNDER",
            MESSENGER_SEND_MESSAGE: "Messenger Mesaj Gönder",
            INSTAGRAM_SEND_MESSAGE: "Instagram Mesaj Gönder",
            INSTAGRAM_COMMENT_REPLY: "Yorumu Yanıtla",
            INSTAGRAM_COMMENT_DELETE: "Yorumu Sil",
            INSTAGRAM_COMMENT_SHOW: "Yorumu Göster",
            INSTAGRAM_COMMENT_HIDE: "Yorumu Gizle",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "Yoruma DM Yanıt",
            TABLE_CREATE_RECORD: "Kayıt Oluştur",
            TABLE_DELETE_RECORD: "Kayıt Sil",
            TABLE_UPDATE_RECORD: "Kayıt Güncelle",
            TABLE_FIND_RECORD: "Kayıt Bul",
            TABLE_FIND_RECORDS: "Kayıt Listele",
            message: "Mesaj",
            condition: "Şart",
            score: "Skor",
            equal: "eşit",
            not_equal: "eşit değil",
            contain: "içerir",
            not_contain: "içermez",
            starts_with: "ile başlar",
            ends_with: "ile biter",
            empty: "boş",
            longer_than: "daha uzun",
            shorter_than: "daha kısa",
            less_than: "daha az",
            less_than_equal: "küçük eşittir",
            greater_than: "büyüktür",
            greater_than_equal: "büyük eşittir",
            value: "Değer",
            failures: "Başarısız",
            email: "E-posta",
            name: "İsim",
            username: "Kullanıcı adı",
            source: "Kaynak",
            language: "Dil",
            timezone: "Saat Dilimi",
            region: "Bölge",
            country: "Ülke",
            referrer: "Yönlendiren",
            url: "URL",
            ip: "IP",
            city: "Şehir",
            lastSeen: "Son Görülen",
            userId: "Kullanıcı ID",
            selectStep: "Adım'ı Seçin",
            keywords: "Anahtar Kelime",
            userSays: "Kullanıcının Söyledikleri",
            addKeyword: "Anahtar Kelime Ekle",
            addUserMessage: "Kullanıcı Mesajı Ekle",
            set: "Özellik",
            to: "ile",
            gender: "Cinsiyet",
            go_to_failure: "Başarısız Yanıt adımına git",
            go_to_success: "Başarılı Yanıt adımına git",
            untilFilled: "sürekli",
            time1: "Bir kere",
            time2: "2 kere",
            time3: "3 kere",
            time4: "4 kere",
            time5: "5 kere",
            any: "Herhangi birşey",
            anytext: "Herhangi bir yazı (harfler veya boşluklar)",
            anytextDescription: "Boş olmayan harfler ve boşluklarla eşleşir",
            alphanumeric: "Harfler Ve Sayılar",
            integer: "Tam Sayı",
            no: "Hayır",
            number: "Sayı",
            phone: "Telefon",
            yes: "Evet",
            yesNo: "Evet - Hayır",
            anyDescription: "Boş olmayan herhangi bir şeyle eşleşir.",
            alphanumericDescription: "Hem harflerle hem de sayılarla eşleşir.",
            integerDescription: "Herhangi bir tamsayı ile eşleşir.",
            noDescription: "Hayır ile eş anlamlı sözcüklerle eşleşir.",
            numberDescription: "Sıralı temel sayıylarla eşleşir.",
            phoneDescription: "Telefon numarasıyla eşleşir.",
            yesDescription: "Evet kelimesinin eş anlamlılarıyla eşleşir.",
            yesNoDescription: "Evet ve hayır kelimelerinin eşanlamlılarıyla eşleşir.",
            emailDescription: "E-postayla eşleşir.",
            urlDescription: "URL ile eşleşir.",
            temperature: "Sıcaklık",
            askWhenInvalid: "geçersiz olursa sor",
            applyFilter: "Filtre Ekle",
            notificationMessageStartSuccess: "Blok ",
            notificationMessageEndSuccess: " Eklendi",
            notificationMessageStartError: "Bir hata oluştu, blok ",
            notificationMessageEndError: " eklenemedi",
            blockChangedWannaUpdate: "Güncellemeyi Kaydetmek İstiyormusunuz ?",
            TEXT: "Yazı",
            IMAGE: "Resim",
            GALLERY: "Galeri",
            BUTTON: "Buton",
            RANDOM_TEXT: "Rastgele Yazı",
            AI_RANDOM_TEXT: "Yapay Zeka Rastgele Yazı",
            AI_IMAGE: "Yapay Zeka Resim",
            QUICK_REPLY: "Hızlı Cevap",
            FILE: "Dosya",
            responses: "Tepkiler",
            flow: "Akış",
            active: "Aktif",
            passive: "Pasif",
            chooseAttributeType: "Özellik Türünü Seçin",
            imageAttachment: "Resim Ekleme",
            audioAttachment: "Ses Ekleme",
            videoAttachment: "Video Ekleme",
            documentAttachment: "Belge Ekleme",
            anyAttachment: "Herhangi bir Ek",
            typeAttributeValue: "Özellik Değerini Gir",
            typeSearchValue: "Arama Değeri yazın",
            male: "Erkek",
            addAttribute: "Özellik Ekle",
            addAttributeDescription:
                "Özniteliğin adı yalnızca A-Z harfleri, 0-9 sayıları, tire veya alt çizgi olan alfasayısal karakterler içerebilir.",
            USER_DATA: "Kullanıcı Bilgisi",
            CUSTOM_ATTRIBUTES: "ÖZEL ÖZNİTELİKLER",
            enterBotResponseHere: "Buraya Bot'un soracağı soruyu yazın...",
            enterPrivateBotResponseHere: "Botun göndereceği gizli mesajı yazın...",
            addCard: "Kart Ekle",
            typeCardTitle: "Kart Başlığı",
            typeCardDescription: "Kart Açıklaması",
            dragAndDropBrowse: "Resim Yükle",
            dragAndDropBrowseFile: "Upload File",
            button: "Buton",
            enterYourMessage: "Mesajınızı Girin",
            imageView: "Resim görünümü",
            imageUploading: "Resim Yükleniyor...",
            clickToChooseNewImage: "Yeni Resim Seçmek İçin Tıklayın",
            clickToChooseNewFile: "Yeni Dosya Seçmek İçin Tıklayın",
            removeTheExistingOne: "Mevcut Olanı Kaldır",
            validateResponseWithEntity: "Yanıtı Doğrula",
            actionOnFailureInput: "Hatalı Yazım Durumunda Ne Yapılsın?",
            askNextQuestion: "Bir sonraki soruyu sor",
            goToSuccessBlock: "Başarılı Bloğuna Git",
            goToFailureBlock: "Başarısız Bloğuna Git",
            saveResposeToAttribute: "Yanıtı Kaydet",
            selectReplyType: "Yanıt Türü'nü seçin",
            questionVariants: "Soru Çeşitleri",
            systemEntities: "Tanımlı Doğrulama İfadeleri",
            delay: "Gecikme",
            retrySectionTextPart: " sor.",
            retrySectionText: "Kulanıcının yanıtı geçersiz ise ",
            addNextQuestion: "Sonraki Soruyu Ekle",
            typeBlockTitle: "Blok başlığı",
            versionHistory: "Sürüm Geçmişi",
            restore: "Güncelle",
            versionName: "Versiyon Adı",
            restoreModalText:
                "Bu eylem, seçilen sürümü geri yükleyecektir. Bu sürümü geri yüklemek istediğinizden emin misiniz?",
            restoreVersion: "Versiyon Güncelle",
            newVersion: "Yeni Versiyon",
            synonymMustBeUnique: "Aynı Eşanlamlı Kelimeleden Birden Fazla Olamaz ",
            save: "Kaydet",
            entries: "Girdiler",
            youHaveNoEntries: "Girdi Bulunamadı",
            inputsCantBeEmpty: "Alanlar Boş Bırakılamaz",
            entryNamesMustBeUnique: "Anahtar Kelime Aynı Olamaz!",
            entityNameCantBeEmpty: "Varlık Adı Boş Bırakılamaz",
            entityNameMustBeUnique: "Varlık Adı Aynı Olamaz",
            synonyms: "Eş Anlamlılar",
            title: "Anahtar Kelime",
            entryName: "Girdi Adı",
            entities: "Varlıklar",
            entityhasbeenUpdatedSuccessfully: "Varlık Başarıyla Kaydedildi",
            emptyError: "Gerekli Alanlar Boş Bırakılamaz",
            allChats: "Tüm Sohbetler",
            paidChats: "Ücretli Sohbetler",
            busiestPeriod: "En Yoğun Dönem",
            ratingDistribution: "Puanlama Dağılımı",
            allMessages: "Tüm mesajlar",
            avarageMessages: "Ortalama Mesajlar",
            popularity: "Popülerlik",
            allUsers: "Tüm kullanıcılar",
            interactionName: "Etkileşim Adı",
            numberOfMessage: "Mesaj Sayısı",
            ofAllUsersMessage: "% Tüm Kullanıcıların Mesajı",
            totalData: "Toplam Veri",
            avgData: "Ortalama Veri",
            exportToCsv: "Csv'ye Aktar",
            exportToExcel: "Excel'e Aktar",
            inMaintenance: "Yapım Aşamasında",
            ADD_TO_SEGMENT: "Segment Ekle",
            REMOVE_FROM_SEGMENT: "Segmentten Çıkar",
            users: "Kullanıcılar",
            webhookName: "Webhook Adı",
            webHookUrl: "Webhook url",
            webHookToken: "Webhook Token",
            delete: "Sil",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Zorunlu Alanlar Boş Bırakılamaz ",
            yourVerificationToken: "Token",
            yourWebHookName: "Webhook Adınız",
            yourWebHookUrl: "Webhook URL'niz",
            enterKey: "Key",
            password: "Şifre",
            headerValue: "Değer",
            saveSuccessfully: "İşleminiz Başarıyla Kaydedildi.",
            urlTypeError: "Lütfen Alanı Doğru Şekilde Doldurunuz (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4o İçin Api Anahtarı Gerekli.",
                apiKeyDesc:
                    "Chatbot + Chat GPT-4o entegrasyonu için Api Key gereklidir. Lütfen api anahtarınızı alın veya deneme için aşağıdaki api anahtarını kullanın. Deneme amaçlı sadece 20 mesaj kullanabilirsiniz.",
                getApiKey: "Bir Open AI Api Anahtarını Alın",
                typeApiKey: "Api anahtarını yazın",
                ownApiKey: "OpenAI Api Anahtarına Sahip Olun",
                trialApiKey: "Deneme Api Anahtarı (20 Mesaj Olarak Sınırlıdır)",
                useOurTrial: "Ücretsiz Deneme Sürümümüzü Kullanın",
                twentyMessages: "20 Mesajı ücretsiz olarak kullanıp deneyebilirsiniz.",
                enableChatGpt3: "Chat GPT-4o Aktifleştirin",
            },
            OPENAI_WEB_SEARCHDesc:
                "Web arama, yapay zeka destekli sistemler aracılığıyla çeşitli web sitelerinden bilgi alınmasını sağlar. Bir arama sorgusu girildiğinde, belirtilen arama derinliğine göre en alakalı sonuçlar taranır ve kullanıcının ihtiyaçlarına uygun bilgiler sağlanır. Ham içerik, görseller ve görsel açıklamaları da daha kapsamlı bir bilgi aktarımı için dahil edilebilir. Ayrıca, elde edilen veriler özetlenebilir veya ham haliyle sunulabilir. Kullanıcılar, belirli alan adlarını dahil ederek arama sonuçlarını filtreleyebilir, böylece en güvenilir kaynaklardan bilgiye erişim sağlanır. Böylece, yapay zeka destekli web aramaları hızlı ve doğru bilgi edinme sürecini optimize eder.",
            TICKET_UPDATE: "GÜNCELLENEN TALEP",
            b2cargo_login_user: "Kullanıcı Girişi",
            b2cargo_product_status: "Ürün Durumu",
            cardInfos: "Kart Bilgileri",
            ficheros: "Dosyalar",
            file: "Dosya",
            fileCancellato: "Dosya silindi",
            impostazioni: "Ayarlar",
            risposta: "Yanıt",
            setUpUpYourChatbot: "Chatbotunuzu Kurun",
            setUpUpYourChatbotDesc:
                "Veri kullanarak chatbotunuzu eğitin, hazır şablonlarımızı kullanın veya sıfırdan başlayın.",
            yourNeedEnterEnterYourOpenAi:
                "Web sitenizi tarayarak bir chatbot oluşturmak için OpenAI API anahtarınızı girmeniz gerekir.",
            overall: "Genel",
            aiModels: "AI Modelleri",
            ragSettings: "RAG Ayarları",
            plugins: "Pluginler",
            supsisRag: "Supsis RAG",
            aiDisabledSuccess: "Yapay Zeka Devre Dışı Bırakıldı",
            aiEnabledSuccess: "Yapay Zeka Devreye Alındı",
            aiUpdateError: "Yapay Zekayı Devre Dışı Bırak ayarı güncellenemedi",
            disableAiAssistant: "Yapay Zekayı Devre Dışı Bırak",
            aiListenerDelay: "AI Listener Gecikme Süresi (ms)",
            aiListenerDelayDesc:
                "AI asistanının müdahale etmeden önce bekleyeceği süre. Kullanıcıya mesaj yazması için süre tanır.",
            scenarios: "Senaryolar",
            selected: "Seçili",
            intelligence: "Zeka",
            speed: "Hız",
            input: "Giriş",
            output: "Çıkış",
            reasoningTokens: "Akıl Yürütme Tokenları",
            pricing: "FİYATLANDIRMA",
            per1mTokens: "1M TOKEN BAŞINA",
            cachedInput: "Önbelleğe Alınmış Giriş",
            context: "BAĞLAM",
            window: "Pencere",
            modelsDisclaimer:
                "Modeller OpenAI API dokümantasyonuna göre listelenmiştir. Fiyat ve özellikler plan/bölgeye göre değişir.",
            llmModelOpenRouter: "LLM Modeli (OpenRouter)",
            activeModel: "Aktif Model",
            aiPluginsTitle: "Yapay Zeka Plugin'leri",
            aiPluginsSubtitle:
                "Bu plugin'ler yalnızca Supsis RAG (OpenRouter) modunda çalışır. Her plugin'i bağımsız olarak açıp kapatabilirsiniz.",
            jsonRepair: "JSON Onarımı",
            responseHealingDesc:
                "LLM'lerden gelen hatalı JSON yanıtlarını otomatik olarak onarır. Eksik parantezler, virgüller, markdown sarmalama veya karışık metin gibi sorunları düzelterek her zaman geçerli, ayrıştırılabilir JSON alırsınız.",
            ragMethod: "RAG Yöntemi",
            openaiRag: "OpenAI RAG",
            openaiRagDesc:
                "OpenAI'nin file_search aracı ile otomatik retrieval. OpenAI API anahtarı gerektirir. Mevcut tüm chatbotlarla uyumludur.",
            supsisRagDesc:
                "MongoDB Voyage AI ile kendi embedding altyapımız. OpenRouter üzerinden tüm LLM'leri kullanabilirsiniz. Çok daha fazla model seçeneği sunar.",
            new: "Yeni",
            openRouterChannel: "OpenRouter Kanalı",
            openRouterChannelDesc: "Supsis RAG için bir OpenRouter kanalı zorunludur. Kanalı seçin veya oluşturun.",
            noOpenRouterChannel: "Henüz OpenRouter kanalı yok.",
            createOpenRouterChannelDesc: "Entegrasyonlar > LLM Kanalları > OpenRouter bölümünden bir kanal oluşturun.",
            embeddingModel: "Embedding Modeli",
            embeddingModelDesc: "Knowledge base verilerini vektöre çevirmek için kullanılacak model.",
            selectOpenRouterChannel: "OpenRouter kanalı seçin",
            fileUploading: "Dosya Yükleniyor",
            filesCompleted: "dosya tamamlandı",
            dontLeavePageUpload: "Sayfadan ayrılmayınız, yükleme devam ediyor...",
            openFile: "Dosyayı aç",
            functionNameNoTurkish: "Fonksiyon adı Türkçe karakter içeremez!",
            readOnlyMode: "Salt Okunur Mod",
            publishedVersionReadOnly: "Yayınlanmış sürüm - Salt okunur",
            fullScreen: "Tam Ekran",
            exitFullScreen: "Çıkış",
            supsisAssistant: "Supsis Asistan",
            availableLibraries: "Kullanılabilir Kütüphaneler:",
            availableVariables: "Kullanılabilir Değişkenler:",
            parametersAutoAvailable:
                "Aşağıda tanımladığınız parametreler otomatik olarak kod içinde değişken olarak kullanılabilir. Doğrudan parametre adıyla erişebilirsiniz.",
            definedParametersUsage: "Tanımlı Parametreler ve Kullanımı:",
            directUsage: "Doğrudan Kullanım:",
            readAllParameters: "Tüm parametreleri okuma:",
            parametersAutoInjected: "Parametreler otomatik inject edilir:",
            parametersAutoInjectedDesc:
                "Tanımladığınız her parametre (örn: apiUrl, timeout) otomatik olarak const değişken olarak kodunuza eklenir. Direkt kullanabilirsiniz!",
            parameterNameVariable: "Parametre adı (değişken)",
            parameterLabelDisplay: "Görünen etiket",
            isHidden: "Gizli mi?",
            parameterDescriptionHelp: "Açıklama (yardım metni)",
            exampleOutputDesc:
                "Bloğunuzun döndüreceği örnek bir çıktı tanımlayın. Bu, kullanıcıların attribute seçicide bloğunuzun çıktısını görmesini sağlar.",
            outputSchemaHelp:
                "Bloğunuzun döndüreceği örnek bir JSON çıktısı girin. Bu, attribute seçicide görünecektir.",
            allowAutoUpdateHelp: "Etkinleştirildiğinde, blok her çalıştığında çıktı şeması otomatik güncellenir.",
            publicEveryone: "Public - Herkese açık",
            unlistedLinkOnly: "Unlisted - Sadece link ile erişilebilir",
            privateSpecificSites: "Private - Sadece belirli sitelere açık",
            allowedSiteIdsHelp: "Bu bloku sadece belirtilen site ID'lerine sahip müşteriler görebilir.",
            importJsonSchemaDesc: "Bir JSON örneği yapıştırın, parametrelerinizi otomatik oluşturalım:",
            tip: "İpucu:",
            jsonSchemaTip:
                "JSON'daki her alan bir parametre olarak eklenecektir. Tip otomatik olarak algılanır (string → text, number → number, boolean → boolean, array → array).",
            systemAttributeSelect: "System Attribute Seç",
            attributeSearch: "Attribute ara...",
            defineStructuredJsonSchema: "Yapılandırılmış JSON Şeması Tanımla",
            structuredJsonSchemaDesc: "Yapıyı oluşturmak için örnek bir JSON yapıştırın:",
            editStructuredJsonSchema: "Yapılandırılmış JSON Şemasını Düzenle",
            fieldName: "Alan Adı",
            displayName: "Görünen Ad",
            isRequired: "Zorunlu mu?",
            aiWizard: "Yapay Zeka Sihirbazı",
            aiWizardDesc:
                "Ne yapmak istediğinizi anlatın, sizin için JavaScript kodunu ve parametrelerini oluşturalım.",
            aiWizardExample:
                'Örn: "Bir API\'den hava durumu bilgisini çekip döndüren bir blok yap." veya "Gelen mesajdaki telefon numarasını regex ile ayıklayan bir kod yaz."',
            writeRequestHere: "İsteğinizi buraya yazın...",
            processing: "İşleniyor...",
            stop: "Durdur",
            applyCode: "Kodu Uygula",
            copyCode: "Kodu Kopyala",
            rebuild: "Yeniden Oluştur",
            aiWizardError: "Asistan bir hata ile karşılaştı. Lütfen tekrar deneyin.",
            aiAssistantPrepared: "Yapay zeka asistanı sizin için bu kodu ve parametreleri hazırladı.",
            applyCodeHelp: "Kodu monaco editor'e aktarır. (Mevcut kodunuzun üzerine yazılır)",
            applyParametersHelp: "Parametreler, mevcut parametre listenize eklenecektir.",
            usedLibraries: "Kullanılan Kütüphaneler:",
            usedLibrariesHelp: "Bu kütüphaneleri kodunuzda kullanabilirsiniz.",
            saveAnswerToAttribute: "Cevabı Attribute'a Kaydet?",
            selectAgent: "Agent seçiniz",
            enterAgentIdOrAttribute: "Agent ID girin veya attribute kullanın",
            callingNumber: "Arayan Numara",
            selectCallingNumber: "Arayan numara seçiniz",
            enterCallingNumberE164: "E.164 formatında arayan numara girin (örn: +905551234567) veya attribute kullanın",
            calledNumber: "Aranan Numara",
            enterCalledNumberE164: "E.164 formatında aranan numara girin (örn: +905551234567) veya attribute kullanın",
            waitForCallEnd: "Çağrı Bitene Kadar Bekle",
            variableName: "Değişken adı",
            variableValueOrAttribute: "Değişken değeri veya attribute",
            addVariable: "Değişken Ekle",
            classificationMode: "Sınıflandırma Modu:",
            textMode: "Metin Modu",
            imageMode: "Resim Modu",
            classificationImageUrlPlaceholder:
                "Ek talimatlar, özel koşullar veya sınıflandırmayı etkileyecek bilgiler (opsiyonel)",
            classificationImagePlaceholder: "Görüntü URL'si",
            tagAddingDesc:
                "Etiketler, ziyaretçilerinizi kategorize etmek için kullanılır. Ziyaretçilerinize manuel olarak veya koşulları kullanarak otomatik olarak etiketler ekleyebilirsiniz. Ayrıca chatbot'unuzdaki eylemleri tetiklemek için etiketleri kullanabilirsiniz.",
            tagsToAdding: "Eklenecek Etiketler",
            assignmentMethod: "Atama Yöntemi",
            algorithmicAssignment: "Algoritmik Atama",
            staticAssignment: "Statik Atama",
            agentToAssign: "Atanacak Temsilci",
            selectAgentPlaceholder: "Temsilci seçiniz",
            unownedRemoveOwner: "Sahipsiz (Owner Kaldır)",
            agentAssignmentHelp: "Seçilen temsilci kanal ve departman ayarlarına uygun olmalıdır",
            leastContact: "En Az Kontağa Sahip Olan",
            agentContactRangeHelp: "Temsilcilerin sahip olduğu kontak sayılarına bakılacak zaman aralığı",
            distributeOnlyToOnline: "Sadece Online Olanlara Dağıt",
            agentsToExclude: "Hariç Tutulacak Temsilciler",
            agentsExcludeHelp: "Seçilen temsilciler atama havuzundan hariç tutulacaktır",
            zohoCrmSync: "Zoho CRM Senkronizasyonu",
            zohoCrmSyncHelp: "Atanan kullanıcı Zoho CRM'de senkronize edilecektir.",
            online: "online",
            promptSettings: "Prompt Ayarları",
            cacheManagement: "Cache Yönetimi",
            blockCannotBeChild: "{draggingType} bloğu {blockType} bloğunun alt öğesi olamaz",
            toolsNotSupported: "Tools desteklenmiyor",
            tag: "Etiket",
            link: "Link",
            preventDefault: "Varsayılanı Engelle",
            whatsapp: "WhatsApp",
            trendyol: "Trendyol",
            whatsappBusinessApi: "WhatsApp Business API",
            instagram: "Instagram",
            telegram: "Telegram",
            facebook: "Facebook",
            twitter: "Twitter",
            skype: "Skype",
            shopify: "Shopify",
            slack: "Slack",
            segment: "Segment",
            copyBlockAsJson: "Bloğu JSON olarak kopyala",
            pasteBlockFromClipboard: "Panodan blok yapıştır",
            douYouWannaDeleteItem: "Bu öğeyi silmek istiyor musunuz?",
            douYouWannaDeleteWithChildren: "Bu öğeyi alt öğeleriyle birlikte silmek istiyor musunuz?",
            blockDetails: "Blok Detayları",
            installationOK: "Kurulu",
            integrateStoryWithTelegram: "Hikayeyi Telegram ile Entegre Et",
            selectIntegratingStory: "Entegre edilecek hikayeyi seçin",
            optional: "opsiyonel",
            aiBot: "AI Bot",
            englishTurkish: "İNGİLİZCE/TÜRKÇE",
            train: "Eğit",
            tuneChatbot: "Botu Ayarla",
            selectPlaceToCopy: "Kopyalamak için uygun bir yer seçin",
            selectPlaceToAdd: "Eklemek için uygun bir yer seçin",
            selectPlaceToMove: "Taşımak için uygun bir yer seçin",
            previewMode: "Önizleme Modu",
            notPublished: "Yayınlanmadı",
            blockJsDesc: "Bu blok, tanımladığınız parametrelerle JavaScript kodunu çalıştırır.",
            jsSecurityNotice: "Güvenlik nedenlerinden dolayı bazı JavaScript özellikleri kısıtlanmıştır.",
            outputSchemaJson: "Çıktı Şeması (JSON)",
            example: "Örnek:",
            newFieldAdd: "Yeni Alan Ekle",
            saveToAttribute: "Özelliğe Kaydet",
            selectFallbackModel: "Yedek model seçin...",
            loadingModels: "Modeller yükleniyor...",
            openaiChannelExists: "OpenAI kanalı mevcut. Devam edebilirsiniz.",
            openaiChannelNotFound: "OpenAI kanalı bulunamadı.",
            createOpenaiChannelDesc: "Entegrasyonlar > OpenAI bölümünden bir OpenAI kanalı oluşturun.",
            embedding: "Embedding",
            company_name: "İşletme Adı",
            company_about_us: "Hakkımızda",
            company_email: "E-posta",
            company_phone: "Telefon",
            company_address: "İşletme Adresi",
            instagram_url: "Instagram",
            youtube_url: "Youtube",
            linkedin_url: "Linkedin",
            facebook_url: "Facebook",
            twitter_url: "Twitter",
            privacy_url: "Gizlilik Politikası (URL)",
            pricing_url: "Fiyatlandırma (URL)",
            contactUs: "Bize Ulaşın",
            aboutUs: "Hakkımızda",
            importJsonSchema: "JSON Şemasını İçe Aktar",
            enterChangelog: "Değişiklik notunu girin (opsiyonel)",
            defineSchema: "Şema Tanımla",
            detailedSettings: "Detaylı Ayarlar",
            noStructureDefined: "Henüz bir yapı tanımlanmadı. 'Şema Tanımla' butonuna tıklayın.",
            javascriptAssistant: "JavaScript Asistanı",
            youCanDo: "Yapabilecekleriniz",
            sendingMessage: "Mesaj gönderme",
            chatTransfer: "Chat transfer",
            chatClosing: "Chat kapatma",
            apiRequests: "API istekleri",
            contactOperations: "Kişi işlemleri",
            attributeUpdating: "Attribute güncelleme",
            examplePrompt1: "API isteği gönder ve yanıtı kullanıcıya göster",
            examplePrompt2: "Kullanıcıdan alınan veriyi doğrula ve kaydet",
            examplePrompt3: "Parametrelerdeki URL ye GET isteği at ve sonucu döndür",
            generateCode: "Kod Oluştur",
            parameterValidation: "Parametre Doğrulama",
            manualAttributeEdit: "Attribute'ı Elle Düzenle",
            manualAttributeEntry: "Attribute değerini elle girin:",
            orderStatus: "SİPARİŞ DURUMU",
            selectABlock: "Bir blok seçin",
            regexTemplates: "Regex Şablonları",
            chooseASegment: "Bir Segment Seçin",
            noSegmentFound: "Segment bulunamadı",
            chooseATag: "Bir Etiket Seçin",
            noTagFound: "Etiket bulunamadı",
            userEntities: "Kullanıcı Varlıkları",
            noWebhookFound: "Webhook bulunamadı",
            chooseAWebhook: "Bir webhook seçin",
            sendFile: "Dosya gönder",
            voiceRecord: "Ses kaydı",
            connect: "Bağlan",
            connectedCount: "Bağlı ({count})",
            instagramIntegration: "Instagram Chatbot Entegrasyonu",
            messengerIntegration: "Messenger Chatbot Entegrasyonu",
            trendyolIntegration: "Trendyol Chatbot Entegrasyonu",
            linkedinIntegration: "Linkedin Chatbot Entegrasyonu",
            telegramQrIntegration: "Telegram QR Chatbot Entegrasyonu",
            forwardLiveAgents: "Canlı Destek Temsilcilerine Aktar",
            deleteTokenConfirm: "Token'ı silmek istediğinizden emin misiniz?",
            integratedStoryRevoked: "Bu durumda entegre edilmiş hikaye iptal edilecektir!",
            tokenLostPermanently: "Token kalıcı olarak kaybolacaktır!",
            tuneYourChatbot: "Chatbotunuzu Ayarlayın",
            tuneChatbotDesc: "Daha iyi sonuçlar elde etmek için son dokunuşları ekleyin.",
            customizeWelcomeMessage: "Karşılama mesajınızı özelleştirin",
            setupAttributes: "Özellikleri ayarlayın",
            attributeValue: "Attribute değeri",
            setupChatbot: "Chatbot'u Kur",
            complete: "Tamamla",
            continue: "Devam Et",
            someContents: "Bazı içerikler...",
            question: "Soru",
            answer: "Cevap",
            chatbotExpert: "Chatbot Tasarım Uzmanı",
            connecting: "Bağlanıyor...",
            chatbotAssistantWelcome: "Merhaba! Ben Supsis Chatbot Asistanınızım 👋",
            howCanIHelpChatbot: "Chatbot tasarımınızla ilgili size nasıl yardım edebilirim?",
            createNewBot: "Yeni bot oluştur",
            optimizeBot: "Bot'u optimize et",
            addAiFeature: "AI özelliği ekle",
            processingActions: "İşlemler yapılıyor...",
            chatbotAssistantInputPlaceholder: "Chatbot tasarımınız için ne yapmak istiyorsunuz?",
            connectionEstablished: "Bağlantı kuruldu",
            agentBusyWait: "Agent şu anda meşgul, lütfen bekleyin...",
            connectionEstablishedHelp: "Bağlantı başarıyla kuruldu! Size nasıl yardım edebilirim?",
            aiThinking: "Yapay zeka düşünüyor...",
            sessionStateUpdated: "Session state güncellendi",
            diagramUpdated: "Diagram güncellendi",
            aiBotWizardTitle: "AI Bot Sihirbazı",
            wizardStepTitleRag: "RAG Yöntemi Seçin",
            wizardStepDescRag: "AI chatbotunuzun bilgi tabanı araması için kullanacağı yöntemi seçin.",
            wizardStepTitleEmbedding: "Embedding Modeli Seçin",
            wizardStepDescEmbedding: "Knowledge base verilerini vektöre çevirmek için kullanılacak model.",
            wizardStepTitleLlm: "LLM Modeli Seçin",
            wizardStepDescLlm:
                "Chatbotunuzun kullanacağı yapay zeka modelini seçin. Daha sonra da değiştirebilirsiniz.",
            loadModels: "Modelleri Yükle",
            retry: "Tekrar Dene",
            routingStrategy: "Yönlendirme Stratejisi",
            fallbackModels: "Fallback Modeller",
            fallbackModelsDesc: "Primary model hata verirse kullanılacak yedek modeller.",
            backup: "Geri",
            connected: "Bağlı",
        },
        coupon: {
            code: "Kod",
            discount: "İndirim",
            endDate: "Bitiş Tarihi",
            name: "İsim",
            email: "E-posta",
            phone: "Telefon",
            add: "Kupon Ekle",
            coupons: "Kuponlar",
            couponDeleted: "Kupon Silindi",
            limit: "Limit",
            visitorBan: "Visitör engellenmiştir.",
            visitorUnBlock: "Engeli Kaldırılmıştır.",
        },
        instagramTitle: "Instagram Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
        instegramFunctionActive: "Instagram Özelliğini Etkinleştir",
        ChatBOT: "Chat Bot",
        WhatsappContacts: "Whatsapp Kişileri",
        InstagramContacts: "Instagram Kişileri",
        MessengerContacts: "Messenger Kişileri",
        LinkedinContacts: "Linkedin Kişileri",
        TelegramContacts: "Telegram Kişileri",
        volumeUp: "Sesi Aç",
        minimize: "Küçült",
        maximize: "Büyüt",
        auditLogs: {
            auditLogsTitle: "Denetim Günlükleri",
            auditLogsSub: "Son 30 gün içinde şirketinizde gerçekleşen olayları takip etmenizi sağlar.",
            actor: "Aktör",
            actorSelect: "Aktör seçin",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "Herhangi Bir Ziyaretçi",
            actorAgent: "Herhangi Bir Temsilci",
            adminUserSuffix: "(Admin Kullanıcı)",
            activityTypeSelect: "Aktivite tipi seçin",
            dateRange: "Tarih Aralığı",
            startDate: "Başlangıç tarihi",
            endDate: "Bitiş tarihi",
            reset: "Sıfırla",
            filter: "Filtrele",
            activeFilters: "Aktif Filtreler:",
            auditLogsTable: "Denetim Logları",
            noActivityYet: "Henüz aktivite bulunmuyor",
            ipAddress: "IP Adresi",
            activityType: {
                blocked: "Engellendi",
                unblocked: "Engel kaldırıldı",
                "chat-opened": "Sohbet açıldı",
                "chat-closed": "Sohbet kapatıldı",
                "chat-rating": "Sohbet değerlendirildi",
                "chat-assigned-to-user": "Sohbet kullanıcıya atandı",
                "chat-forwarded-to-user": "Sohbet kullanıcıya yönlendirildi",
                "contact-owner-updated": "Kişi sahibi güncellendi",
                "user-joined-to-chat": "Kullanıcı sohbete katıldı",
                "ticket-assigned-to-user": "Talep kullanıcıya atandı",
                online: "Çevrimiçi",
                offline: "Çevrimdışı",
                "page-changed": "Sayfa değiştirildi",
                "create-ticket": "Talep oluşturuldu",
                "video-calling-started": "Görüntülü arama başlatıldı",
                "video-calling-closed": "Görüntülü arama kapatıldı",
                "voice-calling-started": "Sesli arama başlatıldı",
                "voice-calling-closed": "Sesli arama kapatıldı",
                "visitor-tag-added": "Ziyaretçi etiketi eklendi",
                "visitor-tag-removed": "Ziyaretçi etiketi kaldırıldı",
                "note-created": "Not oluşturuldu",
                "note-updated": "Not güncellendi",
                "visitor-profile-updated": "Ziyaretçi profili güncellendi",
                "user-added": "Kullanıcı eklendi",
                "user-removed": "Kullanıcı kaldırıldı",
                "user-status-changed": "Kullanıcı durumu değiştirildi",
                "user-logged-in": "Kullanıcı giriş yaptı",
                "user-added-to-department": "Kullanıcı departmana eklendi",
                "user-removed-from-depart": "Kullanıcı departmandan kaldırıldı",
                "user-role-changed": "Kullanıcı rolü değiştirildi",
                "user-password-changed": "Kullanıcı şifresi değiştirildi",
                "user-email-changed": "Kullanıcı e-posta adresi değiştirildi",
                "user-name-changed": "Kullanıcı adı değiştirildi",
                "user-phone-changed": "Kullanıcı telefon numarası değiştirildi",
                "user-disabled": "Kullanıcı devre dışı bırakıldı",
                "user-enabled": "Kullanıcı aktif edildi",
                "settings-updated": "Ayarlar güncellendi",
                "whatsapp-broadcast-created": "WhatsApp toplu mesaj oluşturuldu",
                "whatsapp-broadcast-completed": "WhatsApp toplu mesaj tamamlandı",
                "whatsapp-broadcast-canceled": "WhatsApp toplu mesaj iptal edildi",
                "whatsapp-broadcast-failed": "WhatsApp toplu mesaj başarısız oldu",
                "whatsapp-v1-bot-state-changed": "WhatsApp v1 bot durumu değiştirildi",
                "whatsapp-v2-bot-state-changed": "WhatsApp v2 bot durumu değiştirildi",
                "channel-created": "Kanal oluşturuldu",
                "channel-removed": "Kanal kaldırıldı",
                "channel-visibility-changed": "Kanal görünürlüğü değiştirildi",
                "channel-zoho-config-updated": "Kanal Zoho yapılandırması güncellendi",
                "channel-forward-config-updated": "Kanal yönlendirme yapılandırması güncellendi",
                "login-form-activated": "Giriş formu etkinleştirildi",
                "login-form-deactivated": "Giriş formu devre dışı bırakıldı",
                "login-form-updated": "Giriş formu güncellendi",
                "chatbot-created": "Chatbot oluşturuldu",
                "chatbot-deleted": "Chatbot silindi",
                "chatbot-restored": "Chatbot çöp sepetinden çıkarıldı",
                "chatbot-published": "Chatbot yayınlandı",
                "chatbot-webhook-added": "Chatbot webhook eklendi",
                "chatbot-webhook-removed": "Chatbot webhook kaldırıldı",
                "banned-word-added": "Yasaklı kelime eklendi",
                "banned-word-removed": "Yasaklı kelime kaldırıldı",
                "mail-address-added": "E-posta adresi eklendi",
                "mail-address-removed": "E-posta adresi kaldırıldı",
                "mail-was-sent": "E-posta gönderildi",
                "content-added": "İçerik eklendi",
                "content-removed": "İçerik kaldırıldı",
                "role-added": "Rol eklendi",
                "role-removed": "Rol kaldırıldı",
                "role-updated": "Rol güncellendi",
                "department-added": "Departman eklendi",
                "department-removed": "Departman kaldırıldı",
                "tags-added": "Etiketler eklendi",
                "tags-removed": "Etiketler kaldırıldı",
                "trigger-added": "Tetikleyici eklendi",
                "trigger-removed": "Tetikleyici kaldırıldı",
                "trigger-updated": "Tetikleyici güncellendi",
                "welcome-message-added": "Karşılama mesajı eklendi",
                "welcome-message-removed": "Karşılama mesajı kaldırıldı",
                "customer-group-added": "Müşteri grubu eklendi",
                "customer-group-removed": "Müşteri grubu kaldırıldı",
                "customer-group-updated": "Müşteri grubu güncellendi",
                "webhook-added": "Webhook eklendi",
                "webhook-removed": "Webhook kaldırıldı",
                "webhook-updated": "Webhook güncellendi",
                "contact-prop-added": "Kişi özelliği eklendi",
                "contact-prop-removed": "Kişi özelliği kaldırıldı",
                "invoice-created": "Fatura oluşturuldu",
                "invoice-updated": "Fatura güncellendi",
                "invoice-payment-received": "Fatura ödemesi alındı",
                "invoice-payment-failed": "Fatura ödemesi başarısız oldu",
                "invoice-refunded": "Fatura iade edildi",
                "invoice-deleted": "Fatura silindi",
                "payment-method-added": "Ödeme yöntemi eklendi",
                "billing-address-updated": "Fatura adresi güncellendi",
                "plan-started": "Plan başlatıldı",
                "plan-canceled": "Plan iptal edildi",
                "task-workflow-created": "Görev iş akışı oluşturuldu",
                "task-workflow-deleted": "Görev iş akışı silindi",
                "task-workflow-restored": "Görev iş akışı çöp sepetinden çıkarıldı",
                "task-workflow-permanently-deleted": "Görev iş akışı çöp sepetinden silindi",
                "task-workflow-updated": "Görev iş akışı güncellendi",
                "task-workflow-pipeline-stage-added": "Görev iş akışı aşaması eklendi",
                "task-workflow-pipeline-stage-updated": "Görev iş akışı aşaması güncellendi",
                "task-workflow-pipeline-stage-deleted": "Görev iş akışı aşaması silindi",
                "task-created": "Görev oluşturuldu",
                "task-deleted": "Görev silindi",
                "task-stage-changed": "Görev aşaması değiştirildi",
                "task-workflow-changed": "Görev iş akışı değiştirildi",
                "task-assigned-to-user": "Görev kullanıcıya atandı",
                "task-update-priority": "Görev önceliği güncellendi",
                "task-added-tags": "Göreve etiketler eklendi",
                "task-removed-tags": "Görevden etiketler kaldırıldı",
                "task-update-title": "Görev başlığı güncellendi",
                "task-update-description": "Görev açıklaması güncellendi",
                "task-update-start-date": "Görev başlangıç tarihi güncellendi",
                "task-update-end-date": "Görev bitiş tarihi güncellendi",
                "task-update-owner": "Görev sahibi güncellendi",
                "task-added-followers": "Göreve takipçiler eklendi",
                "task-removed-followers": "Görevden takipçiler kaldırıldı",
                "task-added-collaborators": "Göreve işbirlikçiler eklendi",
                "task-update-checklist": "Görev kontrol listesi güncellendi",
                "task-added-subtask": "Göreve alt görev eklendi",
                "task-removed-subtask": "Görevden alt görev kaldırıldı",
                "task-added-attachment": "Göreve ek eklendi",
                "task-comment-added": "Göreve yorum eklendi",
                "task-comment-updated": "Görev yorumu güncellendi",
                "task-comment-deleted": "Görev yorumu silindi",
                "task-completed": "Görev tamamlandı",
                "task-archived": "Görev arşivlendi",
                "task-restored": "Görev çöp sepetinden çıkarıldı",
                "task-unarchived": "Görev arşivden çıkarıldı",
                "chatbot-credit-low": "Chatbot kredisi düşük",
                "chatbot-credit-done": "Chatbot kredisi tükendi",
                "system-status": "Sistem durumu",
                "whatsapp-credit-low": "WhatsApp kredisi düşük",
                "reservation-created-plan": "Rezervasyon planı oluşturuldu",
                "reservation-updated-plan": "Rezervasyon planı güncellendi",
                "reservation-deleted-plan": "Rezervasyon planı silindi",
                "reservation-created": "Rezervasyon oluşturuldu",
                "reservation-updated": "Rezervasyon güncellendi",
                "reservation-deleted": "Rezervasyon silindi",
                "white-list-added": "Beyaz liste eklendi",
                "white-list-removed": "Beyaz liste kaldırıldı",
                "site-suspended": "Site askıya alındı",
                "site-dead": "Site devre dışı bırakıldı",
                "site-enabled": "Site aktif edildi",
                custom: "Özel aktivite",
                "auto-rebalance-success": "Otomatik bakiye yüklemesi başarılı",
                "auto-rebalance-failed": "Otomatik bakiye yüklemesi başarısız",
                "auto-rebalance-disabled": "Otomatik bakiye yüklemesi devre dışı",
                "automation-created": "Otomasyon oluşturuldu",
                "automation-deleted": "Otomasyon silindi",
                "automation-restored": "Otomasyon çöp sepetinden çıkarıldı",
                "automation-published": "Otomasyon yayınlandı",
                "automation-unpublished": "Otomasyon yayından kaldırıldı",
                "automation-updated": "Otomasyon güncellendi",
                "form-created": "Form oluşturuldu",
                "form-updated": "Form güncellendi",
                "form-deleted": "Form silindi",
                "form-restored": "Form çöp sepetinden çıkarıldı",
                "form-downloaded": "Form verileri indirildi",
                "table-created": "Tablo oluşturuldu",
                "table-deleted": "Tablo silindi",
                "table-restored": "Tablo çöp sepetinden çıkarıldı",
                "table-permanently-deleted": "Tablo çöp sepetinden silindi",
                "table-field-added": "Tablo alanı eklendi",
                "table-field-updated": "Tablo alanı güncellendi",
                "table-field-deleted": "Tablo alanı silindi",
                "table-view-added": "Tablo görünümü eklendi",
                "table-view-updated": "Tablo görünümü güncellendi",
                "table-view-deleted": "Tablo görünümü silindi",
                "table-page-added": "Tablo sayfası eklendi",
                "table-page-updated": "Tablo sayfası güncellendi",
                "table-page-deleted": "Tablo sayfası silindi",
                "table-widget-added": "Tablo widget'ı eklendi",
                "table-widget-updated": "Tablo widget'ı güncellendi",
                "table-widget-deleted": "Tablo widget'ı silindi",
                "table-permission-changed": "Tablo izinleri değiştirildi",
                "table-data-downloaded": "Tablo verileri indirildi",
                "table-data-imported": "Tablo verileri içe aktarıldı",
                "table-data-batch-updated": "Tablo verileri toplu güncellendi",
                "table-data-batch-deleted": "Tablo verileri toplu silindi",
                "contact-data-downloaded": "Kişi verileri indirildi",
                "contact-batch-updated": "Kişi verileri toplu güncellendi",
                "chat-data-downloaded": "Sohbet verileri indirildi",
                "voice-agent-created": "Ses agenti oluşturuldu",
                "voice-agent-updated": "Ses agenti güncellendi",
                "voice-agent-deleted": "Ses agenti silindi",
                "voice-agent-phone-number-inbound-agent-changed": "Telefon numarası gelen çağrı agenti değiştirildi",
                "voice-agent-phone-number-outbound-agent-changed": "Telefon numarası giden çağrı agenti değiştirildi",
                "voice-agent-batch-call-created": "Ses agenti toplu arama oluşturuldu",
                "voice-agent-knowledge-base-created": "Ses agenti bilgi tabanı oluşturuldu",
                "voice-agent-knowledge-base-updated": "Ses agenti bilgi tabanı güncellendi",
                "drive-folder-created": "Drive klasörü oluşturuldu",
                "drive-folder-deleted": "Drive klasörü silindi",
                "drive-folder-renamed": "Drive klasörü yeniden adlandırıldı",
                "drive-file-added": "Drive dosyası eklendi",
                "drive-file-deleted": "Drive dosyası silindi",
                "task-module-rules-rule-added": "Görev modülü kuralı eklendi",
                "task-module-rules-rule-updated": "Görev modülü kuralı güncellendi",
                "task-module-rules-rule-deleted": "Görev modülü kuralı silindi",
                "task-module-rules-rule-enabled": "Görev modülü kuralı etkinleştirildi",
                "task-module-rules-rule-disabled": "Görev modülü kuralı devre dışı bırakıldı",
                "task-module-rules-enabled": "Görev modülü kuralları etkinleştirildi",
                "task-module-rules-disabled": "Görev modülü kuralları devre dışı bırakıldı",
                "contact-module-rules-rule-added": "Kişi modülü kuralı eklendi",
                "contact-module-rules-rule-updated": "Kişi modülü kuralı güncellendi",
                "contact-module-rules-rule-deleted": "Kişi modülü kuralı silindi",
                "contact-module-rules-rule-enabled": "Kişi modülü kuralı etkinleştirildi",
                "contact-module-rules-rule-disabled": "Kişi modülü kuralı devre dışı bırakıldı",
                "contact-module-rules-enabled": "Kişi modülü kuralları etkinleştirildi",
                "contact-module-rules-disabled": "Kişi modülü kuralları devre dışı bırakıldı",
                "module-created": "Modül oluşturuldu",
                "module-updated": "Modül güncellendi",
                "module-deleted": "Modül silindi",
                "relation-created": "İlişki oluşturuldu",
                "relation-updated": "İlişki güncellendi",
                "relation-deleted": "İlişki silindi",
                "web-app-created": "Web uygulaması oluşturuldu",
                "web-app-updated": "Web uygulaması güncellendi",
                "web-app-deleted": "Web uygulaması silindi",
                "web-tab-created": "Web sekmesi oluşturuldu",
                "web-tab-updated": "Web sekmesi güncellendi",
                "web-tab-deleted": "Web sekmesi silindi",
                "developer-token-created": "Geliştirici token'ı oluşturuldu",
                "developer-token-changed": "Geliştirici token'ı değiştirildi",
            },
            tablePagination: {
                goto: "Git",
                pagePer: " / sayfa",
                total: "Toplam",
                prev5: "Önceki 5 Sayfa",
                next5: "Sonraki 5 Sayfa",
                cut: "Kes",
                copy: "Kopyala",
                insertRowAbove: "Üstüne satır ekle",
                insertRowBelow: "Altına satır ekle",
                removeRow: "satırı kaldır",
                emptyRow: "satırı boşalt",
                emptyColumn: "sütunu boşalt",
                emptyCell: "Hücreyi boşalt",
                leftFixedColumnTo: "Sola sabit sütun",
                cancelLeftFixedColumnTo: "Sola sabit sütunu iptal et",
                rightFixedColumnTo: "Sağa sabit sütun",
                cancelRightFixedColumnTo: "Sağa sabit sütunu iptal et",
            },
        },
        task: {
            taskID: "Görev ID",
            completeTask: "Görevi Bitir",
            closedTasks: "Kapatılmış Görevler",
            moveToArchive: "Arşive Taşı",
            changeWorkflow: "Başka İş Akışına Taşı",
            createTaskDesc: "Açıklamanızı buraya yazın...",
            selectWorkflow: "İş Akışı Seç",
            taskNumber: "Görev #",
            priority_lowest: "En Düşük",
            priority_low: "Düşük",
            priority_medium: "Orta",
            priority_high: "Yüksek",
            priority_highest: "En Yüksek",
            workflowActions: "İş Akışı Eylemleri",
            workflowTitle: "İş Akışı Başlığı",
            deleteTask: "Görevi Sil",
            archivingDate: "Arşivleme Tarihi",
            selectOption: "Bir Seçenek Seçin",
            notAuthorizedCreateTask: "Görev Oluşturma Yetkiniz  Yok",
            notAuthorizedCreateTaskDesc: "Bu işlemi yapmak için yetkiniz bulunmamaktadır.",
            goToMessage: "Mesaja git",
            goToChat: "Sohbete git",
            showVisitor: "Ziyaretçiyi Göster",
            closeTheTask: "Görevi Kapat",
            sureAddCompletedList: "Görevi Tamamlandı Listesine Eklemek İstediğinize Emin Misiniz?",
            success: "Başarılı",
            successDesc: "Başarılı bir şekilde yeni alan eklendi.",
            moveAndDeleteTask: "Taskları Taşı ve Sil",
            justDelete: "Sadece Sil",
            selectColumnMoveTask: "Taskları taşımak istediğiniz sütunu seçiniz",
            todo: "Yapılacaklar",
            inProgress: "Devam Ediyor",
            approval: "Onaylandı",
            completed: "Tamamlandı",
            addAComment: "Yorum ekleyin...",
            deleteComment: "Yorumu silmek istediğinize emin misiniz?",
            edited: "Düzenlendi",
            comments: "Yorumlar",
            addComment: "Yorum Ekle",
            workflow: "İş Akışı",
            workflowDetail: "İş Akışı Detay",
            workflowPerm: "İş Akışı Yetkileri",
            perm: "Yetkiler",
            detail: "Detaylar",
            userPerm: "Kullanıcı Yetkileri:",
            deleteCard: "Kart Silme",
            createCard: "Kart Oluşturma",
            editCard: "Kart Düzenleme",
            dragCard: "Kart Taşıma",
            allWorkflow: "Tüm İş Akışları",
            createworkflow: "İş Akışı Oluştur",
            editDragActive: "Düzenleme Aktif",
            editSortOrder: "Sıralama Düzenle",
            deleteWorkflow: "Bu İş Akışını Silmek İstediğinize Emin Misiniz?",
            permEditTask: "Bu Taskı Düzenleme Yetkiniz Yok",
            permEditTaskDes: "Düzenleme Yetkisi İçin Yöneticinizle İletişime Geçiniz.",
            createTaskError: "Görev Oluşturma Yetkiniz Yok",
            createTaskErrorDesc: "Görev Oluşturma Yetkisi İçin Yöneticinizle İletişime Geçiniz",
            moveTaskError: "Görev Durumu Değiştirme Yetkiniz Yok",
            moveTaskErrorDesc: "Görev Durumu Değiştirme Yetkisi İçin Yöneticiniz ile İletişime Geçiniz",
            deleteTaskError: "Görev Silme Yetkiniz Yok",
            deleteTaskErrorDesc: "Görev Silme Yetkisi İçin yöneticinizle İletişime Geçiniz",
            permissionError: "Görev Oluşturma Yetkiniz Yok",
            permissionErrorDesc: "Görev Oluşturma Yetkisi İçin Yöneticinizle İletişime Geçiniz",
            whatsappContactProfileTitle: "{name} / {number} Profili",
            createTaskVisitor: "Görev Oluştur (Ziyaretçi)",
            editWorkflow: "Workflow'u Düzenle",
            visitor: "Ziyaretçi Profili",
            createTaskMessage: "Görev Oluştur (Mesaj)",
            createStage: "Aşama Oluştur",
            stagesAndStatuses: "Aşamalar ve Durumlar",
            workflowCreateDesc: "Workflow Açıklaması",
            subTasks: "Alt Görevler",
            followers: "Takipçiler",
            collaborators: "Üzerinde çalışanlar",
            addRelations: "İlişki ekle",
            relations: "İlişkili",
            main: "Ana Sekme",
            name: "Adı",
            completedOfCheck: "{total} görevden {completed} tamamlandı",
            workflowUpdateMs: "Workflow Başarıyla Güncellendi",
            taskUpdateMs: "Görev Başarıyla Güncellendi",
            workflowCreatedMs: "İş Akışı Başarıyla Oluşturuldu",
            workflowCreateError: "İş Akışı Oluşturulamadı",
            taskCreatedMs: "Görev Başarıyla Oluşturuldu",
            settingsDesc4:
                "Bu şekilde, her bir görevinizi detaylı bir şekilde izleyebilir, ekip üyelerine görev atamaları yapabilir ve genel olarak iş süreçlerinizi daha etkili bir şekilde yönetebilirsiniz. Supsis görev modülü, iş yönetimi ve takım koordinasyonu konusunda size kapsamlı bir çözüm sunar.",
            settingsDesc3:
                "Ayrıca, Supsis görev modülü, özelleştirilebilir bir iş akışıyla kendi çalışma düzeninizi oluşturmanıza olanak tanır. Otomatizasyonlarla görevleri daha etkili bir şekilde yönetebilir ve ekip içindeki işbirliğini artırabilirsiniz.",
            settingsDesc2:
                "Supsis görev modülü, hiçbir görevin gözden kaçmasına izin vermez. Görevleri herhangi bir parametreye göre filtreleyebilir, her iş akışı aşamasının iş yükünü takip edebilir ve takviminizi düzenleyebilirsiniz, böylece zamanlamalarınıza uyum sağlayabilirsiniz.",
            settingsDesc1:
                "Görevler modülü, işbirliği içindeki çalışmaları düzenlemenize, görevleri devretmenize ve takımınızın ilerlemesini izlemenize olanak tanır. İhtiyaçlarınıza göre görevlerinizi herhangi bir görünümü seçerek düzenleyebilir ve otomasyonlarla kendi özel iş akışınızı oluşturabilirsiniz.",
            taskModuleSettingsTitle: "Görev Modülü Ayarları",
            high: "Yüksek",
            medium: "Orta",
            low: "Düşük",
            priority: "Öncelik",
            addExistsSubtask: "Varolan Alt Görevi Ekle",
            addSubtask: "Alt Görev Ekle",
            add: "Ekle",
            newCheckList: "Yeni Kontrol Listesi",
            subtaskTitle: "Alt Görev Başlığı",
            view: "Görüntüle",
            attachFiles: "Dosya Ekle",
            taskDesc: "Görev açıklaması",
            title: "Başlık",
            createWorkflow: "İş Akışı Oluştur",
            editTask: "Görevi Düzenle",
            createTask: "Görev Oluştur",
            deleteColumnCont: "Bu kolonu silmek istediğinizden emin misiniz ?",
            changeStage: "Durum Değiştir",
            filterBar: {
                searchTasksPlaceholder: "Görevlerde ara...",
                otherUsers: "Diğer Kullanıcılar",
                searchUserPlaceholder: "Kullanıcı ara...",
                filter: "Filtrele",
                clearFilters: "Filtreleri temizle",
                apply: "Uygula",
                prioritySelection: "Görev Önceliği Seçimi",
                priorityDescription:
                    "Görevleri öncelik seviyesine göre filtreleyebilirsiniz. Filtrelemek istediğiniz öncelik seviyelerini seçin.",
                aboutPriorityLevels: "Öncelik Seviyeleri Hakkında",
                priorityInfoText:
                    "Öncelik seviyeleri görevlerin önemini belirtir. Yüksek öncelikli görevler ekibinizin önce odaklanması gereken işleri gösterir, düşük öncelikli görevler ise daha az acil işleri belirtir.",
                userSelection: "Kullanıcı Seçimi",
                assigneesDescription:
                    "Görevlere atanan kullanıcılara göre filtreleyebilirsiniz. Sadece atandıkları görevleri görmek istediğiniz kullanıcıları seçin.",
                unassigned: "Atanmamış",
                ownerSelection: "Görev Sahibi Seçimi",
                ownerDescription:
                    "Görev sahiplerine göre filtreleyebilirsiniz. Sahip oldukları görevleri görmek istediğiniz kullanıcıları seçin.",
                searchOwnerPlaceholder: "Görev sahibi ara...",
                followersSelection: "Görev Takipçileri Seçimi",
                followersDescription:
                    "Görev takipçilerine göre filtreleyebilirsiniz. Takip ettikleri görevleri görmek istediğiniz kullanıcıları seçin.",
                searchFollowerPlaceholder: "Takipçi ara...",
                creatorSelection: "Görevi Oluşturan Seçimi",
                creatorDescription:
                    "Görevi oluşturan kişiye veya sisteme göre filtreleyebilirsiniz. Görevleri filtrelemek için kullanıcıları veya sistem türlerini seçin.",
                createdBySystem: "Sistem Tarafından Oluşturulanlar",
                createdByUsers: "Kullanıcılar Tarafından Oluşturulanlar",
                searchCreatorPlaceholder: "Kullanıcı ara...",
                filterByCreatedDate: "Oluşturulma Tarihine Göre Filtrele",
                today: "Bugün",
                thisWeek: "Bu Hafta",
                thisMonth: "Bu Ay",
                startDate: "Başlangıç Tarihi",
                endDate: "Bitiş Tarihi",
                aboutDateFilter: "Tarih Filtresi Hakkında",
                filterByStartDate: "Başlangıç Tarihine Göre Filtrele",
                filterByEndDate: "Bitiş Tarihine Göre Filtrele",
                overdueTasks: "Süresi Dolan Görevler",
                showOverdueTasks: "Süresi dolan görevleri göster",
                importantInfo: "Önemli Bilgi",
                filterByUpdateDate: "Güncellenme Tarihine Göre Filtrele",
                taskTags: "Görev Etiketleri",
                searchTagPlaceholder: "Etiket ara...",
                tagsLoading: "Etiketler yükleniyor...",
                noTagsMatchingSearch: "Arama kriterlerine uyan etiket bulunamadı.",
                noTagsCreated: "Henüz etiket oluşturulmamış.",
                aboutTags: "Etiketler Hakkında",
                pipelineSelection: "Pipeline Durumu Seçimi",
                searchPipelinePlaceholder: "Pipeline ara...",
                order: "Sıra",
                pipelinesLoading: "Pipeline'lar yükleniyor...",
                noPipelinesMatchingSearch: "Arama kriterlerine uyan pipeline bulunamadı.",
                noPipelinesCreated: "Henüz pipeline oluşturulmamış.",
                aboutPipelines: "Pipeline'lar Hakkında",
                selected: "seçili",
                closeTask: "Görevi Kapat",
                tabPriorities: "Öncelik",
                tabOwners: "Görev Sahibi",
                tabFollowers: "Görev Takipçileri",
                tabCreatedBy: "Oluşturan",
                tabCreatedDate: "Oluşturulma Tarihi",
                tabUpdateDate: "Güncellenme Tarihi",
                tabStartDate: "Başlangıç Tarihi",
                tabEndDate: "Bitiş Tarihi",
                tabTags: "Etiketler",
                tabOverdue: "Süresi Dolan Görevler",
                tabStatus: "Durum",
                priorityLowest: "En Düşük Öncelik",
                priorityLow: "Düşük Öncelik",
                priorityMedium: "Orta Öncelik",
                priorityHigh: "Yüksek Öncelik",
                priorityHighest: "En Yüksek Öncelik",
                createdByApi: "API ile oluşturulan görevler",
                createdByChatbot: "Chatbot ile oluşturulan görevler",
                createdByAutomation: "Otomasyon ile oluşturulan görevler",
                dateRangeCreatedDescription:
                    "Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için başlangıç ve bitiş tarihlerini belirleyin. Bu filtre, görevlerin oluşturulma tarihine (createdAt) göre filtreleme yapar.",
                dateInfoCreatedText:
                    "Tarih filtresi, görevlerin oluşturulma tarihine göre sonuçları sınırlandırır. Böylece belirli bir zaman diliminde oluşturulmuş görevleri kolayca bulabilirsiniz.",
                dateRangeStartDescription:
                    "Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için başlangıç tarihini belirleyin. Bu filtre, görevlerin başlangıç tarihine (startDate) göre filtreleme yapar.",
                dateInfoStartText:
                    "Tarih filtresi, görevlerin başlangıç tarihine göre sonuçları sınırlandırır. Böylece belirli bir zaman aralığında başlayacak olan görevleri kolayca bulabilirsiniz.",
                dateRangeEndDescription:
                    "Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için bitiş tarihini belirleyin. Bu filtre, görevlerin bitiş tarihine (endDate) göre filtreleme yapar.",
                dateInfoEndText:
                    "Tarih filtresi, görevlerin bitiş tarihine göre sonuçları sınırlandırır. Böylece belirli bir zaman aralığında bitecek olan görevleri kolayca bulabilirsiniz.",
                dateRangeUpdateDescription:
                    "Seçtiğiniz tarih aralığında güncellenmiş görevleri filtrelemek için başlangıç ve bitiş tarihlerini belirleyin. Bu filtre, görevlerin güncellenme tarihine (updatedAt) göre filtreleme yapar.",
                dateInfoUpdateText:
                    "Tarih filtresi, görevlerin son güncellenme tarihine göre sonuçları sınırlandırır. Böylece belirli bir zaman aralığında güncellenmiş görevleri kolayca bulabilirsiniz.",
                overdueDescription:
                    "Teslim tarihi geçmiş ve hala tamamlanmamış görevleri filtreleyebilirsiniz. Bu filtre aktif olduğunda, sadece süresi dolan görevler görüntülenecektir.",
                overdueDetail:
                    "Teslim tarihi geçmiş ve hala tamamlanmamış görevler, bu filtre aktif olduğunda görüntülenecektir. Bu görevler genellikle ekibinizin en kısa sürede ilgilenmesi gereken görevlerdir.",
                overdueInfoText:
                    "Süresi dolan görevler, teslim tarihi geçtiği halde tamamlanmamış görevlerdir. Bu görevler, ekibinizin dikkatini çekmesi gereken önemli işleri gösterir.",
                tagsDescription:
                    "Görevleri etiketlerine göre filtreleyebilirsiniz. Seçtiğiniz etiketlere sahip görevler görüntülenecektir.",
                tagsInfoText:
                    "Etiketler, görevleri kategorize etmenize ve daha kolay bulmanıza yardımcı olur. Birden fazla etiket seçerseniz, seçilen etiketlerden herhangi birine sahip görevler gösterilecektir.",
                pipelineDescription:
                    "Görevleri pipeline durumlarına göre filtreleyebilirsiniz. İstediğiniz pipeline'ları seçerek, sadece o aşamalardaki görevleri görebilirsiniz.",
                pipelinesInfoText:
                    "Pipeline'lar, görevlerin hangi aşamada olduğunu gösterir. Birden fazla pipeline seçerseniz, seçilen pipeline'lardan herhangi birinde bulunan görevler gösterilecektir.",
            },
            assignees: "Atananlar",
            owner: "Sahip",
            stage: "Durum",
            writeSomething: "Bir şey yazın",
            selectAssginee: "Atanacak Kişi",
            assignee: "Atanan",
            enterNewTaskDesc: "Yeni Görev Açıklaması",
            enterNewTaskTitle: "Yeni Görev Başlığı",
            task: "Görev",
            deleteTaskCont: "Bu görevleri silmek istediğinizden emin misiniz ?",
            deleteWorkFlowCont: "Bu Workflow'u silmek istediğinizden emin misiniz?",
            kanbanBoard: "Kanban Panosu",
            listView: "Liste Görünümü",
            taskNotifications: "Task Bildirimleri",
            reports: "Raporlar",
            workflowSettings: "Workflow Ayarları",
            trashBin: "Çöp Kutusu",
            taskReports: {
                title: "Görev Raporları",
                selectWorkflow: "Workflow seçiniz",
                filters: "Filtreler",
                clear: "Temizle",
                dateRange: "Tarih Aralığı:",
                dateRangePlaceholder: "Başlangıç - Bitiş",
                assignees: "Atanan Kişiler:",
                selectUser: "Kullanıcı seçiniz",
                unassigned: "Atanmamış",
                priority: "Öncelik:",
                selectPriority: "Öncelik seçiniz",
                emptyTitle: "Rapor Görüntülemek İçin Workflow Seçin",
                emptyDescription: "Görev raporlarını görüntülemek için yukarıdan bir workflow seçiniz.",
                loadingTitle: "Rapor Hazırlanıyor",
                loadingSubtitle: "Görev verileri analiz ediliyor...",
                tasksClosed: "görev kapatıldı",
                tasksUpdated: "görev güncellendi",
                tasksCreated: "görev oluşturuldu",
                upcomingDeadlines: "Yaklaşan Deadlinelar",
                statusOverview: "Durum genel bakışı",
                statusOverviewSubtitle: "Biletlerinizin durumunu anlık olarak görün.",
                totalTickets: "Toplam bilet",
                priorityDistribution: "Öncelik Dağılımı",
                teamWorkload: "Takım iş yükü",
                tooltipTasks: "{name}: {count} görev ({percentage}%)",
                errorTitle: "Rapor Yüklenirken Hata Oluştu",
                retry: "Tekrar Dene",
                last7Days: "Son 7 günde",
                dateRangeIn: "{start} - {end} tarihlerinde",
                upcomingCount: "{count} öğenin bitiş tarihi yaklaştı (önümüzdeki 7 gün)",
                upcomingCountZero: "0 öğenin bitiş tarihi yaklaştı (önümüzdeki 7 gün)",
                upcomingInRange: "{count} öğenin bitiş tarihi var ({start} - {end})",
                upcomingInRangeZero: "0 öğenin bitiş tarihi var ({start} - {end})",
                invalidWorkflowId: "Geçersiz Workflow ID formatı: {id}",
                loadSuccess: "Rapor verileri başarıyla yüklendi.",
                unknownError: "Bilinmeyen bir hata oluştu",
                error: "Hata",
            },
            taskNotification: {
                title: "Task Bildirim Ayarları",
                description: "Görev bildirim ayarlarınızı buradan yönetebilirsiniz.",
            },
            workflowSandbox: {
                title: "Silinen İş Akışları",
                description: "30 gün boyunca işlem yapılmayan iş akışları sistem tarafından silinir",
                emptyState: "Çöp sepetinde silinen iş akışı bulunmuyor",
                unnamedWorkflow: "İsimsiz İş Akışı",
                restore: "Geri Yükle",
                permanentlyDelete: "Kalıcı Olarak Sil",
                unknown: "Bilinmiyor",
                user: "Kullanıcı",
                restoreConfirmTitle: "İş Akışını Geri Yüklemek İstediğinize Emin Misiniz?",
                restoreConfirmContent: "{title} iş akışı geri yüklenecek.",
                restoreSuccess: "İş akışı geri yüklendi",
                restoreFailed: "Geri yükleme başarısız oldu",
                deleteConfirmTitle: "İş Akışını Kalıcı Olarak Silmek İstediğinize Emin Misiniz?",
                deleteConfirmContent: "{title} iş akışı kalıcı olarak silinecek. Bu işlem geri alınamaz.",
                deleteOkText: "Evet, Kalıcı Olarak Sil",
                cancel: "İptal",
                deleteSuccess: "İş akışı kalıcı olarak silindi",
                deleteFailed: "Kalıcı silme işlemi başarısız oldu",
                loadError: "Silinen iş akışları yüklenirken hata oluştu",
            },
            archiveAndTrash: "Arşiv ve Çöp Kutusu",
            trash: "Çöp Kutusu",
            loading: "Yükleniyor...",
            startDate: "Başlangıç Tarihi",
            endDate: "Bitiş Tarihi",
            clearFilter: "Filtreyi Temizle",
            noArchivedTasks: "Arşivlenmiş görev bulunamadı",
            noDeletedTasks: "Çöp kutusunda görev bulunamadı",
            total: "Toplam",
            error: "Hata",
            moveToBoard: "Panoya Taşı",
            unarchive: "Arşivden Çıkar",
            taskMovedToBoard: "Görev panoya taşındı",
            taskMoveError: "Görev panoya taşınırken bir hata oluştu",
            taskDeleted: "Görev silindi",
            taskDeleteError: "Görev silinirken bir hata oluştu",
            taskUnarchived: "Görev arşivden çıkarıldı",
            taskUnarchiveError: "Görev arşivden çıkarılırken bir hata oluştu",
            aprobado: "Aprobado",
            kanbanSettings: {
                cancel: "İptal",
                card: "Kart Ayarları",
                column: "Sütun Ayarları",
                kanban: "Kanban Ayarları",
                save: "Kaydet",
                selectField: "Bir alan seçin",
                selectFieldPlaceholder: "Bir alan seçin",
                selectFields: "Kartta görünecek alanları seçin",
                title: "Ayarlar",
            },
            notAuthorisedCreateTask: "Görev oluşturma yetkiniz yok",
            notAuthorisedCreateTaskDesc: "Bu işlemi gerçekleştirmek için yetkiniz bulunmamaktadır.",
            todos: "Yapılacaklar",
        },
        permissionErrors: {
            userCreate: "Kullanıcı Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            userRead: "Kullanıcıları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            userUpdate: "Kullanıcıları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            userDelete: "Kullanıcıları Silmek için yetkiniz yok. Yöneticinizle görüşün",
            visitorBlock: "Ziyaretçileri Engellemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorUnblock: "Ziyaretçileri Engelini Açmak için yetkiniz yok. Yöneticinizle görüşün",
            visitorDetailRead: "Ziyaretçi Detayı Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorListRead: "Ziyaretçi Listesini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorDelete: "Ziyaretçi Silmek için yetkiniz yok. Yöneticinizle görüşün",
            visitorExcel: "Excel Çıktısı Almak için yetkiniz yok. Yöneticinizle görüşün",
            visitorUpdate: "Ziyaretçi Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedVisitorRead: "Yasaklı Ziyaretçi Listesini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordCreate: "Yasaklı Kelime Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordRead: "Yasaklı Kelimeleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordDelete: "Yasaklı Kelimele Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatRead: "Konuşmaları Görmek için yetkiniz yok. Yöneticinizle görüşün",
            chatUpdate: "Konuşmaları Düzenlemek için yetkiniz yok. Yöneticinizle görüşün",
            archiveRead: "Arşivi Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            roleCreate: "Rol Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            roleRead: "Rolleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            roleUpdate: "Rolleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            roleDelete: "Rol Silmek için yetkiniz yok. Yöneticinizle görüşün",
            departmentCreate: "Departman Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentRead: "Departmanları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentUpdate: "Departman Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentDelete: "Departman Silmek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentCreate: "Hazır İçerik Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentRead: "Hazır İçerik Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentUpdate: "Hazır İçerik Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentDelete: "Hazır İçerik Silmek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeCreate: "Karşılama Mesajı Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            welcomeRead: "Karşılama Mesajlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeUpdate: "Karşılama Mesajı Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeDelete: "Karşılama Mesajı Silmek için yetkiniz yok. Yöneticinizle görüşün",
            settingCreate: "Ayar Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            settingRead: "Ayarları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            settingUpdate: "Ayarları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            settingDelete: "Ayar Silmek için yetkiniz yok. Yöneticinizle görüşün",
            reportCreate: "Rapor Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            reportRead: "Raporları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            reportUpdate: "Raporları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            reportDelete: "Rapor Silmek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestCreate: "Ticket Oluşturmak için yetkiniz yok. Yöneticinizle görüşün ",
            offlineSupportRequestRead: "Ticketleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestUpdate: "Ticketlere Cevap Vermek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestDelete: "Ticketleri Silmek için yetkiniz yok. Yöneticinizle görüşün",
            catalogCreate: "Katalog Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            catalogRead: "Katalogu Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            catalogUpdate: "Katalog Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            catalogDelete: "Katalog Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryCreate: "Chatbot Hikayesi Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryRead: "Chatbot Hikayelerini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryUpdate: "Chatbot Hikayelerini Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryDelete: "Chatbot Hikayelerini Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTemplateRead: "Chatbot Şablonlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTemplateAiRead: "Yapay Zeka Chatbot Şablonlarını Görmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotIntegrationsRead: "Chatbot Entegrasyonlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotArchiveRead: "Chatbot Arşivi Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesRead: "Chatbot Varlıklarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesCreate: "Chatbot Varlığı Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesUpdate: "Chatbot Varlıklarını Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesDelete: "Chatbot Varlıkları Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotReportRead: "Chatbot Raporlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTrainRead: "Chatbot Eğitimini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentCreate: "Chatbot Kullanıcı Segmenti Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentRead: "Chatbot Kullanıcı Segmentlerini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentUpdate:
                "Chatbot Kullanıcı Segmentlerini Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentDelete: "Chatbot Kullanıcı Segmentlerini Silmek için yetkiniz yok. Yöneticinizle görüşün",
            integrationsRead: "Entegrasyonlar Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            whatsappIntegrationRead:
                "Whatsapp Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            instagramIntegrationRead:
                "Instagram Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            telegramIntegrationRead:
                "Telegram Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            integrationCreate: "Entegrasyon Etkinleştirmek için yetkiniz yok. Yöneticinizle görüşün",
            triggerCreate: "Tetikleyici Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            triggerRead: "Tetikleyicileri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            triggerUpdate: "Tetikleyicileri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            triggerDelete: "Tetikleyici Silmek için yetkiniz yok. Yöneticinizle görüşün",
            billingRead: "Faturaları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            taskCreate: "Görev Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            taskRead: "Görevleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            taskUpdate: "Görevleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            taskDelete: "Görev Silmek için yetkiniz yok. Yöneticinizle görüşün",
            calendarCreate: "Takvim/Rezervasyon Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            calendarRead: "Takvim/Rezervasyon Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            calendarUpdate: "Takvim/Rezervasyon Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            calendarDelete: "Takvim/Rezervasyon Silmek için yetkiniz yok. Yöneticinizle görüşün",
            mailCreate: "Mail Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            mailRead: "Mailleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            mailUpdate: "Mailleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            mailDelete: "Mail Silmek için yetkiniz yok. Yöneticinizle görüşün",
        },
        message: {
            artificialIntelligence: "Yapay Zeka",
            newApp: "Yeni Uygulama",
            customApps: "Özel Uygulamalar",
            contentStatusStatistics: "İçerik Durum İstatistiği",
            match: "Eşleştir",
            onlineUsersRedis: "Çevrimiçi Kullanıcılar (Redis)",
            allUsersMongo: "Tüm Kullanıcılar (Mongo)",
            readAgentVuex: "Ajan Vuex Oku",
            isAgentConnected: "Ajan Bağlı mı",
            screenshot: "Ekran Görüntüsü",
            response: "Yanıt",
            selectPath: "Yol Seç",
            run: "Çalıştır",
            minifyUsers: "Kullanıcıları Küçült",
            waiting: "Bekleniyor ....",
            prev: "Önceki",
            debugMode: "Hata Ayıklama Modu",
            idFinder: "ID Bulucu",
            qrGenerator: "QR Oluşturucu",
            wabaPricingTool: "WABA Fiyatlandırma Aracı",
            webhookTool: "Webhook Aracı",
            supsisVersion: "SUPSIS {version}",
            windows: "Windows",
            macOS: "macOS",
            ctrl: "Ctrl",
            command: "Command",
            chatWindow: "Sohbet Penceresi",
            redirectConversation: "Görüşmeyi Yönlendir",
            sendPrivateMessage: "Gizli Mesaj Gönder",
            blockUser: "Kişiyi Engelle",
            showProfile: "Profili Göster",
            markAsAnswered: "Cevaplandı Olarak İşaretle",
            switchToChatLayout: "Chat Düzenine Geç",
            switchToTableLayout: "Tablo Düzenine Geç",
            switchToKanbanLayout: "Kanban Düzenine Geç",
            newVersionAvailable: "Yeni Sürüm Mevcut",
            newVersionAvailableDescription:
                "Yeni bir sürüm mevcut. Lütfen yeni sürüme geçmek için aşağıdaki butona tıklayın.",
            currentVersion: "Mevcut Sürüm",
            later: "Daha Sonra",
            downloadNewVersion: "Yeni Sürümü Yükle",
            noActiveChatFound: "Hiç aktif sohbet bulunamadı.",
            noActiveChatFoundSubtitle: "Bu kısımda aktif sohbetler ve size atanan sohbetleri görebilirsiniz.",
            searchRepresentativePlaceholder: "Temsilci arayın.",
            goToAutomation: "Otomasyona Git",
            copyUrl: "URL Kopyala",
            automationLink: "Otomasyon Linki",
            callWithAi: "AI ile Ara",
            callWithWebphone: "Webphone ile Ara",
            writeOnWhatsapp: "WhatsApp'dan Yaz",
            totalRecords: "Toplam: {count} kayıt",
            editInvoice: "Fatura Düzenle",
            editInvoiceSubtitle: "Fatura bilgilerini güncelleyin",
            paymentTerms: "Vade Süresi",
            selectPaymentTerms: "Vade süresi seçin",
            dueDate: "Son Ödeme Tarihi",
            invalidInvoice: "Geçersiz Fatura",
            vatRateLabel: "KDV (%{rate})",
            updateInvoice: "Fatura Güncelle",
            buyExtraChatbot: "Ekstra Chatbot Satın Al",
            selectSessionPackage: "İhtiyacınıza uygun session paketini seçin",
            customSessionAmount: "Özel Session Miktarı",
            enterAmount: "Miktar girin",
            totalPrice: "Toplam Fiyat",
            existingUsageRights: "Mevcut Kullanım Hakkınız Var",
            existingSessionRights:
                "Şu an <strong>{count}</strong> session hakkınız mevcut. Ekstra paket satın almadan önce mevcut haklarınızı değerlendirmenizi öneririz.",
            freeRights: "Ücretsiz Haklar",
            normalPackage: "Normal Paket",
            extraPackage: "Extra Paket",
            usageOrderNote: "Kullanımınız sırasıyla Ücretsiz → Normal → Extra paketlerden düşülür.",
            importantInfo: "Önemli Bilgi",
            packageEndsInfo:
                "Paketiniz <strong>{date}</strong> tarihinde sonlanacaktır ve ücret kesintisi hemen yapılacaktır.",
            buy: "Satın Al",
            shopifyManagesInvoices: "Abonelik faturalarınız Shopify tarafından yönetilmektedir.",
            cancelSubscription: "İptal et",
            paidSubscriptions: "Ücretli Abonelikleriniz",
            trialWillEnd: "Deneme Sürümü Sonlandırılacak",
            trialEndConfirmDescription:
                "Kredi kartı bilgilerinizi kaydederek deneme sürümünüzü sonlandırmak istediğinizi onaylıyor musunuz? Bu işlem sonrasında seçili paketleriniz için ücretlendirme başlayacaktır.",
            confirmAndContinue: "Onayla ve Devam Et",
            trialEnded: "Deneme Sürümünüz Sona Erdi",
            cancelPlan: "İptal Et",
            freePlan: "Ücretsiz Plan",
            proPlan: "Pro Plan",
            agentFeature: "Agent Özelliği",
            freeAgentCount: "Ücretsiz Ajan Sayısı",
            archiveFeature: "Arşiv Özelliği",
            maxChatArchiveTime: "Maksimum Sohbet Arşiv Süresi",
            chatArchiveTime: "Sohbet Arşiv Süresi",
            automationFeature: "Otomasyon Özelliği",
            eventBasedAutomation: "Event Bazlı Otomasyon",
            webhookBasedAutomation: "Webhook Bazlı Otomasyon",
            buttonBasedAutomation: "Button Bazlı Otomasyon",
            timerBasedAutomation: "Timer Bazlı Otomasyon",
            automationCreationLimit: "Otomasyon Oluşturma Limiti",
            freeTaskLimitPerMonth: "Aylık Ücretsiz Görev Limiti",
            blockCount: "Blok Sayısı",
            chatFeature: "Sohbet Özelliği",
            autoTranslation: "Otomatik Çeviri",
            voiceCalling: "Sesli Arama",
            videoCalling: "Görüntülü Arama",
            fileAndVoiceShare: "Dosya ve Ses Kaydı Paylaşımı",
            aiAssistant: "Yapay Zekalı Asistan",
            liveSupportModule: "Canlı Destek Modülü",
            liveTrackingFeature: "Canlı İzleme Özelliği",
            multipleChatWindow: "Çoklu Chat Penceresi",
            screenSharing: "Ekran Paylaşma",
            chatbotFeature: "Chatbot Özelliği",
            chatbotButtonActivity: "Chatbot Buton Aktivitesi",
            storyCountLimit: "Story Sayısı Limiti",
            integrationCount: "Entegrasyon Sayısı",
            versionHistoryCount: "Versiyon Geçmişi Sayısı",
            activeChatbotLimit: "Aktif Chatbot Limiti",
            customerTablesFeature: "Müşteri Tabloları Özelliği",
            customerTable: "Müşteri Tablosu",
            tableAssociation: "Tablo İlişkilendirme",
            aiSupportedRecord: "AI Destekli Kayıt",
            tableModularization: "Tablo Modülleştirme",
            tableReportCreation: "Tablo Rapor Oluşturma",
            tableCreationLimit: "Tablo Oluşturma Limiti",
            fieldsPerTable: "Tablo Başına Alan",
            recordsPerTable: "Tablo Başına Kayıt",
            viewsPerTable: "Tablo Başına Görüntü Oluşturma",
            formFeature: "Form Özelliği",
            formActive: "Form Aktif",
            formCreationLimit: "Form Oluşturma Limiti",
            formSubmitLimit: "Form Gönderim Limiti",
            formViewLimit: "Form Başına Görüntüleme Limiti",
            formFieldCount: "Form Alan Sayısı",
            instagramFeature: "Instagram Özelliği",
            channelCount: "Kanal Sayısı",
            mentionTicket: "Mention Ticket",
            privateReplyMessage: "Private Reply Message",
            commentManagement: "Comment Management",
            manageInbox: "Manage Inbox",
            manageWithChatbot: "Manage with Chatbot",
            linkedinFeature: "LinkedIn Özelliği",
            integration: "Entegrasyon",
            mailFeature: "Mail Özelliği",
            detailedBroadcastReport: "Detaylı Yayın Raporu",
            firstMailFreeCount: "İlk Mail Ücretsiz Sayısı",
            maxMailLimit: "Maksimum Mail Limiti (Gönderim/Alım)",
            mailPerCount: "Mail Per Count (1 = 0.00001|5K=1)",
            mailPricePerCount: "Mail Sayısı Başına Fiyat",
            messengerFeature: "Messenger Özelliği",
            metaLeadFeature: "Meta Lead Özelliği",
            automationManagement: "Otomasyon ile Yönetim",
            ticketManagement: "Ticket ile Yönetim",
            reportFeature: "Rapor Özelliği",
            reporting: "Raporlama",
            basicReporting: "Temel Raporlama",
            detailReporting: "Detaylı Raporlama",
            visitorReporting: "Ziyaretçi Raporlaması",
            customReporting: "Özel Raporlama",
            smsFeature: "SMS Özelliği",
            apiUsage: "API Kullanımı",
            instagram: "Instagram",
            messenger: "Messenger",
            servicesFeatures: "Hizmetler Özellikleri",
            aiVoiceAgentFeature: "AI Ses Ajanı",
            activeAgentCount: "Aktif Agent Sayısı",
            appointmentTracking: "Randevu Takibi",
            bulkCallCount: "Toplu Arama Sayısı",
            voiceCloning: "Ses Klonlama",
            readyVoiceUsage: "Hazır ses kullanımı (OpenAI / ElevenLabs)",
            communityVoiceUsage: "Community ses kullanımı (ElevenLabs)",
            concurrentCallCount: "Aynı anda yapılabilen arama sayısı",
            webAgentFeature: "Web Agent özelliği",
            callViaChatbot: "Chatbot üzerinden arama",
            callViaAutomation: "Otomasyon üzerinden arama",
            callViaTables: "Tablolar üzerinden arama",
            callViaContacts: "Kişiler üzerinden arama",
            llmSupport: "LLM Desteği",
            customLlmIntegration: "Özel LLM model entegrasyonu",
            customDataTraining: "Kendi Bilgi Tabanınız ile Eğitim",
            ivrFeature: "IVR (Tuş basma aksiyonları alma)",
            customFunctions: "Özel Fonksiyonlar ekleme",
            sentimentAnalysis: "Duygu Analizi",
            advancedVoiceSettings: "Gelişmiş Ses Ayarları",
            secretaryDetection: "Telesekreter Algılama",
            customizablePrompts: "Kişiselleştirilebilir Promptlar",
            webTrafficFeature: "Web Trafik Özelliği",
            webTrafficAnalytics: "Web Trafik Analitiği",
            webphoneFeatures: "Webphone Özellikleri",
            integratedWebPhone: "Entegre Web Telefonu",
            clickToCallFeature: "Click to Call Özelliği",
            webPhoneCallHistory: "Web telefonu için Arama Geçmişi",
            generalCallRecords: "Genel Arama Kayıtları",
            userExtensionMapping: "Kullanıcı Dahili Eşleştirme",
            webphoneAutomations: "Webphone Otomasyonları",
            extensionListing: "Dahili Listeleme",
            internalCalling: "Dahili Arama",
            callRouting: "Arama Yönlendirme (Kırmızı Santral)",
            coldCallStart: "Soğuk Arama Başlat (Kırmızı Santral)",
            automationColdCall: "Otomasyon ile Soğuk Arama Başlatma (Kırmızı Santral)",
            ivrRedStation: "IVR (Kırmızı Santral)",
            voiceAnnouncement: "Ses Kaydı Anons Dinletme (Kırmızı Santral)",
            satisfactionSurveyCall: "Memnuniyet Anketi Araması (Kırmızı Santral)",
            customizableCloudPbx: "Özelleştirilebilir Bulut Santral (Kırmızı Santral)",
            liveQueueMonitoring: "Canlı Kuyruk İzleme (Kırmızı Santral)",
            aiVoiceAgentIntegration: "Yapay Zeka Voice Agent ile Entegrasyon (Kırmızı Santral)",
            contactCallHistory: "Kişi Kartlarında Arama Geçmişi Gösterme",
            callProfileDisplay: "Çağrı Anında Profil Gösterme",
            multipleWebPhone: "Çoklu Web Telefonu (Telnyx)",
            voiceRecordingStorage: "Ses Kaydı Saklama",
            whatsappFeature: "WhatsApp Özelliği",
            broadcastMessagePerPrice: "Toplu Mesaj Başına Fiyat",
            businessChannelCount: "Business Kanal Sayısı",
            otherFeatures: "Diğer Özellikler",
            bulkMessageSending: "Toplu Mesaj Gönderimi",
            messageUnregisteredNumbers: "Kayıtsız Numaralara Mesaj",
            personalizedBroadcastMessage: "Kişiselleştirilmiş Toplu Mesaj",
            chatbotIntegration: "Chatbot Entegrasyonu",
            manageWhatsapp: "WhatsApp Yönetimi",
            noAdditionalCost: "Ek Maliyet Gerekmez",
            whatsappVoiceCalling: "WhatsApp Sesli Görüşme",
            suspendDateLabel: "Askıya Alınma Tarihi",
            liveSupportButton: "Canlı Destek",
            noPermissionContactAdmin:
                "Bu işlem için yetkiniz bulunmamaktadır. Lütfen site yöneticinizle iletişime geçin veya canlı destek hattımızdan yardım alın.",
            paymentProblemSolution: "Ödeme Sorunu Çözümü",
            paymentProblemSolutionDesc:
                "Birikmiş faturalarınızı ödeyerek ve ödeme bilgilerinizi güncelleyerek hesabınızı tekrar aktifleştirebilirsiniz.",
            quickSolution: "Hızlı Çözüm",
            quickSolutionDesc: "Fatura ve ödeme sayfamızdan kolayca hesabınızı yeniden aktifleştirebilirsiniz.",
            liveSupportTitle: "Canlı Destek",
            liveSupportDesc: "Herhangi bir sorunuz varsa 7/24 canlı destek ekibimiz yardımcı olmaya hazır.",
            chatHistory: "Sohbet Geçmişi",
            calling: "Aranıyor ....",
            cancelTooltip: "İptal Et",
            deleteAndDiscardTooltip: "Sil ve Vazgeç",
            whatsappSolutionsComparison: "WhatsApp Çözümleri Karşılaştırması",
            searchFeaturePlaceholder: "Özellik ara...",
            feature: "Özellik",
            whatsappV3: "WhatsApp V3",
            qrCodeUnofficialSolution: "(QR Code - Unofficial Solution)",
            whatsappWaba: "WhatsApp WABA",
            metaOfficialApiSolution: "(Meta Resmi API Çözümü)",
            wabaCoex: "WABA CoEx",
            supsisProviderCoexistence: "(Supsis Sağlayıcılı Coexistence)",
            whatsappIntegration: "WhatsApp Entegrasyonu",
            whatsappIntegrationSubtitle: "İşletmenize en uygun WhatsApp çözümünü seçin",
            qrCodeAdvancedFeatures: "QR Kod ile Gelişmiş Özellikler",
            metaCloudApiSolution: "Meta Cloud API - Kurumsal Çözüm",
            appAndApiTogether: "Uygulama + API Aynı Anda",
            advantages: "Avantajlar",
            limitations: "Sınırlamalar",
            quickQrSetup: "Hızlı QR kod ile kurulum",
            messageQuoting: "Mesaj alıntılama",
            newsletterChannels: "Newsletter kanalları",
            getProfilePhoto: "Profil fotoğrafı alma",
            deviceBased: "Cihaz bazlı",
            banRiskContinues: "Ban riski devam eder",
            lowSla: "Düşük SLA",
            metaApprovedSolution: "Meta onaylı resmi çözüm",
            sla99Guarantee: "%99.9 SLA garantisi",
            restApiTemplateMessages: "REST API & Şablon mesajlar",
            broadcastAndAutomation: "Toplu mesaj & otomasyon",
            whatsappUnusableOnPhone: "Telefonda WhatsApp kullanılamaz",
            chatHistoryLost: "Sohbet geçmişi kaybolur",
            apiMessageFee: "API mesaj ücreti var",
            phoneAndApiTogether: "Telefon + API aynı anda",
            chatHistoryPreserved: "Sohbet geçmişi korunur",
            messageEcho: "Mesaj yansıması (Echo)",
            appMessagesFree: "Uygulama mesajları ücretsiz",
            broadcastListsDisabled: "Yayın listeleri devre dışı",
            groupsNoApiSync: "Gruplar API'ye sync olmaz",
            wabaCoexInfoBanner:
                "WABA CoEx (Şubat 2025): Meta'nın resmi Coexistence özelliği sayesinde mevcut WhatsApp Business uygulamanızı kullanmaya devam ederken Cloud API'nin tüm gücünden yararlanabilirsiniz. Uygulama mesajları ücretsiz kalır, API mesajları standart ücretlendirilir. Mesaj yansıması (Echo) ile her iki taraftaki mesajlar senkronize olur.",
            detailedComparison: "Detaylı Karşılaştırma",
            approveAndContinue: "Onayla ve devam et",
            filteringOptions: "Filtreleme Seçenekleri",
            apply: "Uygula",
            dateRange: "Tarih Aralığı",
            startDateLabel: "Başlangıç Tarihi",
            endDateLabel: "Bitiş Tarihi",
            quickFilters: "Hızlı Filtreler",
            siteSelection: "Site Seçimi",
            chatScore: "Chat Puanı",
            platformSelection: "Platform Seçimi",
            chatStarter: "Sohbet Başlatan",
            chatCloser: "Sohbet Kapatan",
            platforms: "Platformlar",
            noDeletableUserFound: "Silinebilir bir kullanıcı bulunamadı.",
            cancelPlanConfirmTitle: "Planı İptal Etmek İstediğinize Emin misiniz?",
            cancelPlanMonthlyDesc:
                "Eğer iptal gerçekleşirse, 1 gün sonunda paketiniz sonlanacaktır. İptal işlemi geri alınamaz ve paketiniz sonlandıktan sonra hizmetlere erişiminiz kesilecektir.",
            cancelPlanYearlyDesc:
                "Eğer iptal gerçekleşirse, paketinizin son günü sonlanacaktır. İptal işlemi geri alınamaz ve paketiniz sonlandıktan sonra hizmetlere erişiminiz kesilecektir.",
            yesCancel: "Evet, İptal Et",
            createInvoice: "Yeni Fatura Oluştur",
            fillInvoiceInfo: "Fatura bilgilerini doldurun",
            invoiceType: "Fatura Tipi",
            selectInvoiceType: "Fatura tipi seçin",
            vatIncluded: "KDV Dahil",
            vatExcluded: "KDV Hariç",
            creationDate: "Oluşturulma Tarihi",
            dueDateLabel: "Son Ödeme Tarihi",
            selectDate: "Tarih seçin",
            markAsPaid: "Ödendi olarak işaretle",
            paymentDate: "Ödeme Tarihi",
            invoiceDescriptionPlaceholder: "Fatura açıklaması giriniz...",
            vatExcludedLabel: "KDV Hariç",
            vatLabel: "KDV",
            totalLabel: "Toplam",
            vatNotApplicable: "KDV uygulanmaz",
            createInvoiceButton: "Fatura Oluştur",
            toActivatePlanNeedOthers: "Bu planı aktifleştirmek için diğer planları aktifleştirmeniz gerekir",
            currentPlan: "Mevcut Plan",
            nextPlan: "Sonraki Plan",
            annualDiscountUpTo30: "Yıllık alımlarda %30'a varan indirim ile daha avantajlı ödeme.",
            monthlyPlanAutoRenew: "Aylık planlar her ayın başında otomatik yenilenir ve faturalandırılır.",
            yearlyPlanPrepaid: "Yıllık plan peşin olarak tahsil edilir ve iptal edilemez.",
            prepaidPlanNote:
                "Ön ödemeli plan aldığınızda aylık pakettiniz iptal edilir. Aylık aboneliğe ön ödemeli paketiniz bittikten sonra geçiş yapabilirsiniz. Yeni bir ön ödemeli paket alırken paketiniz güncellenmez, ekstradan yeni bir abonelik başlar.",
            trialModeNote:
                "Şu an deneme sürümündesiniz; bu süre boyunca ücret alınmaz. Deneme bittikten sonra hizmeti kesintisiz kullanmaya devam etmek için kredi kartı eklemeniz gerekir. Kart ekledikten sonra, seçtiğiniz planın ücretlendirme koşulları geçerli olacaktır.",
            startSubscription: "Aboneliği Başlat",
            buyNow: "Satın Al",
            creditCardRequiredModalTitle: "Kredi Kartı Zorunlu",
            creditCardRequiredModalDesc:
                "Herhangi bir satın alım için kredi kartı zorunludur. Lütfen kredi kartınızı giriniz.",
            automationTasks: "Otomasyon Görevleri",
            daysRemaining: "{count} gün",
            channelSettings: "Kanal Ayarları",
            apiKeyMode: "API Anahtarı Modu",
            byokTitle: "Kendi API Anahtarımı Kullanacağım (BYOK)",
            byokDesc: "OpenRouter hesabınızdaki API anahtarınızı kullanın",
            supsisKeyTitle: "Supsis AI API Anahtarı Sağlasın",
            supsisKeyDesc: "Supsis tarafından sağlanan API anahtarı ile kullanın",
            openrouterApiKey: "OpenRouter API Key",
            openrouterApiKeyHint: "API anahtarınızı OpenRouter Dashboard üzerinden alabilirsiniz.",
            noChannels: "Henüz kanal yok",
            createFirstChannel: "İlk kanalınızı oluşturmak için 'Kanal Ekle' butonuna tıklayın.",
            createChannel: "Kanal Oluştur",
            providerInfo: "Provider Bilgisi",
            channels: "Kanallar",
            channelUpdatedSuccessfully: "Kanal başarıyla güncellendi",
            channelDeletedSuccessfully: "Kanal başarıyla silindi",
            failedToSaveChannel: "Kanal kaydedilemedi",
            failedToDeleteChannel: "Kanal silinemedi",
            apiKeyRequired: "API anahtarı zorunludur",
            deleteChannelConfirm: "Bu kanalı silmek istediğinize emin misiniz?",
            copiedToClipboard: "Panoya kopyalandı",
            appBreadcrumb: {
                tasks: "Görevler",
                broadcastLabel: "Toplu Mesaj",
                walletBalanceTooltip: "Cüzdan Bakiyeniz: {amount}₺",
                broadcastStatusCreated: "Oluşturuldu",
                broadcastStatusScheduled: "Zamanlandı",
                broadcastStatusQueued: "Kuyrukta",
                broadcastStatusRunning: "Gönderiliyor",
                broadcastStatus: "Durum",
                broadcastProgress: "İlerleme",
            },
            confirmDeleteRedStationIntegration: "Bu Kırmızı Santral kanalını silmek istediğinize emin misiniz?",
            enterRedStationIntegration: "Kırmızı Santral API bilgilerinizi girin",
            redStationIntegration: "Kırmızı Santral Entegrasyonu",
            copyChannelID: "Channel ID Kopyala",
            redStationChannels: "Kırmızı Santral Kanalları",
            bannedUserError: "Yasaklama eklenirken bir hata oluştu.",
            bannedUserSuccess: "Yasaklama başarıyla eklendi.",
            selectAtLeastOneOption: "Lütfen en az bir seçenek seçiniz.",
            enterValidValue: "Lütfen geçerli bir değer giriniz.",
            enterValidIpAddress: "Lütfen geçerli bir IP adresi girin.",
            enterValidVisitorId: "Lütfen geçerli bir ziyaretçi kimliği girin.",
            enterValidWhatsappNumber: "Lütfen geçerli bir WhatsApp numarası girin.",
            invalidEmailAddress: "Lütfen geçerli bir e-posta adresi girin.",
            bannedUser: "Yasaklandı",
            unbannedUser: "Yasaklanmadı",
            banModalDescription: "Kullanıcıyı yasaklamak için platform ve değer giriniz.",
            exampleNumber: "Örnek Numara: 905551111111",
            clearSelectedFiltersTooltip: "Sayfada seçili olan filtre değerlerini temizler",
            minutesText: "{count} dakika",
            secondsText: "{count} saniye",
            downloadCooldownWarning: "Yeni bir indirme talebi oluşturmak için lütfen {time} bekleyin.",
            excelExportReceiveQuestion: "Excel dosyasını nasıl almak istersiniz?",
            sendToMe: "Bana Gönder",
            sendToSomeoneElse: "Başkasına Gönder",
            enterEmailAddress: "Email adresi girin",
            exportRequestSuccess: "Talebiniz oluştu, en kısa sürede mail yolu ile ileteceğiz",
            maxDateRangeWarning: "Seçilen Tarih Aralığı En Fazla 45 Gün olabilir",
            ticketOnlyMail:
                "Bu talep yalnızca e-posta üzerinden yanıtlanabilir. WhatsApp üzerinden gönderilen mesajlar iletilemeyecektir.",
            cardInfoUpdateError: "Kart bilgileri güncellenirken bir hata oluştu",
            billingInfoSavedSuccessfully: "Fatura bilgileriniz başarıyla kaydedildi",
            billingInfoSaveError: "Fatura bilgisi kaydetme hatası:",
            paymentInfoSavedSuccessfully: "Ödeme bilgileriniz başarıyla kaydedildi",
            annualDiscount: "Yıllık alımlarda %20 indirim kazanın",
            annualDiscountDescription: "Yıllık abonelik seçerek önemli bir tasarruf sağlayabilirsiniz.",
            payOnlyForUsedFeatures: "Kullandığınız kadar ödeyin",
            payOnlyForUsedFeaturesDescription: "Sadece kullandığınız özellikler için ödeme yapın, fazlasını ödemeyin.",
            cancelAnytime: "İstediğiniz zaman iptal etme",
            cancelAnytimeDescription: "Uzun dönem sözleşmelere gerek yok, dilediğinizde iptal edebilirsiniz.",
            noPermissionDescription:
                "Bu işlemi yapmak için <strong>yetkiniz bulunmamaktadır</strong>. Lütfen yöneticiniz ile iletişime geçiniz.",
            creditCardRequired: "Kredi Kartı Bilgisi Gerekli",
            creditCardRequiredDescription:
                "Ücretli abonelikleriniz bulunmaktadır. Kredi kartı bilgilerinizi girerek devam edebilirsiniz veya aboneliklerinizi iptal ederek devam edebilirsiniz.",
            creditCardRequiredDescription2:
                "Hesabınızda ücretli abonelikler bulunduğu için kredi kartı bilgisi girmeniz gerekmektedir.",
            subscriptionManagement: "Abonelik Yönetimi",
            addCreditCard: "Kart Bilgileri Ekle",
            transferOwnership: "Sahiplik Transfer Et ve Yönlendir",
            errorLoadingAgents: "Ajanlar yüklenirken bir hata oluştu",
            pleaseFillRequiredFields: "Lütfen gerekli alanları doldurun",
            callStartedSuccessfully: "Arama başarıyla başlatıldı",
            errorStartingCall: "Arama başlatılırken bir hata oluştu",
            errorLoadingData: "Veriler yüklenirken bir hata oluştu",
            errorLoadingDataPhoneNumbers: "Telefon numaraları yüklenirken bir hata oluştu",
            noVariablesFound:
                "Promptta herhangi bir değişken bulunamadı. Değişkenler <code v-pre>{{ değişken_adı }}</code> formatında olmalıdır.",
            aiVoiceAgentSpecialVariables: "Özel Değişken Değerleri",
            addAiVoiceAgentChannel: "Kanal Ekle",
            multiLanguageSupport: "Çoklu dil desteği",
            customerService247: "7/24 müşteri hizmeti",
            autoCallAnswer: "Otomatik çağrı karşılama",
            aiVoiceAgentChannelRequired: "AI Ses Ajanı Kanalı Gerekli",
            aiVoiceAgentChannelRequiredDescription:
                "Bu özelliği kullanabilmek için AI Ses Ajanı kanalını eklemeniz gerekmektedir.",
            aiVoiceAgentChannelRequiredDescription2:
                "AI Ses Ajanı, müşterilerinizle telefon görüşmesi yapabilen yapay zeka destekli bir asistandır.",
            startCall: "Aramayı Başlat",
            selectContactFieldPlaceholder: "Kişi bilgisi seçin",
            aiVoiceAgentVariableValuePlaceholder: "Değer girin",
            aiVoiceAgentVariables: "Ajan'ın Değişken Bilgileri",
            aiVoiceAgentVariableManual: "Manuel",
            aiVoiceAgentVariableContact: "Kişi Bilgisi",
            toNumberHelpText: "E.164 formatında olmalıdır. Örnek: +905321234567",
            toNumber: "Aranacak Numara",
            selectAiVoiceAgentHelpText: "Eğer seçmezseniz, numaranın varsayılan giden ajanı kullanılacaktır",
            selectAiVoiceAgent: "Ajan seçin (opsiyonel)",
            aiVoiceAgent: "Ajan",
            selectFromNumber: "Arayan numara seçin",
            fromNumber: "Arayan Numara",
            startAiCall: "AI Ses Ajanı ile Arama Başlat",
            aiCall: "AI Ses Ajanı ile Arama Yap",
            groupByNone: "Gruplandırma yapılmaz",
            groupByAgent: "Kişileri son oturumundaki olan temsilcilere göre gruplandır",
            groupByDepartment: "Kişileri son oturumundaki seçtiği departmana göre gruplandır",
            groupByChannel: "Kişileri geldiği kanala göre gruplandır",
            groupByPlatform: "Kişileri geldiği platforma göre gruplandır",
            groupByWebsite: "Kişileri geldiği website'ye göre gruplandır",
            groupByTag: "Kişileri etiketlerine göre gruplandır",
            groupByAnswerStatus: "Kişileri son oturumundaki cevaplanma durumuna göre gruplandır",
            groupByOwner: "Kişileri sahiplerine göre gruplandır",
            changeGroupBy: "Gruplama Modunu Değiştir",
            changeSortMode: "Sıralama Modunu Değiştir",
            selectIcon: "İkon Seç",
            iconPickerTitle: "İkon Seçici",
            searchIconPlaceholder: "İkon ara...",
            profileFieldsDescriptionChat: "Profil alanlarınızı özelleştirmek için tıklayınız",
            createCommentSuccess: "Yorum başarıyla oluşturuldu",
            createCommentError: "Yorum oluşturulurken hata oluştu",
            updateCommentSuccess: "Yorum başarıyla güncellendi",
            updateCommentError: "Yorum güncellenirken hata oluştu",
            deleteCommentSuccess: "Yorum başarıyla silindi",
            deleteCommentError: "Yorum silinirken hata oluştu",
            formSubmission: "Form Gönderimi",
            selectForm: "Form Seçin",
            updateOwnerUsers: "Sahipliğindeki Kişileri Güncelle",
            updateOwnerUsersDesc:
                "Bu kullanıcının sahipliğindeki kişilere ne yapmak istiyorsunuz? Yeni bir kullanıcıya aktarabilirsiniz veya bu kişileri sahipsiz bırakabilirsiniz.",
            noDepartment: "Departman atanmamış",
            deposit: "Bakiye Yükleme",
            creditUsage: "Bakiye Kullanımı",
            businessMarketing: "Marketing",
            businessUtility: "Utility",
            businessAuthentication: "OTP",
            businessService: "Hizmet",
            incomingSessionMessage: "Gelen Mesaj",
            outgoingSessionMessage: "Giden Mesaj",
            freeTierConversation: "Ücretsiz Konuşma (FTC)",
            chatStart: "Sohbet Başlatma",
            wpMessage: "Whatsapp QR Toplu Mesaj",
            pin: "Sabitle",
            rename: "Yeniden Adlandır",
            browserSpeechRecognitionNotSupported:
                "Tarayıcınız ses tanıma özelliğini desteklemiyor. Chrome tarayıcısı kullanmanızı öneririz.",
            spaceKeyReleaseToSave: "Boşluk tuşunu bıraktığınızda kaydedilecek",
            spaceKeyHint: "Boşluk tuşuna basılı tutarak konuşabilirsiniz",
            listeningInProgress: "Konuşma Dinleniyor...",
            speakNow: "Konuşun...",
            toggleAllPermissions: "Tüm rol izinlerini etkinleştir/kaldır",
            rolePermissions: "Rol İzinleri",
            creatingRole: "Oluşturuluyor...",
            savingRole: "Kaydediliyor...",
            editRole: "Rol Düzenle",
            newRoleCreate: "Yeni Rol Oluştur",
            descriptionEmail:
                "Sohbetteki ziyaretçinin email adresini otomatik olarak mesaj kutusuna ekler ve göndermenize olanak sağlar",
            exampleEmail: "Örnek: @email merhaba",
            nameDescription:
                "Sohbetteki ziyaretçinin ismini otomatik olarak mesaj kutusuna ekler ve göndermenize olanak sağlar",
            exampleName: "Örnek: @name merhaba",
            pmDescription:
                "Gizli mesaj göndermenizi sağlar. Bu mesajları yalnızca diğer müşteri temsilcileri görebilir, ziyaretçiler göremez.",
            examplePm: "Örnek: pm: Bu mesaj gizli",
            chatShortcuts: "Chat Kısayolları",
            showSystemStatus: "Sistem Durumunu Görüntüle",
            showMore: "Daha Fazla Görüntüle",
            showLess: "Daha Az Görüntüle",
            endChatWizard: "Oturum Sonlandırma Sihirbazı",
            terminationError: "Bir hata oluştu",
            profileFieldsUpdateError: "Güncelleme sırasında hata oluştu",
            profileFieldsUpdated: "Profil alanları güncellendi",
            aiSuggestionError: "Yapay Zeka önerileri alınamadı",
            profileFieldsDescription:
                "Bu kişi için özelleştirilmiş profil alanları doldurarak ekibinize daha fazla bilgi sağlayabilirsiniz.",
            categoryTags: "Bu kişiye etikerler vererek hızlıca kategorize edebilirsiniz.",
            manageTags: "Etiketleri Yönet",
            enterNote: "Not giriniz",
            noteDescription: "Bu kişi hakkında not ekleyebilirsiniz. Bu notlar görüşme sonrasında da görülecektir.",
            suggestedProfileFields: "Önerilen Profil Alanları:",
            suggestedTags: "Önerilen Etiketler",
            suggestedNote: "Önerilen Not:",
            applyAll: "Tümünü Uygula",
            aiSuggestionTitle: "Yapay Zeka Önerileri",
            aiSuggestion: "Supsis Asistan'dan Öneri Al",
            makeSelection: "Seçim Yap",
            channel: "Kanal",
            taskClosingDate: "Görev Kapatılma Tarihi",
            confirmDeleteTask: "Bu görevi silmek istediğinize emin misiniz?",
            taskDeletedSuccess: "Görev başarıyla silindi",
            taskDeleteError: "Görev silinirken hata oluştu",
            linkedinChannels: "LinkedIn Kanalları",
            updateLinkedinChannelDesc: "LinkedIn kanalınızı güncelleyin",
            deleteLinkedinChannel: "LinkedIn Kanalını Sil",
            confirmDeleteLinkedinChannel: "Bu LinkedIn kanalını silmek istediğinizden emin misiniz?",
            contactIdPlaceholder: "Contact ID",
            contactId: "Contact ID",
            enterOwnerId: "Sahip ID'si gir",
            selectOwner: "Sahip Seçin",
            dynamic: "Dinamik",
            owner: "Sahip",
            addCollaborator: "İşbirlikçi Ekle",
            dynamicValue: "Dinamik Değer",
            selectCollaborator: "İşbirlikçi Seçin",
            collaborator: "İşbirlikçi",
            collaborators: "İşbirlikçiler",
            addFollower: "Takipçi Ekle",
            selectFollower: "Takipçi Seçin",
            followers: "Takipçiler",
            follower: "Takipçi",
            addAssignee: "Atanan Ekle",
            selectUser: "Kullanıcı Seçin",
            assignees: "Atananlar",
            assignee: "Atanan",
            pipelineStage: "Pipeline Aşaması",
            selectPipelineStage: "Pipeline Aşaması Seçin",
            title: "Başlık",
            taskTitle: "Görev Başlığı",
            description: "Açıklama",
            taskDescription: "Görev Açıklaması",
            priority: "Öncelik",
            selectPriority: "Öncelik Seçin",
            workflow: "İş Akışı",
            selectWorkflow: "İş Akışı Seçin",
            packagePurchase: "Paket Satın Alım",
            upcomingInvoice: "Yaklaşan Fatura",
            invoiceUpdated: "Fatura Güncellendi",
            invoiceMarkedInvalid: "Fatura geçersiz olarak işaretlendi.",
            invoiceUpdateError: "Fatura Güncelleme Hatası",
            invoiceMarkInvalidError: "Fatura geçersiz işaretleme işlemi sırasında bir hata oluştu.",
            refunded: "İade Edildi",
            paid: "Ödendi",
            pending: "Bekleniyor",
            unpaid: "Ödenmedi",
            paymentFailed: "Ödeme Başarısız",
            paymentProcessError: "Ödeme işlemi sırasında bir hata oluştu.",
            paymentSuccessful: "Ödeme Başarılı",
            paymentProcessSuccessful: "Ödeme işlemi başarılı bir şekilde gerçekleşti.",
            invoiceRefund: "Fatura İadesi",
            invoiceRefundedSuccessfully: "Fatura başarılı bir şekilde iade edildi.",
            invoicePaymentError: "Fatura Ödeme Hatası",
            invoicePaymentProcessError: "Fatura ödeme işlemi sırasında bir hata oluştu.",
            invoicePaid: "Fatura Ödendi",
            invoiceMarkedAsPaid: "Fatura başarılı bir şekilde ödendi olarak işaretlendi.",
            invoicePriceUpdateError: "Fatura fiyatı güncelleme işlemi sırasında bir hata oluştu.",
            invoicePriceUpdatedSuccessfully: "Fatura fiyatı başarılı bir şekilde güncellendi.",
            invoicePdf: "Fatura PDF",
            viewInvoice: "Faturayı Görüntüle",
            makePayment: "Ödemeyi Yap",
            socialMedia: "Sosyal Medya",
            web: "Web",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-ticaret",
            utilities: "Araçlar",
            advertising: "Reklam",
            cancelPlanTitle: "Plan iptali",
            cancelPlanDescription:
                "Plan iptali gerçekleştikten sonra paket kullanımınız gün sonuna kadar kullanıma devam edilebilecektir.",
            voteSuccess: "Oy başarıyla kaydedildi",
            voteSuccessDescription: "{integrationName} entegrasyonunun Supsis'e eklenmesi için talebiniz alındı",
            companyName: "İşletme Adı",
            company: "İşletme",
            languageTitle1: "Varsayılan Panel Dili",
            languageTitle2: "Varsayılan Mesajlaşma Dili",
            languageTitle3: "Bölge & Saat Dilimi",
            languageTitle4: "Otomatik Müşteri Dili Ayarı",
            languageTitle5: "WebChat Müşteri Mesajlaşma Dili Seçimi",
            languageDesc1: "Supsis Ai paneli dilini ayarlar",
            languageDesc2: "Varsayılan mesajlaşma dilini buradan değiştirebilirsiniz.",
            languageDesc3: "Bölge ve saat dilimini ayarlar",
            languageDesc4: "Müşteri mesajlaşma dilini yapay zeka desteği ile otomatik olarak algılanmasını sağlar.",
            languageDesc5: "WebChat kanalında müşterinin konuşma dilini seçebme özelliğini aktif eder.",
            featuresTitle1: "Departman Seçimi",
            featuresTitle2: "Müşteriye Sırada Bekleyen Kişi Sayısı Gösterimi",
            featuresTitle3: "Yasaklı Kelime Engeli",
            featuresTitle4: "Müşterilerin “Ticket” oluşturma izni",
            featuresTitle5: "Sesli Görüşme",
            featuresTitle6: "Görüntülü Görüşme",
            featuresTitle7: "Sesli Mesaj Gönderimi (Temsilci)",
            featuresTitle8: "Sesli Mesaj Gönderimi (Müşteri)",
            featuresTitle9: "Otomatik Görüşme Aktarımı",
            featuresTitle10: "Temsilciler Arası Sohbeti Göster",
            featuresTitle11: "Dosya Gönderimi (Temsilci)",
            featuresTitle12: "WebChat Dosya Gönderimi (Müşteri)",
            featuresTitle13: "WebChat Temsilci Bağlanmadan Mesaj Gönderimi",
            featuresTitle14: "WebChat Temsilci Sistem Mesajlarının Gizlenmesi",
            featuresTitle15: "WebChat Müşterisi Kişisel Bilgilerini Silebilmesi",
            featuresTitle16: "Müşteri Çevrimiçi Bildirimi",
            featuresTitle17: "Otomatik Tercüme",
            featuresTitle18: "Ziyaretçi Otomatik Giriş",
            featuresTitle19: "WebChat Konum Paylaşımı (Müşteri)",
            featuresTitle20: "Konum Paylaşımı (Temsilci)",
            featuresTitle21: "Chat AI Copilot",
            featuresTitle22: "Sahipsiz konuşmaların Kuyrukta Bekletilmesi",
            featuresTitle23: "İletişim Bilgisi Gizleme",
            featuresDesc1: "Müşteri tarafından seçilen konulara göre departmana yönlendirme zorunluluğu.",
            featuresDesc2:
                "Temsilcilerin yoğun oldukları zamanda, canlı desteğe bağlanmak isteyen müşterilere kaçıncı sırada olduklarını gösterir.",
            featuresDesc3:
                "Yasaklı Kelime Engeli açık olduğunda temsilcilerin, sisteme tanımlanan yasaklı kelimeleri, müşteriye göndermesi engellenir.",
            featuresDesc4: "WebChat balonunda “Ticket” oluşturma seçeneğini aktif eder.",
            featuresDesc5: "WebChat balonunda sesli görüşme özelliğini aktif eder.",
            featuresDesc6: "WebChat balonunda görüntülü görüşme özelliğini aktif eder.",
            featuresDesc7: "Temsilcilerin sesli mesaj gönderme özelliğini etkinleştirir.",
            featuresDesc8: "Müşterilerin WebChat kanalında sesli mesaj gönderme özelliğini etkinleştirir.",
            featuresDesc9: "Müsait olan temsilcilere, bekleyen görüşmeleri otomatik atar.",
            featuresDesc10: "Temsilciler arası konuşma panelini gösterir.",
            featuresDesc11: "Temsilcilerin dosya gönderme özelliğini etkinleştirir.",
            featuresDesc12: "Müşterilerin WebChat kanalında dosya gönderme özelliğini etkinleştirir.",
            featuresDesc13: "Temsilci bağlanmadan önce müşterinin mesaj gönderebilme özelliğini etkinleştirir.",
            featuresDesc14:
                "Temsilci sistem mesajlarını gizleyerek müşterinin, bu sistem mesajlarını görmesini engeller.",
            featuresDesc15:
                "WebChat balonunda müşterinin kendi kişisel bilgilerini tek tuşla silebilme özelliğini aktif eder.",
            featuresDesc16:
                "WebChat kanalında müşteri konuşmadan ayrıldığında veya geri geldiğinde sistem mesajı ile temsilciyi bilgilendirir.",
            featuresDesc17: "Müşteriden gelen mesajların otomatik olarak temsilcinin diline çevrilmesi.",
            featuresDesc18: "Ziyaretçi balonu tıklar tıklamaz konuşma başlar",
            featuresDesc19: "WebChat kanalında müşterilerin konum paylaşabilme özelliğini aktif eder.",
            featuresDesc20: "Temsilcilerin konum paylaşabilme özelliğini aktif eder.",
            featuresDesc21:
                "Temsilcilerin Yapay Zeka desteği ile yazım hatalarını düzeltme, mesajın tonunu değiştirme, yapay zeka destekli yanıt üretme gibi yapay zeka asistanı kullanımı özelliğini aktif eder.",
            featuresDesc22: "Görüşmenin sahibi olmayan kişileri kuyrukta tutmak için bu özelliği etkinleştirirsiniz.",
            featuresDesc23:
                "Müşterilerin telefon numaraları ve e-mail adreslerinin temsilciler tarafından görüntülenmesini engeller.",
            featuresTitle24: "Görüşme Sonu Sihirbazı",
            featuresDesc24: "Görüşme kapatmadan önce temsilcilere görüşme kapatma sihirbazını göster",
            groupBy: "Gruplandır",
            privacyPolicyAndTerms: "Gizlilik Politikası / Hizmet Şartları",
            privacyPolicyTitle: "Supsis Canlı Destek & Sohbet Sistemleri için Gizlilik Politikası",
            privacyPolicyDescription:
                "Bu Gizlilik Politikası, Softcand Yazılım Hizmetleri A.S. (“Softcand,” “biz,” “bize,” veya “bizim”) tarafından, Supsis web uygulamasının (“Supsis”) kullanıcıları (“siz” veya “sizin”) hakkında topladığı, kullandığı ve ifşa ettiği bilgileri tanımlar. Bu Gizlilik Politikası, Supsis'i kullandığınızda topladığımız bilgilere uygulanır; bu bilgiler, web sitemiz, mobil uygulamalarımız veya Gizlilik Politikasının yayınlandığı diğer platformlar aracılığıyla erişildiğinde geçerlidir.",
            informationWeCollect: "Topladığımız Bilgiler",
            weCollectFollowingInformation: "Aşağıdaki bilgileri topluyoruz",
            customerAccountInformation: "Müşteri Hesap Bilgileri",
            customerAccountData:
                "Bir Supsis hesabı oluştururken, aşağıdaki verileri topluyoruz: ad, soyad, telefon numarası ve e-posta adresi.",
            userInformation: "Kullanıcı Bilgileri",
            userProvidedInformation:
                "Uygulamanın kullanıcıları tarafından sağlanan bilgiler, ad, soyad ve e-posta adresi dahil.",
            dataDeletionProcess: "Veri Silme Süreci",
            dataDeletionProcedures: "Veri silme için bu prosedürleri takip ediyoruz",
            automaticDeletion: "Otomatik Silme",
            automaticDeletionInfo:
                "Müşteri hesapları kapatıldığında veya altı ay boyunca etkin olmadığında otomatik olarak silinir.",
            directRequest: "Doğrudan Talep",
            directRequestInfo:
                "Müşteriler, doğrudan bizimle iletişime geçerek tüm verilerinin silinmesini talep edebilir.",
            websiteVisitorDataDeletion: "Web Sitesi Ziyaretçi Verisi Silme",
            websiteVisitorDataDeletionInfo:
                "Web sitesi ziyaretçileri, sohbet geçmişi, mesajlar ve dosyalar dahil olmak üzere verilerini doğrudan web sohbet arayüzü aracılığıyla silebilir.",
            howToContactUs: "Bize Nasıl Ulaşabilirsiniz",
            contactChannels: "Aşağıdaki kanallar aracılığıyla bize ulaşabilirsiniz",
            dataProcessingAndSharing: "Veri İşleme ve Paylaşma",
            handleCustomerData: "Müşteri verilerini şu şekilde işliyoruz",
            noThirdPartySharing: "Üçüncü Taraf Paylaşımı Yok",
            noThirdPartySharingInfo:
                "Supsis, müşteri verilerini herhangi bir üçüncü taraf kuruluş, şirket veya birey ile paylaşmaz.",
            promotionalEmails: "Tanıtım E-postaları",
            promotionalEmailsInfo:
                "Müşterilere tanıtım e-postaları gönderebiliriz; bu e-postalardan çıkmayı seçebilirler.",
            visitorAndConversationData: "Ziyaretçi ve Sohbet Verileri",
            noSharingVisitorData: "Müşteri ziyaretçi ve sohbet bilgilerini paylaşmıyoruz veya kullanmıyoruz.",
            thirdPartyServices: "3. Taraf Hizmetleri",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Takvimi",
            googleCalendarInfo:
                "Supsis, uygulama içinde takvimle ilgili işlevleri etkinleştirmek için Google Takvimlerini kullanır. Takvimlerden senkronize edilen veriler kimseyle paylaşılmaz ve yalnızca kullanıcıya görünür. Google OAuth sona erdiğinde, Supsis ve Google Takvim'den senkronize edilen tüm etkinlikler otomatik olarak silinir.",
            googleAccountPublicProfile: "Google Hesap Kamu Profili",
            googleAccountPublicProfileInfo:
                "Supsis, kullanıcıları giriş sırasında doğrulamak ve kimliklerini doğrulamak için ad ve e-posta bilgilerini toplar. Bu bilgi doğrulama sonrasında saklanmaz.",
            changesToPrivacyPolicy: "Bu Gizlilik Politikasındaki Değişiklikler",
            privacyPolicyUpdateInfo:
                "Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Önemli değişiklikler yaparsak, güncellenmiş Gizlilik Politikasını web sitemizde veya diğer iletişim kanalları aracılığıyla bildireceğiz.",
            privacyPolicyContactInfo:
                "Bu Gizlilik Politikası hakkında herhangi bir sorunuz varsa, lütfen m@softcand.com adresinden bizimle iletişime geçin.",
            termsOfServiceTitle: "Supsis Canlı Destek & Sohbet Sistemleri için Hizmet Şartları",
            lastUpdated: "Son güncelleme",
            inEffect: "Geçerlidir",
            importantTerms:
                "Önemli: Bu Hizmet Şartları, Gizlilik Politikasını da içeren, hizmetin kullanıcısı olarak adlandırılan kişi ile Softcand Yazılım Hizmetleri Anonim Şirketi (Supsis veya Supsis Canlı Destek veya Supsis Canlı Destek ve Sohbet Sistemleri olarak ticaret yapan) arasında bağlayıcı bir sözleşme oluşturur.",
            termsDescription:
                "Bu Hizmet Şartları, supsis.com (ürün açılış sayfası), softcand.com (şirket web sayfası) veya supsis.live (ürün uygulaması) veya beta.supsis.live (ürün uygulaması beta sürümü) gibi web sitelerimizi kullanmanızı düzenler.",
            applicationOfTerms: "Şartların Uygulanması",
            termsApplyToAllUsers:
                "Bu Şartlar, Hizmeti kendi adınıza veya başka bir birey veya kuruluş adına kullanıyor olsanız da tüm Hizmet kullanıcılarına uygulanır.",
            termsUpdateNotice:
                "Şartları istediğimiz zaman güncelleyebilir veya değiştirebiliriz. Şartları değiştirdiğimizde, web platformumuz aracılığıyla ve e-posta ile sizi bilgilendireceğiz.",
            termsDisagreementNotice:
                "Güncellenmiş Şartlara bağlı kalmayı kabul etmelisiniz; aksi takdirde Hizmeti kullanmaya devam edemezsiniz ve iptal talebinizi yazılı olarak bildirdiğiniz tarihten itibaren geçerli olmak üzere hesabınızı iptal etmelisiniz.",
            consumerRightsNotice:
                "Eğer geçerli yasalar altında 'tüketici' olarak sınıflandırılıyorsanız, bu Şartların bazı kısımlarının uygulanmasını engelleyen yerel yasalar altında yasal haklarınız olabilir ve bu durumda bu kısımlar sizin için geçerli olmayacaktır.",
            theService: "Hizmet",
            serviceGrant:
                "Size, bu Şartlara uygun olarak Hizmeti kullanma hakkı veriyoruz; bu hak, münhasır olmayan, dünya çapında, devredilemez ve geri alınabilir bir haktır.",
            serviceAccess:
                "Hizmete erişebilir ve kullanabilirsiniz (bu kullanımın bir parçası olarak meydana gelen herhangi bir tesadüfi kopyalama dahil) bu Şartlara uygun olarak.",
            serviceAgentAppointment:
                "Hizmete giriş yaptığınızda ve bir sosyal medya hesabını Hizmete bağladığınızda, o Hesapla ilgili olarak sizi temsilci olarak atarız ve sizin adınıza, talimatlarınız doğrultusunda (örneğin, Instagram veya başka bir Platformda doğrudan bir mesaja yanıt verme gibi) Hizmeti sağlamak için işlemler gerçekleştirebiliriz.",
            additionalAccountsAppointment:
                "Hizmete ek Hesaplar bağladığınızda, o hesaplarla ilgili olarak da sizi temsilci olarak atarız ve Ajans kapsamındaki faaliyetleri üstleniriz.",
            accountControl:
                "Her Hesabı kontrol ettiğinizi ve her Hesap için sizin adınıza Ajans kapsamındaki faaliyetleri üstlenmek üzere bizi atama yetkisine sahip olduğunuzu taahhüt edersiniz.",
            serviceAffiliation:
                "Hizmetin, Instagram, Facebook, Twitter veya Hizmeti sağladığımız diğer sosyal medya hizmetleriyle ilişkili veya yetkilendirilmiş olmadığını kabul ve beyan edersiniz ve her Platforma erişimin (Hizmet aracılığıyla dahil) ilgili Platformun Kullanım Şartları ile yönetildiğini kabul edersiniz.",
            serviceLinks:
                "Hizmet, bizim dışımızdaki kişiler tarafından eklenen içeriklerin yanı sıra diğer web sitelerine bağlantılar içerir. Kullanıcı tarafından oluşturulan içerikleri veya bağlantılı web sitelerinde mevcut olan içerikleri onaylamıyoruz, desteklemiyoruz veya onaylamıyoruz.",
            contentMonitoring:
                "Kullanıcılarımız tarafından Hizmete yüklenen veya paylaşılan içeriği izleme, düzenleme veya kaldırma yükümlülüğümüz yoktur.",
            serviceControl:
                "Hizmet üzerinde kontrolü sürdürdüğümüzü ve Hizmeti istediğimiz zaman değiştirebileceğimizi, durdurabileceğimizi veya sona erdirebileceğimizi kabul edersiniz.",
            yourRightsAndObligations: "Haklarınız ve Yükümlülükleriniz",
            contentAdditionRestriction:
                "Hizmete herhangi bir İçerik eklememelisiniz: (1) gerekli tüm haklara, lisanslara ve onaylara sahip olmadığınız sürece; (2) sizin veya bizim herhangi bir yasayı veya düzenlemeyi ihlal etmenize neden olacak içerikler; (3) spam, müstehcen, uygunsuz, iftira niteliğinde, aşağılayıcı, edebe aykırı, isyankar, saldırgan, ırk nefreti kışkırtan, yasadışı, ayrımcı, küfürlü, güven ihlali veya herhangi bir gizlilik yasasını ihlal eden içerikler; (4) bizi veya Hizmeti kötü duruma düşürecek içerikler; veya (5) herhangi bir kişinin fikri mülkiyet veya diğer haklarını ihlal eden içerikler eklememelisiniz.",
            restrictionsOnServiceUse:
                "Hizmete şunları yapmamalısınız: (1) Hizmeti, Hizmetle ilgili olarak yayınladığımız İçeriği veya sahip olmadığınız veya ilgili bir lisansa sahip olmadığınız herhangi bir materyali çoğaltmaya, kopyalamaya, değiştirmeye veya türev eserler hazırlamaya çalışmamalısınız; (2) virüs veya başka kötü niyetli kod dağıtmamalısınız; (3) Hizmeti yanıltıcı veya aldatıcı bilgi yayınlamak için kullanmamalısınız; (4) Hizmetimizde başka bir kişinin Hesabına izinsiz erişmemelisiniz; (5) Hizmetin herhangi bir yönünü değiştirmemeli, devre dışı bırakmamalı, müdahale etmemeli veya aşmamalısınız; veya (6) Hizmetin erişimini veya bütünlüğünü etkileyecek herhangi bir şey yapmamalısınız.",
            payments: "Ödemeler",
            paymentAcknowledgment: "Şunları kabul ve beyan edersiniz",
            paymentMethodDebit:
                "Belirtilen fatura tarihindeki (deneme sürenizin sona erdiği gün) her ay, yıl veya diğer fatura döneminde (uygun olduğunda) bir sonraki fatura dönemi için önceden belirttiğiniz ödeme yönteminden ücret alacağız; ve",
            cancellationPolicy:
                "Eğer Hizmeti iptal ederseniz, bir sonraki fatura tarihinize kadar Hizmete erişiminiz devam edecektir ve mevcut fatura dönemi için ödenen herhangi bir paranın iadesi bizim takdirimize bağlıdır (yani, ödemeler iade edilmez, yalnızca bizim takdirimize bağlı olarak iade edilir).",
            intellectualProperty: "Fikri Mülkiyet",
            contentDefinition:
                "Bu Şartlarda, 'İçerik', metin, ses, grafik, resim ve video biçimindeki materyali veya herhangi bir biçimdeki materyalin herhangi bir kombinasyonunu içerir.",
            intellectualPropertyRightsTransfer:
                "Bu Şartlarda hiçbir şey, herhangi bir fikri mülkiyet hakkının devrini oluşturmaz. Siz, bizimle aranızda, Hizmetteki tüm fikri mülkiyet haklarının bize ait olduğunu kabul ve beyan edersiniz.",
            userContentRights:
                "Siz, Hizmete sağladığınız veya Hizmeti sağlamak amacıyla bize sağladığınız İçerikteki tüm fikri mülkiyet haklarına sahip olduğunuzu veya lisansa sahip olduğunuzu kabul edersiniz.",
            grantLicense:
                "Bize, Hizmeti sağlamak amacıyla (a) Hizmete eklediğiniz İçeriği ve (b) Hesabınızla ilişkili sosyal medya Platformlarında yer alan profil içeriğini kullanma hakkı ve lisansı verirsiniz.",
            subLicense:
                "5(4) paragrafındaki lisansı, Hizmeti sağlamamıza yardımcı olan üçüncü taraf hizmet sağlayıcılarına alt lisans verme hakkına sahibiz.",
            moralRights:
                "Hizmetin faaliyet gösterdiği bazı ülkelerde, yerel yasalar, İçerik yazarlarının İçerik ile ilgili 'ahlaki haklara' sahip olabileceğini tanır. Ahlaki haklar, İçeriğin yazarı olarak atfedilme hakkı, içerik yazarının yanlış atfedilmesine itiraz etme hakkı ve bazı durumlarda İçeriğin aşağılayıcı muameleye maruz kalmasına itiraz etme hakkını içerebilir.",
            licenseSurvival:
                "5(4) paragrafındaki lisans, bu Şartların sona ermesinden sonra da geçerliliğini koruyacaktır.",
            rightsRepresentation:
                "Bize, bu madde 5'te belirtilen lisansları ve diğer taahhütleri vermek için gerekli tüm haklara sahip olduğunuzu beyan ve taahhüt edersiniz.",
            warranties: "Garanti",
            warrantiesAcknowledgment: "Bize, şunları beyan ve taahhüt edersiniz",
            accountOwnership:
                "Hizmete eklenen tüm Hesaplar, herhangi bir Platformda, sizin tarafınızdan sahip olunmakta veya kontrol edilmektedir.",
            serviceUsageAgreement: "Hizmeti bu Şartlara uygun olarak kullanacaksınız; ve",
            legalCapacity: "Bu Şartlara girmek için yasal kapasiteye ve yetkiye sahipsiniz.",
            liability: "Sorumluluk",
            liabilityForLoss:
                "Bu Şartlar altında yükümlülüklerinizi ihlal ederseniz veya Hizmeti kullanırken makul bir özen göstermediğiniz takdirde, meydana gelen herhangi bir kayıp veya zarardan sorumlusunuz.",
            indemnification:
                "Bu Şartları ihlal etmeniz (bu Şartlar altında verdiğiniz garantiler dahil) veya Hizmeti kullanma veya kötüye kullanma sırasında herhangi bir kasıtlı yanlış davranış, yasadışı eylem veya ihmal nedeniyle uğradığımız herhangi bir kayıp veya zarardan bizi tazmin edersiniz.",
            exclusionOfLiability:
                "Yasal olarak izin verilen en geniş ölçüde, bu Şartların 7(5) ve 7(6) maddelerine tabi olarak, Hizmeti kullanmanız veya kullanamamanızla doğrudan veya dolaylı olarak ortaya çıkan tüm talepler, masraflar, kayıplar, zararlar ve maliyetler için tüm sorumluluğumuzu hariç tutuyoruz.",
            totalLiabilityLimit:
                "Yasal olarak izin verilen en geniş ölçüde, bu Şartlar altında sözleşme ihlali, haksız fiil (ihmal dahil) veya başka bir neden için toplam sorumluluğumuz, sorumluluğumuzun doğduğu tarihten önceki bir aylık dönemde Hizmet için ödediğiniz toplam ücretle sınırlıdır.",
            exclusionOfTerms:
                "Yasal olarak izin verilen en geniş ölçüde, bu Şartların 7(5) ve 7(6) maddelerine tabi olarak, bu Şartlarda açıkça belirtilenler dışında tüm şartları, beyanları, garantileri, koşulları, teminatları veya yükümlülükleri (açık veya zımni) hariç tutuyoruz.",
            statutoryObligations:
                "Hizmetle ilgili bazı garantilerin, koşulların, teminatların veya yükümlülüklerin bu Şartlara dahil edilmesi veya Hizmetin sağlanması sırasında uygulanması gerektiğini belirten yasalar olabilir.",
            statuteProhibition:
                "Eğer 7(6) maddesinde belirtilen yasalar, bu Şartlara uygulanıyorsa, bu Şartların hiçbir kısmı, yasal bir yasak olarak tasarlanmış veya işlev görmemektedir.",
            termination: "Fesih",
            terminationAutomatic:
                "Bu Şartlar, herhangi bir nedenle Hizmeti işletmeyi durdurursak otomatik olarak sona erer.",
            terminationNotice:
                "Aksi takdirde, bu Şartları herhangi bir şekilde ihlal ettiğinizi makul bir şekilde düşünüyorsak, size bildirimde bulunarak Hizmete erişiminizi derhal sonlandırabilir veya askıya alabiliriz.",
            cancelService:
                "Hizmeti istediğiniz zaman bize bildirimde bulunarak iptal edebilirsiniz ve mevcut fatura döneminizi tamamlayana kadar Hizmete erişiminiz devam eder.",
            terminationRights: "Bu Şartlar uyarınca size verilen tüm haklar fesih ile sona erer.",
            assignmentRestriction:
                "Bu Şartlar uyarınca haklarınızı devredemez, alt lisans veremez veya başka bir şekilde işleyemezsiniz.",
            invalidProvision:
                "Bu Şartların herhangi bir hükmü geçersiz veya uygulanamaz ise, bu durum, kalan hükümlerinin geçerliliğini veya uygulanabilirliğini etkilemeden, gerekli olduğu ölçüde okunmalıdır.",
            expenseResponsibility:
                "Her taraf, bu Sözleşmeye ve onunla öngörülen olaylara tam etkisini vermek için makul ölçüde gerekli her şeyi kendi masraflarıyla yapmalıdır.",
            governingLaw:
                "Bu Şartlar, Türkiye yasalarına tabidir ve her taraf Türkiye mahkemelerinin yetkisine tabi olur.",
            privacyPolicyTab: "Gizlilik Politikası",
            termsAndConditionsTab: "Hizmet Şartları",
            placeholders: "Yer Tutucular",
            deleteOperation: "Silme İşlemi",
            deleteConfirmationMessage: "Bu filtreyi silmek istediğinizden emin misiniz?",
            deleteSuccess: "Filtre başarıyla silindi",
            filterSavedSuccessfully: "Filtre başarıyla kaydedildi",
            filterCreatedMessage:
                "Az önce oluşturduğunuz {filterName} isimli artık buradan yer alacak dilediğiniz zaman kullanabilirsiniz.",
            copyImage: "Resmi Kopyala",
            copyText: "Metni Kopyala",
            translateVisitorMessage: "Mesajı Çevir",
            replyMessage: "Yanıtla",
            downloading: "Dosya indiriliyor...",
            downloadSuccess: "Dosya başarıyla indirildi",
            downloadFailed: "Dosya indirme başarısız oldu",
            filterName: "Filtre Adı",
            enterFilterName: "Filtre adını giriniz",
            selectVisibility: "Görünürlük seçiniz",
            public: "Genel",
            private: "Gizli",
            includeExistingFilters: "Mevcut Filtreleri Dahil Et",
            includeSearchTerm: "Arama Kelimesini Dahil Et",
            includeSortOrder: "Sıralama Yönünü Dahil Et",
            includeGroupingSelection: "Gruplama Seçimini Dahil Et",
            saveFilter: "Filtreyi Kaydet",
            ban: "Yasakla",
            forwardToDepartmentAndAssign: "Departmana İlet ve Ata",
            storageSpace: "Depolama Alanı",
            cancelled: "İptal edildi",
            running: "Çalışıyor",
            paused: "Duraklatıldı",
            queued: "Kuyruğa alındı",
            scheduled: "Planlandı",
            searchItem: "Öğe ara",
            metaLead: "Meta Müşteri",
            agent: "Ajan",
            invoice: "Fatura",
            whatsapp: "WhatsApp",
            chatbot: "Sohbet Botu",
            webhook: "Webhook",
            table: "Tablo",
            tag: "Etiktet",
            low: "Düşük",
            lowest: "En Düşük",
            medium: "Orta",
            high: "Yüksek",
            highest: "En Yüksek",
            createDepartment: "Departman Oluştur",
            goToLink: "Linke Git",
            emailAddressYouProvide: "Belirttiğiniz e-posta adresiyle zaten bir kullanıcı hesabı oluşturulmuş.",
            channelPrivacyPolicyNotMet: "Kanal gizlilik politikasına uymuyor",
            userIsNotInDepartment: "Kullanıcı bu departman içinde bulunmuyor",
            currentDepartment: "Mevcut Departman",
            validDepartment: "Geçerli Departman",
            youCanForwardToThisDepartment: "Bu departmana yönlendirme yapabilirsiniz",
            goToSettings: "Ayarlara Git",
            changeDepartmentAndForward: "Departmanı Değiştir ve Yönlendir",
            selectDepartmentToForwardAgent:
                "Lütfen konuşmayı {selectAgentName} adlı temsilci için hangi departman üzerinden yönlendirmek istediğinizi seçiniz.",
            selectDepartmentToForward: "Yönlendirmek için Departman Seçin",
            packageConfirmationMessage:
                "Paket satın almak istediğinize emin misiniz? Aldığınız paket anlık ücrete tabidir. İptal ettiğinizde 1 yıl boyunca kullanmaya devam edebilirsiniz. Bu ürünün fiyatı %20 KDV harici fiyatıdır.",
            packagePurchaseConfirmation:
                "Paket satın almak istediğinize emin misiniz? Aylık alınan paketler, her ay başı ücretlendirilecektir. İptal ettiğiniz günden sonra paket kullanımı bitmektedir. Bu ürünün fiyatı %20 KDV harici fiyatıdır.",
            annualPurchaseDiscount: "Yıllık Satın Alımlarda %30 İndirim Fırsatını Yakala",
            customerTables: "Müşteri Tabloları",
            formIntegration: "Form Entegrasyonu",
            automationIntegration: "Otomasyon Entegrasyonu",
            remainingAutomationTask: "Kalan Otomasyon Görevi",
            createUserError: "Kullanıcı oluşturulurken bir hata oluştu",
            sendTemplateMessage: "Şablon Mesaj Gönder",
            startChatWithDifferentChannel: "Farklı Kanal ile Sohbet Başlat",
            whatsappChatStarter: "Whatsapp Chat Başlatıcı",
            pressEnterToJoin: "Enter tuşuna basarak sohbete katılabilirsiniz",
            pressEnterToStartChat: "Enter tuşuna basarak sohbet başlatabilirsin",
            cannotSendMessage: "Bu Kişiye Mesaj Gönderemezsiniz",
            cannotSendSessionMessage: "Bu kişiye oturum mesajı gönderemezsiniz",
            conversationNotInYourDepartments: "Bu konuşma dahil olduğunuz departmanlardan birine ait değil",
            customizeImage: "Görseli Özelleştirmek İstiyorsanız",
            clickToUpload: "Resim yüklemek için buraya tıklayın",
            uploadNote: "Yükleme için kabul edilen dosya formatları ve boyutları aşağıdaki gibidir",
            imageSize: "Resim 2 MB'dan büyük olduğu için yüklenemedi",
            videoSize: "Video 20 MB'dan büyük olduğu için yüklenemedi",
            documentSize: "Belge 2 MB'dan büyük olduğu için yüklenemedi",
            uploading: "Resim yükleniyor, lütfen bekleyin...",
            uploadSuccess: "Resim başarılı bir şekilde yüklendi",
            note: "Not",
            gridView: "Kutu Görünümü",
            completedTasks: "Tamamlanmış Görevler",
            system: "Sistem",
            destroyedBy: "Sohbeti Kapatan",
            channelCreatedSuccess: "Kanal başarıyla oluşturuldu",
            channelCreatedError: "Kanal oluşturma başarısız oldu",
            plans: {
                types: {
                    supsis: "Temsilci Paketleri",
                    chatbot: "Chatbot",
                    automation: "Otomasyon",
                    customer_tables: "Müşteri Tablosu",
                    mail: "E-Posta",
                    tasks: "Görevler",
                    form: "Form",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Yapay Zeka",
                    webhook: "Webhook",
                    telegram: "Telegram",
                    webphone: "Web Phone",
                },
            },
            vipCustomerDescription:
                "Bu kişiyi VIP müşteri olarak işaretlemek, bekleme sırasında en üst sıraya taşır ve öncelikli hizmet almasını sağlar",
            switchOn: "Açık",
            switchOff: "Kapalı",
            ownerDescription:
                "Bu özellik, bir kişinin sahibini belirtir. Kişi sahibinin durumu (çevrimiçi ya da çevrimdışı) fark etmeksizin, açılan sohbetler her zaman sahibine atanır. Sahipli kişiler yalnızca ilgili sahip tarafından görüntülenebilir.",
            permissionError: "Bu işlemi yapmaya yetkiniz yok!",
            copySuccess: "İçerik başarıyla kopyalandı!",
            unowned: "Sahipsiz",
            jsonPreview: "JSON ÖNİZLEME",
            enterNewValue: "Yeni değer girin",
            updatePreferredLanguage: "Tercih Edilen Dili Güncelle",
            updateTags: "Etiketleri Güncelle",
            updateEmail: "E-posta Güncelle",
            enterNewEmail: "Yeni e-posta girin",
            deleteConfirmation: "Silme Onayı",
            confirmDelete: "Bu özelliği silmek istediğinizden emin misiniz?",
            yesDelete: "Evet, Sil",
            vipCustomer: "★ VIP Müşteri",
            takeControlFromChatbot: "Chatbot'tan Kontrolü Al",
            enterJoin: "Enter tuşuna basarak sohbete katılabilirsiniz",
            watchChat: "Konuşmayı İzle",
            untitledAutomation: "👉 İsimsiz Profil Tıklama Otomasyonu",
            event: "Etkinlik",
            chatbotSettings: "Chatbot Yönlendirme Ayarları",
            chatbotScenarioNotFound: "Chatbot Senaryosu Bulunamadı",
            noChatbotScenario: "Sistem üzerinde bir chatbot senaryosu bulunamadı.",
            scenarioNotFound: "Senaryo bulunamadı",
            descNotAvailable: "Açıklama Bulunmuyor",
            lastRegulation: "Son Düzenleme",
            taskCreator: "Görevi Oluşturan",
            notAppointed: "Atanmadı",
            changeStage: "Aşama Değiştir",
            selectedCandidates: "1 seçilen aday(lar)",
            coverPhotoRemove: "Kapak Fotoğrafını Kaldır",
            coverPhotoSet: "Kapak Fotoğrafı Olarak Ayarla",
            autoTransfer: "Kişilerinizi Otomatik Zohoya Aktar",
            autoTransferDescription:
                "Bu kanala gelen kişiler Zoho CRM Contact Modülüne otomatik aktarılır. Zohoya aktarılan kişilerde Zoho widget'larını aktif eder.",
            zohoChannelRequiredTitle: "Zoho CRM Kanalı Gerekli",
            zohoChannelRequiredContent: "Zoho CRM kanalınız bulunmamaktadır. Hemen eklemek için tıklayınız.",
            okText: "Zoho CRM Kanalı Ekle",
            cancelText: "İptal",
            forceQueueForNoOwnerContacts: "Sahipsiz Kişileri Kuyrukta Beklemeye Zorla",
            autoForwardToOwnerForce: "Sahipli Kişileri Otomatik Sahibine Aktar (Chatbot Açıkken bile)",
            autoForwardToOwnerForceDescription:
                "Her durumda sahipli kişiler otomatik olarak sahibine aktarılır. Ne kuyrukta bekletilir nede chatbot chatbot'a aktarılır. Bu ayar kapalı bile olsa eğer sistemde chatbot aktif değilse yine sahibine aktarılır.",
            forceQueueDescription:
                "Sadece sahipli kişiler otomatik atanırken, sahipsiz kişileri kuyrukta bekletmeye zorlar.",
            showNoOwnerContactsToAdmins: "Sahipsiz Kişileri Sadece Adminlere Göster",
            showNoOwnerContactsDescription: "Sahipsiz kişiler sadece adminlere gözükür",
            autoAssignOwner: "Otomatik Kişi Sahiplendirme",
            autoAssignOwnerDescription: "Chat otomatik bir temsilciye atanırken aynı zamanda sahibi olarak da atanır.",
            creator: "Oluşturan",
            hideShow: "Gizle / Göster",
            url: "URL",
            dropdown: "Seçilebilir",
            selectRepresentativeChatbot: "Temsilci/Chatbot Seç",
            selectDomain: "Domain Seç",
            selectColumns: "Tabloda Görmek İstediğiniz Sütunları Seçiniz",
            cannedMessages: "Hazır Mesajlar",
            templateMessages: "Şablon Mesajlar",
            chatbots: "Chatbotlar",
            noCannedMessages: "Hazır Mesaj Bulunamadı",
            filterToFindMore: "Filtrelerinizi değiştirerek daha fazla hazır mesaj bulabilirsiniz.",
            runPrompt: "Prompt Çalıştır",
            noLeadsFound: "Bu kişi için lead bulunamadı",
            deals: "Anlaşmalar",
            noDealsFound: "Bu kişi için anlaşma bulunamadı",
            loadingDeals: "Anlaşmalar yükleniyor",
            salesOrders: "Satış Siparişleri",
            noSalesOrdersFound: "Bu kişi için satış siparişi bulunamadı",
            loadingSalesOrders: "Satış siparişleri yükleniyor",
            contacts: "Kişiler",
            noContactsFound: "Bu telefon numarası için kişi bulunamadı",
            loadingContacts: "Kişiler yükleniyor",
            zohoCRM: "Zoho CRM",
            viewContact: "İletişimi Görüntüle",
            noNotesAdded: "Henüz not eklenmemiş",
            attachments: "Ekler",
            addNewNote: "Yeni Not Ekle",
            savingg: "Kaydediliyor...",
            warningFillFields: "Lütfen başlık ve içerik alanlarını doldurun.",
            successNoteAdded: "Not başarıyla eklendi.",
            errorAddingNote: "Not eklenirken bir hata oluştu.",
            noteTitle: "Not Başlığı",
            noteContent: "Not İçeriği",
            selectPreferredAgent: "Ziyaretçiye atamak istediğiniz tercih edilen temsilciyi seçin.",
            postOperations: "Post Operasyonlar",
            loadingPostOperations: "Post operasyonlar yükleniyor",
            noPostOperations: "Bu kişi için post operasyon bulunamadı",
            postOperationDetails: "Post Operasyon Detayları",
            noMediaDocuments: "Bu kişiye ait medya ve belge mevcut değildir.",
            selectionLimitError: "En fazla 30 tane seçebilirsiniz.",
            showNote: "Notu Herkese Göster",
            hideNote: "Notu Gizle",
            updateNote: "Notu Güncelle",
            addUserNote: "Kullanıcı hakkında not ekle",
            privateNote: "Özel Not",
            metaReferrals: "Meta Referrals",
            noMetaReferrals: "Meta reklam etkileşimi bulunmamaktadır.",
            searchPrompt: "Bir Şeyler Arayınız.",
            noRecentResults: "Yakın zamanlarda bir sonuç bulunmadı.",
            contactInfo: "Kişi Bilgileri",
            noPropertiesAdded: "Henüz özellik eklenmemiş.",
            propertyAddedUpdated: "Özellik başarıyla eklendi/güncellendi.",
            propertyError: "Özellik eklenirken/güncellenirken bir hata oluştu.",
            propertyDeleted: "Özellik başarıyla silindi.",
            propertyDeleteError: "Özellik silinirken bir hata oluştu.",
            zohoSynchronization: "Zoho Senkronizasyonu",
            zohoSyncConfirmation: "Kişi değişiklik işlemlerini Zoho'da da yapmak istiyor musunuz?",
            hideOtherInfo: "Diğer Bilgileri Gizle",
            showOtherInfo: "Diğer Bilgileri Göster",
            whatsappChatStart: "WhatsApp Chat Başlat",
            ownership: "Müşteri Sahipliği",
            countryAndLanguage: "Ülke, Dil",
            calendarEvent: "Takvim Etkinliği",
            reservation: "Rezervasyon",
            contact: "İletişim",
            user: "Kullanıcı",
            customerOwnership: "Müşteri Sahipliği",
            ownerless: "Sahipsiz",
            preferredDepartment: "Tercih Edilen Departman",
            flowluTransfer: "Flowlu'ya Aktar",
            mergeSuccess: "Birleştirme işlemi başarıyla gerçekleştirildi.",
            visitorOwnershipWarning: "Bu ziyaretçi başka bir kullanıcının sahipliğinde.",
            newAutomation: "Yeni Otomasyon",
            automations: "Otomasyonlar",
            createProfileAutomation: "Profil Otomasyonu Oluştur",
            profileButtonClicked: "Profil butonuna tıklandı",
            profileButtonDescription: "Bu otomasyon, bir profil butonuna tıklandığında tetiklenecektir.",
            automationName: "Otomasyon adı",
            create: "Oluştur",
            dayRange: "Gün Aralığı",
            hourRange: "Saat Aralığı",
            last24Hours: "Son 24 Saat",
            today: "Bugün",
            yesterday: "Dün",
            thisWeek: "Bu hafta",
            lastWeek: "Geçen hafta",
            last7Days: "Son 7 gün",
            last30Days: "Son 30 gün",
            thisMonth: "Bu ay",
            lastMonth: "Geçen ay",
            startDateTime: "Başlangıç Tarih Saati",
            endDateTime: "Bitiş Tarih Saati",
            complaint: "Şikayet",
            opens: "Açılışlar",
            clicks: "Tıklamalar",
            mockData: "(Sahte Veri)",
            noGrouping: "Gruplama Yok",
            forwardToDepartment: "Departmana İlet",
            toMobileAgents: "Mobil Temsilciler",
            noMediaAndDocuments: "Bu kişiye ait medya ve belge mevcut değildir",
            reportBug: "Hata Raporla",
            waitingForReply: "Cevap Bekliyor",
            memorySize: "Bellek Boyutu",
            usedMemory: "Kullanılan Depolama",
            availableMemory: "Kullanılabilir Depolama",
            memoryLimit: "Aşım Miktarı",
            memoryLimitPrice: "Aşım Ücreti",
            telegramBotIsReachable: "Telegram Bot Servisine Ulaşılıyor",
            telegramBotIsHealthy: "Telegram Bot Servisine Sağlıklı",
            telegramBotIsUnhealthy: "Telegram Bot Servisinde Sorun Var",
            pieView: "Pasta Görünümü",
            chartView: "Grafik Görünümü",
            tableView: "Tablo Görünümü",
            lastUpdate: "Son Güncelleme",
            task: "Görev",
            filterBy: "Filtreye Göre",
            watchAllLive: "Tümünü Canlı İzle",
            sessionsUnique: "Oturumlar (Tekil Kullanıcılar)",
            sessionsAll: "Oturumlar (Tüm Kullanıcılar)",
            moreFeaturesDesc:
                "Daha fazla özellik, daha fazla entegrasyon, daha fazla temsilci! Ekibinizi daha iyi yönetmek ve işletmenizi maksimum potansiyeline ulaştırmak için şimdi harekete geçin!",
            metaLeadForms: "Meta Lead Formlar",
            metaLeadsConnectedSucs: "Meta Leads başarıyla bağlandı",
            failedToConnectMetaLeads: "Meta Potansiyel Müşterilere bağlanılamadı",
            forbiddenChannel: "Yasaklı Kanal",
            forbiddenChannelDesc: "Bu kanalı görmenize izin verilmiyor",
            firstContact: "İlk İletişim",
            needsAnalysis: "İhtiyaç Analizi",
            offerSent: "Teklif Gönderildi",
            offerReview: "Teklif İncelemesi",
            decisionPhase: "Karar Aşaması",
            personDeleted: "Kişi Silindi",
            metaLeadsIntegration: "Meta Leads Entegrasyonu",
            phoneNumberIsInvalid: "Telefon numarası geçersiz.",
            addAnItem: "Bir öğe ekleyin",
            saveItem: "Öğeyi Kaydet",
            customItem: "Özel Öğe",
            backgroundPhoto: "Arka Plan Resmi",
            whenYouActivateFeature: "Bu özelliği aktif ettiğiniz zaman rezervasyon sayfasında gözükmez",
            logo: "Logo",
            noLogo: "Logo Yok",
            addTeamMember: "Ekip Üyesi Ekle",
            timezone: "Zaman Dilimi",
            selectDayys: "Gün(ler) Seçin",
            selectStartHour: "Başlangıç Saatini Seçin",
            selectEndHour: "Bitiş Saatini Seçin",
            moveLeft: "Sağa Taşı",
            moveRight: "Sola Taşı",
            reply: "Cevap",
            replyToAll: "Herkese Cevapver",
            deleteThreadMessage: "Konu Mesajını Sil",
            totalEmailsBounced: "Geri Dönen Toplam E-posta",
            totalEmailsComplained: "Şikayet edilen toplam e-posta",
            untilNowTotalEmailOpens: "Şimdiye kadar toplam e-posta açılışı",
            untilNowTotalEmailLinkClicks: "Şimdiye kadar toplam e-posta bağlantısı tıklamaları",
            uniqueClicks: "Benzersiz Tıklamalar",
            untilNowTotalUniqueEmail: "Şimdiye kadar toplam benzersiz e-posta bağlantısı tıklamaları (alıcı başına)",
            emailCampaignTimeline: "E-posta Kampanyası Zaman Çizelgesi",
            receivedBroadcasts: "Alınan Yayınlar",
            groupDeletedSuccessfully: "Grup başarıyla silindi",
            verify: "Doğrula",
            done: "Bitti",
            pleaseSelectAnEmailAddress: "Lütfen bir mail adresi seçiniz.",
            goBack: "Geri Dön",
            show: "Göster",
            vueEmailEditor: "Vue E-posta Editörü (Demo)",
            saveDesign: "Tasarım Kaydet",
            exportHTML: "HTML dışa aktar",
            saveAsEmailCustomerGroup: "E-posta Müşteri Grubu Olarak Kaydet",
            saveAsWhatsappCustomerGroup: "Whatsapp Müşteri Grubu Olarak Kaydet",
            deleteModalFormDesc:
                "Bu formu sildiğiniz takdirde, forma ait tüm veriler kalıcı olarak silinecektir. Devam etmek istediğinizden emin misiniz?",
            todo: "Yapılacaklar",
            inProgress: "Devam Ediyor",
            approval: "Onay",
            completed: "Tamamlanmış",
            transactionType: "İşlem Tipi",
            previousBalance: "Önceki Bakiye",
            nextBalance: "Sonraki Bakiye",
            amount: "Tutar",
            wpIntegrationChannelRequired: "Whatsapp Web Entegrasyon Kanalı Gerekli.",
            wpIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Web entegrasyonu Whatsapp Web Kanalı gerektirir. Lütfen yeni bir kanal oluşturun.",
            wabaIntegrationChannelRequired: "Whatsapp Business Entegrasyon Kanalı Gerekli.",
            wabaIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Business API entegrasyonu Whatsapp Web Kanalı gerektirir. Lütfen yeni bir kanal oluşturun.",
            instaIntegrationChannelRequired: "Instagram Entegrasyon Kanalı Gerekli.",
            instaIntegrationChannelRequiredDesc:
                "Chatbot + Instagram entegrasyonu Instagram Kanalı gerektirir. Lütfen yeni bir kanal oluşturun.",
            createWpChannel: "Whatsapp Web Kanalı Oluştur",
            createWabaChannel: "Whatsapp Business API Kanalı Oluştur",
            createInstaChannel: "Instagram Kanalı Oluştur",
            failedToDeleteGroup: "Grup silinemedi",
            failedToDeleteGroups: "Gruplar silinemedi",
            failedToFetchGroupContacts: "Grup kişileri getirilemedi",
            mailAddressDeletedSuccessfully: "Posta Adresi Başarıyla Silindi",
            defaultMailAddressChangedSuccessfully: "Varsayılan posta adresi başarıyla değiştirildi",
            mailAddressAlreadyRegistered: "Mail adresi zaten kayıtlı veya boş olamaz.",
            pleaseVerifyByClicking: "Mail adresinize gönderilen linke tıklayarak doğrulama yapınız.",
            signSucsRegistered: "İmza başarıyla kaydedildi",
            myContacts: "Kişilerim",
            unanswered: "Cevapsız",
            emailBroadcasts: "Toplu e-mail gönderimleri",
            monthlyLimit: "Aylık Limit",
            totalShipments: "Toplam Gönderim",
            shippingStatus: "Gönderim Durumu",
            lastAction: "Son İşlem",
            receiver: "Alıcı",
            delivered: "Teslim Edildi",
            opened: "Açıldı",
            clicked: "Tıklandı",
            bounced: "Geri Döndü",
            clickedLinks: "Tıklanan Linkler",
            reason: "Sebep",
            timer: "Zamanlayıcı",
            implemented: "Uygulandı mı?",
            module: "Modül",
            excelDownload: "Excel İndir",
            serviceFeatures: "Hizmet Özellikleri",
            mailAddressDeletedSucs: "Mail adresi başarıyla silindi",
            inputSearchText: "Arama metni girin",
            createRecord: "Kayıt Oluştur",
            separatorCharacter: "Ayırıcı Karakter",
            exampleResultPreview: "Örnek Sonuç Önizlemesi",
            importRecords: "Kayıtları İçe Aktar",
            equals: "Eşit",
            notEquals: "Eşit Değil",
            startsWith: "İle Başlar",
            endsWith: "İle Biter",
            greaterThan: "Daha Fazla",
            lessThan: "Daha Az",
            before: "Önce",
            after: "Sonra",
            is: "Eşittir",
            isNot: "Eşit Değildir",
            empty: "Boş",
            notEmpty: "Boş Değil",
            isOneOf: "Şunlardan biri",
            between: "Arasında",
            field: "Alan",
            records: "Kayıt",
            addIntegration: "Entegrasyon Ekle",
            chatbotScenarioReleased: "Chatbot Senaryosu yayınlandı",
            chatbotScenarioHasBeenCanceled: "Chatbot Senaryosu yayından kaldırıldı",
            titleAndDesc: "Başlık & Açıklama",
            templateAndMailSelection: "Template & Mail Seçimi",
            peopleToSend: "Gönderilicek Kişiler",
            submissionPlans: "Gönderim Planı",
            summary: "Özet",
            broadcastTitle: "Yayın Başlığı",
            sentByEmail: "Gönderilen Email",
            emailTemplate: "Email Taslağı",
            onlyPeopleWithEmail: "Sadece Mail adresi olan kişiler gönderim için geçerlidir.",
            sendNow: "Şimdi Gönder",
            plan: "Planla",
            senderEmail: "Gönderen E-Posta",
            totalBuyer: "Toplam Alıcı",
            estimatedDuration: "Tahmini Süre",
            person: "Kişi",
            shippingIsNowComplete: "Gönderim işlemi tamamlandı!",
            back: "Geri",
            customerName: "Müşterinin İsmi",
            customerEmail: "Müşterinin Emaili",
            customValue: "Özel Değer",
            selectMailTemplate: "Mail şablonu seçmelisiniz.",
            youMustSelectSendingMailAddress: "Gönderen mail adresi seçmelisiniz.",
            youMustSelectCustomerGroupSend: "Gönderilecek müşteri grubunu seçmelisiniz.",
            createBroadcast: "Toplu Gönderim Oluştur",
            broadcastDetails: "Toplu Gönderim Detayları",
            youCanCheckYourEmailStatus:
                "Paketinizi yükselterek e-posta durumunuzu kontrol edebilirsiniz. Planınızı yükselterek e-posta durumunuzu kontrol edebilirsiniz.",
            sentDetails: "Gönderilen detaylar",
            failed: "Başarısız oldu",
            total: "Toplam",
            totalEmailsProcessed: "İşlenen toplam e-posta",
            totalEmailsDelivered: "Gönderilen toplam e-posta",
            toAvailableAgents: "Mevcut Temsilciler için",
            toAvailableDepartments: "Mevcut Departmanlar için",
            toWithAgentAndDepartment: "Temsilci ve Departman ile",
            toMobilAgents: "Mobil Temsilcilere",
            toPreferredAgents: "Tercih Edilen Temsilcilere",
            searchAgent: "Temsilci Ara",
            searchDepartment: "Departman Ara",
            searchMobileAgent: "Mobil Temsilci Ara",
            searchAgentOrDepartment: "Temsilci veya departman arayın",
            searchPreferredAgent: "Tercih edilen Temsilciyi arayın",
            noAgentsAvailableToForward: "İletmek için uygun temsilci yok",
            noDepartmentsAvailableToForward: "İletmek için uygun Departman yok",
            checkChannelVisibilityTitle: "Kanal gizlilik ayarlarınızı kontrol ediniz",
            checkChannelVisibilityDescription:
                "Göremediğiniz departmanlar var ise kanal gizlilik ayarlarını kontrol ediniz",
            goToChannelSettings: "Kanal ayarlarına git",
            noMobileAgentsAvailableToForward: "İletmek için Uygun Mobil Temsilci yok",
            noPreferredAgentsAvailableToForward: "İletmek için tercih edilen Temsilci yok",
            ifYouSendThisConversationToTheQueue:
                "Bu görüşmeyi kuyruğa gönderirseniz, sizi sohbetten çıkaracak ve görüşmeyi kuyruğa yerleştirecektir. Otomatik sohbet ataması etkinleştirilmişse, görüşme uygun bir temsilciye atanacak ve size geri aktarılabilir.",
            ifAutomaticChatAssignmentIsDisabled:
                "Otomatik sohbet ataması devre dışı bırakılmışsa, görüşme kuyrukta kalacaktır. Yetkili personel, görüşmeyi kuyruktan alabilir.",
            sendQueue: "Kuyruğa Gönder",
            agentName: "Temsilci Adı",
            departmentName: "Departman Adı",
            toQueue: "Kuyruğa",
            selectTimezone: "Saat dilimini seçin",
            userFilter: "Kullanıcı Filtre",
            confidenceScore: "Güven Puanı",
            chatbotLanguage: "Chatbot Dili",
            botScenerio: "Bot Seneryosu",
            selectTemplate: "Şablon Seçiniz",
            importFromReadyTemplates: "Hazır Şablonlardan İçe Aktar",
            classification: "Sınıflandırma",
            addClassification: "Sınıflandırma Ekle",
            expressionClassified: "Sınıflandırılacak Ifade",
            zohoModuleName: "Zoho Modül Adı",
            selectModule: "Modül Seç",
            standardFields: "Standart Alanlar",
            selectStandardField: "Standart Alan Seç",
            customFields: "Özel Alanlar",
            selectCustomFields: "Özel Alan Seç",
            aiFunction: "Yapay Zeka Fonksiyonu",
            aiFunctionDesc: "Kullanıcı girdilerine dayalı eylemler gerçekleştirmek için yapay zeka işlevini yönetin.",
            aiClassificationTextMode: "Metin Sınıflandırma",
            aiClassificationImageMode: "Görüntü Sınıflandırma",
            aiClassificationImageUrlLabel: "Sınıflandırılacak Görsel (URL)",
            aiClassificationImageUrlPlaceholder: "https://... şeklinde bir görsel adresi giriniz",
            functionName: "Fonksiyon Adı",
            functionDesc: "Fonksiyon Açıklaması",
            addParameter: "Parametre Ekle",
            chooseAiStory: "Bir yapay zeka hikayesi seçin",
            chatbotAiPromptDesc:
                " Yapay zeka, 'prompt' özelliğini kullanarak belirli bir görev veya sorun hakkında talimatlar verilerek öğrenir ve nasıl davranması gerektiğini belirler.",
            enterPrompt: "Prompt girin.",
            aiParameterTunings: "AI Parametre Ayarları",
            aiParameterTuningsDesc:
                "Yapay zekayı daha duyarlı ve doğru hale getirmek için yapay zeka parametrelerini ayarlayabilirsiniz. Bu parametreler YZ'nin davranışını ve kullanıcı girdilerine nasıl yanıt verdiğini kontrol etmek için kullanılır.",
            temperature: "Sıcaklık",
            temperatureDesc:
                "Hangi örnekleme sıcaklığının kullanılacağı, 0 ile 2 arasında. 0,8 gibi daha yüksek değerler çıktıyı daha rastgele hale getirirken, 0,2 gibi daha düşük değerler daha odaklı ve deterministik hale getirecektir.",
            topDesc:
                "Çekirdek örnekleme olarak adlandırılan sıcaklıkla örneklemeye alternatif olarak model, en üst_p olasılık kütlesine sahip belirteçlerin sonuçlarını dikkate alır. Yani 0.1, yalnızca en üst %10 olasılık kütlesini içeren belirteçlerin dikkate alındığı anlamına gelir. Genellikle bunu veya sıcaklığı değiştirmenizi öneririz, ancak ikisini birden değil.",
            toolChoices: "Araç Seçenekleri",
            noneDesc:
                "Yok, modelin herhangi bir aracı çağırmayacağı ve bunun yerine bir mesaj oluşturacağı anlamına gelir",
            autoDesc:
                "Otomatik mod varsayılan değerdir ve modelin bir mesaj oluşturma veya bir ya da daha fazla aracı çağırma arasında seçim yapabileceği anlamına gelir.",
            requiredDesc:
                "Gerekli mod, modelin kullanıcıya yanıt vermeden önce bir veya daha fazla aracı çağırması gerektiğidir",
            createArticles: "Makale Oluştur",
            createArticlesDesc: "Kullanıcılarınızın sorularına yanıt bulmalarına yardımcı olacak makaleler oluşturun.",
            articlesTitle: "Makale Başlığı",
            articlesContent: "Makale İçeriği",
            createFaq: "Sıkça Sorulan Sorular (SSS) oluşturun",
            createFaqDesc:
                "Sohbet botunuz için yeni bir SSS oluşturun. Bu, sohbet robotunuzun kullanıcının sorularını yanıtlamasına yardımcı olacaktır.",
            question: "Soru",
            saveAndClose: "Kaydet ve Kapat",
            contentPreview: "İçerik önizleme",
            updateChannelDesc6: "Whatsapp business api kanalını güncelleyin",
            newWabaChannel: "Yeni Whatsapp Business Kanalı",
            newWabaChannelDesc: "Whatsapp business api için yeni bir kanal oluşturun",
            upgradePackageTitle: "Paketinizi Yükseltip Limitlerden Kurtulun",
            upgradePackageDescription:
                "Daha fazla özellik, daha fazla entegrasyon, daha fazla temsilci! Ekibinizi daha iyi yönetmek ve işletmenizi maksimum potansiyeline ulaştırmak için şimdi harekete geçin!",
            upgradePackage: "Yükselt",
            deleteFiles: "Dosyaları Sil",
            sureDeleteMultipleFiles: "Seçili dosyaları silmek istediğinize emin misiniz?",
            selectAll: "Hepsini Seç",
            cancelSelection: "Seçimi iptal et",
            deleteSelected: "Seçili dosyaları sil",
            newFolder: "Yeni Klasör",
            newFile: "Yeni Dosya",
            noFilesFound: "Bu klasörde dosya bulunamamıştır",
            uploadFile: "Dosya Yükle",
            enterFolderName: "Lütfen Klasör Adını Giriniz",
            folderName: "Klasör Adı",
            dropFileHere: "Dosyaları buraya bırakın",
            createFolder: "Klasör Oluştur",
            fileUploadingError: "Dosya yüklenirken bir hata oluştu",
            fileUploadingSucs: "Klasör başarıyla oluşturuldu",
            folderNameNotEmpty: "Klasör adı boş olamaz",
            deleteFolder: "Klasörü Sil",
            sureDeleteFolder: "Bu klasörü ve içindeki tüm dosyaları silmek istediğinize emin misiniz?",
            deletionSucs: "Silme işlemi başarılı",
            deleteFile: "Dosyayı Sil",
            sureDeleteFile: "Bu dosyayı silmek istediğinize emin misiniz?",
            deletionError: "Silme işlemi sırasında bir hata oluştu",
            selectFile: "Dosya Seç",
            moreThanOneSelect: "Birden fazla dosya seçebilirsiniz",
            selectAnFile: "Bir dosya seçin",
            bulkSms: "Toplu SMS",
            sendBulkSmsCustomers: "Müşterilerinize toplu SMS gönderin",
            writeYourMessage: "Mesajınızı Buraya Yazın.",
            sendSms: "SMS Gönder",
            sendSmsYourCustomers: "Müşterilerinize sms gönderin",
            manageChannelDetail: "Kanal bilgilerini yönetin",
            details: "Detaylar",
            teamGramChannels: "TeamGram Kanalları",
            newTeamGramIntegration: "Yeni TeamGram Entegasyonu",
            teamGramIntegration: "TeamGram Entegrasyonu",
            notMoreThanOneTeamGramChannels: "Birden fazla TeamGram Kanalı oluşturamazsınız",
            teamGramDetail: "TeamGram Detayı",
            manageYourTeamGramIntegration: "TeamGram Entegrasyonunuzu Yönetin",
            trendyolChannels: "Trendyol Kanalları",
            trendyolStoreIntegration: "Trendyol Mağaza Entegrasyonu",
            trenyolStoreConnection: "Trendyol mağazınızı bağlayın.",
            deleteTrendyolIntegration: "Trendyol Entegrasyonu sil",
            sureDeleteTrendyolIntegration:
                "Trendyol entegrasyonunu silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
            trendyolStoreChannel: "Trendyol Mağaza Kanalı",
            deleteTrendyolChannel: "Trendyol Kanalını sil",
            channelUpdatedSucs: "Kanal Başarıyla Güncellendi.",
            failedUpdateChannel: "Kanal Güncellenemedi.",
            trendyolStoreIntegrationDetail: "Trendyol Mağaza Entegrasyon Detayı",
            configureTrendyolStoreIntegrationDetail: "Trendyol Mağaza Entegrasyonuzu Yapılandırın",
            trenyolStoreProductQuestManage: "Trendyol Mağaza - Ürün Soruları Yönetimi",
            trendyolStoreDesc:
                "Trendyol mağaza ürünlerine gelen soruları yönetmek için aşağıdaki ayarları kullanabilirsiniz.",
            zohoCrmChannels: "Zoho CRM Kanalları",
            zohoPersonalChannel: "Zoho Kişisel Kanallar",
            connectZoho: "Zoho CRM'e bağlan",
            updateChannelDesc5: "Zoho CRM Kanalını Güncelleme",
            zohoCrmIntegration: "Zoho CRM Entegrasyonu",
            sureDeleteZohoChannel: "Zoho CRM kanalını silmek istediğinizden emin misiniz?",
            createNotMoreThanOneZohoChannels: "Birden fazla Zoho Kanalı oluşturamazsınız",
            removeZohoLink: "Zoho Bağlantısını Kaldır",
            connectToZoho: "Zohoya Bağlan",
            chatClosed: "Chat kapandı",
            scoreChat: "Chat puanlandı",
            createdTicket: "Ticket oluşturuldu",
            updatedTicket: "Ticket güncellendi",
            newUserCreated: "Yen kullanıcı oluşturuldu",
            updateUser: "Kullancı güncellendi",
            deleteUsers: "Kullancı silindi",
            changeStatusRepresent: "Temsilci durumu değişti",
            incomingMessage: "Gelen Mesaj",
            outgoingMessage: "Giden Mesaj",
            createdNewTicket: "Yeni Ticket Oluştu",
            bitrix24Channels: "Bitrix24 Kanalları",
            sureDeleteBitrixChannel: "Bitrix24 kanalını silmek istediğinizden emin misiniz?",
            bitrix24Integrations: "Bitrix24 Entegrasyonu",
            notCreateMoreThenOneChannel: "Birden fazla Ideasoft kanalı oluşturamazsınız",
            connectToBitrix24: "Bitrix24'e Bağlanın",
            connectToBitrix24Api: "Bitrix24 Api'e Bağlanın",
            updateChannel: "Kanalı Güncelle",
            updateChannelDesc: "Bitrix24 Api kanalını güncelle",
            yourBitrix24Domain: "Bitrix24 Alan Adınız",
            bitrix24ConnectedSucs: "Bitrix24 başarıyla bağlandı",
            failedToConnectBitrix24: "Bitrix24'e bağlanılamadı",
            channelCreatedSuccessfully: "Kanal başarıyla oluşturuldu",
            failedToCreateChannel: "Kanal oluşturulamadı",
            holidayPlusChannels: "Holiday+ Kanalları",
            newHolidayPlusIntegration: "Yeni Holiday+ Entegrasyonu",
            holidayPlusIntegrations: "Holiday+ Entegrasyonu",
            notCreateMoreThanOneHolidayChannel: "Birden fazla Holiday+ Kanalı oluşturamazsınız",
            holidayPlusDetail: "Holiday+ Detay",
            manageHolidayPlusIntegration: "Holiday+ Entegrasyonunuzu Yönetin",
            ideasoftChannels: "Ideasoft Kanalları",
            connectToIdeasoft: "Ideasoft'a Bağlanın",
            connectToIdeasoftApi: "Ideasoft api'ye bağlanın",
            updateChannelDesc2: "Whatsapp business api kanalını güncelleyin",
            ideasoftIntegration: "Ideasoft Entegrasyonu",
            sureDeleteIdeasoftChannel: "Ideasoft kanalını silmek istediğinizden emin misiniz?",
            moreThanOneChannelError: "Birden fazla Ideasoft Kanalı oluşturamazsınız",
            websiteAddress: "Website Adresi",
            ideasoftConnectedSucs: "Ideasoft başarıyla bağlandı",
            failedToConnectIdeasoft: "Ideasoft'a bağlanılamadı",
            redirectURLcopiedToClipboard: "Panoya kopyalanan URL'yi yeniden yönlendirme",
            openAIChannels: "OpenAI Kanalları",
            newOpenAiChannel: "Yeni OpenAI kanalı",
            createNewChannelOpenAi: "OpenAI için yeni bir kanal oluşturun",
            updateChannelDesc3: "Whatsapp business api kanalını güncelleyin",
            openAiIntegration: "OpenAI Entegrasyonu",
            sureDeleteOpenAiChannel: "OpenAI kanalını silmek istediğinizden emin misiniz?",
            createMoreThenOneOpenAiChannel: "Birden fazla OpenAI Kanalı oluşturamazsınız",
            postaCellChannels: "PostaCell Kanalları",
            newPostaCellChannel: "Yeni PostaCell Kanallar",
            createNewPostaCellChannel: "PostaCell sms sağlayıcısı için yeni bir kanal oluşturun",
            updateChannelDesc4: "Whatsapp business api kanalını güncelleyin",
            accessControl: "Erişim Kontrolü",
            leads: "Leadler",
            ensureFacebookAccount: "Facebook hesabı ve sayfası olduğundan emin olun",
            ensureAdAccount: "Reklam hesabına sahip olduğundan emin olun",
            page: "Sayfa",
            questions: "Sorular",
            leadCount: "Lead Sayısı",
            showLeads: "Lead'leri Göster",
            syncLeeds: "Leedleri senkronize et",
            wpStartChat: "Whatsapp Chat Başlatıcı",
            archivedIn: "Arşivlenmiş mi?",
            makeSelect: "Seçim Yap",
            newLead: "Yeni Leed",
            initalContact: "İlk İletişim",
            needsAssessnment: "İhtiyaç Analizi",
            proposalSent: "Teklif Gönderildi",
            proposalReview: "Teklif İncelemesi",
            negotiation: "Pazarlık",
            decisionStage: "Karar Aşaması",
            closure: "Kanapnış",
            followUp: "Takip",
            campagin: "Kampanya",
            adSet: "Reklam Seti",
            ad: "Reklam",
            inArchived: "Arşivlendi",
            deletedSelectedPerson: "Seçili Kişileri sil",
            sureDelSelectedPerson: "Seçili Kişileri silmek istediğinizden emin misiniz?",
            deletePerson: "Kişiyi Sil",
            sureDeletePerson: "Kişiyi silmek istediğinizden emin misiniz?",
            phoneNumberNotAvailable: "Telefon numarası mevcut değil",
            statusSucsUpdated: "Durum başarıyla güncellendi",
            statusUpdatedFailed: "Durum güncellenirken bir hata oluştu",
            archivedContact: "Kişiyi arşivle",
            sureWantArchivePerson: "Bu kişiyi arşivlemek istediğinizden emin misiniz?",
            personArchived: "Kişi Arşivlendi",
            personArchivedHead: "Arşivleme işlemi başarısız oldu",
            metaLeadChannels: "Meta Lead Kanalları",
            wpStartSpeech: "Whatsapp Konuşma Başlatıcı",
            pleaseSelectStartChat: "Lütfen sohbeti başlatmak istediğiniz kanalı seçin:",
            phoneNumber: "Telefon Numarası",
            phoneNumberDesc: "Ülke kodu ile birlikte boşluk girmeden sadece rakamlar ile",
            channelDesc: "Hangi kanal üzerinden chat başlatmak istiyorsunuz",
            pleaseSelectStartChatOn: "Lütfen sohbeti başlatmak istediğiniz kanalı seçin",
            notAuthorizedChannel: "Bu kanala erişim yetkiniz yok.",
            phoneNumberError: "Telefon Numarası Hatalı",
            chatStartError: "Sohbet başlatılırken bir hata oluştu. Lütfen tekrar deneyin.",
            noRecordFailed: "Kayıt bulunamadı",
            metaLeadsChannel: "Meta Leads Kanalı",
            mlChannelDetails: "Meta Leads Kanal Detayları",
            manageMlChannel: "Meta Leed'lerinizi Yönetin",
            deleteMetaLeadsChannelInfo: "Meta Leads kanalını silmek istediğinizden emin misiniz?",
            contactPage: "İletişim Sayfası",
            addRouted: "Yönlendirilmiş Ekle",
            otherEmailProviders: "Diğer E-posta Sağlayıcıları",
            visitorScreenNaming: "Visitor Ekranı İsimlendirme",
            enterCatalogTitle: "Katolog Başlığı giriniz...",
            passwordUpdate: "Şifre Güncelle",
            showCenterScreen: "Ekranın Ortasında Göster",
            skipNow: "Hemen Atla",
            confirm: "Onaylayın",
            newTable: "Yeni Tablo",
            actions: "İşlemler",
            integrationsTrendyol:
                "Trendyol mağazanızı bağlayın ve müşterilerinizin sorularını otomatik olarak yanıtlayın.",
            integrationsHoliday: "Chatbot üzerinden otel ve oda sağlamak için Holiday+ entegrasyonunu yapın!",
            integrationsTeamgram:
                "Müşteri yönetiminizi kolaylaştırmak için müşterilerinizi Supsis'ten Teamgram'a aktarın!",
            integrationsTicimax: "Segmentlere ayrılmış Ticimax üyelerine otomatik mesaj gönderin.",
            integrationsBitrix24:
                "Müşterilerinize gelişmiş bir chatbot deneyimi sunmak için Bitrix24 API'yi aktifleştirin.",
            integrationsIdeasoft:
                "Müşterilerinize gelişmiş bir chatbot deneyimi sunmak için Ideasoft API'yi aktifleştirin.",
            integrationsOpenAI:
                "OpenAI Hizmetlerini Aktifleştir, Chatbot AI Yanıtı, AI Asistanı CoPilot, Chatbot AI Bilgi Tabanı.",
            integrationsSMSPostacell: "PostaCELL SMS Sağlayıcısı ile SMS gönderme özelliğini etkinleştirin.",
            integrationsMetaLeads:
                "Meta Müşterilerinizi Supsis ile etkili bir şekilde yönetin. Müşterilerinizi Ticket, Chatbot veya Canlı Destek ile entegre edin.",
            integrationsZoho: "Zoho CRM'deki iş süreçlerinizi Supsis ile entegre edin.",
            integrationsYouTubeComments:
                "YouTube yorumlarını tek panelden yönetin ve müşterilerinizle etkileşim kurun.",
            integrationsGoogleBusinessReviews:
                "Google Business yorumlarını tek panelden yönetin ve müşterilerinizle etkileşim kurun.",
            integrationsGooglePlayReviews:
                "Google Play Store uygulama yorumlarını tek panelden yönetin ve kullanıcılarınızla etkileşim kurun.",
            integrationsAppStoreReviews:
                "App Store uygulama yorumlarını tek panelden yönetin ve kullanıcılarınızla etkileşim kurun.",
            integrationsGoogleDrive: "Google Drive dosyalarınızı Supsis içinden yönetin ve sohbetlerde paylaşın.",
            integrationsPage: {
                compare: "Kıyasla",
                dead: "Dead",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "Instagram Login ile direkt bağlantı. Facebook hesabına gerek yok.",
                messenger: "Messenger",
                linkedin: "Linkedin",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "YouTube Comments",
                googleBusinessReviews: "Google Business Reviews",
                googlePlayReviews: "Google Play Reviews",
                appStoreReviews: "App Store Reviews",
                googleDrive: "Google Drive",
                webTabs: "Web Sekmeler",
                webTabsDesc: "Sidebar menüye özel sekmeler ekleyerek dış uygulamaları Supsis içinde açın",
                webApps: "Web Apps",
                webAppsDesc: "Kendi web uygulamalarınızı yükleyin ve yönetin",
                mail: "Mail",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc:
                    "Ticimax mağaza bilgilerinizi Supsis üzerinden kolayca yönetmenizi ve müşterilerinize anlık yanıtlar vermenizi sağlar.",
                tsoft: "T-SOFT",
                tsoftDesc: "T-SOFT Mağzanızı Siparişlerinizi ve kargo durumlarını SUPSIS AI ile kolayca yönetin.",
                ikas: "IKAS",
                ikasDesc: "Ikas Mağzanızı Siparişlerinizi ve kargo durumlarını SUPSIS AI ile kolayca yönetin.",
                cacheManager: "Cache Manager",
                cacheManagerDesc: "Otomasyon ve chatbot'lar arası veri paylaşımı için cache yönetimi",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Meta Leads",
                voice: "Ses",
                webphoneRedsantral: "Webphone (Kırmızı Santral)",
                webphoneRedsantralDesc: "Web tabanlı telefon sistemi entegrasyonu",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "Global arama yapabilmek için Telnyx entegrasyonu",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "NetGSM santral sistemi ile web tabanlı telefon entegrasyonu",
                aiVoiceAgent: "AI Voice Agent",
                aiVoiceAgentDesc:
                    "Telefonlarınızı sesli yapay zeka asistanı ile yönetin. Ayrıca web sitesinize sesli asistan entegre edebilirsiniz.",
                artificialIntelligenceFallback: "Yapay Zeka",
                openRouter: "OpenRouter",
                openRouterDesc: "Tüm LLM modellerine tek API ile erişim",
                openAIDesc: "GPT-4, GPT-4o ve ChatGPT modelleri",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "Gemini modelleri",
                anthropic: "Anthropic",
                anthropicDesc: "Claude 3.5 Sonnet ve Claude modelleri",
                mistral: "Mistral",
                mistralDesc: "Mistral Large ve diğer modeller",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "Azure OpenAI servisleri",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "AWS LLM platformu",
                cohere: "Cohere",
                cohereDesc: "Command R+ ve NLP modelleri",
                xai: "xAI",
                xaiDesc: "Grok modelleri",
                deepInfra: "DeepInfra",
                deepInfraDesc: "LLM inference altyapısı",
                together: "Together",
                togetherDesc: "Açık kaynak LLM servisleri",
                fireworks: "Fireworks",
                fireworksDesc: "Hızlı LLM inference",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "AI model platformu",
                parasail: "Parasail",
                parasailDesc: "LLM API servisi",
                nebius: "Nebius",
                nebiusDesc: "Cloud AI altyapısı",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "Qwen modelleri",
                xiaomi: "Xiaomi",
                xiaomiDesc: "MiLM modelleri",
                sambaNova: "SambaNova",
                sambaNovaDesc: "AI donanım ve yazılım",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "Kimi modelleri",
                minimax: "Minimax",
                minimaxDesc: "Abab modelleri",
                nvidia: "NVIDIA",
                nvidiaDesc: "NVIDIA NIM modelleri",
                whatsappComparisonTitle: "WhatsApp Çözümleri Karşılaştırması",
            },
            forward: "İleri",
            trendyol: "Trendyol",
            packUpRequired: "Paket Yükseltimi Gerekli",
            upgradePack: "Paket Yükselt",
            supsisMobilApp: "SUPSIS MOBİL APP",
            supsisMobilAppDesc: "IOS ve Android Uygulaması Marketlerde!",
            sendEmail: "Email Gönder",
            jumpToMessage: "Mesaja gitmek için tıklayınız",
            doesntMatter: "Farketmez",
            designer: "Tasarım",
            targetContacts: "Hedef Kişiler",
            scheduler: "Zamanlayıcı",
            planAndTask: "Çalışma Planı",
            insights: "Öngörüler",
            createRole: "Rol Oluştur",
            noRole: "Rol atanmamış",
            addUserToRole: "Role kullanıcı ekle",
            moveToRole: "Başka role taşı",
            noUsersInRole: "Bu rolde kullanıcı yok",
            removeUserFromRole: "Kullanıcıyı rolden çıkar",
            removeUserFromRoleConfirm: " kullanıcısını bu rolden çıkarmak istediğinize emin misiniz?",
            selectNewRole: "Yeni rol seçin",
            selectRole: "Rol seçin",
            roleUsersUpdated: "Kullanıcılar güncellendi",
            userNotFound: "Kullanıcı bulunamadı",
            unnamed: "İsimsiz",
            createSubject: "Konu Oluştur",
            createUser: "Kullanıcı Oluştur",
            blockManuel: "Manuel Blok",
            showHide: "Göster/Gizle",
            contactSearch: "Kullanıcı Ara",
            favorites: "Favoriler",
            downloadAllData: "Tüm Verileri İndir",
            downloadThePage: "Sayfayı İndir",
            choosePoints: "Puan Seç",
            createdAt: "Oluşturulan",
            action: "Aksiyon",
            searchChannel: "Kanal Ara",
            activeChannels: "Aktif Kanallar",
            deleteChannels: "Silinen Kanallar",
            selectChannel: "Kanal Seç",
            channelFilter: "Kanal Filtresi",
            noConversationDesc: "Burada aktif sohbetleri ve size atanmış sohbetleri görebilirsiniz.",
            forMe: "Bana Özel",
            unAssigned: "Atanmamış",
            agentDetails: "Temsilci Detayları",
            contactProperties: "Kullanıcı Değerleri",
            goToProfile: "Profile Git",
            addNote: "Not Ekle",
            noPreferredAgent: "Henüz Tercih Edilen Bir Temsilci Yok",
            toPrefer: "Tercih Et",
            inChat: "Sohbette",
            watching: "İzliyor",
            chatsTitle: "Sohbetler",
            dealyTimeMaxValueError: "Gecikme süresi en fazla 15 olabilir",
            dealyTimeTypeError: "Gecikme süresi sayı olmalı",
            passedTimeHm: "{hour} Saat {min} Dakika",
            passedTimeMs: "{min} Dakika {sec} saniye",
            passedTimeSc: "{Sec} Saniye",
            translateMessage: "Mesajınız yapay zeka tarafından çevrilmiştir.",
            toneChanged: "Mesaj tonu {tone} olarak değiştirildi",
            aiResponseAdded: "Yapay Zeka Yanıtı Mesaja Eklendi",
            messageLonger: "Mesaj Daha Uzun Hale Getirildi",
            grammarFixed: "Yazım Düzeltildi",
            aiTranslate: "Çeviri",
            other: "Diğer",
            yourLanguage: "Sizin diliniz",
            contactLanguage: "Müşteri Dili",
            myLanguage: "Benim dilim",
            forwardToChatbot: "Chatbota İlet",
            friendly: "Dostça",
            confident: "Kararlı",
            straightForward: "Basit",
            casual: "Gündelik",
            professional: "Profesyonel",
            longSentence: "Uzun Cümle",
            changeTone: "Tonu Değiştir",
            fixGrammar: "Yazım Düzelt",
            aiResponse: "Yapay Zeka Yanıtı",
            templateButtonNote:
                "Kişiyi yasaklamak için, büyük veya küçük harf fark etmeksizin yasaklama düğmesinde aşağıdaki metinleri kullanmaya dikkat edin. ",
            templateButtonTags: "#Mesaj Gönderme# | #Abonelikten Çıkar# | #Yasakla# | #Engelle#",
            dashboard: "Kontrol Paneli",
            adminReports: "Admin Raporları",
            calendarModule: "Takvim Modülü",
            taskModule: "Görev Yönetim Modülü",
            maxUrlButtonMessage: "En fazla 2 adet url buton ekleyebilirsiniz.",
            noPreferredDepartment: "Tercih Edilen Departman Yok",
            searchForDepartment: "Departman Ara",
            departmentAssignedToTheVisitor: "Ziyaretçiye atamak istediğiniz departmanı seçin.",
            assignPreferredDepartment: "Tercih Edilen Departmana Ata",
            smsChannel: "Sms Kanalı: ",
            whatsappv1Channel: "Whatsapp V1 Kanalı: ",
            whatsappv2Channel: "Whatsapp V2 Kanalı: ",
            whatsappv3Channel: "Whatsapp V3 Kanalı: ",
            wBChannel: "Whatsapp Business Kanalı: ",
            linkedinChannel: "Linkedin Kanalı: ",
            telegramChannel: "Telegram Kanalı: ",
            messengerChannel: "Messenger Kanalı: ",
            instagramChannel: "İnstagram Kanalı: ",
            allPlatforms: "Tüm Platformlar",
            cbStartMessageDesc:
                "Kullanıcının girdiği ilk mesaj, chatbot tarafından otomatik olarak işlenerek ilgili adrese yönlendirilsin.",
            cbStartMessage: "Chatbot Başlangıç Mesajı",
            messengerUserProfile: "Messenger Kişi Profili",
            instagramUserProfile: "Instagram Kişi Profili",
            linkedinUserProfile: "Linkedin Kişi Profili",
            telegramUserProfile: "Telegram Kişi Profili",
            noEventFound: "Etkinlik Bulunamadı",
            visitorMails: "Ziyaretçi E-postaları",
            visitorActions: "Ziyaretçi Hareketleri",
            notVerified: "Doğrulanmadı",
            visitorEvents: "Etkinlikler",
            assignedTasks: "Atanan Görevler",
            mails: "Mailler",
            prefferedAgents: "Tercih Edilen Temsilciler",
            createEvent: "Etkinlik Oluştur",
            blockManagement: "Engelleme Yönetimi",
            deleteUser: "Kullanıcıyı Sil",
            blocked: "Engellendi",
            profiles: "Profiller",
            similiarProfiles: "Benzer Profiller Bulundu",
            ReplyAsAPm: "Özel Mesaj Olarak Yanıtla ve Kapat",
            replyAsAComment: "Yorum Olarak Yanıtla ve Kapat",
            messengerAddDesc: "Aşağıdaki Bağlan düğmesine tıklayın ve Facebook hesabınıza giriş yapın.",
            instaAddPrivacyCheckDesc: "{Privacy} ve {Terms and Conditions} Okudum Ve Kabul Ediyorum.",
            instaAddDesc5: "Aşağıdaki Bağlan düğmesine tıklayın ve Facebook hesabınıza giriş yapın.",
            instaAddDesc4: "Facebook Geliştirici olarak kaydolun",
            instaAddDesc3: "<b>'Mesajlara erişime izin ver'</b> anahtarının açık olduğundan emin olun",
            instaAddDesc2: "Instagram profesyonel hesabınızın Facebook sayfanıza bağlı olduğundan emin olun",
            instaAddDesc1: "Instagram hesabınızın bir Instagram profesyonel (Business) hesabı olduğundan emin olun.",
            selectedDepartment: "Seçilen Departman",
            departmentForwardEnable: "Departman Yönlendirme Kuralı Etkin",
            departmentForwardRule: "Departman Yönlendirme Kuralı",
            departmentForwardDesc: "Kanala gelen sohbetlerin hangi departmana yönlendirileceğini seçin.",
            channelName: "Kanal Adı",
            forwardToLiveAgents: "👉 Canlı Temsilcilere Yönlendir",
            manageIgChannel: "Instagram Kanalınızı Yönetin",
            igDetail: "Instagram Detay",
            manageVisibilityDesc: "Bu kanalı kimlerin görebileceğini yönet",
            selectAnIgAccount: "Bağlamak istediğin Instagram hesabını seç.",
            connectToInsta: "Instagram'a Bağlan",
            connectToMetaLeads: "Meta Leads Hesabına Bağlan",
            deleteInstaChannelInfo: "Instagram kanalını silmek istediğinizden emin misiniz?",
            instagramChannels: "Instagram Kanalları",
            checkboxWarning: "Bu alanın seçilmesi zorunludur",
            onlyChatbot: "Sadece Chatbot",
            onlyAgents: "Sadece Temsilciler",
            sendingAllow: "Gönderim",
            receiving: "Alım",
            platform: "Platform",
            banModalTitle: "Ziyaretçi Yasaklama Ekranı",
            selectDepartmentDesc: "Görünürlüğü değiştirmek istediğiniz departmanları seçin",
            selectAgentDesc: "Görünürlüğü değiştirmek istediğiniz temsilcileri seçin",
            selectDepartment: "Departman Seç",
            selectAgent: "Temsilci Seç",
            visibleDepartments: "Gören Departmanlar",
            visibleAgents: "Gören Temsilciler",
            visibilityInfoCont: "Tüm temsilciler ve departmanlar bu kanalı görebilir",
            editDepartmentVisibility: "Departman İzinlerini Düzenle",
            editAgentVisibility: "Temsilci İzinlerini Düzenle",
            typeSTToSearch: "Kullanıcı aramak için birşeyler yazınız",
            exportToCSV: "CSV'ye Aktar",
            clear: "Temizle",
            usedSessionCount: "Kullanılan Oturum Sayısı",
            maxSessionCount: "Maksimum Oturum Sayısı",
            leftSessionCount: "Kalan Oturum Sayısı",
            planManagement: "Plan Yönetimi",
            maxAutomationTask: "Maksimun Otomasyon Görevi",
            teamChat: "Takım Konuşması",
            templateNameIsNotValid: "Şablon Adı Geçerli Değil",
            relatedAdvertisement: "İlgili Reklam",
            whatsappNumber: "Whatsapp Numarası",
            createTask: "Görev Oluştur",
            integrationsWhatsappV1:
                "Supsis ve WhatsApp arasında sorunsuz bir iletişim kurmak için WhatsApp Planı gerekmektedir.",
            integrationsWhatsappV2:
                "WhatsApp entegrasyonu ile QR kodla hızlı kurulum, otomatik yanıtlar ve chatbot destekli müşteri hizmetleri.",
            integrationsWhatsappBusiness:
                "WhatsApp Business API ile toplu mesaj gönderimi, müşteri gruplama ve etkili bilgilendirme/pazarlama.",
            integrationsInstagram:
                "Instagram mesajlarınızı tek panelden yönetin, sosyal medyada kesintisiz müşteri iletişimi sağlayın.",
            integrationsLinkedin:
                "LinkedIn mesaj ve yorumlarını yönetin, otomatik yanıtlarla hızlı müşteri etkileşimi kurun.",
            integrationsTelegram: "Telegram kanalınızı tek platformdan yönetin, tüm mesajları kolayca kontrol edin.",
            integrationsWebchat:
                "Web sitenizde 7/24 aktif chatbot, SSS yanıtları ve müşteri adayı takibiyle dönüşüm artırın.",
            selectDays: "Gün Seçin",
            addTime: "Saat Ekle",
            instagramContactList: "Instagram Kişi Listesi",
            archiveAllRated: "Herhangi bir puanlama yapılan tüm konuşmaları getir.",
            allChannels: "Tüm kanallar",
            comment: "Yorum",
            news: "Yenilikler",
            conversation: "Takım konuşması",
            speechTermination: "Konuşmayı sonlandır",
            noSystemMessage: "Henüz Sistemde Mesaj Yok !",
            supsisCustomerService: "Supsis'in sunduğu müşteri hizmetleri,",
            supsisClickExperience: "deneyimini tıklayarak deneyebilirsiniz.",
            customerPage: "Müşteri Sayfasına Git",
            buttonTitle: "Buton Başlığı",
            buttonType: "Buton Tipi",
            buttonSendMessage: "Mesaj gönder",
            buttonGoToBlock: "Bloğa git",
            buttonOpenUrl: "Aç URL",
            buttonPhoneCall: "Telefon görüşmesi",
            buttonOpenMoment: "Açık Anı",
            buttonCloseChat: "Sohbeti Kapat",
            buttonTransferChat: "Sohbeti Aktar",
            buttonCreateTicket: "Bilet Oluştur",
            you: "Sen",
            and: "ve",
            deleteVisitor: "Kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            deleteThread: "Tüm mailleri silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            deleteMail: "Maili silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            dndBlocked: "Dosya gönderim ayarları kapalı.",
            tokenCopied: "Erişim token'ı kopyalandı.",
            apiIntegration: "Geliştirici",
            generateToken: "Token Üret",
            copyToken: "Token Kopyala",
            labels: "Etiketler",
            noData: "İçerik Yok",
            color: "Renk",
            titleColor: "Başlık Rengi",
            secondTitleColor: "İkinci Başlık Rengi",
            tag_name_indicator: "Etiket Adı",
            sendMessage: "Mesaj Gönder",
            removeFromG: "Gruptan Çıkar",
            delChannel: "Bu kanalı silmek istediğinizden emin misiniz?",
            new_name: "Yeni İsim",
            set_group_info: "Grup bilgilerini düzenle",
            shortcut_desc_num: "Numeric rakamlarla aktif konuşmalar arası geçiş yapma",
            copilot_desc_num: "Chat Ekranında Copilot u açmayı sağlar",
            typing_w_chat: "yazıyor...",
            edit_group_info: "Grup Bilgilerini Düzenle",
            notif_sound: "Bildirimlerin Sesini Aç",
            notif_mute: "Bildirimleri Sessize Al",
            leave: "Ayrıl",
            group: "Grup",
            updateTag: "Etiket Güncelle",
            os_browser: "İşletim Sistemi ve Tarayıcı",
            ordered_desc: "Sohbetleri sırayla temsilcilere atar.",
            random_desc: "Sohbetleri temsilcilere rastgele atar.",
            Rrobin_desc: "Temsilcilere sohbetleri round robin tarzında atar. (En az meşgul olan temsilciler öncelikli)",
            RrobinRev_desc:
                "Temsilcilere sohbetleri round robin tarzında atar. (En fazla meşgul olan temsilciler öncelikli)",
            algo_desc: "Otomatik sohbet atama için algoritmayı seçin",
            algorithm: "Algoritma",
            addTag: "Etiket Ekle",
            tags: "Etiketler",
            searchRepresentative: "Temsilci Arayın.",
            preferredRepresentative: "Temsilciler",
            voting: "Oylanıyor",
            chatWidget: "Supsis Sohbet Balonu",
            webhooks: "Web Kancaları",
            selectHooks: "Seçenekeler",
            planRequired: "{integratable} Plan Gerekmektedir.",
            allIntegrations: "Tüm Entegrasyonlar",
            disableAgentSystemMessages: "Temsilci sistem mesajlarını gizle",
            disableAgentSystemMessagesDesc: "Temsilci Sistem Mesajlarını Gizle.",
            disableAutoTranslate: "Otomatik Tercüme",
            disableAutoTranslateDesc:
                "Farklı dillerden gelen mesajları otomatik olarak çevirir. Böylece müşterilerinizle daha kolay iletişim kurabilirsiniz.",
            shouldAddMethod:
                "Ödeme Metodu & Fatura Adresi alanını doldurmalısınız!\nHesabınızdan para cekilmeyecektir.\nAy sonunda kullanım tutarınıza göre fatura oluşacaktır",
            approveSelection: "Seçiminizi Onaylayın",
            trialDaysEndSelectPlan: "Plan Seçinimini Onaylayın",
            trialDaysEndSelectPlanDesc: "Deneme sürümünüz bitmiştir. Aşağıdan plan seçerek onaylamanız gerekmektedir.",
            infinitePlay: "Sürekli çal",
            hideBubbleOnMobile: "Mobilde gizle",
            deleteSystemLanguage: "Sistemden {code} dilini siler",
            assignedChat: "Atanan Chat",
            check: "Onay kutusu",
            systemStatus: "Sistem Durumu",
            chatAssignedToUser: "Yeni chat atandı",
            inactiveThresholdTime: "Pasif Chat Süresi (dakika)",
            tippyInactiveThresholdTime:
                "Konuşmada verilen süre içinde herhangi bir mesaj gönderilmediğinde konuşma pasif olarak kabul edilir.Değeri (dakika) olarak giriniz. En az 1dk En çok 120dk olmalıdır.",
            inactiveTerminateTime: "Pasif Chat Kapatma Süresi (dakika)",
            tippyInactiveTerminateTime:
                "Konuşma pasif olduktan verilen süre  sonra kapatılacaktır. Değeri (dakika) olarak giriniz. En az 0 en çok 120dk olmalıdır.",
            removePendingMessage: "Mesaj gönderimi iptal et",
            disconnected: "Bağlı Değil",
            visitorWriteEmptyChatTippy: "Müşteri, konuşamaya temsilci bağlanmadan önce yazabilir.",
            visitorWriteEmptyChat: "Müşteri, temsilci bağlanmadan yazabilir.",
            visitorConnectionEventSystemMessageEnabled:
                "Ziyaretçinin bağlantı durumu sistem mesajlarını etkinleştirir.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Ziyaretci ayrıldı ve ziyaretci geri geldi sistem mesajlarını gösterir.",
            openBubble: "Konuşma Balonu Aç",
            showHeaderImage: "Şirket Logosu ve İsim Göster",
            changeLogo: "Logoyu Değiştir",
            changePhoto: "Resmi Değiştir",
            addPhoto: "Resim ekle",
            seePhoto: "Resmi Gör",
            deletePhoto: "Resmi Sil",
            askQuestion: "Soru sor",
            locationPermsNeeded: "Bu özelliği kullanabilmeniz için konum izinleri gerekli",
            useMyLocation: "Konumumu kullan",
            acceptingChat: "Chat alımı açık",
            notAcceptingChat: "Chat alımı kapalı",
            websiteChatWidgetIntegration: "Website Chat Balonu Entegrasyonu",
            loggedOut: "Çevrimdışı",
            listStatuses: "Durumlar",
            hideInactiveAgents: "Pasif Temsilcileri Gizle",
            hideMinorValues: "Küçük Değerleri Gizle",
            agentActivities: "Temsilci Aktivitileri",
            newHASHContent: "#Etiket Ekle",
            hash: "Etiket",
            languageRemovalQuestion: "Sistemden {code} dilini silmek üzeresiniz!",
            blockBy: "Temsilci",
            hashText: "Etiket",
            exampleHash: "siparis-takip",
            cardInfos: "Kart Bilgileri",
            saveSystemCardInfo: "Kartınız sistemimize kaydedilip ödenecek tarih geldiğinde otomatik ödenir.",
            cardNumber: "Kart Numarası",
            cardType: "Kredi Kartı Türü",
            skt: "SKT",
            cvv: "CVV",
            saveCard: "Kartı Kaydet",
            cardNameSurname: "Kart Sahibinin Adı Soyadı",
            confidentialityAgreementCheck: "Gizlilik Sözleşmesini Kabul Ediyorum",
            confidentialityAgreement: "Gizlilik Sözleşmesi",
            notValidHash: "Boşluk karakteri içermemelidir",
            videoCallEnabledDesc: "Görüntülü arama özelliğini etkinleştirmek için aktif edin",
            videoCallEnabled: "Görüntülü Arama Özelliği",
            audioCallDesc: "Sesli arama özelliğini etkinleştirmek için aktif edin",
            audioCallEnabled: "Sesli Arama Özelliği",
            assignPreferredAgent: "Tercih Edilen Temsilciyi Ata",
            representativeAssignedToTheVisitor: "Ziyaretçiye atamak istediğiniz tercih edilen temsilciyi seçin.",
            agentFileSendEnabledDesc: "Temsilcilerin dosya gönderme özelliğini etkinleştirir",
            agentFileSendEnabled: "Temsilciler Dosya Gönderebilir",
            visitorFileSendEnabledDesc: "Ziyaretciler dosya gönderme özelliğini açıp kapatmanıza izin verir",
            visitorFileSendEnabled: "Ziyaretciler Dosya Gönderebilir",
            visitorAutoLogin: "Ziyaretçi Otomatik Giriş",
            visitorAutoLoginDesc: "Ziyaretçi balonu tıklar tıklamaz konuşma başlar",
            agentVoiceRecordEnabledDesc: "Temsilcilerin ses kaydetme özelliğini etkinleştirir",
            agentVoiceRecordEnabled: "Temsilciler Ses Kaydedebilir",
            visitorVoiceRecordEnabledDesc: "Ziyaretcilerin ses kaydetme özelliğini etkinleştirir",
            visitorVoiceRecordEnabled: "Ziyaretciler Ses Kaydedebilir",
            startVideoCall: "Görüntülü Görüşme",
            startAudioCall: "Sesli Görüşme",
            visitorGDPRDeleteEnabledDesc: "Ziyaretciler tüm bilgilerini silme özelliğini açıp kapatmanıza izin verir",
            visitorGDPRDeleteEnabled: "Ziyaretciler tüm bilgilerini silebilir",
            visitorLocationEnabled: "Ziyaretciler konum paylaşabilir",
            visitorLocationEnabledDesc: "Ziyaretçilerin konum paylaşımını açmasına veya kapatmasına izin verir",
            customerLocationEnabled: "Temsilciler konum paylaşabilir",
            customerAutoMergeEnabled: "Aynı kişileri otomatik birleştirir",
            customerAutoMergeEnabledDesc:
                "Bu özellik, otomatik birleştirme işlemini gerçekleştirerek aynı kişilere ait verileri etkili bir şekilde bir araya getirir. Bu sayede benzer profillere sahip kullanıcılar, veri setlerinde daha tutarlı ve düzenli bir şekilde temsil edilir.",
            chatAiCopilot: "Chat AI Copilot",
            chatAiCopilotDesc: "Chat AI Copilot Kullanarak Müşterilerinizin Sorularını Otomatik Olarak Cevaplayın",
            customerLocationEnabledDesc: "Temsilcilerin konum paylaşımını açmasına veya kapatmasına izin verir",
            thoesNotOwners: "Owner olmayanları sırada beklet",
            thoesNotOwnersDesc:
                "Görüşmenin sahibi olmayan kişileri kuyrukta tutmak için bu özelliği etkinleştirirsiniz.",
            hideContactInfo: "İletişim bilgilerini gizle",
            hideContactInfoDesc:
                "Bu özelliği etkinleştirdiğinizde, müşterilerinizin numaraları ve e-postaları temsilcilerden gizlenecektir.",
            triggerAlreadyExists: "Bu koşula ait bir tetikleyici zaten var.",
            ticketStatusForm: "Ticket Durum Formu",
            statusFormTitle: "Ticket Durum Başlığı",
            allStatus: "Tüm Durumlar",
            triggers: "Tetikleyiciler",
            trigger: "Tetikleyici",
            noTrigger: "Henüz Tetikleyici Eklemediniz",
            triggerSkipLoginForm: "Giriş Formu",
            triggerSkipLoginFormTrue: "Giriş Formunu Göster",
            triggerSkipLoginFormFalse: "Giriş Formunu Atla Mesajı Başlat",
            noContent: "içerik yok",
            toCreate: " Oluşturmak için",
            clickTheButton: "butonuna tıklayın",
            triggerContent:
                " Açılan pencerede görülmesini istediğiniz açıklamayı yazın. Yalnızca bir dilde yazmanız yeterlidir diğer dillere çeviri otomatik olarak yapılmaktadır.",
            triggerDrag: "Sürükleyerek veya çubuğa tıklayarak mesaj süresini ayarlayabilirsiniz.",
            triggerNewCondition: "Butonu ile yeni bir koşul ekleyebilirsiniz.",
            triggerNoConditionDescription1:
                "Seçenekler arasından istediğiniz koşulları oluşturabilirsiniz. Herhangi bir tetikleyici için hiçbir koşul oluşturmamanız halinde ilk sıradaki tetikleyici aktif olur.",
            triggerNoConditionDescription2:
                "Yine ziyaretçi sayfasında aynı koşullara sahip tetikleyicilerden yalnızca bir tanesi aktif olarak gözükür.",
            triggerShowAndHide: "Tetikleyicilerin göstermek istediğinizde gösterebilir veya gizleyebilirsiniz.",
            countryLanguage: "Ülke/Dil",
            addTrigger: "Tetikleyici Ekle",
            yesPlease: "Evet, lütfen!",
            noThanks: "Hayır, teşekkürler.",
            firstAnswer: "Soru Diyaloğu Olumlu Yanıt",
            secondAnswer: "Soru Diyaloğu Olumsuz Yanıt",
            noTitle: "Başlık Yok",
            sumChat_MediaFile: "Medya ve Belgeler",
            importantWarning: "ÖNEMLİ UYARI",
            images: "Resimler",
            URLS: "Linkler",
            files: "Dosyalar",
            warning: "UYARI!",
            noCondition: "Şart Yok! Artı ikonuna tıklayarak Şart ekleyebilirsiniz.",
            showTriggers: "Tetikleyicileri Göstermek için Tıklayın",
            showThisTrigger: "Bu Tetikleyiciyi Göstermek için Tıklayın",
            hideTriggers: "Tetikleyicileri Gizlemek için Tıklayın",
            hideThisTrigger: "Bu Tetikleyiciyi Gizlemek için Tıklayın",
            updateTrigger: "Tetikleyiciyi Güncelle",
            conditions: "Koşullar",
            messageDurationPerRow: "Her Bir Satır İçin Mesaj Süresi",
            dayTime: "Saat",
            weekDay: "Haftanın günü",
            spendTimePage: "Sayfada Geçirilen Zaman",
            spendTimeSite: "Sitede Geçirilen Zaman",
            pageUrl: "URL",
            pageTitle: "Sayfa Başlığı",
            equal: "Eşit",
            not_equal: "Eşit Değil",
            less_than: "Küçüktür",
            greater_than: "Büyüktür",
            less_than_or_equal: "Küçüktür veya Eşittir",
            greater_than_or_equal: "Büyüktür veya Eşittir",
            visitorName: "Ziyaretçi Adı",
            seconds10: "10 saniye",
            seconds30: "30 saniye",
            minute1: "1 dakika",
            minutes5: "5 dakika",
            minutes10: "10 dakika",
            minutes30: "30 dakika",
            hour1: "1 saat",
            hours2: "2 saat",
            hours4: "4 saat",
            hours8: "8 saat",
            hours12: "12 saat",
            hours24: "24 saat",
            maxCondition: "Maksimum Durum",
            doYouWishToDeleteTrigger: "Tetikleyiciyi Silmek İstiyor musunuz",
            contains: "İçerir",
            not_contains: "İçermez",
            chatLanguage: "Konuşma Dili",
            translating: "Çevriliyor",
            liveSupportStartingWait: "Canlı Destek Başlatılıyor , Lütfen Bekleyiniz",
            noConnection: "Bağlantı Yok!",
            buyWhatsapp: "WhatsApp satın alın",
            integrations: "Entegrasyonlar",
            refundInvoiceSure: "Faturayı iade etmek istediğinize emin misiniz?",
            invoiceMarkedAsPaidSuccess: "Fatura ödendi olarak işaretlenmiştir.",
            invoiceMarkedAsPaidError: "Hata , Fatura ödendi olarak işaretlenemedi.",
            deleteConfirm: "Bu {object} gerçekten silmek istiyor musunuz?",
            markPaidConfirm: "Bu faturayı ödendi olarak işaretlemek istediğine emin misin?",
            startChatDesc: "Konuşma Başlat",
            addLink: "Bağlantı",
            selectStep: "Bir adım seçiniz:",
            addGOTO: "Git",
            sendFastLink: "Şifresiz Giriş Linki Gönder",
            or: "Veya",
            allTags: "Tüm Etiketler",
            showDetail: "Detay Göster",
            hideDetail: "Detay Gizle",
            weLlSendPhone: "Telefonunuza Gönderelim",
            weLlSendEmail: "E-Posta Gönderelim",
            linkSentToPhone: "Link sms olarak gönderildi",
            offerlinkSendToPhone: "SMS ile size uygulamamızın indirme linkini gönderelim.",
            offerlinkSendToMail: "Mail ile size uygulamamızın indirme linkini gönderelim.",
            theEmail: "Kayıtlı E-postam",
            differentEmail: "Farklı E-posta",
            linkSentToMailBox: "Link mail adresinize gönderildi",
            errorOccurred: "Hata oluştu !",
            clickStoreIcon: "Telefonunuza uygun olan icona tıklayarak mobil uygulamaya ulaşabilirsiniz",
            meetWithSupsis: "SUPSIS mobil uygulamamız ile tanışmak ister misiniz?",
            downloadMobileApps: "Mobil Uygulamayı İndirin",
            getApps: "Uygulamaları Edinin",
            info: "Bilgi",
            conversationHistory: "Konuşma Geçmişi",
            events: "Takvim Etkinlikleri",
            reservations: "Rezervasyonlar",
            planInfoHeader: "Plan Bilgisi",
            planInformation:
                "Planınız {selectedPlan} Plan ({detailMaxAgentCount} Temsilci) ({freeAgent} Ücretsiz Temsilci)",
            creditAvailable: "Planınızda mevcut olan Temsilci krediniz: ",
            upDownGradePlan: "Planınızı yükseltmek/düşürmek istiyorsanız, lütfen",
            click: "Tıklayın",
            all: "Hepsi",
            preferredLanguage: "Tercih Edilen Dil",
            kmkAutoDepartmentBind: "KMK Otomatik Departmant Bulma",
            kmkAutoDepartmentBindDesc: "KMK Müşteri sayfalarında otomatik mağaza adını bulur ve login formuna set eder",
            visitorEmailUpdated: "Ziyaretci eposta adresi güncellendi",
            visitorEmailIsNotValid: "Girdiniz eposta adresi doğru değil",
            visitorNameUpdated: "Ziyaretci adı güncellendi",
            clickToEdit: "Düzenlemek için tıklayın",
            addEmail: "+ Email Adresi Ekle",
            addFullname: "+ Ad Ekle",
            partner: "Ref?",
            isIntegrated: "Entegrasyon?",
            agentCount: "Temsilci Sayısı",
            autoStartChat: "Otomatik Chat Başlangıcı",
            bubbleColor: "Chat Balonu Rengi",
            openFolder: "Aç",
            preDefined: "Temalar",
            customIcon: "Bilgisayarınızdan Yükleyin",
            theme: "Tema",
            themeSettings: "Tema Ayarları",
            chatThemeSettings: "Chat Tema Ayarları",
            bubbleSettings: "Chat Balonu Ayarları",
            inputHeightOfBubble: "Balon Boyutu",
            inputPixelsOfChatBubble: "Chat Balonu'nun Kenarlara Olan Uzaklıklığını Düzenlemek İçin Tıklayın",
            modalTitleIsMarginAsPixelInfo: "Chat Balonu'nun Kenarlara Olan Uzaklıklığı : ",
            inputPxOfXaxis: "Yatay Konum",
            inputPxOfYaxis: "Dikey Konum",
            inputPxOfMobileXaxis: "(Mobil) Yatay Konum",
            inputPxOfMobileYaxis: "(Mobil) Dikey Konum",
            animations: "Animasyonlar",
            preferredAnimation: "Tercih Edilen Animasyon",
            selectAnAnimation: "Bir Animasyon Seçin",
            inputOfBubbleMessage: "Genis Chat Balonlarına İçerik Ekle.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Sohbet Balonunu Oturum Açma Durumuna Bağlı Olarak Gizleme Ayarıdır.Kapalı olması durumunda tüm ziyaretçilere gösterilir.",
            showChatBubbleOnlyLoggedUser: "Balonu Yalnızca Oturum Açmış Kullanıcıya Göster. (ideasoft)",
            helloDoUNeedHelp: "Merhaba, yardımcı olabilirim!",
            bubbleIcon: "Chat Balonu Resmi",
            overrideMargins: "Kenar Boşluklarını Özelleştir",
            autoHideBubble: "Chat Balonunu Gizle",
            vtippyAutoHideBubble: "Temsilciler çevrimdışıyken chat balonunu gizler",
            hideBubble: "Chat Balonunu Devredışı Bırak",
            vtippyHideBubble: "Chat balonunu devredışı bırakır, göstermez.",
            overrideMobileMargin: "Mobil Versiyon Boşlukları Özelleştir",
            vtippyMobileMargin: "Mobil versiyon için chat balonu kenar boşluklarını özelleştir",
            vtippyHideBubbleOnMobile: "Chat Balonu mobile kullanan ziyaretçilerde gizlenir.",
            isFabsActive: "Açılır Menüleri Göster",
            isAlwaysActive: "Menü her zaman açık",
            isAlwaysActiveDesc: "Web görünümünde sohbet balonu menüsünün her zaman açık kalmasını ister misiniz?",
            bubbleOpenableMenu: "Chat Balonu Açılır Menü",
            vtippyIsFabsActive: "Açılır Menüleri Gösterme / Gizleme Ayarıdır",
            vtippyIsFabsAsIcon: "Açılır menünde ikonların görünüp görünmeyeceğinin ayarıdır.",
            vtippyTranslateButton: "Seçili Olan Dili Diğer Dillere Çevirir.",
            vtippyTranslateClearButton: "Diğer dillerdeki içerikleri temizler.",
            vtippySelectnotification: "Bildirim sesi seçebilirsiniz.",
            vtippyVoiceLevel: "Ses seviyesini ayarlayabilirsiniz.",
            vtippyStartVoice: "Dinle",
            vtippyInfiniteNotification:
                "Yeni gelen Chatler panel de aktif değilseniz çalmaya devam eder. Tıklayarak aktif-pasif düzenleyebilirsiniz.",
            vtippyNewVisitorNotification: "Web sitenize gelen ziyaretçiler için sesli bildirim ayarları.",
            vtippyNewChatNotification: "Sisteme gelen her yeni chat için sesli bildirim ayarları.",
            vtippyNewConversationNotification: "Size atanan her yeni chat için sesli bildirim ayarları.",
            vtippyNewMessageNotification: "Size atanmış chatlerden gelen mesaj bildirim ayarları.",
            vtippyPrivateMessageNotification: "Takım konuşmasından gelen mesajlar için sesli bildirim ayarları.",
            isFabsAsIcon: "Menü İkonlarını Göster.",
            setMarginAsPixel: "Piksel olarak ayarla",
            returnDefaultMargins: "Varsayılan Kenar Boşluğu Ayarları",
            closePreviewColors: "Ön İzlemeyi Kapat",
            previewColors: "Ön İzlemeyi Aç",
            videoCalls: "Görüntülü Görüşmeler",
            filterLost: "Kaçan Konuşmalar",
            vtipyCustomLogin:
                "Ziyaretçileriniz sisteme bağlanırken giriş formunda istenecek bilgileri buradan özelleştirebilirsiniz.",
            vtipyLoginlessChat:
                "Ziyaretçileriniz sisteme bağlanırken giriş formu gösterilmez. Temsilciler ziyaretçilerin kişisel bilgilerini isteyerek kullanılır",
            loginlessChat: "Ziyaretçi Giriş Formu",
            imageUrl: "Resim",
            replied: "Yanıtlandı",
            solved: "Çözüldü",
            openImage: "Resmi Aç",
            writeFeedback: "Supsis ile  ilgili geri bildirimini buraya yazabilirsin.",
            feedbackFailed: "Geri bildirim gönderimi sırasında hata oluştu.",
            feedbackSuccessful: "Geri bildirim gönderimi başarılı.",
            sendFeedback: "Geribildirim Gönder",
            errorReport: "SUPSIS ile ilgili yaşadığınız sorunlar hakkında bize geri bildirimde bulunabilirsiniz.",
            sendErrorFeedBack: "Yaşadığınız sorunla ilgili bize geri bildirimde bulunun.",
            successImgUpload: "Resminiz başarıyla yüklendi",
            successImgDelete: "Resim başarıyla silindi.",
            errorImgUpload: "Resminiz yüklenirken bir hata meydana geldi",
            errorImgDelete: "Resim silinirken bir hata meydana geldi",
            chatBotEndStatics: "Chatbot Konusma Sonuçlandırma Oranı",
            videoCallDist: "Video Görüşme Dağılımı",
            deleteSite: '" {siteName} " Sitesi Silinsin mi ?',
            deleteThisSite: "Bu siteyi sil",
            departmentInfo: "Departman Bilgisi",
            infoAboutDepartment: "Departman hakkında kısa bilgi",
            deleteDepartmentQuestion: "Bu departmanı gerçekten silmek istiyor musunuz?",
            departmentDeleted: "Departman silindi",
            departmentTitle: "Departman Başlığı",
            updateDepartmentForm: "Departman Güncelleme Formu",
            updateCompleted: "Güncelleme Tamamlandı",
            CatalogUpdatedSuccessfully: "Güncelleme Başarıyla Tamamlandı",
            integrateSupsiswithIntegratable: "Supsis ve {integratable} arasında sohbet bilgilerini kolaylıkla iletin.",
            installationOK: "Yüklü",
            newDepartmentForm: "Yeni Departman Kayıt Formu",
            newDepartment: "Yeni Departman",
            departmentSaved: "Departman Kaydedildi",
            addUsersToDepartment: "Departmana kullanıcı ekle",
            removeFromDepartment: "Departmandan çıkar",
            moveToDepartment: "Başka departmana taşı",
            noUsersInDepartment: "Bu departmanda kullanıcı yok",
            selectAtLeastOneUser: "En az bir kullanıcı seçin",
            departmentUsersUpdated: "Kullanıcılar güncellendi",
            copyToDepartment: "Departmana da ekle",
            userAlreadyInDepartment: "Kullanıcı zaten bu departmanda",
            removeUserFromDepartmentConfirm: "Bu kullanıcıyı departmandan çıkarmak istediğinize emin misiniz?",
            bulkUpdateProgress: "Toplu güncelleme",
            usersUpdated: "güncellendi",
            collapseAll: "Tümünü Daralt",
            expandAll: "Tümünü Genişlet",
            allDepartments: "Tüm Departmanlar",
            moveToAllDepartments: "Tüm Departmanlara Aktar",
            copyToAllDepartments: "Tüm Departmanlara da Ekle",
            sameDepartment: "Aynı isimde bir departman mevcut!",
            sameValue: "Aynı isimde bir değer mevcut!",
            sameTag: "Aynı isimde bir etiket mevcut!",
            departments: "Departmanlar",
            department: "Departman",
            announcements: "Duyurular",
            announcement: "Duyuru",
            newAnnouncement: "Yeni Duyuru",
            announcementInfo: "Duyuru Bilgisi",
            infoAboutAnnouncement: "Duyuru hakkında kısa bilgi",
            deleteAnnouncementQuestion: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            announcementDeleted: "Duyuru silindi",
            announcementTitle: "Duyuru Başlığı",
            updateAnnouncementForm: "Duyuru Güncelleme Formu",
            newAnnouncementForm: "Yeni Duyuru Kayıt Formu",
            announcementSaved: "Duyuru kaydedildi.",
            chatTimingSettings: "Chat Süre Ayarları",
            assetOversize: "Göndermek istediğiniz dosyanın boyutu 10mb'den büyük olmamalıdır.",
            assetOversizeMB: "Göndermek istediğiniz dosyanın boyutu {mb} mb'den büyük olmamalıdır.",
            assetOversizeWithExt: "Dosya boyutu 10mb'tan küçük ve png,jpg formatında olmalıdır.",
            messageDeleted: "Bu mesaj silindi",
            filterVideoCall: "Görüntülü Görüşmeleri Gösterir",
            filterLostChat: "Kayıp Sohbetleri Filtreler",
            filterClosedByAgent: "Temsilci Tarafından Kapatılan Sohbetleri Filtreler",
            notificationText: "Supsis bildirimlerinin doğru şekilde çalışması için ",
            notificationTitle: "Bildirimler Kapalı",
            deniedText:
                "Bildirimleriniz kapalıdır, Müşterilerinizi kaçırmamanız için bildirimlerinizi açmanız gerekmektedir.",
            deniedTitle: "Bildirimlerinizi Açmak İçin Tıklayınız !",
            deniedHeader: "Müşterilerinizi kaçırmamak için bildirimlerinizi açmanız gerekmektedir!",
            showNotificationGuide: "Detaylar için tıklayın",
            howToEnableNotification: "Bildirimleri Nasıl Etkinleştirebilirim",
            notificationOK: "Tamam",
            notificationUnderstood: "Anladım",
            notificationCancel: "İptal",
            howToEnableNotificationInstruction1: "Tarayıcının adres çubuğundaki kilit ikonuna tıklayınız",
            howToEnableNotificationInstruction2: "İzinler kısmında 'Bildirimler' pasif gözüküyorsa aktifleştirin",
            howToEnableNotificationInstruction3:
                'İzinler kısmında "Bildirimler" gözükmüyorsa "Site Ayarlarına" tıklayınız',
            howToEnableNotificationInstruction4:
                'Site ayarları sayfasından "İzinler" bölümden "Bildirimler" iznini açınız',
            checkPaymentMethod: "Lütfen ödeme yönteminizi kontrol edin",
            pushNotificationEnabled: "Harika, Bildirim gönderimi etkin.",
            pushNotificationDenied: "Bildirim izinlerini reddettiniz",
            suspendedMessage: "Hesabınız askıya alındı",
            suspendedDescription: "Hesabınız ödenmemiş faturalarınız yüzünden askıya alındı.",
            enableNotification: "Bildirimlerinizi açınız.",
            languageSettings: "Konuşma Dili",
            problemsSound:
                'Eğer bildirimler ile ilgili sorun yaşıyorsanız, tarayıcınızın adres çubuğundan (Resimde Gösterilen) kilit iconuna tıklayıp "Site Ayarları" alanından tıklayarak, açılan  bölümden "Ses" izin ver olarak değiştirebilirsiniz.',
            betweenRepresentative: "Bir temsilci yeni mesajı.",
            desktopNotifications: "Bildirimler",
            notificationDisable: "Temsilci ayarlarından masaüstü bildirimlerini kapatabilirsiniz.",
            notificationEnabled: "Supsis bildirimleri aktif.",
            newMessageAlert: "Yeni bir mesajınız var.",
            newConversationAlert: "Yeni bir konuşmanız var.",
            chatBot: "ChatBot",
            ticketResponse: "Representative Response:",
            archived: "Arşivle",
            chatbotChatCount: "CHATBOT",
            closeChat: "Mesajlaşmayı Bitir",
            ticket: "Ticket",
            formStep: "Form Adımı",
            menuStep: "Menü Adımı",
            contentStep: "İçerik Adımı",
            menuTitle: "Menü Başlığı",
            messageContent: "Mesaj İçeriği",
            goToLive: "Temsilciye Aktar",
            prevStep: "Önceki Adıma Dön",
            button: "Buton",
            addImage: "Görüntü",
            addText: "Metin",
            stepTitle: "Adım Başlığı",
            addTicket: "Ticket",
            formDescription: "Soru",
            addInput: "Soru",
            addRandomText: "Rastgele Metin",
            changeTitle: "Başlığı Değiştir",
            changeVisitorTitle: "Visitor Başlığını Değiştir",
            catalog: "Katalog Başlığı",
            openTheCatalog: "Kataloğu Aç",
            catalogNotOpen:
                "Katalog özelliği devre dışı. Müşterilerinize önceden hazırlanmış içeriklerle destek sağlamak için katalok özelliğini açabilirsiniz.",
            showCatalogCategories: "Katalog menünüsün chat balonunda gözükme durumunu değiştir.",
            showChatBot: "ChatBot menünüsün chat balonunda gözükme durumunu değiştir.",
            openCatalog: "Katalog",
            unreadMessages: "Okunmamış Mesajlar",
            personalFirstMsg: "Temsilci İlk Cevaplama Süresi Ortalaması(sn)",
            personalRating: "Personel Puan Ort.",
            soundSettings: "Bildirim Ayarları",
            newPrivateMessage: "Özel Mesaj",
            addNewGroup: "Yeni Grup Oluştur",
            teamChatTeam: "Takım Mesajları",
            teamChatDm: "Dm Mesajları",
            teamChatDepartment: "Departman Mesajları",
            teamChatGroup: "Grup Mesajları",
            newMessage: "Yeni Mesaj",
            newConversation: "Yeni Chat",
            newVisitor: "Yeni Ziyaretçi",
            chatPosition: "Chat Konumu",
            bottomLeftCorner: "Sol alt köşe",
            leftDocked: "sola Yerleştir",
            bottomRightCorner: "Sağ alt köşe",
            rightDocked: "sağa Yerleştir",
            chatPositionSelect: "Konum Seçiniz",
            bottomLeft: "Sol Alt",
            left: "Sola yaslı",
            bottomRight: "Sağ Alt",
            right: "Sağa yaslı",
            mailorname: "E-Posta ya da İsim",
            breaksByTime: "Zamana göre mola sayıları",
            clPlaceholder: "Müşteri formunda gözükücek isim",
            fieldName: "Anahtar İsim",
            value: "Değer",
            addSetting: "Yeni Bir Ayar Ekle",
            globalSettings: "Genel Ayarlar",
            target: "Yük testi adresi",
            duration: "Yük testi süresi(sn)",
            arrivalCount: "Bot Sayısı(adet)",
            bootMaxLife: "Bir botun ayakta kalma süresi(sn)",
            startLoadTest: "Yük Testini Başlat",
            noClusterInstanceFound: "Sunucu bulunamadı",
            stopLoadTest: "Yük Testini Bitir",
            integrationDesc: "Aşağıdaki  tek satırlık kodu sitenize  eklemeniz yeterlidir.",
            integrationDemoCode: "Örnek entegrasyon demo kodu",
            integrationWindow: "Siteme Nasıl Entegre Yaparım ?",
            notIntegrated: "Entegrasyon",
            help: "Yardım",
            notIntegratedDesc:
                "Chat sistemini sitenize eklemediğinizi farkettik. Sitenize entegre edip ilk görüşmeyi başlattığınızda entegrasyonu tamamlamış olacaksınız. ENTEGRASYON KODU için tıklayınız",
            backToLogin: "Tekrar Giriş Yap",
            passwordlessLoginUnsuccessful:
                "Giriş başarısız.Giriş linkinin süresi dolmuş veya daha önce kullanılmış olabilir.",
            passwordlessLogin: "Şifresiz Giriş",
            loginWithEmail: "Eposta ile Giriş Yap",
            loginWithPassword: "Şifre ile Giriş Yap",
            enteringPasswordless: "Şifresiz Giriş Yapılıyor...",
            toMainPath: "Anasayfaya yönlendir",
            userRoleChanged: "Kullanıcı izinleriniz değişti. Devam etmek için ana sayfaya yönlendirileceksiniz.",
            passwordChangeSuccess: "Şifre Değiştirme İşleminiz Başarılı...",
            feedback: "Geri bildirim",
            showFeedbackHistory: "Geri bildirim gönderilmiş mesajları göster.",
            newSelfServiceSite: "Yeni Self Servis Site",
            subdomain: "Alt alan adı",
            rootUserEmail: "Kullanıcı Eposta",
            rootUserName: "Adınız",
            newVersion: "Yeni Sürüm Mevcut",
            closeLiveSupport: "Canlı Desteği Kapat",
            newVersionShort: "Yeni Sürüm",
            bannedWordRestrict: "Yasaklı Kelime Engelleme",
            ticketShow: "Müşterilerin Ticket Oluşturmasına izin ver",
            ticketShowDesc: "Chat Menüsünden Ticket Oluşturma Seçeneğini aktif et",
            autoLoadIframe: "Canlı Trafik",
            autoLoadIframeDesc: "Iframe otomatik yükler ve tüm ziyaretci trafiği alır",
            bannedWordRestrictDesc:
                "Yasaklı Kelime Engelleme açık olduğunda temsilciler sisteme tanımlanana yasaklı kelimeleri ziyaretcilere yazması engellenir",
            agentDown: "Temsilci Düştü",
            delayChat: "Geciken Konuşma",
            tableSettingTippy: "Tabloda görünecek bilgileri burdan değiştirebilirsiniz.",
            tableSettings: "Tablo Ayarları",
            tableSettingsInfo:
                "Tabloda görünecek bilgileri burdan değiştirebilirsiniz. En fazla 7 tane sütun seçebilirsiniz",
            privateParametry: "Özelliştirilmiş Kullanıcı Parametreleri",
            systemOperetor: "Sistem Bilgileri",
            cityAndDistrict: "Şehir/İlçe",
            general: "Genel",
            availability: "Temsilci Çalışma Saatleri",
            home: "Anasayfa",
            successful: "Başarılı",
            forgetPasswordSent: "Parola sıfırlama maili gönderildi, e-mailinizi kontrol ediniz.",
            saturday: "Cumartesi",
            friday: "Cuma",
            thursday: "Perşembe",
            wednesday: "Çarşamba",
            tuesday: "Salı",
            monday: "Pazartesi",
            sunday: "Pazar",
            download: "Dosyayı İndir",
            calendarPassedTimeHour: "{hour} saat {name}",
            calendarPassedTime: "{hour} saat {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} saat {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Adlı Kullanıcının {sDate} Günü çalışma Takvimi",
            workSchedule: "{name} Adlı kullanıcın {sDate} - {eDate} Arası Çalışma Takvimi",
            calendar: "Takvim",
            noRating: "Hiç Puanlama Yapılmamış",
            rateDist: "Puan Dağılımı",
            distConversation: "Temsilcilerin Konuşma Dağılımı",
            distributionConversa: "Puanlama Dağılımı",
            distChatbotAgent: "İletişim Kanalları",
            distAgent: "Chatbot & Agent",
            distFugitive: "Kaçan Konuşma & Karşılanan Konuşma",
            distLive: "Canlı Sohbet",
            distChatbot: "Chatbot",
            distComplex: "Chatbot + Canlı Sohbet",
            distHandled: "Karşılanan Konuşma",
            distMissed: "Kaçan Konuşma",
            distWeb: "Web Site",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Whatsapp Chat Sayısı",
            statsByTime: "Zamana Göre Konuşma Sayıları",
            selectRep: "Bir temsilci seçin",
            allRepresentatives: "Bütün Temsilciler",
            avgRating: "Puan Dağılım ({point}) ({count} değerlendirme)",
            avgFirstMessageTime: "Ortalama ilk müdehale süresi ",
            totalBreakTime: "Sistem Mola Süresi",
            totalBreakNum: "Mola Sayısı",
            averageConTime: "Ortalama Konuşma Süresi",
            multiWpReportTitle: " Whatsapp Konuşma Sayısı",
            multiWpReport: " Whatsapp Chat Dağılımı",
            multiWpReportExplanation: " Whatsapp Kanallarınızın Chat Miktarını Görebilirsiniz.",
            longestConTime: "En uzun Konuşma Süresi",
            shortestConTime: "En Kısa Konuşma Süresi",
            refresh: "Yenile",
            waitingReply: "Cevap Bekleyenler",
            organizationName: "Organizasyon Adı",
            companySlogan: "İşletme Sloganı",
            messageSentErr: "Mesaj gönderilemedi, tekrar deneyiniz.",
            messageSent: "Mesaj gönderildi.",
            openPrivateChat: "Temsilciler arası konuşmayı aç {shortcut}",
            escKey: "Aktif konuşmayı gizle {shortcut}",
            archiveChatKey: "Arşiv Sayfası alttaki sohbete inmeyi sağlar.",
            chatCopilot: "{shortcut} Chat CoPilot özelliğini açar",
            privateChat: "Temsilciler Arası Konuşma Paneli",
            multiModeAlertDesc:
                'SUPSIS başka bir pencerede açık. SUPSIS\'ı bu pencerede kullanmak için "Burada Kullan"a tıklayın.',
            useHereText: "Burada Kullan",
            brandVisibility: "SUPSIS marka etiketi chat balonunda gözükür",
            focusInput: " İmleci aktif olan konuşmanın yazma alanına odaklar {shortcut}",
            send: "Gönder",
            notYet: "Henüz değil",
            sending: "Gönderiliyor",
            onlyRepresentative: "Mesajınız sadece temsilciler tarafından görülecektir.",
            yourMessage: "Mesajınız",
            liveFabListDescription: "Canlı Destek",
            messengerIntegrationDesc:
                "Messenger mesajlarınızı tek panelden yönetin, müşteri etkileşimini Supsis ile kolayca sürdürün.",
            checkDepartmentToAgent: "Çevrimiçi temsilcinin kontrol edileceği departman",
            ifAllOfflineStory: "Çevrimiçi temsilci yoksa yönlendirmek için hikaye",
            AssignMessagesToAgents: "Tüm mesajları Temsilcilere Yönlendir",
            firstChatbotAndAssign: "Önce Chatbot Cevap Verir ve Sonra Temsilciye Yönlendirir",
            hybridAssign:
                "Sistem, çevrimiçi bir temsilci olup olmadığını görmek için departmanı kontrol eder ve çevrimiçi bir temsilci yoksa, bunu chatbot'a atar.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Telefon",
            emailFabListDescription: "E-posta",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Bu alana {channelLink} kanalınızın linkini koyabilirsiniz.",
            typeYourAccountLink: "Bu alana {accountLink} hesabınızın linkini koyabilirsiniz.",
            typeYourMessage: "Mesajınızı buraya yazın",
            typeYourMessageMail:
                "Bu alana girilen mesaj Müşteri tarafından yukarıdaki mail adresine ilk mesaj olarak gönderilecektir.",
            typeYourMessageDesc:
                "Bu alana girilen mesaj, Müşteri tarafından yukarıdaki telefon numarasına ilk mesaj olarak gönderilecektir.",
            sendNumber: "Mesajın gönderileceği telefon numarası: {path}",
            callNumber: "Müşterinizin arayacağı telefon numarası: {phoneNumber}",
            numberIsNotCorrect: "Eksik numara girildi !!",
            emailIsNotCorrect: "E-posta Hatalı !",
            selectFab: "Bir Fab Seçin",
            notValid: "Sadece harf girebilirsiniz.(Tek karakter). e,d,f,z,a,x,c,v,w,t,n harfleri geçersizdir",
            forMacUsers: " Mac kullanıcıları Control(⌃) tuşunu kullanabilir",
            basePriceValue: "Taban Fiyat",
            basePriceDiscount: "İndirim",
            basePriceCurrency: "Para Birimi",
            customerDBEnabled: "Veritabanı Seçimi: Müşterinin Kendi Veritabanı Sunucusu Kullan",
            customerDBDisabled: "Veritabanı Seçimi: Supsis Veritabanı Sucunusu Kullan",
            mongoConnectionString: "Mongo Bağlantısı",
            whatsappBasePriceValue: "Whatsapp Taban Fiyatı",
            whatsappPlusBasePriceValue: "Whatsapp Plus Taban Fiyatı",
            instagramBasePriceValue: "Instagram Taban Fiyatı",
            instagramPlusBasePriceValue: "Instagram Plus Taban Fiyatı",
            clientAddress: "İstemci Adresi",
            customerClientAddress: "Müşteri İstemci Adresi",
            apiAddress: "Api Adresi",
            socketAddress: "Soket Adresi",
            backendAddress: "BackEnd Adresi",
            panelLogoUrl: "Panel Logo Adresi",
            panelCustomCssUrl: "Özel Panel Css Adresi",
            customerLogoUrl: "Müşteri Logo Adresi",
            customerCssUrl: "Müşteri css Adresi",
            siteAlias: "Site Adı",
            language: "Dil",
            features: "Özellikler",
            interactionPopularity: "Etkileşimlerin popülerliği",
            interactionCount: "Etkileşim Sayısı",
            uniqueUserCount: "Benzersiz Kullanıcı Sayısı",
            allUserPercentage: "(%) Tüm Kullanıcıların Yüzdesi",
            represantativeSettings: "Kullanıcı Ayarları",
            documentTitle: "Supsis Doküman Formu",
            supsisDocument: "Supsis Döküman",
            ApiDoc: "Api Dönümanı",
            chatBalloonTehemeSettings: "Sohbet Balonu ve Tema Ayarları",
            customLoginFormSettingsTitle: "Ziyaretçi Giriş Formunu Özelleştir",
            addNewField: "Yeni Alan Ekle",
            editField: "Alanı Düzenle",
            typeHere: "Buraya yaz",
            pco: "PÇO",
            perPage: "/sayfa",
            perPageInFilter: "Adet",
            noUserInfoFound: "Kullanıcı Bilgisi Bulunamadı",
            startFilter: "Ara",
            CHAT: "Sohbet",
            showMyChats: "Bana Atananları Göster",
            showOnlineAgents: "Sadece Çevrimiçi Olanları Göster",
            showWaitingChats: "Temsilci Bekleyenleri Göster",
            addNewStatus: "Durum Ekle",
            newTitleContent: "Başlık Ekle",
            roleName: "Rol Adı",
            error: "Hata",
            contentType: "İçerik Tipi",
            contentTitle: "İçerik Başlığı",
            newSiteForm: "Yeni Site Kayıt Formu",
            updateSiteForm: "Site Güncelleme Formu",
            newBannedWordForm: "Yeni Yasaklı Kelime Kayıt Formu",
            updateBannedWordForm: "Yasaklı Kelime Güncelleme Formu",
            newWelcomeMessageForm: "Yeni Karşılama Mesajı Kayıt Formu",
            updateWelcomeMessageForm: "Sistem Mesajı Güncelleme Formu",
            newDefaultContentForm: "Yeni Hazır İçerik Kayıt Formu",
            updateDefaultContentForm: "Hazır İçerik Güncelleme Formu",
            newSubjectForm: "Yeni Konu Kayıt Formu",
            updateSubjectForm: "Konu Güncelleme Formu",
            showIntro: "Tanıtımı Göster",
            showChatColorMeaning: "Sohbet Renkleri",
            options: "Seçenekler",
            resetPassword: "Şifreyi yenile",
            audioLevel: "Sesli uyarı ses seviyesi",
            privateChatNotificationSound: "Bildirim sesi",
            continue: "Devam et",
            newRoleForm: "Yeni Rol Kayıt Formu",
            updateRoleForm: "Rol Güncelleme Formu",
            newUserForm: "Yeni Kullanıcı Kayıt Formu",
            updateUserForm: "Kullanıcı Güncelleme Formu",
            changeOSRForm: "Çevrimdışı Mesaj Değiştir",
            tooltipOSRForm: "Çevrimdışı mesajı değiştireblirsiniz.",
            newOSRForm: "Çevrimdışı Destek Formu",
            newOSRMessages: "Çevrimdışı Mesaj Ekle",
            newOsrMessageTitle: "Çevrim Dışı Mesaj Başlığı",
            updateOSRForm: "Çevrimdışı Güncelleme Formu",
            osrTitle: "Başlık",
            osrTitleDescription: "Çevrimdışı destek formu başlığı ekleyebilirsiniz",
            osrContent: "İçerik",
            osrContentDescription: "Çevrimdışı destek formu içeriği ekleyebilirsiniz",
            hello: "merhaba dünya",
            date: "Tarih",
            startDate: "Başlangıç Tarihi",
            finish: "Bitiş",
            start: "Başlangıç",
            search: "Ara",
            endDate: "Bitiş Tarihi",
            representative: "Temsilciler",
            representative_: "Temsilci",
            star: "Yıldız",
            filter: "FİLTRELE",
            reset: "SIFIRLA",
            dailyChatList: "Günlük Konuşma Listesi",
            dailyChatDuration: "Günlük Konuşma Süreleri",
            chatDuration: "Konuşma Süresi",
            dailyChatGraph: "Günlük Konuşma Grafiği",
            ok: "Tamam",
            cancel: "Vazgeç",
            chatCount: "Chat Sayısı",
            shortest: "En Kısa",
            longest: "En Uzun",
            average: "Ortalama",
            count: "Adet",
            averagePoint: "Ortalama Puan",
            pointDist: "Puan Dağılımı",
            point: "Puan",
            filters: "Filtreler",
            totalCustomer: "Toplam Müşteri",
            avResponseTime: "Ort. İlk Müdahale Zamanı",
            breakDuration: "Mola Süresi",
            breakCount: "Mola Adeti",
            active: "Aktif",
            passive: "Pasif",
            userForm: "Kullanıcı Formu",
            startChat: "Chat Başlat",
            sender: "Gönderen",
            profile: "Profil",
            name: "Ad",
            number: "Numara",
            username: "Kullanıcı Adı",
            updateUserName: "Kullanıcı Adı Güncelle",
            email: "E-Posta",
            password: "Şifre",
            oldPassword: "Eski Şifre",
            newPassword: "Yeni Şifre",
            passwordAtLeast: "Şifre (en az {num} karakter)",
            passwordRepeat: "Şifre Tekrar",
            changePassword: "Şifre Değiştir",
            status: "Durum",
            enableState: "Aktif?",
            douYouWishToDeleteUser: "Bu kullanıcıyı gerçekten silmek istiyor musunuz?",
            douYouWishToDeleteAnnouncement: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            userDeleted: "Kullanıcı silindi",
            userSaved: "Kullanıcı kaydedildi.",
            oldPasswordError: "Eski şifre hatalı, lütfen kontrol edin.",
            chooseAnOption: "Lütfen tercih ettiğiniz bildirim sesini seçin.",
            userVolumeUpdated: "Ses ayarı güncellendi.",
            save: "Kaydet",
            update: "Güncelle",
            addNewMenu: "Yeni Menü Ekle",
            addNewContent: "Yeni İçerik Ekle",
            pleaseTitleEnter: "Lütfen başlık girin",
            like: "Beğenilme",
            disLike: "Beğenilmeme",
            users: "Kullanıcılar",
            visitor: "Ziyaretçiler",
            allContacts: "Tüm Bağlantılar",
            allUsers: "Tüm Temsilciler",
            allSites: "Tüm Siteler",
            newUser: "Yeni Kullanıcı",
            noNewUser: "Henüz bir kullanıcı yok.",
            noNewAdminUser: "Henüz bir admin kullanıcı yok.",
            noNewAnnouncement: "Henüz bir duyuru yok.",
            noRoleFound: "Henüz bir rol yok.",
            noBannedWordFound: "Henüz yasaklı kelime yok.",
            noWelcomeMessageFound: "Henüz sistem mesajı yok.",
            noSubjectFound: "Henüz konu yok.",
            noVisitorFound: "Ziyaretci bulunamadı.",
            noContactFound: "Rehber bulunamadı.",
            sendResponse: "Cevap Yaz",
            delete: "Sil",
            duplicate: "Kopyala",
            makeDefault: "Varsayılan Yap",
            checkMore: "Daha Fazlası",
            useReadyTemplates: "Hazır Şablonlar Kullanın",
            useAITemplates: "Hazır Yapay Zeka Şablonları Kullanın",
            noRePresentativeFound: "Temsilci bulunamadı.",
            noLiveSupportFound: "Henüz canlı destek kaydı yok.",
            noLiveSupportFoundWithDepartment: " Departmanına Ait Chat Kaydı Yoktur",
            noBannedVisitorFound: "Henüz bir yasaklı ziyaretçi yok.",
            removeBanDescription: "Yasağı kaldır",
            editThisItem: "Bu kaydı güncelle",
            removeThisItem: "Bu kaydı sil",
            role: "Rol",
            newRolePlaceHolder: "Yeni rol eklemek için tıklayınız...",
            autoChatAssignLimit: "Otomatik Konuşma Atama Limiti",
            chatAssignInfo: "-1 = Sistem varsayılanı, 0 = Hiç atama yapılmaz, >0 = Verilen değer kadar atama yapılır.",
            relatedDepartments: "İlgili Departmanlar",
            subjectInfo: "Konu seçilmemesi halinde tüm konulara izin verilecektir..",
            archive: "Arşiv",
            offlineSupportRequests: "Çevrimdışı Destek",
            offlineModeMessage: "Çevrimdışı Mesaj",
            offlineMode: "Çevrimdışı Mod",
            first: "İlk",
            last: "Son",
            query: "Ara",
            clean: "Temizle",
            loading: "Yükleniyor",
            loadMore: "Daha fazla yükle",
            noMessage: "Hiç mesaj yok...",
            selectChat: "Konuşma Seçiniz",
            noMessageInChat: "Bu konuşmada herhangi bir mesaj bulunamadı",
            noMediaToShow: "Gösterilecek Medya Yok",
            userInfo: "Kullanıcı Bilgileri",
            firstSeen: "İlk Görülme",
            userProfile: "Profil",
            addCalendarEvent: "Etkinlik +",
            chatId: "Konuşma ID",
            visitorId: "Ziyaretçi ID",
            visitingPage: "Ziyaret Edilen Sayfa",
            osAndBrowser: "İşletim Sistemi & Tarayıcı",
            customerClientVersion: "Müşteri Versiyonu",
            visitorFeedback: "Müşteri Geri Bildirimi",
            notes: "Notlar",
            nameSurname: "Adı Soyad",
            chats: "Konuşmalar",
            bannedVisitors: "Yasaklı Ziyaretçiler",
            country: "Ülke",
            city: "Şehir",
            cityDistrict: "İl İlçe",
            browser: "Tarayıcı",
            os: "İşletim Sistemi",
            ipAddress: "IP Adresi",
            connectionDate: "Bağlantı Zamanı",
            transaction: "İşlem",
            banRemoved: "Engelleme kaldırıldı.",
            bannedWords: "Yasaklı Kelimeler",
            newBannedWord: "Yeni Yasaklı Kelime",
            noBannedWord: "Henüz bir engelli kelime yok.",
            bannedWordForm: "Yasaklı Kelime Formu",
            word: "Kelime",
            bannedWordAndWordGroup: "Yasaklı kelime / kelime grubu",
            doYouWishToDeleteBannedWord: "Bu yasaklı kelimeyi gerçekten silmek istiyor musunuz?",
            doYouWishToOfflineSupportRequest: "Bu mesajı silmek istiyor musunuz?",
            bannedWordSaved: "Yasaklı kelime kaydedildi",
            deletedSuccessfully: "Başarıyla silindi",
            deleteErrorMsg: "Silme işlemi gerçekletirilemedi, tekrar deneyiniz",
            socketError: "Sockete Bağlantı sorunu. Lütfen sayfayı yenileyip tekrar deneyiniz",
            socketConnecting: "Sunucu ile bağlantı kuruluyor",
            offlineModeDescription: "Sistem kapalı, müşteriler canlı desteğe erişemeyecek.",
            offlineModeSettingsDescription: "Ayarlar menüsünde 'Çevrimdışı Mod' özelliğini kontrol edin.",
            offlineModeUser: "Sistemde en az bir online temsilci olması gerekir.",
            adminCannotConnectSocket: "Adminler sokete bağlanamaz.",
            liveSupport: "Canlı Destek",
            siteVisitors: "Site Ziyaretçileri",
            visitors: "Ziyaretçiler",
            mail: "Mailler",
            thoseConnectedToLiveSupport: "Canlı Desteğe Bağlananlar",
            visitorHistory: "Ziyaretçi Geçmişi",
            visitorHistoryDescription: "Ziyaretçi sohbet geçmişini görüntüleyebilir ve indirebilirsiniz.",
            privateMessage: "Özel Mesaj",
            addRepresentative: "Temsilci Ekle",
            forwardRepresentative: "Temsilciye Yönlendir",
            keyboardShortcuts: "Klavye Kısayolları",
            chatColorMeanings: "Konuşma Renk Anlamları",
            connLostCheckInternet: "Bağlantınız koptu. Lütfen internet bağlantınızın olduğundan emin olunuz.",
            wishToEndThisChat: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            defaultContents: "Şablonlar",
            contents: "İçerikler",
            newDefaultContent: "Yeni Hazır İçerik",
            newCTRLContent: "CTRL İçeriği Ekle",
            newALTContent: "ALT İçeriği Ekle",
            newTABContent: "TAB İçeriği Ekle",
            shortcutChar: "Kısayol Karakteri",
            pickOne: "Birini seçin",
            writeSomething: "Bir karakter yazın (a-z|0-9)",
            letterSequence: "Harf Serisi",
            exampleText: "Örnek: fut -> futbol",
            anyChar: "Herhangi bir karakter",
            shorcutKey: "Kısayol tuşu",
            content: "İçerik",
            shortcutName: "Kısayol Adı",
            type: "Tip",
            shortcut: "Kısayol",
            deleteContentQuestion: "Bu Hazır İçeriği gerçekten silmek istiyor musunuz?",
            defaultContentDeleted: "Hazır İçerik silindi.",
            defaultContentSaved: "Hazır İçerik kaydedildi.",
            defaultContentForm: "Hazır İçerik Formu",
            titleContentForm: "Hazır İçerik Başlığı",
            contentMoved: "İçerik taşındı.",
            cannotMoveFullParent: "Bu elemanı taşıyamazsınız",
            yourEmail: "E-Posta Adresiniz",
            yourName: "Adınız ve Soyadınız",
            lostPassword: "Şifremi Unuttum",
            login: "Giriş",
            forgotPassword: "Parolamı Unuttum",
            multipleSession: "Başka bir yerde oturum açtınız.",
            notAuthorizedToDisplayPage: "Bu sayfayı görüntülemek için izniniz bulunmuyor!",
            permissions: "İzinler",
            newPermission: "Yeni İzin",
            permissionForm: "İzin Formu",
            displayTitle: "Görüntüleme başlığı",
            key: "Anahtar",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: "Bu izni gerçekten silmek istiyor musunuz?",
            permissionDeleted: "İzin silindi.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Yeni Rol",
            selectARole: "Bir Rol Seç",
            yes: "Evet",
            no: "Hayır",
            fullAuth: "Tam Yetki",
            roleDeleted: "Rol silindi.",
            sameRole: "Aynı isimde bir rol mevcut",
            roleSaved: "Rol kaydedildi.",
            roleForm: "Rol Formu",
            roles: "Roller",
            settings: "Ayarlar",
            selectTopic: "Departman Seçimi",
            autoCallTransfer: "Otomatik Görüşme Aktarımı",
            customerTyping: "Kullanıcı Yazıyor",
            typing: "Yazıyor",
            agentTyping: "Temsilci  Yazıyor",
            disconnectTime: "Konuşmayı Sonlandırma Süresi (sn)",
            tippyDissconnectTime: "Hareketsiz durumdaki konuşmayı kaç saniye sonra kapatılacağını ayarlar",
            queueNumberVisibleFeature: "Ziyaretciye Sırada Bekleyen Kişi Sayısını Göster",
            privateChatEnabled: "Temsilciler Arası Sohbeti Göster",
            delayedTalkTime: "Gecikme Süresi(sn)",
            employeeAverageChatCount: "Personel chat oranı için ortalama konuşma sayısı",
            customerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            autoAssignLimit: "Otomatik Atama Limiti",
            wasted: "Boşa Düşme Süresi (sn)",
            settingsSaved: "Ayarlar kaydedildi.",
            settingsCannotSaved: "Ayarlar Kaydedilemedi",
            noAuthorization: "Yetkiniz Yok!",
            warningBadInput: "0 ile 70 arasında bir sayı girmeniz önerilir.",
            warningBadInputMarginY: "Dikey Kenar Boşluğu Girişi Hakkında Uyarı ⚠️",
            warningBadInputMarginX: "Yatay Kenar Boşluğu Girişi Hakkında Uyarı ⚠️",
            warningBadInputBubbleSize: "Balon Boyutu Girişi Hakkında Uyarı ⚠️",
            settingFormWrong: "Girdiğiniz veriler hatalıdır, kontrol edip tekrar deneyiniz",
            delayTime: "Gecikme Zamanı (sn.)",
            sites: "Siteler",
            newSite: "Yeni Site",
            noSiteYet: "Henüz bir site yok.",
            siteAddress: "Site Adresi",
            turnBack: "Geri Dön",
            customerRepLimit: "Müşeri Temsilcisi Limiti",
            siteSaved: "Site kaydedildi.",
            siteSaveError: "Site oluştururken hata oluştu.",
            subjects: "Konular",
            newSubject: "Yeni Konu",
            noSubject: "Henüz bir konu yok.",
            subject: "Konu",
            subjectTitle: "Konu Başlığı",
            infoAboutSubject: "Konu hakkında kısa bilgi",
            deleteSubjectQuestion: "Bu konuyu gerçekten silmek istiyor musunuz?",
            subjectDeleted: "Konu silindi",
            subjectSaved: "Konu kaydedildi.",
            osrFromMessageSaved: "Çevrimdışı mesaj kaydedildi.",
            welcomeMessages: "Sistem Mesajları",
            newWelcomeMessages: "Yeni Karşılama Mesajı",
            noWelcomeMessage: "Henüz bir sistem mesajı yok.",
            welcomeMessageContent: "Sistem mesaj içeriği",
            makeChoice: "Bir seçim yapın...",
            welcomeMessage: "Karşılama Mesajı",
            repLoggedIn: "Temsilci oturum açtı",
            loginMessage: "Oturum kapatma mesajı",
            message: "Mesaj",
            messageTitle: "Başlık",
            deleteWelcomeMessageQuestion: "Bu sistem mesajını gerçekten silmek istiyor musunuz?",
            welcomeMessageDeleted: "Sistem mesajı silindi",
            welcomeMessageSaved: "Sistem mesajı kaydedildi.",
            welcomeMessageForm: "Sistem Mesajı Formu",
            noRep: "Henüz bir temsilci yok.",
            addChat: "Görüşmeye Ekle",
            forwardChat: "Görüşmeyi Yönlendir",
            ago: "önce",
            repName: "Temsilci Adı",
            lastOnline: "Son Bağlantı/Online zamanı",
            lastStatusChange: "Son Durum Değişikliği",
            activeChat: "Aktif konuşma",
            userMaxCapacity: "Max Chat Kapasitesi",
            noActiveChat: "Aktif konuşma yok.",
            watch: "İZLE",
            join: "KATIL",
            open: "KONUŞMAYI AÇ",
            directMessage: "ÖZEL MESAJ",
            block: "ENGELLE",
            transactions: "İşlemler",
            informations: "Bilgiler",
            visitStart: "Ziyaret Başlangıcı",
            fullName: "Adı Soyadı",
            waitChatTime: "Bekleme Süresi/Chat Süresi",
            blockUserConfirm: "Bu kişiyi gerçekten engellemek istiyor musunuz?",
            messaging: "Mesajlaşma",
            hideChat: "Konuşmayı Gizle",
            block_: "Engelle",
            privateMessage_: "Gizli Mesaj",
            assignRep: "Temsilci Ata",
            joinChat: "Konuşmaya Katıl",
            forwardRep: "Yönlendir",
            leaveChat: "Görüşmeden Ayrıl",
            endChat: "Görüşmeyi Sonlandır",
            translatedTextDescription: "Amazon  bu mesajın {from} -> {to} çevirisini yapmıştır.",
            autoTranslate: "Otomatik Tercüme",
            translateThisMessage: "Bu mesajı çevir",
            autoTranslateDetectedDesc:
                "Ziyaretçi {visitorLanguage} dilinde konuşuyor. Otomatik Tercümeyi Etkinleştirmek İçin Buraya Tıklayın",
            on: "Açık",
            off: "Kapalı",
            copy: "Kopyala",
            prevChats: "Önceki Konuşmalar",
            noShortCut: "Kısayol yok",
            leaveChartConfirm: "Konuşmadan ayrılmak istediğinize emin misiniz?",
            endChatConfirm: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            chatBar: "Konuşma Gösterge Paneli",
            endConversation: "Görüşmeyi Sonlandır",
            onlyOneRep: "Bu konuşmadaki tek temsilci sizsiniz!",
            chatList: "Konuşma Listesi",
            unreadTitle: "Okunmamış",
            visitorLeftTitle: "Ziyaretci Çıkış",
            activeChatTitle: "Aktif Konuşma",
            autoAssignedTitle: "Otomatik Atanmış",
            watchModeTitle: "İzleme Modu",
            lostChat: "Temsilci Bağlantısı Kopmuş",
            repLostConn: "Temsilci konuşmadan koptu ise konuşma arkaplanı pembe olur.",
            chatWidthDelay: "Gecikmeye Düşen Chat",
            repChatWidthDelay:
                "Sistemde aktif temsilci olmadığında veya yoğunluktan dolayı ziyaretçi alınmadığında konuşma arka planı yeşil rengi olur. ",
            unreadMsg: "Okunmamış Mesaj Varsa  arkaplan açık mavi olur.",
            visitorLeftChat: "Ziyaretçi konuşmadan ayrıldı ise arkaplan koyu gri olur.",
            activeChatMsg: "Konuşma aktif ise arkaplan yeşil olur",
            autoAssignMsg: "Otomatik atama ile atandı ve konuşmaya daha bakılmadı ise arkaplan hardal olur",
            watchModeMsg: "İzleme modunda açıldı ise arkaplan kırmızı olur",
            online: "Çevrimiçi",
            beRightBack: "Hemen Dönecek",
            away: "Hemen Dönecek",
            busy: "Meşgul",
            offline: "Çevrimdışı",
            logout: "Çıkış Yap",
            forWindows: "Windows İçin",
            forMac: "Mac İçin",
            nextChatFromActive: "Aktif konuşmadan bir sonraki konuşmaya geç {shortcut}",
            previousChatFromActive: "Aktif konuşmadan bir önceki konuşmaya geç {shortcut}",
            hideActiveChat: "Aktif konuşmayı gizle {shortcut}",
            closeActiveChat: "Aktif konuşmayı bitir {shortcut}",
            firsthiddenChat: "En çok beklemiş müşterinin konuşmasına bağlan {shortcut}",
            firstChatWaiting: "{shortcut} Cevap bekleyen konuşmaya geçiş yap",
            previousOpenedChat: "{shortcut} Sıra farketmeksizin, bir önce açılan konuşmaya geçiş yap",
            hashHintMessage: "{shortcut} ile hashtag kısayollarını hızlıca girebilirsiniz",
            pmHintMessage: "{shortcut} İle Gizli mesaj Gönderebilirsiniz (Örnek pm: selam)",
            vtippyTicketNotification: "Size gelen her yeni ticket için bildirim ayarları",
            newTicketSound: "Yeni Ticket",
            vtippyDepartmentNotification: "Departman konuşmasından gelen mesajlar için bildirim ayarları ",
            vtippyGroupNotification: "Oluşturulan gruplardan gelen mesajlar için bildirim ayarları ",
            vtippyAnnouncemenNotification: "Yeni gelen duyurular için bildirim ayarları",
            billingAddress: "Fatura Adresi",
            addNewAddress: "Yeni Adres Ekle",
            adressTitle: "Adres Başlığı",
            address: "Adres",
            languageSelection: "Dil Seçimi",
            shortcutHintMessage: "Kısayol mesajları ile daha hızlı mesajlar iletebileceğinizi biliyormusunuz. ",
            switchBetweenConversations: "kısayolları ile chatler arası hızlıca geçiş yapabileceğini biliyor musun?",
            atNameHintMessage: "{shortcut} ile ziyaretçinin adını hızlıca yazabileceğini biliyor musun?",
            dndHintMessage: "Sürükle bırak ile dosya upload edebilirsiniz.",
            pasteFile: "{shortcut} ile dosya gönderebilirsiniz.",
            atEmailHintMessage: "{email} ile ziyaretçinin E-postasını hızlıca yazabileceğini biliyor musun ?",
            pastePlainText: "{shortcut} Kopyaladığınız ifadeyi stilsiz düz metin olarak yapıştırır.",
            pressAndTalk: "Basarak konuşmanı yazıya dökebilirsin",
            historyDetails: "Geçmiş Detayları",
            chat: "Konuşma",
            chatNotFound: "Konuşma Bulunamadı.",
            dataNotFound: "Data bulunamadı",
            visitorInfo: "Ziyaretçi Bilgileri",
            timeSpent: "Geçen Süre",
            noActiveVisitors: "Aktif ziyaretçi yok",
            select: "Seç",
            fullname: "Tam Ad",
            text: "Metin",
            numeric: "Sayısal",
            phone: "Telefon",
            optionsPlaceholder: "Seçenek değeri",
            selectField: "Açılır Menü eklemek istiyorsanız tıklayın",
            fullnameField: "Tam Ad alanı eklemek istiyorsanız tıklayın.",
            textField: "Metin alanı eklemek istiyorsanız tıklayın.",
            labelField: "Açıklama alanı eklemek istiyorsanız tıklayın.",
            numericField: "Sayısal alanı eklemek istiyorsanız tıklayın.",
            phoneField: "Telefon alanı eklemek istiyorsanız tıklayın.",
            departmentField: "Bölüm eklemek istiyorsanız tıklayın",
            emailField: "Email alanı eklemek istiyorsanız tıklayın.",
            visible: "Görünür",
            required: "Zorunluluk",
            label: "Açıklama",
            totalConnected: "Konuşma Sayısı",
            missedChat: "Kaçan Konuşma Sayısı",
            workTime: "Mesai Süresi",
            closedChatCount: "Kapatılan Konuşmalar",
            activeConvo: "Aktif konuşulan",
            notAnswered: "Henüz cevap verilmemiş",
            delayedConvo: "Gecikmiş Konuşmalar",
            leavingRep: "Ayrılan temsilci",
            staffRate: "Personel Çalışma Oranı",
            customLoginAlert: "Formunuzda  en az 1 adet görünür alan olmak zorundadır.",
            atLeastOneLanguage: "En az bir dil açıklaması olmak zorundadır.",
            requiredField: "Bu alan zorunludur.",
            notRequiredField: "Bu alan zorunlu değildir.",
            visibleField: "Bu alan formda gözükür.",
            notVisibleField: "Bu alan formda gözükmez.",
            connectServer: "Sunucuya bağlısınız",
            disconnectServer: "Sunucu ile bağlantınız kesildi",
            liveChatOff: "Canlı Destek Kapalı",
            visitorScreen: "Ziyaretçi Ekranı",
            viewOnTheSite: "Sayfada Görüntüle",
            viewOnTheSiteTippy: "Yaptığınız Değişikliklerin Nasıl Durduğunu Görmek İçin Tıklayın.",
            showHint: "İpucu Göster",
            dontShowHint: "İpucu Gösterme",
            liveChatOn: "Canlı Destek Açık",
            nightModeOff: "Gece Modu Kapalı",
            nightModeOn: "Gece Modu Açık",
            edit: "Düzenle",
            deleteField: "Sil",
            arrow_upward: "Yukarı Taşı",
            arrow_downward: "Aşağı Taşı",
            doubleClickEdit: "Düzenlemek için iki kere tıklayın veya düzenle butonuna basın.",
            newCatalogCategory: "Yeni Katalog Kategorisi",
            childCreate: "Alt içerik oluşturmak için tıklayın",
            updateCatalogCategoryFrom: "Katalog Kategori Güncelle Formu",
            newCatalogCategoryFrom: "Yeni Katalog Kategori Formu",
            catalogMenu: "Menü",
            catalogContent: "İçerik",
            catalogCategoryName: "Katalog kategori adı",
            newCatalogContentFrom: "Yeni Katalog İçerik Formu",
            catalogContentName: "Katalog içerik adı",
            catalogCategorySaved: "Katalog katagorisi kaydedildi",
            catalogCategoryDeleted: "Katalog kategorisi silindi.",
            catalogCategoryRate: "İçerik Puanı",
            catalogContentFeature: "Katalog Özelliği",
            vtipyAudioLevel: "Bildirim seslerini kısmanız veya açmanız için kullanılır.",
            vtipyOrganizationName: "Organizasyon adını değiştirip güncelleyebilirsiniz.",
            vtipyBrandVisibility: "Supsis etiketinin, chat balonunda gösterip gösterilmeyeği ayarıdır.",
            vtipyBrandVisibilityForced: "Yalnızca ProPlan kullanıcıları değiştirebilir!!",
            vtipyClientDefault: "Temsilci sayfası dilini buradan değiştirebilirsiniz.",
            vtipyCustomerClientDefault: "Müşteri(Chat) sayfasının dilini buradan değiştirebilirsiniz.",
            vtipyVisitorPreferredLang: "Müşteri(Chat) sayfasında konuşma dilini seçebilir.",
            vtipyCustomerClientLanguageDetect: "Müşteri(Chat) sayfasının dilini otomatik olarak algılıyabilirsiniz.",
            vtipySelectTopic:
                "Müşterilerin seçtiği konulara göre departmanlara(konulara) yönlendirmek zorunlu hali gelir.",
            vtipyAutoCallTransfer: "Müsait olan temsilcilere, bekleyen görüşmeleri otomatik atar.",
            vtipyCustomerTyping: "Müşterinin chat ekranında yazdıklarını, temsilci chat ekranında görmenizi sağlar.",
            vtipyAgentTyping: "Temsilcinin yazma durumunu müşteri baloncuğunda gösterir.",
            vtipyQueueNumberVisibleFeature:
                "Temsilcilerin yoğun oldukları zamanda, bağlanmak isteyen müşterilere kaçıncı sırada olduklarını gösterir.",
            vtipyPrivateChatEnabled: "Temsilciler arası konuşma panelini gösterir.",
            vtipyDelayedTalkTime:
                'Bu süre zarfında konuşmaya hiçbir temsilci bağlanmadığında "Geciken Konuşma" olarak etiketlenir.',
            vtipyOfflineMode: "Sistemi çevrim dışı moda almanızı sağlar.",
            vtipyAutoAssignLimit: "Temsilciye otomatik kaç tane müşteri(chat) atama yapılacağını belirler.",
            vtipyCustomerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            tippyDisconnectTime: "Müşteri bağlantısı koptuktan sonra chatin kapanma süresi (sn).",
            changeSettings: "Global Ayarı Değiştirin",
            totalBg: "TOPLAM SOHBETLER",
            activeBg: "SANA ATANMIŞ",
            watchBg: "İZLEME",
            waitingBg: "KUYRUKTAKİLER",
            lateBg: "ÇOK BEKLEYENLER",
            freeBg: "BOŞTA OLANLAR",
            maxCapacityBg: "MAKS KAPASITE",
            addNewSettings: "Yeni Bir Global Ayar Ekleyin",
            darkMode: "Gece Modu",
            clientDefault: "Panel varsayılan dil",
            customerClientDefault: "Müşteri kısmı varsayılan dil",
            customerClientLanguageDetect: "Müşteri kısmı dili otomatik algıla",
            visitorPreferredLang: "Müşteri konuşma dilini seçsin",
            preferredThemeColor: "Konuşma Ekranı Tema Tercihi",
            detail: "İncele",
            langSetting: "Dil Ayarı",
            supportUs: "Bize Ulaşın (Canlı Destek)",
            contactUs: "Bize Ulaşın",
            changeLang: "Dil Değiştir",
            fontSizeSetting: "Ekran Büyütme Ayarı",
            changeLangDesc: "Uygulama dilini {code} olarak ayarlar.",
            trLang: "Türkçe",
            enLang: "İngilizce",
            fieldRequired: "{field} alanı gereklidir.",
            selectALanguage: "Bir Dil Seçiniz",
            selectATheme: "Bir Tema Seçiniz",
            responseForm: "Cevap Formu",
            clientRequestInfo: "Müşteri Talep Bilgisi",
            createdDate: "Oluşturma Tarihi",
            descMessage: "Mesaj",
            new: "Yeni",
            lastLoginPlatform: "Platform",
            requiredFieldField: "Bu alan zorunludur",
            catalogCategoryMenu: "Katalog Kategori menüsü ekle",
            catalogCategoryLeaf: "Katalog kategorisi alt menüsü ekle",
            selectAllPermission: "Tümünü Seç",
            catalogCategories: "Katalog",
            copiedClipboard: "Panoya kopyalandı",
            organizationLogo: "İşletme Logosu",
            changePlan: "Plan Değiştir",
            close: "Kapat",
            vtipyUploadLogo:
                "Şirket logonuzu bu alandan yükleyerek müşteri maillerinde ve müşteri sayfasında kendi logonuzu kullanabilirsiniz.",
            tagName: "Etiket Adı",
            tagDescription: "Etiket Açıklaması",
            tagColor: "Etiket Rengi",
            userInformations: "Kullanıcı Bilgileri",
            incomingChat: "Gelen Chat",
            support: "Destek",
            team: "Takım",
            groups: "Gruplar",
            newConversationStarted: "Yeni görüşme başladı",
            allHistoryLoaded: "Tüm geçmiş yüklendi",
            chatCreator: "Sohbet Oluşturan",
            enterGroupTitle: "Grup başlığı girin",
            requiredTitle: "Başlık alanı boş geçilemez",
            requiredChannel: "Kanal adı boş geçilemez",
            next: "Sonraki",
            add: "Ekle",
            selectPeople: "Kişileri seçin",
            textLimitAlertMessage:
                "WhatsApp'ta karakter sınırlaması 19 karakterdir ve bu sınırdan sonrası görüntülenmez. Ancak web üzerinde, 19 karakter sınırını aşan metinler bir alt satıra otomatik olarak geçirilir ve görüntülenir.",
            Aufgabe: "Görev",
            FromName: "Gönderen Adı",
            ImportFromReadyTemplates: "Hazır Şablonlardan İçe Aktar",
            KeepUsingFeatures: "Özelliklerinizi Kullanmaya Devam Etmek İçin",
            activeSubjects: "Aktif Konular",
            activeUsers: "Aktif Kullanıcılar",
            anWarteschlange: "Kuyruk",
            aprobado: "Onaylandı",
            beginsWith: "İle Başlayan",
            brand: "Marka",
            campaign: "Kampanya",
            cantProceedPayment: "Ödeme işlemine devam edilemedi",
            chatbotScenarioHasBeenCancelled: "Chatbot senaryosu iptal edildi",
            chatbotTickets: "Chatbot Talepleri",
            completado: "Tamamlandı",
            configureTrendyolStoreStoreIntegrationDetail: "Trendyol Mağaza Entegrasyonunuzu Yapılandırın",
            connectZohoZoho: "Zoho CRM'e Bağlan",
            createMoreThanOneOpenAiChannel: "Birden fazla OpenAI kanalı oluşturamazsınız",
            deleteModalModalFormDesc:
                "Bu formu silerseniz, tüm form verileri kalıcı olarak silinecektir. Devam etmek istediğinize emin misiniz?",
            deleteZohoLinkbulkSms: "Toplu SMS",
            deselectAll: "Tüm Seçimi Kaldır",
            failToDeleteGroup: "Grup silinemedi",
            failToDeleteGroups: "Gruplar silinemedi",
            failToFetchGroupContacts: "Grup kişileri getirilemedi",
            favorite: "Favoriler",
            featureIsNotAvailable: "Özellik mevcut değil.",
            group2: "Grup",
            groupByThis: "Buna Göre Grupla",
            groupSubjects: "Konuları Grupla",
            groupedByStatus: "Duruma Göre Gruplandı",
            grouping: "Gruplandırma",
            ifYouSendThisConversationToTheQue:
                "Bu konuşmayı kuyruğa gönderirseniz, sizi sohbetten çıkaracak ve konuşmayı kuyruğa alacaktır. Otomatik atama etkinse, konuşma uygun bir temsilciye atanacak ve size geri dönebilir.",
            initialContact: "İlk Temas",
            isOneOff: "Tek Seferlik",
            manageYourYourTeamGramIntegration: "TeamGram entegrasyonunuzu yönetin",
            mobile: "Mobil",
            needsAssessment: "İhtiyaç Değerlendirmesi",
            noLanguage: "Dil Belirtilmemiş",
            noPermission: "Görev oluşturma izniniz yok.",
            noPlatform: "Platform Belirtilmemiş",
            notAuthorisedChannel: "Bu kanala erişim yetkiniz yok.",
            notCreateMoreThanOneChannel: "Birden fazla Ideasoft kanalı oluşturamazsınız",
            offlineTickets: "Çevrimdışı Talepler",
            onlyActive: "Sadece Aktifler",
            onlyPassive: "Sadece Pasifler",
            passiveSubjects: "Pasif Konular",
            passiveUsers: "Pasif Kullanıcılar",
            payNow: "ŞİMDİ ÖDE",
            removeZohoLinkbulkSms: "Toplu SMS Gönder",
            saveAsAsEmailCustomerGroup: "E-posta Müşteri Grubu Olarak Kaydet",
            saveAsAsWhatsAppCustomerGroup: "WhatsApp Müşteri Grubu Olarak Kaydet",
            saving: "Kaydediliyor...",
            selectGroupingCriteria: "Gruplandırma Kriteri Seçin",
            sendBulkBulkSmsCustomers: "Müşterilerinize Toplu SMS Gönderin",
            showAll: "Hepsini Göster",
            supprimerZohoLinkbulkSms: "Toplu SMS",
            sureDeleteDeleteZohoChannel: "Zoho CRM kanalını silmek istediğinize emin misiniz?",
            suspendedPlan: " özellikleri askıya alındı",
            temperatura: "Sıcaklık",
            ticketSettings: "Talep Ayarları",
            trendyolStoreConnection: "Trendyol Mağazanızı Bağlayın",
            usageLimitExceeded: "Kullanım limiti aşıldı",
            utoForwardToOwnerForce: "Otomatik Temsilciye Yönlendir (Chatbot aktif olsa bile)",
            visitorScreenLabel: "Ziyaretçi Ekranı Etiketi",
        },
        telegram: {
            typeInTelegramToken: "Telegram Token'i Girin",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Telegram Supsis Entegrasyonu",
            telegramAlertForm: "Telegram bot token adresinden alabilirsiniz",
            telegramAlertTitle: "Jetonu gerçekten silmek istiyor musunuz?",
            telegramAlertText: "Belirteç kalıcı olarak kaybolacak!",
        },
        wp: {
            sendingStatus: "Gönderimde",
            sent: "Gönderildi",
            allErrors: "Tüm Hatalar",
            inProcess: "İşlemde",
            sendingStatuses: "Gönderim Durumları",
            downloadCSV: "CSV İndir",
            errorMessage: "Hata Mesajı",
            noNumbersAdded: "Numara Eklenmedi",
            downloadDetails: "Detayları İndir",
            broadcastFound: "{count} toplu gönderim bulundu",
            resendForFailedNumbersTooltip: "Kalan Kişilere Tekrar Gönderim Başlat",
            date: "Tarih",
            walletBalanceInsufficient: "Cüzdan Bakiyeniz Yetersiz.",
            broadcastCreatedSuccess: "Toplu mesaj başarıyla oluşturuldu.",
            broadcastCreateFailed: "Toplu mesaj oluşturulamadı.",
            resendTitlePrefix: "Yeniden Gönderim ({count} kişi): ",
            duplicateTitlePrefix: "Klonlanmış: ",
            broadcastClonedSuccess: "Toplu mesaj başarıyla klonlandı.",
            broadcastCloneFailed: "Toplu mesaj klonlanamadı.",
            broadcastCancelRequestSent: "Toplu mesaj iptal talebi gönderildi. Lütfen bekleyin...",
            broadcastCancelledSuccess: "Toplu mesaj başarıyla iptal edildi.",
            downloadError: "İndirme işlemi sırasında hata oluştu!",
            progressTooltipFormat: "{percent}% ({sent} gönderildi/{total} kişi)",
            successRatioTooltipFormat:
                "Toplam Gönderilen = {total} \n Başarılı Mesaj = {success} \n Başarısız Mesaj = {failed}",
            notAvailable: "Yok",
            fieldRequired: "{field} alanı zorunludur.",
            defaultBroadcastMessageText: "Merhaba {{name}}, bizi tercih ettiğiniz için teşekkür ederiz.",
            sendAgain: "Tekrar Gönder",
            shippingDetails: "Gönderim Detayları",
            whatsapp: "Whatsapp",
            importContactsFromFile: "Kişileri Dosyadan İçe Aktar",
            chatStartingWait: "Konuşma başlatılıyor , Lütfen Bekleyiniz",
            chatStarted: "Konuşma başlatıldı",
            chatNotStarted: "Konuşma başlatılamadı",
            contactSelected: "kişi seçildi",
            startChatWithAnyNo: "Herhangi Bir Numara ile Sohbete Başlayın",
            toLittleChar: "Eksik rakam girildi !",
            typeInANumberDesc: "Sohbet başlatmak için numarayı yazın",
            wpPlusAndLicenceRequired: "Whatsapp Plus Planı ve Lisansı Gereklidir.",
            wpPlusAndLicenceRequiredDesc:
                "Rehberinizde kayıtlı olmayan numaralara sohbet başlatabilmeniz için whatsapp planınızı yükseltmeli ve bir lisans almalısınız.",
            agreement: "Sözleşme",
            purchase: "Satın Alma",
            activating: "Whatsapp Hizmeti Etkinleştirme",
            authenticating: "QR Kodu Doğrulama",
            ready: "Tamamla",
            activationTitle: "Supsis Üzerinde Whatsapp Entegrasyonu Etkinleştirme:",
            wpIntegrationInstruction1: "Whatsapp'ı Telefonunuzda Açın",
            wpIntegrationInstruction2: "Menü'yü yada Ayarlar'ı seçin ve Bağlı Cihazlar'a tıklayın. ",
            wpIntegrationInstruction3: "Kodu taramak için telefonunuzu bu ekrana doğrultun",
            qrGeneratingWait: "QR Kodu Oluşturuluyor lütfen bekleyin...",
            pleaseContinueToWaitUntilCompleted:
                "QR Kodu doğrulandıktan sonra otomatik olarak tamamlandı alanına geçecektir. Lütfen bekleyiniz...",
            authenticatingWait: "Oturum açılıyor, lütfen bekleyin...",
            enableFeature: "Whatsapp Özelliğini Etkinleştir",
            unsubscribeWpInetgration: "Whatsapp Entegrasyonu aboneliğini sonlandır",
            unsubscribeIGIntegration: "Instagram Entegrasyonu aboneliğini sonlandır",
            wpBack: "Geri",
            terminatelWpInetgration:
                "Abonelikten çık butonuna tıkladığınızda whatsapp entegrasyonunuz sonlandırılacaktır.",
            cancelWpInetgration: "Whatsapp entegrasyonunu iptal etmek istiyor musunuz?",
            terminatelIGIntegration:
                "Abonelikten çık butonuna tıkladığınızda instagram entegrasyonunuz sonlandırılacaktır.",
            cancelIGIntgeration: "Instagram entegrasyonunu iptal etmek istiyor musunuz?",
            startChatWp: "Sohbet Başlat",
            readAndAgree: "Okudu onaylıyorum",
            subscribe: "Abone Ol",
            subscribed: "Abone olundu",
            toEnableWpDescription: "Whatsapp Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
            waitForWpActivationDescription:
                "Whatsapp hesap hizmetiniz aktif hale geliyor. Lütfen bekleyin. Yaklaşık 30 saniye sürer.",
            greatWpActivatedDescription: "Whatsapp hesap hizmetiniz etkinleştirildi.",
            unsubscribe: "Abonelikten Çık",
            planDetails: "Özellikler",
            sendReceiveMessage: "Mesaj Gönderme & Alma ",
            sendReceiveImage: "Resim Gönderme & Alma ",
            sendReceiveAudio: "Ses Kaydı Gönderme & Alma ",
            sendReceiveGif: "GIF Gönderme & Alma",
            startChat: "Supsis'te Chat Başlatma",
            supsisFunctionality: "Kullanışlı Supsis Sohbet Özelliği",
            onePhoneMultiAgent: "Tek Telefon ile Birden Fazla Temsilci",
            basicIntegration: "Uğraştırmayan Basit Entegrasyon",
            purchaseHeader: "Supsis-Whatsapp Entegrasyonu Satın Alma",
            wpServices: "Whatsapp Hizmeti",
            wpServicesIntegrationCompleted: "Whatsapp entegrasyonunuz tamamlandı. Artık kullanabilirsiniz.",
            purchasePaymentDescription:
                "Whatsapp Özelliği aydan aya faturalandırılır. Aboneliği kabul ettikten sonra whatsapp hizmetiniz aktif hale gelecektir.",
            wpIntegrationFeatures: "Whatsapp Entegrasyonu Özellikler",
            saveChanges: "Değişiklikleri Kaydet",
            contactList: "Kişi Listesi",
            broadcast: {
                broadcast: "Toplu Mesaj",
                detail: "Detay",
                customer: "Müşteri",
                phoneNumbers: "İrtibat Numaraları",
                showMore: "Daha Fazla Göster",
                showLess: "Daha Az Göster",
                groupName: "Grup İsmi",
                messages: "Mesajlar",
                status: "Durum",
                usageCost: "Kullanım Maliyeti",
                sendingTime: "Gönderme Zamanı",
                progress: "İlerleme",
                groupDetail: "Grup Detayı",
                messagesPerContact: "Kişi Başına Mesaj Sayısı",
                successRatio: "Başarı Oranı",
                message: "Mesaj",
            },
            messages: "Mesajlar",
            broadcastRequests: "Toplu Mesaj İstekleri",
            customerGroups: "Müşteri Grupları",
            messageTemplates: "Mesaj Şablonları",
            plans: "Planlar",
            wpIntegrationRequired: "Whatsapp Entegrasyonu Gerekli",
            wpRequiredIntegrationDescription:
                "Üzgünüz, ziyaret ettiğiniz sayfa whatsapp'ınızı entegre ettiğinizde aktif hale gelecektir.",
            integrateWp: "Hadi, Whatsapp'ı Entegre Edin",
            active: "Aktif",
            archived: "Arşivlenmiş",
            createBroadcastMessage: "Toplu Mesaj Oluştur",
            title: "Başlık",
            description: "Açıklama",
            createdAt: "Oluşturma Tarihi",
            numbers: "Numaralar",
            actions: "Hareketler",
            action: "Aksiyon",
            createCustomerGroup: "Özel bir müşteri grubu oluşturun",
            search: "Ara",
            name: "İSİM",
            contacts: "Kişiler",
            noContactFound: "Kişi Bulunamadı",
            broadcastTitle: "Toplu mesajınıza bir başlık yazın.",
            recipients: "Alıcılar",
            selectRecipients: "Alıcıları Seçin",
            writeYourMessage: "Mesajınızı yazın.",
            schedule: "Planla",
            scheduleNowOrLater: "Şimdi veya daha sonra planlayın.",
            summary: "Özet",
            cancel: "İptal",
            send: "Gönder",
            sending: "Gönderiliyor",
            deleteCustomerGroup: "Bu müşteri grubunu silmek istediğinizden emin misiniz? {name}",
            customerGroupDeleting: "Müşteri grubu siliniyor ...",
            customerGroupDeletingSuccess: "Müşteri grubu başarıyla silindi",
            customerGroupDeletingError: "Müşteri grubu silinirken hata oluştu",
            wpPlusRequired: "Whatsapp Plus Planı Gerekli.",
            broadcastMessageArchived: "Toplu mesaj grubu arşivlendi",
            broadcastMessageNotArchived: "Toplu mesaj grubu arşivlenmedi",
            groupNameSearch: "Müşteri Grubu Adını Yazın",
            groupNameDesc: "Müşteri grubu adı müşteri gruplarınızı tanımlayın",
            save: "Kaydet",
            number: "NUMARA",
            addColumn: "Sütun Ekle",
            addColumnDesc: "Tabloya bir sütun ekleyin",
            addNewContact: "Yeni Kişi Ekle",
            addNewContactDesc: "Tabloya kişi ekleme",
            importFile: "Dosyadan İçe Aktar",
            importFileDesc: "Kişileri excel veya csv dosyasından içe aktarın",
            contactAdded: "Kişi eklendi",
            updateCustomerGroup: "Müşteri grubu güncelleniyor...",
            updateCustomerGroupSuccess: "Müşteri grubu başarıyla güncellendi",
            sendBroadcastMessage: "Toplu Mesaj Gönder",
            columnName: "Sütun Adı",
            columnType: "Sütun Tipi",
            defaultValue: "Varsayılan Değer",
            setDefaultValue: "Varsayılan değeri mevcut kişilere ayarla",
            age: "Yaş",
            location: "Konum",
            gender: "Cinsiyet",
            selectContactFile: "Kişilerin Olduğu Dosyayı Seçin",
            selectContactCsvOrExcel: "Bir CSV veya EXCEL dosyası seçin.",
            importConfiguration: "Dosyanızı içe Aktarın",
            customizeFile: "Eklediğiniz kişiler dosyasını düzenleyin.",
            sendMessageTo: "Mesajı kime göndermek istiyorsunuz?",
            allContact: "Tüm Kişiler",
            messageTypes: "Mesaj Tipleri",
            whenSendMessage: "Mesajı ne zaman göndermek istiyorsunuz?",
            instantlyRightNow: "Hemen Şimdi",
            completed: "Tamamlandı",
            scheduleFuture: "Gelecekteki bir tarih için zamanlama",
            messageDesc: "Mesajınız anında tüm alıcılara gönderilecektir",
            messageSendAt: "Mesajınız adresindeki tüm alıcılara şu tarihte iletilecektir: ",
            estimatedPrice: "Tahmini Fiyat",
            estimatedTime: "Tahmini Süre",
            now: "Şimdi",
            tenMinute: "10 Dakika",
            cancelled: "İptal Edildi",
            failed: "Başarısız",
            running: "Devam Ediyor",
            queued: "Sıraya Alındı",
            scheduled: "Planlanmış",
            noNumberAdded: "Numara Eklenmedi",
            csvOrExcelFile: "CSV veya Excel Dosyası",
            broadcastMessagesToContactFile: "Kişi Listesine Toplu Mesaj Gönderme",
            broadcastMessageTemplates: "Toplu Mesaj Şablonları",
            messageFlow: "Mesaj Akışı",
            textMessageSupport: "Kısa Mesaj Desteği",
            imageMessageSupport: "Resimli Mesaj Desteği",
            spamPreventions: "Spam Mesaj Önleme",
            includesAllBasicPlans: "Whatsapp Paketindeki Tüm Özellikleri İçerir",
            chatbotIntegration: "Chatbot Entegrasyonu",
            messageToNewNumbers: "Yeni Numaralara Mesaj Gönderme",
            broadcastMessageToEveryone: "Herkese Toplu Mesaj Gönderme",
            personalizedBroadcastMessage: "Kişiselleştirilebilir Toplu Mesajlar",
            customerGroupSegmentation: "Müşteri Grubu Segmentasyonu",
            scheduleBroadcastMessage: "Toplu Mesaj Planlama",
            locationMessageSupport: "Konum Mesajı Desteği",
            advancedSpamPreventions: "Gelişmiş Spam Mesaj Önleme",
            whatsappPlans: "Whatsapp Planları",
            selectBestPlan: "Sana uygun planı seç",
            comingSoon: "Çok Yakında...",
            selectFile: "Bir dosya seçin",
            uploadFromComputer: "Bilgisayardan Yükle",
            created: "Oluşturuldu",
            message: "Mesaj",
            cancelIGIntegration: "Do you want to cancel instagram integration?",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            trendyolQandA: "Trendyol Soru-Cevapları",
            chatbotTickets: "Chatbot Talepleri",
            offlineTickets: "Çevrimdışı Talepler",
            ticketSettings: "Talep Ayarları",
            instagramComments: "Instagram Yorumları",
            messengerComments: "Messenger Yorumları",
            facebookComments: "Facebook Yorumları",
            trendyolComments: "Trendyol Yorumları",
            ticketSelection: "Ticket Seçildi",
            bulkClose: "Toplu Kapat",
            igComment: "Instagram Yorum",
            igMentioned: "Instagram Bahsetme",
            incomingReqChatbot: "Chatbot ile Gelen Talepler",
            incomingReqWebForm: "Web Formdan Gelen Talepler",
            incomingReqAutomation: "Otomasyondan Gelen Talepler",
            thisPersonEmailAnswered: "Bu kişi e-posta ile cevaplanmak istiyor",
            thisPersonWpAnswered: "Bu kişi WhatsApp üzerinden cevap bekliyor.",
            clickStartWpChat: "WhatsApp chat başlatmak için tıklayınız",
            requestProgress: "Talep İlerleme Durumu",
            requestMessage: "Talep Mesajı",
            clickAddMailAddress: "Mail adresi eklemek için tıklayınız",
            sendReplyCloseTicket: "Cevap Gönder ve Ticket'ı Kapat",
            closeTicket: "Ticket'ı Kapat",
            selectEmailSender: "E-posta Göndericisini Seçin",
            withEmailWillNotRecievice: "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!",
            deleteCommentAndClose: "Yorumu Sil ve Kapat",
            sendReplyAndClose: "Yanıtı Gönder ve Kapat",
            startChatWp: "WhatsApp Chat Başlat",
            sureWantToDeleteTicket: "adet bileti silmek istediğinizden emin misiniz?",
            bulkDeleteConfirmation: "Toplu Silme Onayı",
            selectedTicketSucsDelete: "Seçili biletler başarıyla silindi.",
            thereErrorDeletingTicket: "Biletler silinirken bir hata oluştu.",
            deleteConfirm: "Silme Onayı",
            sureDeleteTicket: "Bu bileti silmek istediğinizden emin misiniz?",
            ticketSucsDelete: "Bilet başarıyla silindi.",
            represantiveSucsAppoint: "Temsilci başarıyla atandı.",
            ticketClosedSucs: "Ticket başarıyla kapatıldı.",
            ticketCloureFailed: "Ticket kapatma işlemi başarısız oldu.",
            unprocessed: "İşlenmemişler",
            pleaseSelectValidStatus: "Lütfen geçerli bir durum seçin.",
            ticketStatusBeenUpdatd: "Bilet Durumu güncellendi.",
            doYouWantCloseTicket: "Ticket'ı kapatmak istiyor musunuz?",
            ticketWillMarkedClosed: "Ticket kapandı olarak işaretlenecek ve arşivlenecek.",
            errorUpdatingTicketFailed: "Ticket Status güncellenirken bir hata oluştu.",
            igCommentDeleteIgPost: "Instagram yorumu IG gönderinizden silinmiştir.",
            igCommentHideChange: "Instagram yorum gizleme durumu değiştirildi.",
            pleaseChooseRepresent: "Lütfen bir temsilci seçin.",
            selectedTicketSucsDelegated: "Seçili biletlere temsilci başarıyla atandı.",
            errorOccuredDuringDelegation: "Temsilci atama işlemi sırasında bir hata oluştu.",
            bulkTicketClosing: "Toplu Bilet Kapatma",
            sureWantCloseTicket: "adet bileti kapatmak istediğinizden emin misiniz?",
            selectedTicketSucsClosed: "Seçili biletler başarıyla kapatıldı.",
            thereErrorClosingTicket: "Biletler kapatılırken bir hata oluştu.",
            changeFilterTicketPage: "Biletler sayfasındaki filtreleri değiştirme",
            nameOfFilter: "Filtrenin adı.",
            filterValue: "Filtre değeri",
            deletesSelectedTickets: "Seçilen biletleri siler",
            idTicketBeDelete:
                "Silinecek biletlerin id'leri.  (seçilen bilet kimlikleri veya listelenen tüm bilet kimlikleri)",
            assignsAgentSelectedTickets: "Seçilen biletlere bir temsilci atar",
            idTicketBeAssigned:
                "Atanacak biletlerin id'leri. (seçilen bilet kimlikleri veya listelenen tüm bilet kimlikleri)",
            idAgentAssigned: "Atanacak temsilcinin kimliği",
            changesStatusSelectedTicket: "Seçilen biletlerin durumunu değiştirir",
            idTicketWhoseStatus:
                "Durumu değiştirilecek biletlerin id'leri. (seçilen bilet kimlikleri veya listelenen tüm bilet kimlikleri)",
            newStatus: "Yeni Durum",
            selectedTicketsSucsUpdated: "Seçili biletlerin durumu başarıyla güncellendi.",
            errorWhileChangingStatus: "Biletlerin durumu değiştirilirken bir hata oluştu.",
            thisPageVoiceAssistant: "Bu Sayfada Sesli Asistanı Var",
            hello: "Merhaba!",
            voiceAssistantContent:
                " Bu sayfada size yardımcı olacak bir <strong>Yapay Zeka Asistanı</strong> olduğunu biliyor muydun?.\n            Asistanı kullanmak için aşağıdaki yöntemleri deneyebilirsiniz:",
            commandHoldingDownTheKey: "tuş kombinasyonuna basılı tutup konuşarak komut verebilirsiniz.",
            topRightContent: "Sağ üst köşedeki",
            clickOnTheIcon: "simgesine tıklayarak asistanı başlatabilirsiniz.",
            sampleVoiceCommands: "Örnek Sesli Komutlar:",
            showMyTickets: "Benim ticketlarımı göster",
            showMeZeynepsOpenTicket: "Bugünkü Zeynep'in açık ticketlarını göster.",
            deleteTicketsScreen: "Ekrandaki ticketları sil",
            assigntLastTicketAli: "Sonuncu ticket'ı Ali'ye ata.",
            changeStatusAllTicket: "Tüm ticketların durumunu yapıldı olarak değiştir.",
            setStatusTicketsScreen: "Ekrandaki ticketların durumları ...... olarak ayarla.",
            assigntUserTicketScreen: "Ekrandaki ticketlara .... kullanıcısına ata.",
            assigntFirstTicket: "İlk ticket'ı bana ata.",
            showIgTickets: "Geçen ayki instagram ticketlarını göster.",
            makeChoice: "Seçim Yap",
            makeAssignment: "Atama Yap",
            tickets: "Ticketlar",
            instagramTickets: "İnstagram Ticketları",
            facebookTickets: "Facebook Ticketları",
            trendyolTickets: "Trendyol Ticketlerı",
            automationTickets: "Otomasyon Ticketlerı",
            supsisFormTickets: "Supsis Form Ticketları",
            columnSettings: "Kolon Ayarları",
            ticketField: "Ticket Alanı",
            contactPropertyFields: "Kullanıcının Değerleri",
            ticketFilterList: {
                archivedRequests: "Arşivlenmiş Talepler",
                comingFromFacebook: "Facebook dan Gelenler",
                comingFromInstagram: "Instagram'dan Gelenler",
                unassignedOpenRequests: "Atanmamış Açık Talepler",
                openRequests: "Açık Talepler",
                requestsOpenedThisWeek: "Bu Hafta Açılan Talepler",
                specialList: "Özel Liste",
                creationDate: "Oluşturulma Tarihi",
                supsisFromTheForm: "Supsis Formdan Gelenler",
                fromTrendyol: "Trendyoldan Gelenler",
                comesWithAutomation: "Otomasyondan Gelenler",
                label: "Etiket",
                status: "Durum",
                subject: "Konu",
                email: "E-Posta",
                name: "İsim",
                phone: "Telefon",
                type: "Tür",
                assignedUser: "Atanan Kullanıcı",
            },
            appointingRepresentative: "Temsilci ata",
            ticketTagFilter: "Ticket Konusu Filtre Etiketi",
            ticketEmails: "Yönlendirelecek E-Posta Listesi",
            save: "Kaydet",
            delete: "Sil",
            transactions: "İşlemler",
            noEmailTicketNotifications: "Ticket Eposta  Yönlendirme Kaydı Bulunamadı",
            emailIsNotValid: "Eposta Adresi Geçersiz",
            emailNotificationDeleted: "Ticket Yönlendirme Kaydı Silindi",
            emailNotificationDeleteError: "Ticket Yönlendirme Kaydı Silinemedi!!",
            tagFilterRequired:
                "Ticket Konusu Filtre Etiketi Gereklidir. Tüm ticket'lar için * (wildcard) etiketini kullanabilirsiniz!",
            emailsRequired: "Ticket Yönlendirmesi için en az 1 Eposta adresi girilmelidir",
            emailNotificationCreated: "Ticket Yönlendirme Kaydı Oluşturuldu",
            emailNotificationCreateError: "Ticket Yönlendirme Kaydı Oluşturulamadı!!",
            ticketForwarding: "Ticket E-posta Yönlendirme",
            ticketTagFilterDesc:
                "Ticket filtrelemek için chatbot tasarımda kullandığınız ticket konularını kullanır. Farklı bir etiket yazıp enter'a basıp ekleyebilirsinz. '*' etiketi seçerseniz tüm ticketları seçer",
            ticketEmailsDesc:
                "Ticket'ların yönlendireleceği eposta listesi. Sistemdeki temsilcilerin adresleri seçerek ekleyebilirsiniz. Sistem dışı  eposta/lar da ekleyebilirsiniz.",
            ticketList: "Ticket Yönlendirme Kuralları",
            ticketTagFilterPlaceHolder: "Ticket filtresi, hepsi için * seçiniz",
            ticketEmailsPlaceHolder: "Yönlendirme eposta listesi",
            assignFirstTicket: "Assign the first ticket to me.",
            assignLastTicketAli: "Assign the last ticket to Ali.",
            assignUserTicketScreen: "Assign the tickets on the screen to the user .....",
            placeholders: "Placeholders",
            ticketStatusBeenUpdated: "Статус билета был обновлен.",
        },
        theme: {
            headerColor1: "Başlık (Sol)",
            headerColor1A: "Başlık Kısmı Renk/Saydamlık",
            headerColor2: "Başlık (Sağ)",
            headerColor2A: "Başlık Kısmı 2. Renk/Saydamlık",
            backgroundColor: "Arkaplan (Sol)",
            backgroundColorA: "Arkaplan 1. Renk/Saydamlık",
            backgroundColor2: "Arkaplan (Sağ)",
            backgroundColor2A: "Arkaplan 2. Renk/Saydamlık ",
            opacity: "Saydamlık",
            textColor: "Genel Metin Rengi",
            errorTheme: "Hata Rengi",
            bubbleBackground: "Temsilci balon rengi",
            bubbleVisitorBackground: "Müşteri balon rengi",
            bubbleBackgroundA: "Temsilci balon saydamlığı",
            bubbleVisitorBackgroundA: "Müşteri balon saydamlığı",
            bubbleText: "Temsilci konuşma rengi",
            bubbleVisitorText: "Müşteri konuşma rengi",
            textFormColor: "Form rengi",
            selectCustom: "Özel Tema Seç",
            font: "Font",
            headerColorSecond: "Başlık Üst Rengi",
            headerColorFirst: "Başlık Alt Rengi",
            backgroundColorFirst: "Arkaplan Üst Rengi",
            formColor: "Form Yazı Rengi",
            buttonColor: "Buton Rengi",
            backgroundColorSecond: "Arkaplan Alt Rengi",
            chatBotButtonText: "Chatbot Yazı Rengi",
            chatBotButtonColor: "Chatbot Buton Rengi",
        },
        billing: {
            paymentId: "Ödeme ID",
            billType: "Fatura Türü",
            invoiceAmount: "Fatura Tutarı",
            invoiceDate: "Fatura Tarihi",
            invalidBill: "Geçersiz Fatura",
            invalidBillNotPossible: "Bu fatura daha oluşmadığı için geçersiz işaretleme yapılamaz.",
            allInvoices: "Tüm Faturalar",
            manualInvoices: "Manuel Faturalar",
            endOfPeriodInvoices: "Dönem Sonu Faturalar",
            purchaseInvoices: "Satın Alımlar",
            paidInvoices: "Ödenmiş Faturalar",
            unpaidInvoices: "Ödenmemiş Faturalar",
            walletDeposit: "Cüzdan Yükleme",
            myInvoices: "Faturalarım",
            updateBillingInfo: "Fatura Bilgilerini Güncelle",
            notFoundSavedBillingAddress: "Kayıtlı fatura adresi bulunmamaktadır",
            notFoundSavedCard: "Kayıtlı kredi kartı bulunmamaktadır",
            cardInfoIsStoredSecurelyByIyzico: "Kart bilgileriniz Iyzico tarafından güvenli bir şekilde saklanmaktadır",
            paymentMethodAndInvoiceAddress: "Ödeme Yöntemi & Fatura Adresi",
            unpaidInvoiceBannerMessage:
                "Ödenmemiş faturanız bulunmaktadır. Hizmet kesintisi yaşamamak için lütfen faturanızı ödeyin.",
            unpaidInvoiceBannerMessageWithDate:
                "Ödenmemiş faturanız bulunmaktadır. {date} tarihinden önce ödeme yapmadığınız takdirde hesabınız askıya alınacaktır.",
            clickToPay: "Ödeme sayfasına git",
            packageDescriptions: {
                whatsapp: "Normal Whatsapp hesabınızı entegre ederek müşterilere her yönden cevap verebilirsiniz.",
                whatsappBusiness:
                    "Whatsapp Business hesabınızı entegre ederek müşterilere her yönden cevap verebilirsiniz.",
                supsis: "Daha çok temsilci ile müşterilerinize daha hızlı ve etkili bir şekilde cevap verebilirsiniz.",
                chatbot: "Chatbot entegrasyonu ile müşterilerinize 7/24 hizmet verebilirsiniz.",
                instagram: "Instagram hesabınızı entegre ederek müşterilere her yönden cevap verebilirsiniz.",
                telegram: "Telegram hesabınızı entegre ederek müşterilere her yönden cevap verebilirsiniz.",
                custom: "Sizin için özel planlarımızdan birini seçerek işletmenize özel çözümler alabilirsiniz.",
                messenger: "Messenger hesabınızı entegre ederek müşterilere her yönden cevap verebilirsiniz.",
                trendyol:
                    "Trendyol hesabınızı entegre ederek müşterilerinizin sorularına hızlıca cevap verebilirsiniz.",
                metaLead: "Meta Lead hesabınızı entegre ederek lead yönetimini panel üzerinden yönetebilirsiniz.",
                customerTables:
                    "Dinamik tablolar oluşturarak müşteri bilgilerinizi, siparişlerinizi ve daha fazlasını yönetebilirsiniz.",
                form: "Form oluşturarak müşterilerinizden bilgi toplayabilir ve bu bilgileri raporlayabilirsiniz.",
                automation:
                    "Otomasyonlar oluşturarak işlerinizi otomatikleştirebilir ve daha hızlı hizmet verebilirsiniz.",
                mail: "Mail entegrasyonu ile müşterilerinize mail gönderebilir ve mail alabilirsiniz.",
                tasks: "Görevler oluşturarak işlerinizi planlayabilir ve takip edebilirsiniz.",
                artificialIntelligence:
                    "Yapay zeka entegrasyonu ile müşterilerinize daha hızlı ve etkili bir şekilde cevap verebilirsiniz.",
                webhook: "Webhook entegrasyonu ile diğer uygulamalarınızı Supsis'e entegre edebilirsiniz.",
                default: "Daha detaylı bilgi için paketleri hemen inceleyin.",
            },
            autoRenew: "Otomatik Yenileme",
            purchased: "Satın Alındı",
            currentPlans: "Mevcut Planlarım",
            expirationDate: "SKT",
            yourNameSurname: "Adınız Soyadınız",
            editCardInformation: "Kart Bilgileri Düzenle",
            invoiceSettings: "Fatura Ayarları",
            invoiceEmailAddress: "Fatura E-Posta Adresi",
            defaultRootEmail: "Varsayılan: Temel e-posta",
            popular: "Popüler",
            selectedPlan: "Seçilen Plan",
            editPlan: "Planı Düzenle",
            removePlan: "Planı Kaldır",
            showPlan: "Planı Göster",
            hiddenPlan: "Planı Gizle",
            contactSales: "Satışla İletişime Geç",
            showLess: "Daha az göster",
            more: "Daha Fazla",
            selectTransactionType: "İşlem Tipi",
            walletLogs: "Cüzdan Kayıtları",
            addBalance: "Bakiye Ekle",
            availableBalance: "Kullanılabilir Bakiye",
            walletTransactions: "Cüzdan Hareketleri",
            autoReload: "Otomatik Yükleme",
            transactionTypes: "İşlem Tipleri:",
            transactionTypesHint: "(Tıklayarak tek seçim, Ctrl+tık ile çoklu seçim)",
            importantInfo: "Önemli Bilgiler",
            walletImportantPoint1:
                "Kartınızdan ödeme alınamazsa sistem otomatik pasife geçer, kendiniz aktif etmelisiniz.",
            walletImportantPoint2:
                "10 dakikada sadece 1 kez yükleme yapar. Yoğun kullanım için hedef bakiyeyi yüksek tutun.",
            walletImportantPoint3: "Daha fazla bildirim için Bildirim Ayarları'ndan açabilirsiniz.",
            walletImportantPoint3Before: "Daha fazla bildirim için ",
            walletImportantPoint3After: "'ndan açabilirsiniz.",
            walletImportantPoint4: 'Otomatik yüklemeleri "Cüzdan Hareketleri" sekmesinde görebilirsiniz.',
            walletImportantPoint5:
                "Yükleme sayısında ve miktarında limitasyon yoktur, doğru ayarları girdiğinizden emin olun.",
            autoBalanceReload: "Otomatik Bakiye Yükleme",
            autoBalanceReloadDesc:
                "Cüzdan bakiyeniz belirlediğiniz eşik değerin altına düştüğünde otomatik olarak bakiye yükler.",
            autoReloadToggle: "Otomatik Yükleme",
            autoReloadToggleDesc: "Bu özelliği aktif/pasif yapabilirsiniz",
            disabledDueToFailure: "Başarısızlık nedeniyle devre dışı bırakıldı",
            thresholdValue: "Eşik Değer (TL)",
            thresholdValueDesc: "Bakiye bu değerin altına düştüğünde otomatik yükleme yapılır",
            reloadMode: "Yükleme Modu",
            reloadModeDesc: "Bakiye eşik değerin altına düştüğünde ne yapılsın?",
            addFixedAmount: "Sabit tutar ekle",
            fixBalance: "Bakiyeyi sabitle",
            modeAddDesc:
                "Bakiye eşik değerin altına düştüğünde belirlenen tutar eklenir. Örn: Eşik 50 TL, Bakiye 30 TL → 200 TL eklenir → Bakiye 230 TL olur.",
            modeFixedDesc:
                "Bakiye eşik değerin altına düştüğünde bakiye belirlenen tutara tamamlanır. Örn: Eşik 50 TL, Bakiye 30 TL → 170 TL eklenir → Bakiye 200 TL olur.",
            amountToAdd: "Eklenecek Tutar (TL)",
            targetBalance: "Hedef Bakiye (TL)",
            amountToAddDesc: "Bakiye eşik değerin altına düştüğünde bu tutar eklenecek",
            targetBalanceDesc:
                "Bakiye eşik değerin altına düştüğünde bakiye bu tutara tamamlanacak (eşik değerden büyük olmalı)",
            panelNotifications: "Panel Bildirimleri",
            panelNotificationsDesc: "Hangi durumlarda bildirim almak istiyorsunuz",
            notifyOnRecharge: "Başarılı yükleme bildirimi",
            notifyOnFailure: "Başarısızlık bildirimi",
            notifyOnDisabled: "Devre dışı bırakılma bildirimi",
            emailNotifications: "Email Bildirimleri",
            emailNotificationsDesc: "Kimler email bildirimi alsın (opsiyonel)",
            emailPlaceholder: "Email adreslerini girin (virgül ile ayırın)",
            emailHint: "Boş bırakırsanız sadece site sahibine email gönderilir",
            lastTrigger: "Son Tetikleme:",
            neverTriggered: "Henüz tetiklenmedi",
            failedAttempt: "Başarısız Deneme:",
            saveSettings: "Ayarları Kaydet",
            tabAll: "Tümü",
            tabAiUsage: "AI Kullanımı",
            tabVoiceAgent: "Voice Agent",
            tabAutomation: "Otomasyon",
            balanceAddedSuccess: "Whatsapp hesap bakiyenize {price}TL Bakiye eklenmiştir",
            balanceAddFailed: "Hesabınıza bakiye eklenemedi.",
            autoRebalanceLoadError: "Auto rebalance ayarları yüklenemedi",
            thresholdMinError: "Eşik değeri 0 veya daha büyük olmalıdır",
            targetBalanceMinError: "Hedef bakiye 0'dan büyük olmalıdır",
            targetBalanceThresholdError: "Hedef bakiye eşik değerden büyük olmalıdır",
            autoRebalanceSaveSuccess: "Auto rebalance ayarları başarıyla kaydedildi",
            settingsSaveFailed: "Ayarlar kaydedilemedi",
            testFailed: "Test başarısız oldu",
            creditCardRequiredForAutoReload: "Otomatik yükleme için önce kredi kartı bilgilerinizi eklemeniz gerekir",
            notificationSettings: "Bildirim Ayarları",
            appsumoPack: "Appsumo Packet",
            updatePlan: "Planı Güncelle",
            createPlan: "Plan Oluştur",
            freePack: "Ücretsiz Plan",
            instantFee: "Anında Ücret Alınacaktır",
            planSequence: "Plan Sırası",
            requiredCodes: "Gerekli Kod Sayısı",
            subHeading: "Alt Başlık",
            featureKey: "Özellik Anahtarı",
            customerKey: "Müşteri Anahtarı",
            monthlyPrice: "Aylık Fiyat",
            monthlyNonDiscounted: "Aylık İndirimsiz Fiyat (Fonksiyonel Olmayan Ekran)",
            twoYearDiscount: "2 Yıllık İndirim",
            yearDisccount: "Yıllık İndirim",
            sixMonthDiscount: "6 Ay",
            threeMonthDiscount: "3 Ay",
            features: "Özellikler",
            sessionCount: "Oturum Sayısı",
            subType: "Abonelik Türü",
            skipTrialVersion: "Deneme Sürümünü Atla",
            skipTrialVersionDesc:
                "Deneme sürümünü atlayabilir ve işletmeniz için uygun paketi seçerek devam edebilirsiniz. Deneme sürümünü atlarsanız, bu eylem geri alınamaz.",
            skipStep: "Bu Adımı Atla",
            switchToPay: "Ödemeye Geç",
            forward: "İleri",
            pleaseFillInCard: "Lütfen kart bilgilerini doldurun!",
            fillInTheBillingAddress: "Lütfen fatura adresi bilgilerini doldurun!",
            cardNumberWrong: "Kart Numarası Yanlış!",
            pleaseConfirmTheUser: "Lütfen kullanıcı sözleşmesini onaylayın.",
            pleaseCheckYourCard: "Lütfen kartınızı ve bilgilerinizi kontrol edin.",
            site: "Site",
            period: "Dönem",
            billStatus: "Fatura Durumu",
            totalPrice: "Toplam Fiyat + KDV",
            depositMoneyWallet: "Cüzdana Para Yatır",
            threeMonthly: "3 Aylık",
            sixMonthly: "6 Aylık",
            twoYearly: "2 Yıllık",
            forever: "Sonsuza dek",
            extraPackage: "Ekstra Paket",
            teamPackage: "Ekip Paketleri",
            adventPackage: "Avantajlı Paketler",
            couponError: "Kupon kodu yanlış veya süresi dolmuş.",
            enterYourCard: "Lütfen Kredi Kartınızı girin",
            invalidCard: "Geçersiz kredi kartı, Ödeme Alınmadı",
            calculateThis: "Şunun için hesaplayın:",
            adventageousPackage: "Avantajlı paket indirimleri!",
            cupponApplied: "Kupon başarıyla uygulandı",
            subStart: "Abonelik Başlatıldı",
            subSuccessStart: "Aboneliğiniz başarıyla başlatıldı.",
            success: "Başarılı",
            succesDesc: "Abonelik başarıyla oluşturuldu.",
            successDesc: "Özelliğiniz başarıyla etkinleştirildi.",
            maxNumber: "Konuşulacak maksimum temsilci sayısı",
            currentAmountDetails: "Mevcut tutarın ayrıntıları",
            endOfMonthForecastDetails: "Ay sonu tahmin ayrıntıları",
            totalAmount: "Toplam Tutar",
            vatAmount: "KDV Tutarı (%20)",
            totalAmountIncludingVAT: "KDV Dahil Toplam Tutar",
            hideDetails: "Ayrıntıları Gizle",
            createInvoice: "Fatura Oluştur",
            reimbursementMade: "Geri Ödeme Yapıldı",
            invalidInvoice: "Geçersiz Fatura",
            balanceTopUp: "WhatsApp Bakiye Yükleme",
            paidSuccessfully: "Fatura başarıyla ödendi.",
            paymentFailed: "Fatura ödeme işlemi başarısız oldu.",
            areYouSurePaid: "Bu faturanın ödenmiş olarak işaretlenmesini istediğinizden emin misiniz?",
            invoiceMarkedPaid: "Fatura ödendi olarak işaretlendi.",
            invoiceMarkedFailed: "Bir hata oluştu ve fatura ödendi olarak işaretlenemedi.",
            areYouSureRefundInvoice: "Bu fatura için bir geri ödeme işlemi yapmak istediğinizden emin misiniz?",
            youMustFillInEmpty: "Tüm boş alanları doldurmalısınız.",
            createdNewInvoice: "Yeni fatura başarıyla oluşturuldu.",
            createdNewInvoiceFailed: "Fatura oluşturulurken bir hata oluştu.",
            invoiceUpdated: "Fatura tutarı başarıyla güncellendi.",
            invoiceUpdatedFailed: "Faturanın güncellenmesinde bir sorun oluştu.",
            plans: "Planlar",
            companyName: "Şirket Adı",
            company: "Şirket",
            individual: "Bireysel",
            person: "Kişi",
            invoiceAddressInfo: "Fatura Adres Bilgileri",
            idNo: "Türk Kimliği",
            taxOffice: "Vergi Dairesi",
            taxNumber: "Vergi Numarası",
            packageCanNotDownSupsis:
                "Paketinizin seviyesi düşürülemiyor. Paketinizi düşürmek için lütfen birkaç Temsilcinizi silin veya devre dışı bırakın.",
            packageCanNotDownWp:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen WhatsApp Kanallarınızdan birkaçını silin.",
            packageCanNotDownWPBussiness:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen WhatsApp İş Kanallarınızdan birkaçını silin.",
            chooseYourPlan: "Plan Seçin",
            numberOfRepresentatives: "Temsilci Sayısı",
            numberOfChannels: "Kanal Sayısı",
            wpNumberOfChannels: "WhatsApp Kanal Sayısı",
            igNumberOfChannels: "Instagram Kanal Sayısı",
            msNumberOfChannels: "Messenger Kanal Sayısı",
            cancelIt: "İptal et",
            activePlan: "Aktif Plan",
            activate: "Etkinleştir",
            noTransition: "Geçiş Yok",
            daysLater: "Günler Sonra",
            payBack: "Geri Öde",
            areYouSoreRefundInvoice: "Bu fatura için iade işlemi yapmak istediğinizden emin misiniz?",
            copied: "Kopyalandı",
            copiedToClipboard: "İçerik panoya kopyalandı.",
            copyFailed: "Kopyalama işlemi başarısız oldu.",
            invoiceGenerated: "Fatura kesildi",
            invoiceNotGenerated: "Fatura kesilmedi",
            notAvailable: "N/A",
            estimated: "Tahmini",
            dueDate: "Son Ödeme Tarihi",
            markAsPaid: "Ödendi İşaretle",
            refundPayment: "Geri Ödeme Yap",
            editInvoice: "Faturayı Düzenle",
            deleteInvoice: "Faturayı Sil",
            adminGroup: "Admin",
            billTypeNone: "Yok",
            billTypeManual: "Manuel",
            billTypeMonthly3: "3 Aylık",
            billTypeMonthly6: "6 Aylık",
            billTypeAnnual: "Yıllık",
            billTypeAnnual2: "2 Yıllık",
            billTypeEducation: "Eğitim",
            billTypeConsultancy: "Danışmanlık",
            billTypeInstallation: "Kurulum",
            billTypeOther: "Diğer",
            paymentNotPossible: "Ödeme Yapılamadı",
            saveCardFirst: "Ödeme yapmak için önce kredi kartınızı kaydediniz.",
            paid: "Ödendi",
            unPaid: "Ödenmemiş",
            editPrice: "Fiyatı Düzenle",
            payNow: "Şimdi Öde",
            youAreCurrentlyOnTrial:
                "Şu anda deneme süresindesiniz. Özel paketleri görmek için şimdi denemeyi atlayabilirsiniz.",
            youAreCurrentlyLimited:
                "Paketleriniz koşulsuz olduğu için şu anda sistem tarafından sınırlandırılmış durumdasınız.",
            youHaveOneRepresentative: "Bir temsilciniz var.",
            deactivateOrDeleteYourPiece:
                "Parça Temsilcinizi devre dışı bırakın veya silin ya da bir temsilci satın alın.",
            youHaveOneWhatsappQRChannel: "Bir Whatsapp QR kanalınız var.",
            deleteYourWhatsAppQR: "Whatsapp QR kanalınızı silin veya bir kanal satın alın.",
            youHaveAWhatsappBusiness: "Bir Whatsapp Business kanalınız var.",
            deleteYourWhatsapp: "Whatsapp Business kanalınızı silin veya bir kanal satın alın.",
            youHaveAnInstagram: "Bir Instagram kanalınız var.",
            deleteYourInstagram: "Instagram kanalınızı silin veya bir kanal satın alın.",
            youHaveAMessenger: "Bir Messenger kanalınız var.",
            deleteYourMessenger: "Messenger kanalınızı silin veya bir kanal satın alın.",
            additionalPackages: "Ek Paketler",
            availablePackages: "Mevcut Paketler",
            buyNow: "Satın Al",
            invoiceInformation: "Fatura Bilgileri",
            invoiceAddress: "Fatura Adresi",
            invoiceType: "Fatura Türü",
            review: "İncele",
            viewDetails: "Detayları Görüntle",
            addNewAddress: "Yeni Adres Ekle",
            enterYourBillingAddress: "Fatura Adresinizi Giriniz",
            selectPlan: "Plan Seç",
            paymentStatus: "Ödeme Durumu",
            amount: "Tutar",
            invoiceID: "Fatura ID",
            expected: "Bekleniyor..",
            currentAmount: "Mevcut Tutar",
            monthlyEstimatedAmount: "Ay Sonu Tahmini Tutar",
            creationDate: "Kesim Tarihi",
            invoiceStatus: "Fatura Durumu",
            invoicePeriod: "Fatura Dönemi",
            newPaymentMethod: "Yeni Ödeme Yöntemi",
            channelCount: "Kanal Sayısı",
            remainingTime: "Kalan Süre",
            chatbotLimit: "Chatbot Limiti",
            free: "Ücretsiz",
            maxChatbotSession: "Maksimum Chatbot Sayısı",
            buyIt: "Satın al",
            renewalDate: "Yenilenme Tarihi",
            monthly: "Aylık",
            yearly: "Yıllık",
            packagePeriod: "Paket Dönemi",
            packageType: "Paket Türü",
            packageManagement: "Paket Yönetimi",
            invoiceManagement: "Fatura Yönetimi",
            futureInvoice: "Gelecek Fatura",
            pastInvoices: "Geçmiş Faturalar",
            creditCard: "Kredi kartı",
            invoice: "Fatura",
            mustBeUpgradePlanForChatBot: "Chatbot özelliğini aktif edebilmeniz için Pro Plan'a geçmelisiniz!",
            incorrect: "Hatalı",
            cardInfo: "Kart Bilgisi",
            billingDetails: "Fatura Detayları",
            firstPreferredCard: "Birincil Kart Olarak Ayarla",
            primary: "Birincil",
            addCardIyzico:
                "Kayıtlı bir kartınız bulunmamaktadır. Aylık kullanım ücretlerinizi ödeyebilmeniz için kart eklemeniz gerekmektedir.Ödeme sistemi iyzico tarafından sağlanmaktadır.",
            billingPlanSettings: "Fatura & Ödeme",
            paymentMethod: "Ödeme Yöntemi",
            billingDate: "Fatura Tarihi",
            isPaid: "Ödeme Durumu",
            billingHistory: "Fatura Geçmişi",
            markPaid: "Ödendi Olarak İşaretle",
            paymentDate: "Ödeme Tarihi",
            pay: "Faturayı Öde",
            newInvoice: "Fatura Oluştur",
            updateBilling: "Fatura Adresini Değiştir",
            updateCard: "Kredi Kartını Değiştir",
            paymentBilling: "Ödeme Metodu & Fatura Adresi",
            price: "Fatura Tutarı",
            billingAddress: "Açık Adres",
            billingCity: "Şehir",
            billingCountry: "Ülke",
            contactName: "Faturalandırma Kişi Adı",
            expireMonth: "Son Kullanma T. Ay",
            expireYear: "Son Kullanma T. Yıl",
            expireDate: "Son Kullanma Tarihi",
            cardNumber: "Kart Numarası",
            cardHolderName: "Kart Üzerindeki Ad Soyad",
            cardAlias: "Kart takma isim",
            identityNumber: "Kimlik/Vergi  Numarası",
            name: "Ad",
            surname: "Soyad",
            email: "Eposta",
            addCard: "Kart Ekle",
            update: "Güncelle",
            cancel: "Vazgeç",
            save: "Kaydet",
            saving: "Kaydediliyor",
            noInvoiceFound: "Fatura kaydı bulunamadı",
            year: "Yıl",
            updating: "Güncelleniyor",
            newInvoiceForm: "Yeni Fatura Oluşturma Formu",
            error: "Hata",
            transactions: "İşlemler",
            paymentMethodAdded: "Ödeme yöntemi başarıyla eklendi",
            paymentMethodAddError: "Ödeme yöntemi eklenemedi, Hata oluştu",
            creditCardChanged: "Kredi kartınız değiştirildi",
            errorOccurred: "Bir hata oluştu, tekrar deneyin.",
            billingDetailUpdated: "Fatura bilgileriniz güncellendi",
            invoiceCreated: "Fatura kaydı başarıyla oluşturuldu",
            paymentSuccess: "Faturanız başarıyla ödendi, teşekkür ederiz",
            paymentFail: "Faturanız ödenirken  hata oluştu daha sonra tekrar deneyiniz.",
            startWith: "{binNumber} ile başlayan {cardFamily} kart",
            billingAddressChanged: "Fatura Adresi bilgileri güncellendi ",
            hidePlan: "Planı Gizle",
            informationShopping:
                "Ödeme bilgileriniz, fatura bilgileriniz, kredi kartı bilgileriniz Shopify tarafından kontrol edilmektedir.",
            trialTimeInformation:
                "Deneme Sürümü bitmesine {dayCount} gün kaldı. Bu süre bitimine kadar ödeme yöntemi girmemeniz durumunda sistem tarafından otomatik olarak FREE Plan'a geçilir.",
            trialTimeInformationShort: "Son {dayCount} Gün",
            currentPlanLabel: "Mevcut Plan: {planName} Plan ({agentCount} Temsilci)",
            changeCancelPlan: "Planı Değiştir/İptal et",
            oneAgent: "Temsilci",
            agent: "Temsilci",
            yourCurrentPlan: "Mevcut Plan",
            month: "Ay",
            billedMonthToMonth: "(Aylık Faturalandırma)",
            selectAgentCount: "Temsilci Sayısı Seçin",
            selectFreePlan: "Free Plan Seçin",
            planDetails: "Plan Detayları",
            multiAgent: "(Çok Temsilci)",
            selectProPlan: "Pro Plan Seçin",
            foreverFree: "Süresiz Free",
            websiteIntegration: "Web Sitesi Entegrasyonu",
            websiteIntegrationUnlimited: "Web Sitesi Entegrasyonu",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Görüntülü Arama",
            multiAgentUpTo: "Çok Temsilcili ({agentCount} Temsilciye Kadar)",
            audioCallUnlimited: "Sesli Arama",
            screenSharingUnlimited: "Ekran Paylaşımı",
            fileTransferUnlimited: "Dosya Paylaşımı",
            autoChatAssignerUnlimited: "Otomatik Sohbet Ataması",
            multiLanguageTranslationUnlimited: "Otomatik Dil Çeviricisi",
            detailedReporting: "Raporlama",
            days30TrialsAvailable: "30-Günlük Ücretsiz Deneme",
            limitedArchiveLookupLastMo: "Sınırlı Arşiv Araması (Son {monthCount}-ay)",
            fullCustomizationUnlimited: "Özelleştirme",
            planUpdated: "Planınız başarıyla güncellendi.",
            planUpdating: "Planınız güncelleniyor...",
            planUpdatingDescription: "Güncelleme süresince lütfen bekleyin!",
            done: "Tamamlandı",
            freePlanUpdated: "Planınız Free Plan olarak güncellendi. (Maksimum Temsilci Sayısı: 1)",
            proPlanUpdated: "Planınız Pro Plan olarak güncellendi. (Maksimum Temsilci Sayısı: {proPlanUpdated}) ",
            canNotDwnGrade:
                "Planınız PRO {agentCountFirst} Temsilci sayısından {valNewPlnToUppr} {agentCountSecond} sayısına  düşürülemez!. Temsilci kredileriniz kullanımda. ",
            deleteWarning: " {valDif} Temsilci silmeniz gerekmektedir.",
            warnMessage: "Seçilen plan, mevcut plandan farklı olmalıdır",
            add: "Ekle",
            cancelYourPlan: "Planını İptal Et",
            upgradeYourPlan: "Planını Yükselt",
            downgradeYourPlan: "Planını Düşür",
            agree: "KABUL ET",
            disagree: "VAZGEÇ",
            invoices: "Faturalar",
            priceIntervals: "Tutar Aralığı",
            selectSiteAlias: "Site Adı Girin veya Seçin",
            selectPriceInterval: "Tutar Aralığı Girin veya Seçin",
            isRefunded: "Geri Ödeme Yapıldı mı?",
            invoiceId: "Fatura No",
            siteId: "Site No",
            createdDate: "Olurşturulma Tarihi",
            failCount: "Başarısız Çekim Denemesi Adeti",
            failDate: "Yapılmayan Ödemenin tarihi",
            Dashboard: "Gösterge Paneli",
            Agents: "Temsilciler",
            Integration: "Entegrasyon",
            Settings: "Ayarlar",
            Contacts: "Kişiler",
            Domain: "Domain",
            lastActivity: "Son Aktivite",
            basePrice: "Taban Fiyat",
            packagePrice: "Paket Fiyatı",
            whatsappPrice: "Whatsapp Fiyatı",
            realtimeVisitorCount: "Anlık Ziyaretçi",
            suspend: "Askıya Al",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Deneme Günü",
            mobile: "Mobil",
            webSite: "Web Sitesi",
            websiteOrigins: "Web Sitesi Kaynağı",
            ownerName: "Sahibinin Adı",
            ownerEmailAddress: "Sahibinin Email'i",
            discount: "İndirim",
            daysLeft: "Kalan Gün",
            newTrialPopUp: "Yeni Deneme Süresi Kaç Gün Olsun",
            newWpPricePopUp: "Yeni Whatsapp Ücreti Ne Kadar Olsun ?",
            newIGPricePopUp: "Yeni Instagram Ücreti Ne Kadar Olsun ?",
            newBasePricePopUp: "Yeni Supsis Taban Fiyatı Ne Kadar Olsun ?",
            siteInfoUpdated: "Site Bilgisi Güncellendi",
            siteInfoNotUpdated: "Site Bilgisi Güncellenmedi",
            siteInfoNotUpdatedErr: "Hata Oluştu! Site Bilgisi Güncellenmedi.",
            billingContactInfo: "Fatura iletişim bilgileri başarıyla güncellendi.",
            compony: "Şirket",
            cuponApplied: "Kupon başarıyla uygulandı",
            cupponError: "Kupon kodu hatalı veya süresi dolmuş.",
            deleteYourWhatsApp: "WhatsApp Business kanalını silin veya yeni bir kanal satın alın.",
            depotMoneyWallet: "Cüzdana Para Yükle",
            newWabaChannel: "Yeni WhatsApp Business Kanalı",
            newWabaChannelDesc: "Yeni bir WhatsApp Business API kanalı oluştur",
            packageCanotDownSupsis:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen bazı temsilcilerinizi silin veya pasife alın.",
            packageCanotDownWPBussiness:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen bazı WhatsApp Business kanallarınızı silin.",
            packageCanotDownWp:
                "Paketiniz düşürülemez. Paketinizi düşürmek için lütfen bazı WhatsApp kanallarınızı silin.",
            paidSuccesfully: "Fatura başarıyla ödendi.",
            planes: "Planlar",
            sito: "Site",
            updateChannelDesc6: "WhatsApp Business Kanalını Güncelle",
            yearDiscount: "Yıllık İndirim",
            youHaveAWhatsAppBusiness: "Bir adet WhatsApp Business kanalınız var.",
            youHaveOneWhatsAppQRChannel: "Bir adet WhatsApp QR kanalınız var.",
        },
        tour: {
            representativeTab: "Temsilci Tablosu",
            stats: "İSTATİSTİK PANELİ",
            chats: "CHAT PANELİ",
            settings: "AYARLAR",
            status: "DURUM",
            prevStep: "Önceki Adım",
            nextStep: "Sonraki Adım",
            finish: "Bitir",
            skip: "Atla",
            skip2: "Sistemi biliyorum bir daha gösterme",
            startTour: "Tura Başla",
            firstTimeIntro:
                "Sisteme ilk defa girdiğini keşfettim izin verirsen ufak bir tanıtıcı tur başlatmak istiyorum",
            hi: "Merhaba",
            welcomeTo: "Supsis Canlı Destek'e Hoşgeldin",
            statsPanel: "Sistemle anlık olarak bekleyen, toplam, aktif chat sayılarını gösteren durum çubuğudur.",
            sidebarMenu: "Menü",
            sidebarMenuContent: "Sayfalar arası geçişleri buradan yapabilirsiniz.",
            representativePrivateMessage: "Temsilciler Arası Konuşma Paneli",
            representativePrivateMessageContent: "Temsilciler arası özel konuşmaları buradan görebilirsiniz.",
            helpMenu: "Yardım Menüsü",
            helpMenuContent: "Sistem hakkında yardım bilgilerine buradan ulaşabilirsiniz.",
            settingsMenu: "Ayarlar Menüsü",
            settingsMenuContent: "Dil, gece modu ve ekran büyütme adımlarını buradan yapabilirsiniz.",
            startChat: "Sohbeti Başlat",
            profileMenu: "Profil Menüsü",
            profileMenuContent: "Müsaitlik durumunuzu değiştireblir ve temsilci ayarlarınızı buradan yapabilirsiniz.",
            visitorsTab: "Ziyaretçiler",
            visitorsTabContent: "Ziyaretçileri buradan görebilirsiniz.",
            visitorTabHistory: "Ziyaretçi Geçmişi",
            visitorTabHistoryContent: "Ziyaretçi geçmişini buradan görebilirsiniz.",
            representativ_eTab: "Temsilciler",
            representativeTabContent: "Temsilcileri buradan görebilirsiniz.",
            liveSupport: "Canlı Destek",
            liveSupportContent: "Canlı Destek alan müşteri sayısını buradan görebilirsiniz. ",
            siteVisitors: "Site Ziyaretçileri",
            siteVisitorsContent: "Site ziyaretçi sayısını buradan görebilirsiniz. ",
            tableSettings: "Tablo Ayarları",
            tableSettingsContent: "Tabloda kolon gösterme veya gizlemeyi buradan yapabilirsiniz.",
            selectColumnsToDisplay: "Gösterilecek kolonları seçin",
            selectAll: "Tümünü Seç",
            deselectAll: "Tümünü Kaldır",
            resetToDefault: "Varsayılana Dön",
            settingsSaved: "Ayarlar kaydedildi",
            watchModeButton: "İzleyici Butonu",
            watchModeContent: "İzleyici mode olarak buradan katılabilirsiniz ve sadece yazılanları görüntülersiniz.",
            popoverInfo: "Ziyaretçi Detay",
            popoverInfoContent: "Ziyaretçi hakkında  bilgi verir.",
            popoverButton: "Gelişmiş Konuşma Ayarları",
            popoverButtonContent:
                "Konuşmayı açar, temsilciye direk mesaj atabilir veya ziyaretçiyi engelleyebilirsiniz.",
            openChat: "Konuşma Katıl Butonu",
            openChatContent: "Konuşmayı buradan açabilirsiniz",
            pagination: "Sayfalama Menüsü.",
            paginationContent: "Sayfa sayısını buradan arttırabilirsiniz.",
            chatwindow: {
                chatWindowSettingsButtons: "KONUŞMA PENCERESİ AYARLAR BUTONU",
                chatWindowActionButtons: "KONUŞMA PENCERESİ GENEL İŞLEM BUTTONLARI",
                chatPanelActions: "KONUŞMA PANELİ İŞLEMLERİ",
                otherPanels: "DİĞER PANELLER",
                settingsButton: "Konuşma engelleme, yönlendirme, gizli mesaj atma ve temsilci atama yapabilirsiniz.",
                chatColorButton: "Konuşma balonlarındaki hangi renk ne anlama geldiğini buradan öğrenebilirsiniz",
                keyboardShortcutButton:
                    "Yazışma esnasında kolaylık sağlayan fonksiyonların veya diğer kullandığın özelliklerin kısayollarını buradan bulabilirsin",
                hideButton: "Açık konuşmayı aşağıya indirir arka planda açık kalmaya devam eder",
                closeButton: "Açık konuşması sonlandırır ve konuşmadan çıkarsınız",
                ellipsisButton:
                    "Daha fazla işlemler burada yer almaktadır. Özel mesaj gönderme , ziyaratci banlama , temsilci atama gibi işlemler buradan yapılır",
                userInfoWidget: "Ziyaretçi hakkında detaylı bilgiler burada yer alacaktır",
                preparedContentWidget:
                    "Burada hazır içerik şablonları bulunmaktadır. İster tıklayarak ister kısayolunu konuşma ekranında yazı yazma alanında kısayol serisi tuşlayarak hazır içerikleri hızlıca ekleyebilirsin",
                chatHistoryWidget:
                    "Bu ziyaretcinin geçmiş konuşmaları varsa burada listelenecektir. Eski konuşma detaylarını buradan inceleyebilirsin",
                chatBarButton:
                    "Aktif konuşmayı buradan engelleyebilir, temsilciye gizli mesaj atabilir ve görüşmeden ayrılabilirsiniz.",
            },
            changeLang: "Can change system language",
            changeStatus: "Can change your availability status",
            changeTheme: "Can switch dark and light theme",
            closeChat: "Close Chat",
            contentStep: "Content Step",
            formStep: "Form Step",
            goToLive: "Connect Representative",
            logout: "Can logout system from here",
            menuStep: "Menu Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            ticket: "Ticket",
        },
        adminUser: {
            newAdminUserForm: "Yeni Admin Kullanıcısı Kayıt Formu",
            updateAdminUserForm: "Admin Kullanıcısı Güncelleme Formu",
            adminUsers: "Admin Kullanıcılar",
            newAdminUser: "Yeni Admin Kullanıcı",
            noAdminUser: "Henüz bir admin kullanıcı yok.",
            adminUserName: "Admin Kullanıcı Adı",
        },
        report: {
            channel: "Kanal",
            channelType: "Kanal Türü",
            contactCount: "Kişi Sayısı",
            tag: "Etiket",
            owner: "Yönetici",
            email: "Email",
            language: "Dil",
            approvalCount: "Onay Sayısı",
            adTitle: "Reklam Başlığı",
            sourceType: "Kaynak Türü",
            mostUsedTag: "En Çok Kullanılan Etiket",
            leastUsedTag: "En Az Kullanılan Etiket",
            timeDistribution: "Zamana Göre Kişi Dağılımı",
            channelDistribution: "Kanala Göre Kişi Dağılımı",
            tagDistribution: "Etiketlere Göre Kişi Dağılımı",
            platformDistribution: "Platforma Göre Kişi Dağılımı",
            ownerDistribution: "Sahibine Göre Kişi Dağılımı",
            languageDistribution: "Dile Göre Kişi Dağılımı",
            adsDistribution: "Reklamlara Göre Kişi Dağılımı",
            adNameDistribution: "Reklam Adına Göre Kişi Dağılımı",
            adsetDistribution: "Reklam Seti Adına Göre Kişi Dağılımı",
            campaignDistribution: "Kampanya Adına Göre Kişi Dağılımı",
            contactPropertyDistribution: "Seçilebilir Profil Alanlarına Göre Kişi Dağılımı",
            mostEffectiveAd: "En Etkili Reklam",
            leastEffectiveAd: "En Az Etkili Reklam",
            totalPersonCount: "Toplam Kişi Sayısı",
            mostUsedChannel: "En Çok Kullanılan Kanal",
            leastUsedChannel: "En Az Kullanılan Kanal",
            columnChart: "Sütun Grafik",
            pieChart: "Pasta Grafik",
            mostUsed: "En Çok Kullanılan",
            leastUsed: "En Az Kullanılan",
            mostUsedLanguage: "En Çok Kullanılan Dil",
            leastUsedLanguage: "En Az Kullanılan Dil",
            mostAssigned: "En Çok Atanan",
            leastAssigned: "En Az Atanan",
            averagePersonCount: "Ortalama Kişi Sayısı",
            mostUsedPlatform: "En Çok Kullanılan Platform",
            leastUsedPlatform: "En Az Kullanılan Platform",
            personCount: "Kişi Sayısı",
            person: "Kişi",
            commentAnalysis: "Yorum Analizi",
            whatsappChannelDistribution: "Whatsapp Kanallarına Göre Chat Dağılımları",
            instagramChannelDistribution: "Instagram Kanallarına Göre Chat Dağılımları",
            messengerChannelDistribution: "Messenger Kanallarına Göre Chat Dağılımları",
            trendyolChannelDistribution: "Trendyol Kanallarına Göre Chat Dağılımları",
            metaLeadsChannelDistribution: "Meta Leads Kanallarına Göre Chat Dağılımları",
            chatDistributionByTelegramChannels: "Telegram Kanallarına Göre Chat Dağılımları",
            chatDistributionByLinkedinChannels: "Linkedin Kanallarına Göre Chat Dağılımları",
            channelTimeseries: "Kanal Zaman Grafiği",
            channelPies2: "Kanal Dağılımları",
            date: "Tarih",
            incomingMessages: "Gelen Mesajlar",
            outgoingMessages: "Giden Mesajlar",
            customerCount: "Müşteri Sayısı",
            mailCount: "Posta Sayısı",
            answered: "Cevaplandı",
            unanswered: "Cevapsız",
            selectChannel: "Bir Kanal Seçin",
            sentMails: "Gönderilen Postalar",
            sentMailCount: "Gönderilen Posta Sayısı",
            ticketDistribution: "Bilet Dağıtımı",
            selectWorkflow: "İş Akışınızı Seçin",
            chartView: "Grafik Görünümü",
            tableView: "Tablo Görünümü",
            fullScreen: "Tam Ekran",
            distributionOfTasks: "Görevlerin Dağılımı",
            mostMissioned: "En Görevli",
            leastTask: "En Az Görev",
            leastTasked: "En Az Görevli",
            totalNumberTasks: "Toplam Görev Sayısı",
            errorFetchingTask: "Görev verileri alınırken hata oluştu:",
            pipelinePhase: "Boru Hattı Aşaması",
            status: "Durum",
            numberOfTasks: "Görev Sayısı",
            insufficientData: "Yetersiz Veri",
            hourly: "(Saatlik)",
            hourlyAverage: "Saatlik Ortalama",
            hourlyMax: "Saatlik Maksimum",
            hourlyMin: "Saatlik Minimum",
            dailyAverage: "Günlük Ortalama",
            dailyMax: "Günlük Maksimum",
            dalyMin: "Günlük Minimum",
            totalAmount: "Toplam Miktar",
            averageAmount: "Ortalama Miktar",
            minAmount: "Minimum Miktar",
            maxAmount: "Maksimum Miktar",
            siteCount: "Site Sayısı",
            agentCount: "Temsilci Sayısı",
            channelsTimeSeries: "Kanallar Grafiği",
            channelPies: "Kanallar Pasta Grafiği",
            pieView: "Pasta Grafiği",
            topVisitorCountry: "En Çok Ziyaretçinin Geldiği Ülke",
            websiteTrafficByCountry: "Ülkeye Göre Website Trafiği",
            visitorCount: "Ziyaretçi Sayısı",
            websiteVisitorTraffic: "Website Ziyaretçi Trafiği",
            websiteTraffic: "Website Trafiği",
            author: "Yazan",
            topWorstComments: "En Kötü Yorumlar",
            topBestComments: "En İyi Yorumlar",
            topBestWorstComments: "En İyi/Kötü Yorumlar",
            topComments: "Yorum Analizi",
            noComment: "Henüz Yorum Yapılmadı",
            minWaitingTime: "Minimum Bekleme Süresi",
            maxWaitingTime: "Maksimum Bekleme Süresi",
            averageWaitTime: "Ortalama Bekleme Süresi",
            waitTime: "Bekleme Süresi (Saniye)",
            agentWaitDurationTitle: "Temsilci Bekleme Süresi Grafiği",
            incomingMessage: "Gelen Mesaj(lar)",
            outgoingMessage: "Giden Mesaj(lar)",
            totalSpent: "Toplam Harcama",
            avgSpent: "Ortalama Harcama",
            totalPayment: "Toplam Yükleme",
            walletStatus: "Cüzdan Durumu",
            walletBalanceStatus: "Cüzdan Bakiyesi Durumu",
            messageTraffic: "Mesaj Trafiği",
            breakCount: "Mola Sayısı",
            agentBreakTime: "Temsilcilerin Mola Sayıları ☕",
            agentStatusHour: "Temsilci Durumu (Saat)",
            agentWorkTimeCalendar: "Temsilci Çalışma Süresi Takvimi",
            agentActivity: "Temsilci Aktivitesi",
            noEnoughtData: "Yeterli Veri Yok",
            averageFirstResponse: "Ortalama İlk Cevap Süresi",
            slowestResponser: "En Yavaş Cevap Veren",
            fastestResponder: "En Hızlı Cevap Veren",
            firstAnswerTimeSec: "İlk Mesaj Süresi (Saniye Olarak)",
            firstAnswerByAgent: "Temsilcilerin İlk Mesaj Süresi",
            averageSolutionTime: "Ortalama Çözüm Süresi",
            slowestSolver: "En Yavaş Çözen",
            fastestSolver: "En Hızlı Çözen",
            averageChat: "Ortalama Chat",
            leastChatReceiver: "En Az Chat Alan",
            mostChatRecipients: "En Çok Chat Alan",
            averageTicket: "Ortalama Ticket",
            leastTicketReceiver: "En Az Ticket Alan",
            mostTicketRecipients: "En Çok Ticket Alan",
            resolveTime: "Çözüm Süresi (dk)",
            resolveTimeByUser: "Kullanıcıya Göre Chat Çözüm Süresi (Dakika olarak)",
            chatResolveTimeByAgent: "Temsilcilere Göre Sohbet Çözüm Süresi",
            chatDistByHandDesc: "Temsilci, chatbot ve hibrit tarafından kaç sohbet gerçekleştirildi?",
            chatDistByHandleType: "Yanıtlayana Göre Chat Dağılımı",
            chatCountsByHandleType: "Yanıtlayana Göre Chat Sayıları",
            missed: "Kaçırıldı",
            chatDistByAnsDesc: "Kaç sohbet yanıtlandı ya da kaçırıldı?",
            chatCountsByAns: "Yanıta Göre Chat Sayıları",
            chatCountByPlatform: "Platforma Göre Chat Sayıları",
            chatDistByPDesc: "Hangi platforma kaç chat geldi?",
            chatDistByPlatform: "Platforma Göre Chat Dağılımı",
            ticketCountByUser: "Temsilcilere Göre Ticket Sayıları",
            ticketCountByStatus: "Yanıtlama Durmuna Göre Chat Sayıları",
            user: "Temsilci",
            saveAsImage: "Görsel olarak indir",
            download: "İndir",
            chatDistByUsers: "Temsilcilere Göre Chat Dağılımı",
            chatCountsByUsers: "Temsilcilere Göre Chat Sayıları",
            minDuration: "Minimum Süre",
            maxDuration: "Maksimum Süre",
            totalDurationByAgent: "Temsilci Toplam Oturum Süresi",
            averageDurationByAgent: "Temsilci Ortalama Oturum Süresi",
            totalDurationByCB: "Chatbot Toplam Oturum Süresi",
            averageDurationByCB: "Chatbot Ortalama Oturum Süresi",
            viewUnitAs: "Birim",
            hybrid: "Hibrit",
            handledBy: "Tarafından:",
            sessionDurationOverall: "Genel Oturum Süresi",
            allChannels: "Tüm Kanallar",
            sessionsDurationOverall: "Oturum Süreleri Genel",
            sessionsOverall: "Oturumlar Genel",
            eventCount: "Etkinlik Sayısı",
            calendarEvents: "Takvim Etkinlikleri",
            reservationEvents: "Rezervasyon Etkinlikleri",
            incomingMails: "Gelen Mailler",
            incomingMailCount: "Gelen Mail Sayısı",
            reservation: "Rezervasyon",
            event: "Etkinlik",
            reservationEventCount: "Rezervasyon Etkinlik Sayısı",
            channelBreakdown: "Kanal Dağılımı",
            websiteAnalysis: "Website Analizi",
            customerSatisfaction: "Müşteri Memnuniyeti",
            teamBreakAnalysis: "Takım Çalışma/Mola Analizi",
            dailyAgentActivity: "Günlük Temsilci Aktiviteleri",
            agentPerformance: "Temsilci Performansı",
            chatDistributions: "Chat Dağılımı",
            contactDistributions: "Kişi Dağılımı",
            users: "Kullanıcı",
            segmentTimeseries: "Segment Grafiği",
            segmentsOverall: "Genel Segmentler",
            unmatchRatio: "Eşleşmeme Oranı",
            totalMatchCount: "Toplam Eşleşme Sayısı",
            totalUnmatchCount: "Toplam Eşleşmeme Sayısı",
            matchRatio: "Eşleşme Oranı",
            matched: "Eşleşen",
            trainingOverall: "Genel Eğitim",
            trainingStatusTimeseries: "Eğitim Durumu Zaman Grafiği",
            duration: "Süre",
            totalSessionDuration: "Toplam Oturum Süresi",
            averageSessionDuration: "Ortalama Oturum Süresi",
            second: "Saniye",
            minute: "Dakika",
            hour: "Saat",
            aggregateAs: "Şu şekilde hesapla",
            chatbotSessionDurationOverall: "Genel ChatBot Oturum Süresi",
            ratingTimeSeries: "Oylama Grafiği",
            chatCountTimeseries: "Sohbet Sayısı Zaman Grafiği",
            notRated: "Puanlanmamış",
            totalRatingCount: "Toplam Değerlendirme Sayısı",
            averageRating: "Ortalama Değerlendirme",
            weightedAverageRating: "Ağırlıklı Ortalama Değerlendirme",
            rate: "Puanlama",
            ratingOverall: "Müşteri Değerlendirmeleri",
            session: "Oturum",
            total: "Toplam",
            average: "Ortalama",
            max: "En Fazla",
            min: "En Az",
            sessionCount: "Oturum Sayısı",
            uniqueUsers: "Benzersiz Kullanıcılar",
            viewAs: "Şu şekilde görüntüle: ",
            overall: "Genel",
            detailReport: "Detaylı Rapor",
            dailyReports: "Günlük Raporlar",
            pointBasedReports: "Puan Bazlı Raporlar",
            personDateBasedPointReport: "Kişi ve Gün Bazlı Puan Raporu",
            personDateBasedReport: "Kişi ve Gün Bazlı Rapor",
            personBasedReport: "Kişi Bazlı Raporlar",
            personAndDateBasedGraph: "Kişi ve Gün Bazlı grafiği",
            noReport: "Rapor Yok",
            reports: "Raporlar",
            totalBar: "Toplam",
            ticketCount: "Talep Sayısı",
            erorFetchingTask: "Görev verileri alınırken hata oluştu:",
            selectaChannel: "Bir Kanal Seçin",
        },
        announcements: {
            menu: "Duyurular",
            newAnnouncementForm: "Yeni Duyuru Kayıt Formu",
            updateAnnouncementForm: "Duyuru Güncelleme Formu",
        },
        stats: {
            total: "Sistemdeki aktif konuşmaların sayısıdır.",
            active: "Size ait olan aktif konuşmaların sayısıdır.",
            waiting: "Temsilci atanmayı bekleyen yeni aktif konuşma sayısıdır.",
            late: "Belli bir süre geçmiş  ve temsilci atanmayı bekleyen yeni konuşmaların sayısıdır.",
            free: "Temsilcisi çıkış yaptıktan sonra yeni temsilci atamayı bekleyen konuşmaların sayısıdır.",
            pco: "[Personel Çalışma Oranı] : Sistemdeki çevrimiçi temsilcilerin toplam alabildiği konuşma sayısının doluluk oranınıdır. ",
            maxCapacity: "Sistemin bekletmeden temsilci atayabileceği maksimum chat sayısıdır",
            chatbot: "Chatbot'un aktif konuşma sayısı",
        },
        time: {
            lastYear: "Son Yıl",
            thisYear: "Bu Yıl",
            last3Months: "Son 3 ay",
            last7: "Son 7 Gün",
            today: "Bugün",
            yesterday: "Dün",
            lastWeek: "Geçen Hafta",
            currentWeek: "Bu Hafta",
            currentMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last30Day: "Son 30 gün",
            allTime: "Tüm Zamanlar",
            custom: "Farklı Bir Zaman",
        },
        fastWizard: {
            generalColors: "Genel Renkler",
            tellUsMore: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            moreInfo: "Genel Ayarlar",
            display: "Tema Ayarları",
            availability: "Temsilci Çalışma Saatleri",
            preview: "Ön İzleme",
            installCode: "Kurulum",
            previous: "Önceki Adım",
            setupSupsisLiveChat: "SUPSIS LIVE Hızlı Kurulum",
            continue: "Sıradaki Adım",
            completeInitialize: "Hızlı Kurulumu Tamamla",
            completedMessage: "SUPSIS Live Hızlı Kurulumu Başarıyla Gerçekleştirildi.",
            websiteIntegration: "Supsis Live entegrasyonu için web sitenizin adresi",
            customizeLiveChat: "Canlı Sohbetinizi Özelleştirin",
            createBrandedExperience: "Ziyaretçileriniz için markalı bir sohbet deneyimi oluşturun.",
            chatColor: "Chat Rengi",
            chooseChatColor: "Bir Renk Seçin.",
            chatBubble: "Chat Balonu",
            selectBubble: "Bir Chat Balonu Seçin",
            chatBubbleColor: "Chat Balonu Rengi",
            selectChatBubbleColor: "Chat Balonu Rengini Seçin",
            customSelection: "Özel Seçim:",
            onlineSupportVisitorTime: "Ziyaretçilerinize hangi zaman aralıklarında hizmet sağlarsınız ?",
            channelAvailability: "Çevrimci Zamanlama",
            availability724: "7/24 Sürekli Hizmet",
            basedOnTeam: "Temsilci Çalışma Saatleri Dahilinde",
            basedOnTeamExplanation:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür",
            customHours: "Özel Çalışma Saatleri",
            customHoursExplanation: "Kendi Çalışma Saatlerinizi Belirleyin",
            customHoursTimezone: "Bölgesel Zaman Dilimi:",
            customHoursFrom: "Başlangıç:",
            customHoursTo: "Bitiş:",
            customHoursAddHours: "+Saat Ekle",
            previewDesktop: "Masaüstü",
            previewIpad: "Tablet",
            installationAndInstructions: "Kurulum & Talimatlar",
            installationTrackingCode: "Takip numarasını web sitenize yükleyin",
            installationTrackingCodePlease:
                "Lütfen kodu, SUPSIS Canlı sohbeti etkinleştirmek istediğiniz herhangi bir sayfada {bodyTag} etiketinin bitiminden hemen önce aşağıdaki talimatlara uygun olarak yapıştırın.",
            installationInstructionsJavascript:
                " Yukarıda verilen entegrasyon kodunu {bodyTag} etiketi içerisinde kapanıştan hemen öncesine yapıştırın.",
            installationInstructionsShopify1: "1. Shopify panelinize giriş yapın",
            installationInstructionsCopy: "Kopyala",
            installationInstructionsCoppyMessage: "Entegrasyon komutları panoya kopyalandı",
            installationInstructionsShopify2:
                "2. Online Store > Themes > Actions 'a gidin,altındaki açılır menüden  Current Theme > Edit code >theme.liquid 'e ilerleyin",
            installationInstructionsShopify3:
                "3.Yukarıda verilen entegrasyon kodunu, theme.liquid scriptinin sonundaki {bodyTag} etiketinin hemen önüne yerleştirin.",
            installationInstructionsIdeaSoft1: "1. Bayi panelinize giriş yapınız.",
            installationInstructionsIdeaSoft2: "2. Ayarlar -> SEO -> Arama Motoru Servisleri adımını takip ediniz.",
            installationInstructionsIdeaSoft3:
                '3. Takip Kodu  kısmından "Meta Tag ile Site Doğrulama"  seçeneğini seçiniz.',
            installationInstructionsIdeaSoft4:
                "4. Açılan kutuya yukarıdaki entegrasyon kodunu kopyalayıp yapıştırın ve kaydediniz.",
            installationInstructionsIdeaSoft5:
                '5. Ayarlar -> Optimizasyonlar -> "Ön Belleği Temizle" butonuna basınız. Entegrasyon tamamlanmıştır.',
            installationInstructionsWordPress1: "1. WordPress yönetici panelinize giriş yapın",
            installationInstructionsWordPress2: "2. Görünüm > Tema Düzenleyici'ye gidin",
            installationInstructionsWordPress3:
                "3. (en sağda) Tema Dosyaları altında, Tema Altbilgisini (footer.php)'yi bulun ve seçin",
            installationInstructionsWordPress4:
                "4.Yukarıdaki entegrasyon kodunu alttaki {bodyTag} etiketinin önüne yapıştırın.",
            installationInstructionsWordPress5: "5. Değişiklikleri kaydetmek için Dosyayı Güncelle'yi tıklayın",
            installationInstructionsOpenCart1: "1. Opencart admin panelinize giriş yapın",
            installationInstructionsOpenCart2: "2. Tasarım > Tema Düzenleyici'ye gidin",
            installationInstructionsOpenCart3:
                "3. 'common' klasörünü seçin ve içerisindeki 'header.twig' dosyasını açın.",
            installationInstructionsOpenCart4:
                "4.Yukarıdaki entegrasyon kodunu, alttaki {headTag} etiketinin önüne yapıştırın.",
            installationInstructionsOpenCart5: "5. Kaydet butonuna tıklayın",
            installationInstructionsTicimax1: "1. Ticimax yönetim panelinize giriş yapın",
            installationInstructionsTicimax2: "2. Tasarım > Tasarım ayarları > Header Footer Tasarımını açın",
            installationInstructionsTicimax3: "3. Logo tasarımı kısmında 'Kaynak'butonunu tıklayın.",
            installationInstructionsTicimax4: "4. HTML kodunun altına yukarıdaki entegrasyon kodunu yapıştırın.",
            installationInstructionsEticaretteyim1: "1. Eticaretteyim yönetim panelinize giriş yapın",
            installationInstructionsEticaretteyim2:
                "2. Eklentiler > HTML Oluştur > Kısmından SUPSIS Adını Verip  Kodu Kopyalamanız Yeterlidir.",
            installationInstructions: "Talimatlar",
            installationVerify: "Web Sitenizin Supsis Kurulumunu Doğrulayın",
            installationVerifyChecking: "Kontrol Ediliyor",
            installationVerifyCheck: "Kontrol Et",
            installationVerifyCheckingStatus: "{website} sitesinin SUPSIS entegrasyon durumu kontrol ediliyor",
            installationCheckingStatusMessageYes: "SUPSIS LIVE {website} sitesine entegre olmuştur.",
            installationCheckingStatusMessageNo:
                "SUPSIS şu anda {website} sitesine entegre değil.\n Entegrasyon işleminizi şimdi ya da daha sonra tamamlayabilirsiniz.",
            vtippyPreferredLanguage: "Tercih Edilen Dil ",
            chatAvailability: "Chat Availability",
        },
        packages: {
            mostPopular: "EN ÇOK TERCİH EDİLEN",
            currency: "₺",
            activePlan: "AKTİF PLAN",
        },
        totalCost: {
            title: "SUPSİS MALİYETİ",
            monthlyPayments: "Aylık Ödemeler",
            currency: "₺",
            currencyMonthly: "₺ / Aylık",
            oneTimePayments: "Tek Seferlik Ödemeler",
            oneTimeDiscount: "Yıllık Paket İndirimi",
            currencyYearly: "₺ / Yıllık",
            totalOneTimeCost: "Toplam İlk Seferde ödenecek Tutar",
            totalTax: "Vergi ( %18 )",
            referenceCode: "Referans Kodunuz var mı?",
            referencePlaceholder: "Lütfen Kodu Giriniz",
            codeButton: "Uygula",
            monthlyCost: "Hesabınızdan Aylık Çekilecek Tutar?",
            oneTimeFullCost: "Tek Seferlik Herşey Dahil Tutar?",
            payment: "Ödemeyi Yap",
        },
        akinon: {
            typeOrSelectSKU: "SKU yazın veya seçin",
            akinonUserId: "Akinon Kullanıcı Id",
            userEmail: "Kullanıcı Email",
            userEmailDesc: "Kullanıcı e-postasını yazın veya seçin...",
            send: "Gönder",
            selectCity: "İlçe Seçin",
            city: "İlçe",
            selectState: "İlinizi Seçin",
            state: "İl",
            useMap: "Haritayı Kullan",
            chooseAddress: "Adres Seç",
            selectCountry: "Ülke Seç",
            country: "Ülke",
            productIdDesc: "Ürün yazın veya seçin...",
            productId: "Ürün Id'si",
            userIdDesc: "Akinon kullanıcı id'si yazın...",
            productSKU: "Ürün SKU'su",
            latitudeDesc: "Hedef konum enlemini yazın veya seçin...",
            longitudeDesc: "Hedef konumun boylamını yazın veya seçin...",
            orderNumber: "Sipariş numaranız",
            orderDesc: "Sipariş numarasını yazın...",
            longitude: "Boylam",
            latitude: "Enlem",
        },
        probel: {
            branchCode: "Branş Kodu",
            branchCodeDesc: "Branş kodunu yazın veya seçin...",
            hospitalBranchCode: "Şube Kodu",
            hospitalBranchCodeDesc: "Şube kodunu yazın veya seçin...",
            clinicCode: "Poliklinik Kodu",
            clinicCodeDesc: "Poliklinik kodunu yazın veya seçin...",
            date: "Randevu Tarihi",
            dateDesc: "Randevu tarihini girin veya seçin...",
            patientToken: "Hasta Token",
            patientTokenDesc: "Hasta tokenini yazın veya seçin...",
            appointmentId: "Randevu Id",
            appointmentIdDesc: "Randevu id'sini yazın veya seçin...",
            identityType: "Kimlik Türü",
            identityNumber: "Kimlik Numarası",
            name: "Hasta Adı",
            surname: "Hasta Soyadı",
            gender: "Hasta Cinsiyet",
            birthDay: "Hasta Doğum Tarihi",
            phoneNumber: "Hasta Telefon Numarası",
            identityTypeDesc: "Kimlik türünü yazın veya seçin...",
            identityNumberDesc: "Kimlik numarasını yazın veya seçin...",
            nameDesc: "Hasta adını yazın veya seçin...",
            surnameDesc: "Hasta soyadını yazın veya seçin...",
            genderDesc: "Hasta cinsiyetini yazın veya seçin...",
            birthDayDesc: "Hasta doğum tarihini yazın veya seçin...",
            phoneNumberDesc: "Hasta telefon numarasını yazın veya seçin...",
        },
        headBar: {
            source: "Kaynak",
            label: "Etiket",
            completed: "Tamamlandı mı?",
            email: "E-mail",
            phone: "Telefon",
            name: "Ad",
            date: "Tarih",
            subject: "Konu",
            situation: "Durum",
            representative: "Temsilci",
            transactions: "İşlemler",
            channel: "İletişim Kanalı",
            Email: "E-mail",
        },
        login: {
            loginTitle1: "Supsis AI'ya",
            loginTitle2: "Hoşgeldiniz",
            email: "Email Adresiniz",
            emailPlaceholder: "Lütfen e-posta adresinizi giriniz.",
            emailError: "Lütfen Geçerli E-posta Giriniz",
            password: "Şifreniz",
            passwordLogin: "Şifresiz Giriş",
            passwordAndLogin: "Şifre ile Giriş Yap",
            passwordNew: "Şifremi Yenile",
            loginAnd: "Veya",
            passwordPlaceholder: "Lütfen şifrenizi giriniz.",
            loginMemory: "Bu cihazı hatırla",
            passwordForget: "Şifremi unutum",
            passwordNewAgain: "Yeni Şifre",
            passwordNewAgainTwo: "Yeni Şifre Tekrarı",
            passwordNewAgainPlaceholder: "Lütfen yeni şifrenizi giriniz.",
            passwordNewAgainPlaceholderTwo: "Lütfen yeni şifre tekrarınızı giriniz.",
            login: "Giriş Yap",
            loginFooter: "Veya, E-Posta ile Giriş Yap",
            emailLogin: "E-Posta ile Giriş yap",
            welcomeTitle: "Hoşgeldin",
            welcomeMorning: "Günaydın",
            welcomeAfternoon: "İyi Günler",
            welcomeEvening: "İyi Akşamlar",
            welcomeNight: "İyi Geceler",
        },
        settings: {
            ipWhitelist: "IP Erişim Listesi",
            loadMore: "Daha Fazla...",
            detectIpAddress: "IP Adresimi Algıla",
            addWighteListAddress: "IP Adresi Beyaz Liste Ekleme",
            accessControlSubTitles:
                "Erişim Kontrolü Yalnızca yetkilendirilmiş IP’lerin sisteme erişmesine izin veren ek bir güvenlik katmanı sağlar",
            companyInformation: "İşletme Bilgileri",
            ipAddress: "IP Adresim",
            whiteList: "Güvenli IP Listesi",
            whiteListAdd: "Güvenli IP Ekle",
            whiteListDeletedSuccessfully: "Güvenli IP Listesinden silindi",
            whiteListDeletedFailed: "Güvenli IP Listesinden silinemedi",
            whiteListAddedSuccessfully: "Güvenli IP Listesine eklendi",
            whiteListAddedFailed: "Güvenli IP Listesine eklenemedi",
            deleteWhiteListTitle: "Güvenli IP Listesinden silmek istediğinize emin misiniz?",
            talkSettings: "Konuşma Ayarları",
            talkSubtitles: "Konuşma Ayarlarınızı Yönetin",
            dateAndTime: "Tarih ve Saat",
            actor: "Kullanıcı",
            event: "Etkinlik",
            accessControl: "Erişim Kontrolü",
            rulesGroup: "Kurallar",
            organizationLongName: "Organizasyon Uzun Adı",
            visitorNewDesc: "Ziyaretçi temasının yeni sürümünü kullanabilirsiniz.",
            transactionType: "İşlem Tipi",
            priorBalance: "Önceki Bakiye",
            nextBalance: "Sonraki Bakiye",
            amount: "Tutar",
            phoneNumber: "Telefon Numarası",
            profileInfoRemoved: "Profil bilgisi kaldırıldı.",
            newValueUpdated: "Yeni Değer Güncellendi.",
            ballanceToTransferred: "Aktarılıcak Bakiye",
            availableBalance: "Mevcut Bakiye",
            balanceReceived: "Alınan Bakiye",
            totalBalance: "Toplam Bakiye",
            paymentCard: "Ödeme Yapılacak Kart",
            wpPhoneNumber: "Whatsapp Telefon Numarası",
            wpSendingMessage: "Whatsapp İlk Mesaj Gönderme",
            auditlogs: "Denetim Günlükleri",
            myaccount: "Hesabım",
            notifications: "Bildirimler",
            company: "Şirket",
            features: "Özellikler",
            general: "Genel",
            chat: "Sohbet",
            timings: "Süre Ayarları",
            language: "Dil",
            wallet: "Cüzdan",
            "bubble-settings": "Sohbet Balonu Ayarları",
            "bubble-actions": "Sohbet Balonu Özellikleri",
            "theme-settings": "Sohbet Teması Ayarları",
            visitorLoginForm: "Ziyaretçi Giriş Formu",
            visitorAttribute: "Ziyaretçi Profil Bilgileri",
            timing_settings: "Süre Ayarları",
            auto_assign: "Chat Atama",
            availability: "Çalışma Saatleri",
            "website-integration": "Web Sitesi Entegrasyonu",
            General: "Genel",
            Chat: "Sohbet",
            Timings: "Süre Ayarları",
            Integration: "Entegrasyon",
            developer: "Geliştirici",
            integration: "Entegrasyon",
            visitorNew: "Yeni Ziyaretçi Tasarıma Geçiş",
            companySubtitles: "İşletmenizin genel bilgilerini yönetin.",
            featuresSubtitles: "Supsis'in akıllı özelliklerini yönetin.",
            languageSubtitles: "İşletmenizin tercih ettiği dili & saat dilimini ayarlayın.",
            bubbleSettings: "Sohbet Balonu Ayarları",
            bubbleSettingsSubtitles: "Sohbet balonu ayarlarınızı yönetin.",
            bubbleActionsSubtitles:
                "Sohbet balonu özelliklerinizi genişletin. Firmanıza ait whatsapp ,mail ,telefon bilgilerini ziyaretçilerinizle paylaşabilirsiniz.",
            chatThemeSettingsSubtitles: "Sohbet teması ayarlarınızı yönetin.",
            visitorLoginFormSubtitles: "Ziyaretçi giriş formu ayarlarınızı yönetin.",
            chatTimingSettingsSubtitles: "Chat Süre Ayarları - Konuşma Süresi Kontrolleri ve Seçenekleri.",
            webSiteIntegrationSubtitles: "Web sitenize sohbet balonu ekleyin.",
            apiAccessTitle: "API Erişimi",
            apiAccessSubtitles: "Token kodunuza burdan ulaşabilirsiniz.",
            youTubeActionForm: "Youtube Kanalınızı Ekleyin",
            linkedinActionForm: "Linkedin Hesabınızı Ekleyin",
            telegramActionForm: "Telegram Hesabını Ekleyin",
            facebookActionForm: "Facebook Sayfanızı Ekleyin",
            tiwitterActionForm: "Twitter Sayfanızı Ekleyin",
            instagramActionForm: "Instagram Sayfanızı Ekleyin",
            liveSupportDescription: "Müşterilerinizle canlı bir sohbet açın",
            ticketDescription: "Müşterilerinizle canlı bir sohbet açın",
            whatsappDescription: "Müşterileriniz WhatsApp ile size ulaşsın",
            phoneDescription: "Müşterileriniz telefon ile size ulaşsın",
            emailDescription: "Müşterileriniz e-posta ile size ulaşsın",
            facebookDescription: "Müşterileriniz Facebook ile size ulaşsın",
            twitterDescription: "Müşterileriniz Twitter ile size ulaşsın",
            instagramDescription: "Müşterileriniz Instagram ile size ulaşsın",
            youtubeDescription: "Müşterileriniz Youtube ile size ulaşsın",
            linkedinDescription: "Müşterileriniz Linkedin ile size Ulaşsın",
            telegramDescription: "Müşterileriniz Telegram ile size Ulaşsın",
            whatsappModalTitle: "Whatsapp İşlem Formu",
            whatsappModalDescription: "Whatsapp hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            phoneModalTitle: "Telefon İşlem Formu",
            phoneModalDescription: "Telefon numaranızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            emailModalTitle: "E-Posta İşlem Formu",
            emailModalDescription: "E-posta hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            facebookModalTitle: "Facebook İşlem Formu",
            facebookModalDescription: "Facebook hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            twitterModalTitle: "Twitter İşlem Formu",
            twitterModalDescription: "Twitter hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            instagramModalTitle: "Instagram İşlem Formu",
            instagramModalDescription: "Instagram hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            youtubeModalTitle: "Youtube İşlem Formu",
            youtubeModalDescription: "Youtube hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            linkedinModalTitle: "LinkeIn İşlem Formu",
            linkedinModalDescription: "LinkedIn hesabını bağlama için lütfen aşşağıdaki formu doldurunuz",
            telegramModalTitle: "Telegram İşlem Formu",
            telegramModalDescription:
                "Telegram Hesabınızı bağlama için aşağıdaki forma Telegram profil linkini yazınız",
            instagramAlertTitle: "Instagram Entegrasyonu Gerekli",
            instagramAlertDesc:
                "Üzgünüz, ziyaret ettiğiniz sayfa, Instagram'ınızı entegre ettiğinizde etkinleştirilecektir.",
            instagramActivateText: "Haydi, Instagram'ı Entegre Et",
            remove: "Kaldır",
            edit: "Düzenle",
            connected: "Bağlı",
            add: "Ekle",
            themeDescription: "Sohbet Tema  Ayarları.",
            fontDescription: "Sohbet Yazı Tipi Ayarları.",
            emailTitle: "E-Posta Adresinizi Giriniz",
            emailMessage: "E-posta İlk Gönderim Mesajı",
            isFabsAsIcon: "Menü İkon Yazılarını Göster.",
            chatBubbleTextSetting: "Chat Balonu Yazı Ayarı",
            textOnChatBubble: "Chat Balonu üzerinde gözükecek metin ayarlarını yapabilirsiniz.",
            textToAppearOnChatBubble: "Chat Balonu üzerinde Gözükecek Metin",
            newVisitorProfileInformation: "Yeni Ziyaretçi Profil Bilgisi",
            newVisitorProfileInformationDescription: "Ziyaretçi profil bilgisine yeni değer ekler",
            create: "Oluştur",
            newAdd: "Yeni Ekle",
            toInform: "Bilgilendirme",
            toInformDescription: "Bu sayfada eklediğiniz değerleri ziyaretci giriş formu ile eşleştirebilirsiniz.",
            showVisitor: "Ziyaretçiyi Göster",
            label: "Etiket",
            text: "Yazı",
            email: "E-posta",
            phone: "Telefon",
            number: "Sayı",
            url: "URL",
            date: "Zaman",
            dropdown: "Seçilebilir",
            languageTimeZone: "Dil & Bölge",
            timeZoneTitle: "Bölge & Saat Dilimi",
            timeZoneDescription: "Bölge ve saat dilimi ayarları",
            advertising: "Pubblicità",
            balanceToTransferred: "Balance to be transferred",
            ballanceToTransfer: "Solde à transférer",
            changeSettings: "تغيير إعدادات تعيين الدردشة التلقائية",
            crm: "CRM",
            ecommerce: "E-commerce",
            sms: "SMS",
            socialMedia: "Social Media",
            utilities: "Utilità",
            web: "Web",
        },
        userInfoWidget: {
            zohoInfo: "Zoho Bilgileri",
            messageSearch: "Mesaj Ara",
            userInformation: "Kullanıcı Bilgileri",
            fullName: "Adı Soyadı",
            newValue: "Yeni Değer",
            newProfileInfo: "Yeni Profil Bilgisi",
            affiliatedRepresentatives: "Temsilciler",
            preferredAgents: "Tercih Edilen Temsilciler",
            labels: "Etiketler",
            agentNotes: "Temsilci Notları",
            newNote: "Yeni Not",
            note: "Not",
            available: "adet not mevcut.",
            systemInformation: "Sistem Bilgileri",
            speechID: "Konuşma Kimliği",
            customerVersion: "Müşteri Version",
            IPAddress: "IP Adresi",
            pageVisited: "Ziyaret Edilen Sayfa",
            systemAndBrowser: "İşletim Sistemi & Tarayıcı",
            countryAndLanguage: "Ülke & Dil",
            clickToEdit: "Düzenlemek Yazının içine tıklayın",
            adsYouAreInterestedIn: "İlgilendiği Reklamlar",
            detail: "Detay",
            adsTitle: "Başlık",
            adUrl: "Reklam Url",
            sourceID: "Kaynak ID",
            resourceType: "Kaynak Türü",
            adsBody: "İçerik",
            adsCreateDate: "Oluşturma Tarihi",
            adsUpdateDate: "Güncellenme Tarihi",
        },
        newWizartV2: {
            generalSettings: "Genel Ayarlar",
            themeSettings: "Tema Ayarları",
            representativeWorkingHours: "Temsilci Çalışma Saatleri",
            preview: "Önizleme",
            setup: "Kurulum",
            formStepTitle: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            supsisEntergation: "Supsis'i Hangi Websitenizde kullanacaksınız? :",
            goToNextStep: "Bir Sonraki Adıma Geç",
            readytemplate: "Hazır Renk Şablonu Kullan",
            customSettings: "Özel Ayarlar",
            customerMessageView: "Müşteri mesaj Görünümü",
            backcgroundColor: "Arka Plan Rengi",
            textColor: "Yazı Rengi",
            agentMessageView: "Temsilci Mesaj Görünümü",
            workingHours: "Ziyaretçilerine hangi zaman aralıklarında hizmet sağlarsınız?",
            continuousService: "Sürekli Hizmet",
            continuousServiceDescription: "Chat balonu her zaman aktif olur. Siz sistemde olmasanız bile.",
            vote: "Seçimini Yap",
            representativeWorking: "Temsilci Çalışma Saatleri Dahilinde",
            representativeWorkingDescription:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür.",
            computer: "Bilgisayar",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Entegrasyon Kodunu Web Sitenize Yükleyin",
            password: "Set New Password",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Kanalları (QR)",
            whatsappTitleV2: "Whatsapp V2 Kanalları (QR)",
            channelName: "Kanal",
            phoneNummer: "Telefon Numarası",
            forwardToChatbot: "Chatbot'a ilet",
            forwardingChatbotOrLiveAgent: "Yönlendirme (Chatbot veya Live Agent)",
            addChannel: "Kanal Ekle",
            newWhatsappChannel: "Yeni Whatsapp Kanalı",
            newWhatsappChannelDescription: "QR Kodunu tarayarak yeni bir whatsapp kanalı oluşturun",
            editWhatsappChannel: "Whatsapp Kanalını Düzenleyin",
            editWhatsappChannelDescription: "Whatsapp kanalını düzenleme",
            whatsappChannel: "Whatsapp Kanalı",
            deleteWhatsappChannelDescription: "Bu kanalı silmek istediğinizden emin misiniz?",
            whatsappIntegration: "Whatsapp Entegrasyonu",
            deleteChannel: "Kanalı Sil",
            restartChannel: "Kanalı Yeniden Başlat",
            wantRestartChannel: "Kanalı yeniden başlatmak istiyor musun?",
            deleteSMSChannelDescription: "SMS kanalını silmek istediğinizden emin misiniz?",
            smsChannel: "SMS Kanalı",
            maxChannelCount: "Birden Fazla SMS Kanalı Oluşturamazsınız !",
            smsModalText:
                "Modern iletişim çözümleriyle entegre olmamız, size kolay ve etkili bir şekilde SMS gönderme imkanı sunuyor. İletişimde sınırları kaldırın, müşterilerinizle doğrudan bağlantı kurun!",
            smsModalBtn: "Sms Kanalı Açmak İçin Tıklayınız...",
            postaCellDetail: "PostaCell Kanal Detayı",
            phoneNumber: "Phone Number",
        },
        noPermission: "Bu işlemi gerçekleştirmek için yetkiniz yok. Yöneticinizle görüşün.",
        mail_integration_detail: {
            title: "Mail Detay",
            integration: "Entegrasyon",
            sender: "Gönderen Maili",
            signature: "İmza",
            inbox: "Gelen Kutusu",
            medias: "Medya",
            visibility: "İzinler",
            settings_group: "Ayarlar",
            contacts: "Kişiler",
        },
        whatsapp_business_api: {
            userVisibility: "Kullanıcı Görünürlüğü",
            userVisibilityDesc:
                "Kullanıcıların erişebileceği kanallar, rollerine ve kanalın görünürlük ayarlarına bağlıdır. Full Admin veya root rolüne sahip kullanıcılar tüm kanalları görebilir. Eğer bir kanalın görünürlük ayarları boş ise, kanal herkese açıktır. Ancak, kanal belirli kullanıcılar veya departmanlar için tanımlanmışsa, sadece bu kullanıcılar veya departman üyeleri kanalı görebilir.",
            searchTemplate: "Şablon ara...",
            forwardToChatbot: "Chatbot'a Yönlendir",
            forwarding: "Yönlendirme (Chatbot veya Canlı Temsilci)",
            forwardLiveAgents: "👉 Canlı Desteğe Yönlendir",
            forwardingToDepartment: "Departmana Yönlendirme",
            selectDepartment: "Departman Seç",
            createWbChannel:
                "Whatsapp Business kanalı oluşturmak için Whatsapp Business paketi satın almalısınız. Uygun fiyatlı paketlere hemen ulaşabilirsiniz.",
            wbCreateChannelMax: "Whatsapp Business kanal oluşturma limitine ulaştınız. Maximun",
            wbContinue:
                "Whatsapp Business Kanalı oluşturabilirsiniz. Devam etmek için paketinizi yükseltin yada Whatsapp Business kanalarınızdan bir kaçını siliniz.",
            chatInitiatorTemplate: "Sohbet Başlatıcı Şablonu",
            selectChatInitiatorTemplate: "Sohbet başlatıcı şablonunuzu seçin.",
            dailyUsageReport: "Günlük Kullanım Raporu",
            metaInsightsTitle: "Meta Insights",
            metaInsightsSubtitle: "WhatsApp Business API istatistiklerini görüntüleyin",
            metaInsightsDateRange: "Tarih Aralığı",
            metaInsightsDateStart: "Başlangıç",
            metaInsightsDateEnd: "Bitiş",
            metaInsightsGranularity: "Granularity",
            metaInsightsGranularityDay: "Günlük",
            metaInsightsGranularityMonth: "Aylık",
            metaInsightsGranularityHalfHour: "Yarım Saat",
            metaInsightsRefresh: "Yenile",
            metaInsightsTabMessaging: "Messaging Analytics",
            metaInsightsTabConversation: "Conversation Analytics",
            metaInsightsTabPricing: "Pricing Analytics",
            metaInsightsTabTemplate: "Template Analytics",
            metaInsightsTabTemplateGroup: "Template Group Analytics",
            metaInsightsErrorMessaging: "Messaging analytics verisi alınamadı",
            metaInsightsErrorConversation: "Conversation analytics verisi alınamadı",
            metaInsightsErrorPricing: "Pricing analytics verisi alınamadı",
            metaInsightsErrorTemplate: "Template analytics verisi alınamadı",
            metaInsightsErrorTemplateGroup: "Template group analytics verisi alınamadı",
            metaInsightsViewChart: "Grafik Görünümü",
            metaInsightsViewTable: "Tablo Görünümü",
            metaInsightsDownloadExcel: "Excel İndir",
            metaInsightsTotalSent: "Toplam Gönderilen",
            metaInsightsTotalDelivered: "Toplam Teslim Edilen",
            metaInsightsDeliveryRate: "Teslim Oranı",
            metaInsightsUnitMessage: "mesaj",
            metaInsightsMessageStats: "Mesaj İstatistikleri",
            metaInsightsSent: "Gönderilen",
            metaInsightsDelivered: "Teslim Edilen",
            metaInsightsDateColumn: "Tarih",
            metaInsightsCountryBreakdown: "Ülke Bazlı Dağılım",
            metaInsightsNoData: "Veri bulunamadı. Lütfen tarih aralığını kontrol edin.",
            metaInsightsPieChart: "Pasta Grafik",
            metaInsightsTotalConversations: "Toplam Konuşma",
            metaInsightsTotalCost: "Toplam Maliyet",
            metaInsightsAvgCost: "Ortalama Maliyet",
            metaInsightsUnitConversation: "konuşma",
            metaInsightsCostPerConversation: "$/konuşma",
            metaInsightsCategoryBreakdown: "Kategori Bazlı Dağılım",
            metaInsightsConversationStats: "Konuşma İstatistikleri",
            metaInsightsCategoryDistribution: "Kategori Dağılımı",
            metaInsightsConversationCount: "Konuşma Sayısı",
            metaInsightsCost: "Maliyet",
            metaInsightsCategory: "Kategori",
            metaInsightsType: "Tip",
            metaInsightsConversationCategoryAuth: "Kimlik Doğrulama",
            metaInsightsConversationCategoryMarketing: "Pazarlama",
            metaInsightsConversationCategoryService: "Hizmet",
            metaInsightsConversationCategoryUtility: "Yardımcı",
            metaInsightsConversationCategoryOther: "Diğer",
            metaInsightsConversationDistribution: "Konuşma Dağılımı",
            metaInsightsTotalVolume: "Toplam Hacim",
            metaInsightsAvgUnitCost: "Ortalama Birim Maliyet",
            metaInsightsCostPerMessage: "$/mesaj",
            metaInsightsPricingCategoryBreakdown: "Fiyatlandırma Kategorisi Dağılımı",
            metaInsightsPricingTypeBreakdown: "Fiyatlandırma Tipi Dağılımı",
            metaInsightsPricingStats: "Fiyatlandırma İstatistikleri",
            metaInsightsCostDistribution: "Maliyet Dağılımı",
            metaInsightsCountry: "Ülke",
            metaInsightsVolume: "Hacim",
            metaInsightsTier: "Tier",
            metaInsightsPricingCategoryAuth: "Kimlik Doğrulama",
            metaInsightsPricingCategoryAuthInternational: "Uluslararası Kimlik Doğrulama",
            metaInsightsPricingCategoryMarketing: "Pazarlama",
            metaInsightsPricingCategoryService: "Hizmet",
            metaInsightsPricingCategoryUtility: "Yardımcı",
            metaInsightsPricingCategoryReferral: "Referans Dönüşümü",
            metaInsightsPricingTypeRegular: "Normal",
            metaInsightsPricingTypeFreeCustomerService: "Ücretsiz Müşteri Hizmeti",
            metaInsightsPricingTypeFreeEntryPoint: "Ücretsiz Giriş Noktası",
            metaInsightsTemplateAboutTitle: "Template Analytics Hakkında",
            metaInsightsTemplateAboutDesc:
                "Template analytics için template seçmeniz gerekmektedir. Maksimum 10 template seçebilirsiniz. Analytics verileri günlük granularity ile döner ve 90 günlük geçmiş verisine erişebilirsiniz.",
            metaInsightsTemplateSelectLabel: "Template Seçin (Maksimum 10)",
            metaInsightsTemplateSelectPlaceholder: "Template seçin...",
            metaInsightsFetchData: "Verileri Getir",
            metaInsightsTotalRead: "Toplam Okunma",
            metaInsightsReadRate: "Okunma Oranı",
            metaInsightsRead: "Okunmuş",
            metaInsightsTemplatePerformance: "Template Performansı",
            metaInsightsCostInfo: "Maliyet Bilgileri",
            metaInsightsTotalSpent: "Toplam Harcama",
            metaInsightsCostPerDelivered: "Teslim Başına Maliyet",
            metaInsightsClickInfo: "Tıklama Bilgileri",
            metaInsightsClickInfoDesc:
                "URL ve Quick Reply buton tıklamaları sadece MARKETING ve UTILITY kategorisindeki template'ler için mevcuttur.",
            metaInsightsTemplateNoData:
                "Template analytics verisi bulunamadı. Template ID'lerini belirleyerek veri çekebilirsiniz.",
            metaInsightsTemplateId: "Template ID",
            metaInsightsTemplateGroupAboutTitle: "Template Group Analytics Hakkında",
            metaInsightsTemplateGroupAboutDesc:
                "Template group analytics için Meta'da oluşturulmuş template group ID'lerini girmeniz gerekmektedir. Maksimum 10 grup girebilirsiniz. Analytics verileri günlük granularity ile döner ve 90 günlük geçmiş verisine erişebilirsiniz.",
            metaInsightsTemplateGroupIdsLabel: "Template Group ID'leri (virgülle ayırın, maksimum 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "Örn: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "Template Group Performansı",
            metaInsightsGroupBreakdownTitle: "Grup Bazlı Performans",
            metaInsightsGroupLabel: "Grup",
            metaInsightsTemplateGroupNoData:
                "Template group analytics verisi bulunamadı. Template group ID'lerini belirleyerek veri çekebilirsiniz.",
            metaInsightsGroupId: "Grup ID",
            capiStatus: "CAPI Durumu",
            capiActive: "Aktif",
            capiPassive: "Pasif",
            capiConnectionMethod: "Bağlantı Yöntemi",
            capiConnectThroughMeta: "Connect through Meta",
            capiWithDatasetAndToken: "With Dataset and Token",
            capiOauthInfoDesc:
                "Meta üzerinden bağlantı kurmak için tekrar yetkilendirme yapmanız gerekiyor. Bu işlem mevcut kanalınızı bozmaz, sadece ek izinler ekler.",
            capiConnecting: "Bağlanıyor...",
            capiConnectWithMeta: "Meta ile Bağlan",
            capiDatasetSelection: "Dataset Seçimi",
            capiSelectDataset: "Bir dataset seçin",
            capiCreating: "Oluşturuluyor...",
            capiCreateNewDataset: "Yeni Dataset Oluştur",
            capiDatasetId: "Dataset ID",
            capiEnterDatasetId: "Dataset ID'sini girin",
            capiAccessToken: "Access Token",
            capiEnterAccessToken: "Access token'ı girin",
            capiTesting: "Test Ediliyor...",
            capiTestConnection: "Bağlantıyı Test Et",
            capiConnectionSuccess: "Bağlantı başarılı",
            capiConnectionFailed: "Bağlantı başarısız",
            capiAutoEventSend: "Otomatik Event Gönderimi",
            capiEventInitiateCheckout: "Sohbet Başlatıldı",
            capiEventInitiateCheckoutDesc: "Yeni konuşma oluşturulduğunda",
            capiEventPurchase: "Satın Alma",
            capiEventPurchaseDesc: "Satın alma tamamlandığında",
            capiEventAppointmentBooked: "Randevu Oluşturuldu",
            capiEventAppointmentBookedDesc: "Randevu rezervasyonu yapıldığında",
            capiEventAddToCart: "Sepete Eklendi",
            capiEventAddToCartDesc: "Ürün sepete eklendiğinde",
            capiEventViewContent: "İçerik Görüntülendi",
            capiEventViewContentDesc: "Bir sayfa veya ürün görüntülendiğinde",
            capiEventOrderCreated: "Sipariş Oluşturuldu",
            capiEventOrderCreatedDesc: "Sipariş başarıyla oluşturulduğunda",
            capiEventOrderShipped: "Sipariş Kargoya Verildi",
            capiEventOrderShippedDesc: "Sipariş kargoya verildiğinde",
            capiMetaConnectionSuccess: "Meta bağlantısı başarılı",
            capiMetaConnectionFailed: "Meta bağlantısı başarısız",
            capiDatasetsLoadError: "Dataset'ler yüklenemedi",
            capiDatasetCreated: "Yeni dataset oluşturuldu",
            capiDatasetCreateError: "Dataset oluşturulamadı",
            capiConnectionTestSuccess: "CAPI bağlantısı başarılı!",
            capiConnectionTestFailed: "CAPI bağlantısı başarısız",
            capiConnectionTestError: "Bağlantı testi yapılamadı",
            wabaMovementsTitle: "Webhook Aktiviteleri",
            wabaMovementsSubtitle: "WhatsApp Business API kanal aktivitelerini takip edin",
            wabaMovementsTotalActivity: "toplam aktivite",
            wabaMovementsEmailNotifications: "Email Bildirimleri",
            wabaMovementsActive: "Aktif",
            wabaMovementsOff: "Kapalı",
            wabaMovementsEmailSettingTitle: "Account bildirimlerini email olarak al",
            wabaMovementsEmailSettingDesc: "Webhook aktiviteleri için email bildirimi gönderilsin",
            wabaMovementsEmailListHeader: "Bildirim gönderilecek email adresleri",
            wabaMovementsEmailPlaceholder: "Email adresi girin",
            wabaMovementsNoEmailsYet: "Henüz email adresi eklenmedi",
            wabaMovementsActivityLoadError: "Activity logları yüklenirken bir hata oluştu",
            wabaMovementsNotificationsOn: "Email bildirimleri açıldı",
            wabaMovementsNotificationsOff: "Email bildirimleri kapatıldı",
            wabaMovementsUpdateError: "Güncelleme sırasında bir hata oluştu",
            wabaMovementsEmailAlreadyAdded: "Bu email adresi zaten ekli",
            wabaMovementsEmailAdded: "Email adresi eklendi",
            wabaMovementsEmailAddError: "Email eklenirken bir hata oluştu",
            wabaMovementsEmailRemoved: "Email adresi kaldırıldı",
            wabaMovementsEmailRemoveError: "Email kaldırılırken bir hata oluştu",
            freeChat: "Ücretsiz Sohbet",
            paidChat: "Ücretli Sohbet",
            templateMessage: "Şablon Mesajı",
            outgoingSession: "Giden Oturum",
            incomingSession: "Yaklaşan Oturum",
            totalCost: "Toplam Maliyet",
            allOptNumbers: "Tüm katılım numaraları.",
            startChat: "Sohbet Başlat",
            lastMessageDate: "Son Mesaj Tarihi",
            sureDeleteTemplate: "Bu şablonu silmek istediğinize emin misiniz?",
            manageWhoChannelChat: "Bu kanal sohbetlerini kimlerin görebileceğini yönetin",
            profileImageDesc: "Bu, işletmenizin WhatsApp ekran resmi olacaktır",
            bussinesDesciption: "Bussines Açıklama ",
            descOfWork: "İşletmenizin birkaç kelimeyle açıklaması (Maksimum 512 Karakter)",
            accountStatus: "Hesap Durumu",
            dockerStatus: "Docker Durumu",
            phoneQuality: "Telefon Kalitesi",
            customersOrDay: "Müşteriler/Gün",
            messagingLimit: "Mesajlaşma Sınırı",
            canSendMessage: "Mesaj Gönderilebilir",
            officialDetails: "Resmi Detaylar",
            officialDetailsDesc:
                "Bu adresler, WhatsApp'ta sizinle sohbet eden kullanıcılara her zaman profil bölümünde gösterilecektir. Düzenledikten sonra onay için WhatsApp'a göndereceğiz.",
            addressLine: "Adres Hattı",
            stateIfApplic: "Eyalet (varsa)",
            zipCodeOrPostCode: "Zip Kodu/Posta Kodu",
            selectCountry: "Ülke Seçiniz",
            selectBussVertical: "İş Alanı Seçiniz",
            saveInfo: "Bilgileri Kaydet",
            active: "Aktif",
            banned: "Yasaklı",
            low: "Düşük",
            medium: "Orta",
            high: "Yüksek",
            connected: "Bağlı",
            disConnected: "Bağlantı Kesildi",
            flagged: "İşaretlendi",
            pending: "Beklemede",
            restricted: "Kısıtlanmış",
            unknown: "Bilinmiyor",
            available: "Mevcut",
            limited: "Sınırlı",
            blocked: "Engellendi",
            loadingProfile: "Profil bilgileri yükleniyor...",
            businessProfileTitle: "İşletme Profili",
            lastUpdate: "Son güncelleme:",
            updateFromMeta: "Meta'dan Güncelle",
            waitSeconds: "{n}s bekleyin",
            wabaInfoTitle: "WhatsApp Business Account Bilgileri",
            phoneInfo: "Telefon Bilgileri",
            verifiedNameLabel: "Doğrulanmış Ad:",
            phoneNumberLabel: "Telefon Numarası:",
            codeVerificationLabel: "Kod Doğrulama:",
            platformSettings: "Platform Ayarları",
            platformTypeLabel: "Platform Tipi:",
            throughputLevelLabel: "Throughput Seviyesi:",
            twoFaPinLabel: "2FA PIN:",
            enabled: "Aktif",
            disabled: "Pasif",
            dailyLimit: "Günlük Limit",
            messageSending: "Mesaj Gönderimi",
            businessInfoTitle: "İşletme Bilgileri",
            profilePhoto: "Profil Fotoğrafı",
            change: "Değiştir",
            profilePhotoNote: "JPG veya PNG (maks. 5MB, önerilen: 640x640px)",
            aboutText: "Hakkında Metni",
            aboutPlaceholder: "İşletmeniz hakkında kısa bir açıklama yazın...",
            aboutHint: "WhatsApp profilinizde görünecek kısa açıklama (maks. 139 karakter)",
            businessDescriptionLabel: "İşletme Açıklaması",
            businessDescriptionPlaceholder: "İşletmenizin detaylı açıklamasını yazın...",
            descriptionHint: "İşletmenizin detaylı açıklaması",
            contactEmail: "İletişim E-postası",
            emailPlaceholder: "ornek@sirket.com",
            businessAddress: "İşletme Adresi",
            addressPlaceholder: "Tam adres bilgisi",
            website1: "Website 1",
            website2: "Website 2",
            website1Placeholder: "https://www.sirket.com",
            website2Placeholder: "https://www.facebook.com/sirket",
            businessCategory: "İşletme Kategorisi",
            selectBusinessCategory: "İşletme kategorisi seçin",
            categoryHint: "İşletmenizin faaliyet alanını seçin",
            revertChanges: "Değişiklikleri Geri Al",
            updateButton: "Güncelle",
            accountModeLabel: "Hesap Modu:",
            na: "N/A",
            verticalOther: "Diğer",
            verticalAuto: "Otomotiv",
            verticalBeauty: "Güzellik, Spa ve Kuaför",
            verticalApparel: "Giyim ve Konfeksiyon",
            verticalEdu: "Eğitim",
            verticalEntertain: "Eğlence",
            verticalEventPlan: "Etkinlik Planlama ve Hizmet",
            verticalFinance: "Finans ve Bankacılık",
            verticalGrocery: "Gıda ve Bakkaliye",
            verticalGovt: "Kamu Hizmeti",
            verticalHotel: "Otel ve Konaklama",
            verticalHealth: "Tıbbi ve Sağlık",
            verticalNonprofit: "Kâr Amacı Gütmeyen",
            verticalProfServices: "Profesyonel Hizmetler",
            verticalRetail: "Alışveriş ve Perakende",
            verticalTravel: "Seyahat ve Ulaşım",
            verticalRestaurant: "Restoran",
            verticalAlcohol: "Alkol",
            verticalOnlineGambling: "Çevrimiçi Kumar",
            verticalPhysicalGambling: "Fiziksel Kumar",
            verticalOtcDrugs: "Reçetesiz İlaçlar",
            verticalMatrimonyService: "Evlilik Hizmeti",
            success: "Başarılı",
            succesDesc: "Profil bilgileriniz başarılı bir şekilde güncellendi.",
            wabaOverview: "WABA Sağlığına Genel Bakış",
            manageChannelDetail: "Kanal bilgilerinizi yönetin",
            wpBussChannelDetail: "Whatsapp Business Kanal Detayı",
            manageWpBussChannel: "Whatsapp iş kanalınızı yönetin",
            channelName: "Kanal Adı",
            phoneNumberE164: "Telefon Numarası",
            phoneNumberE164Place: "Telefon Numarası örn: 908501234455",
            channelUpdatedSucs: "Kanal başarıyla güncellendi",
            faieldUpdateChannel: "Kanal güncellenemedi",
            completeSetup: "Kurulumu Tamamla",
            completeSetupDescription:
                "WhatsApp Business API kurulumunu tamamlamak için lütfen aşağıdaki butona tıklayarak bağlantı sayfasına gidin.",
            connectWhatsAppBusinessAccount: "WhatsApp Business Hesabını Bağla",
            infoLabel: "Bilgilendirme",
            onboardingInfoDescription:
                "WhatsApp Business API kurulumu için Facebook Business hesabınızın ve WhatsApp numaranızın hazır olması gerekmektedir.",
            businessId: "Business ID",
            phoneNumberId: "Phone Number ID",
            wabaId: "WABA ID",
            userAccessibility: "Kullanıcı Erişebilirliği",
            userAccessibilityDesc:
                "Aşağıda belirtilen kişiler bu kanaldaki kişi ve chatları görebilir (sahiplik varsa erişemez). Bu ayar şuralarda aktif olarak rol alır: <ul><li><strong>Otomatik chat atama:</strong> Bu kanala gelen müşteriler buradaki gizliliğe göre atama yapılır, bu kanalara erişimi olmayanlara chat vermez</li><li><strong>Yönlendirme işlemleri:</strong> Başka bir yerden chat yönlendirme veya chat'e başka bir temsilci eklenebilmesi için buradaki ayarlarla örtüşmesi lazım, izin verilemeyen kişiye yönlendirme yapılmaz</li><li><strong>Müşteri/kişi listeleri:</strong> Gördüğünüz listeler bu ayara göre gelir, göremediğiniz kişiler varsa buradaki ayarla ilgili olabilir</li><li><strong>Sahiplendirme:</strong> Bir müşteriyi bir temsilciye sahiplendirmek isterseniz yine bu ayar sınırında yapabilirsiniz</li></ul>",
            makePublicButton: "Herkese Açık Yap",
            channelOwners: "Kanal Sahipleri",
            channelOwnersDesc:
                "Kanal sahipleri bu kanaldaki tüm konuşmaları görüntüleme yetkisine sahiptir. Görünürlük ayarlarından bağımsız olarak tüm mesajları okuyabilirler.",
            editChannelOwners: "Kanal Sahiplerini Düzenle",
            selectChannelOwner: "Kanal Sahibi Seç",
            selectChannelOwnerDesc: "Bu kanalın sahibi olacak temsilcileri seçin",
            makePublicConfirmTitle: "Bu kanalı herkese açık yapmak istediğinize emin misiniz?",
            makePublicConfirmContent: "Bu işlem sonrasında tüm temsilciler bu kanaldaki konuşmaları görebilecektir.",
            makePublicConfirmOk: "Evet, Herkese Açık Yap",
            makePublicSuccessMessage: "Kanal herkese açık hale getirildi",
            stepSetupTemplate: "Şablonu Kur",
            stepEditTemplate: "Şablonu Düzenle",
            stepSubmitReview: "İncelemeye Gönder",
            templateNameAndLanguage: "Şablon adı ve dil",
            editModeNoticeText:
                "Düzenleme modunda şablon adı ve dil değiştirilemez. Yalnızca kategori (onaylanmamışsa), bileşenler ve time-to-live düzenlenebilir.",
            nameYourTemplate: "Şablonunuza ad verin",
            enterTemplateNamePlaceholder: "Şablon adı girin",
            selectLanguage: "Dil seçin",
            content: "İçerik",
            footerOptional: "Alt bilgi • İsteğe bağlı",
            enterTextPlaceholder: "Metin girin",
            bodyLabel: "Gövde",
            bodyPlaceholder: "Mesaj gövde metninizi girin",
            bold: "Kalın",
            italic: "İtalik",
            strikethrough: "Üstü çizili",
            headerLabelRecommended: "Önerilen",
            headerLabelOptionalTextOnly: "İsteğe bağlı (Yalnızca metin)",
            headerLabelRequiredProduct: "Zorunlu (Ürün)",
            headerLabelOptional: "İsteğe bağlı",
            headerNone: "Yok",
            headerTextOption: "Metin",
            headerDocument: "Belge",
            headerProduct: "Ürün",
            productHeaderAutoSet: "Ürün şablonları kullanılırken ürün başlığı otomatik ayarlanır.",
            headerTextPlaceholder: "Mesajınızın başlığına kısa bir metin satırı ekleyin",
            mediaHintNote: "Not:",
            mediaHintIntro: "Kabul edilen dosya formatları ve boyutları:",
            mediaHintImage: "Görsel: JPEG, PNG (Maks. 5 MB)",
            mediaHintVideo: "Video: MP4 (Maks. 16 MB)",
            mediaHintDocument: "Belge: PDF (Maks. 100 MB)",
            productHeaderAutoInfo: "Ürün başlığı kataloğunuzdan otomatik eklenir. Manuel yapılandırma gerekmez.",
            carouselContentDescription:
                "İki ayrı mesaj oluşturun: Önce genel metin mesajı (gövde). İkinci olarak görsel/videolu carousel kartları. Her carousel kartının kendi gövde metni (isteğe bağlı) ve butonları (zorunlu, en az 1) olabilir. Genel gövde mesajında buton olamaz; yalnızca carousel kartlarında buton olabilir.",
            contentDescriptionProduct:
                "Ürün mesajı şablonunuz için gövde metni ekleyin. Ürün başlığı kataloğunuzdan otomatik eklenir. Meta tarafından barındırılan Cloud API şablon değişkenlerini ve içeriğini inceleyecektir.",
            contentDescriptionLTO:
                "Sınırlı süre teklifi şablonunuz için başlık ve gövde ekleyin. Bu şablon tipinde alt bilgi desteklenmez. Meta tarafından barındırılan Cloud API şablon değişkenlerini ve içeriğini inceleyecektir.",
            contentDescriptionCarousel:
                "Genel gövde metni ve carousel kartları ekleyin. Her carousel kartının kendi başlığı, isteğe bağlı gövde metni ve butonları vardır. Ana gövde mesajında buton olamaz; yalnızca carousel kartlarında buton olabilir. Meta tarafından barındırılan Cloud API şablon değişkenlerini ve içeriğini inceleyecektir.",
            contentDescriptionDefault:
                "Şablonunuz için başlık, gövde ve alt bilgi ekleyin. Meta tarafından barındırılan Cloud API şablon değişkenlerini ve içeriğini inceleyecektir.",
            readyToSubmit: "Göndermeye hazır",
            submitReviewDescription:
                "Şablonunuz Meta incelemesi için gönderilecektir. Bu işlem genellikle birkaç dakika sürer ancak 24 saate kadar uzayabilir.",
            bodyContentAdded: "Gövde içeriği eklendi",
            buttonsAddedCount: "{count} buton eklendi",
            previous: "Önceki",
            discard: "Vazgeç",
            next: "İleri",
            submitForReview: "İncelemeye Gönder",
            updateTemplate: "Şablonu Güncelle",
            cannotProceed: "Devam Edilemiyor",
            noChangesReason:
                "Şablonda hiçbir değişiklik yapılmadı. Lütfen devam etmeden önce en az bir değişiklik yapın.",
            categoryCannotChangeWarning: "Onaylanmış şablonlarda kategori değiştirilemez.",
            setupYourTemplate: "Şablonunuzu kurun",
            setupDescription:
                "Mesaj şablonunuzu en iyi tanımlayan kategoriyi seçin. Ardından göndermek istediğiniz mesaj türünü seçin.",
            learnMoreCategories: "Kategoriler hakkında daha fazla bilgi edinin.",
            marketing: "Marketing",
            utility: "Yardımcı",
            authentication: "Doğrulama",
            categoryCannotChangeApproved: "Onaylanmış şablonlar için kategori değiştirilemez",
            categoryCannotEditApproved:
                "Onaylanmış şablonlarda kategori düzenlenemez. Yalnızca bileşenler ve time-to-live düzenlenebilir.",
            notSupported: "Desteklenmiyor",
            selectProductMessageType: "Ürün mesajı tipini seçin",
            selectOtpAutofillType: "OTP otomatik doldurma tipini seçin",
            templatePreview: "Şablon önizlemesi",
            previewAlt: "Önizleme",
            previewAltCallPermission: "Arama izni talebi",
            previewSampleCard: "Örnek kart",
            previewCardPreview: "Kart önizlemesi",
            previewBodyMarketingDefault:
                "Merhaba! Taze ürünlerimize göz atın! Tüm alışverişinizde ek %10 indirim için HEALTH kodunu kullanın.",
            previewBodyCarouselStep0: "Öne çıkan ürünlerimize göz atın! Harika fırsatları keşfetmek için kaydırın.",
            previewSpecialOffer: "Özel Teklif",
            previewEndsIn2Days: "2 gün içinde bitiyor",
            previewExpiresLabel: "Bitiş: ",
            previewSeeAllOptions: "Tüm seçenekleri gör",
            previewBodyLto:
                "Hemen başlıyoruz! Yeni sabun koleksiyonumuzda 2 al 1 öde. Bu Kara Cuma'yı el yapımı sabunlarla unutulmaz kılın.",
            previewWinterSaleHeader: "Kış İndirimi başladı!",
            previewBodyCoupon:
                "Aralık sonuna kadar alışveriş yapın ve tek kullanımlık WINTER25 kodunu kullanarak tüm siparişinizde %25 indirim kazanın!",
            previewViewBizCatalog: "{BIZ_NAME} kataloğunu WhatsApp'ta görüntüle",
            previewBrowseCatalogueDetails: "Resimleri ve teklif detaylarını inceleyin.",
            previewBodyCatalogue:
                "Favori ürünlerinizi artık WhatsApp üzerinden satın alın! Tam kataloğumuzu inceleyin.",
            previewBodyCatalogueSingle: "Bu harika ürünü inceleyin! İhtiyaçlarınız için ideal.",
            previewBodyCatalogueMulti: "Bir şey mi unuttunuz? Görünüşe göre bu ürünleri sepetinizde bırakmışsınız.",
            previewBodyCatalogueCarousel: "En yeni ürünlerimizi keşfedin! Kataloğumuzu inceleyin ve aradığınızı bulun.",
            previewBodyUtility:
                "İyi haber! Siparişiniz 23KFEJJ2312 kargoya verildi! Takip bilgileriniz aşağıdaki bağlantıdadır.",
            previewBodyAuth: "123456 doğrulama kodunuzdur. Güvenliğiniz için bu kodu paylaşmayın.",
            previewBodyPlaceholder: "Mesaj gövdeniz burada görünecek",
            previewBodyCarouselPlaceholder: "Carousel mesaj gövdeniz burada görünecek",
            previewButtonN: "Buton {n}",
            previewProductNDescription: "Ürün {n} açıklaması",
            previewTemplateGoodFor: "Bu şablon şunlar için uygundur",
            previewTemplateAreasCustomise: "Özelleştirebileceğiniz şablon alanları",
            previewDescCatalogue:
                "Ürün/hizmet keşfi, satış, teklifler, hedefli pazarlama, kişiselleştirilmiş alışveriş",
            previewDescCoupon:
                "Kolay kullanım için kopyala butonu ile promosyon kodları gönderin. Yalnızca bir kopyala kodu butonu.",
            previewDescCarousel:
                "Birden fazla ürün veya hizmeti yatay kaydırılabilir görünümde sergileyin. Her kartın kendi görseli, açıklaması ve aksiyon butonları olabilir.",
            previewDescMarketing: "Hoş geldin mesajları, promosyonlar, teklifler, kuponlar, bültenler, duyurular",
            previewDescUtility:
                "Sipariş onayları, hesap güncellemesi, makbuzlar, randevu hatırlatıcıları, faturalandırma",
            previewDescAuth: "Tek kullanımlık şifre, hesap kurtarma kodu, hesap doğrulama, bütünlük kontrolleri",
            previewCustomisableCallPermission: "Başlık, gövde, alt bilgi",
            previewCustomisableCoupon: "Başlık (metin), gövde, buton (kopyala kodu metni hariç)",
            previewCustomisableCarousel: "Genel gövde mesajı, carousel kartları (her biri medya, gövde, butonlarla)",
            previewCustomisableMarketing: "Medya, başlık, gövde, alt bilgi, buton",
            previewCustomisableUtility: "Başlık, gövde, alt bilgi",
            previewCustomisableAuth: "Gövde",
            productMessage: "Ürün Mesajı",
            callUs: "Bizi Arayın",
            unsubscribe: "Abonelikten Çık",
            trackShipment: "Kargoyu Takip Et",
            choosePreference: "Tercih seçin",
            autoVerify: "Otomatik Doğrula",
            yourTemplateNamePlaceholder: "şablon_adınız",
            templateNameLabel: "Şablon adı",
            categoryLabel: "Kategori",
            languageLabel: "Dil",
            templateCreatedSuccess: "Şablon başarıyla oluşturuldu ve incelemeye gönderildi!",
            templateUpdatedSuccess: "Şablon başarıyla güncellendi!",
            mediaUploadedSuccess: "Medya başarıyla yüklendi",
            mediaUploadFailedPrefix: "Medya yüklemesi başarısız: ",
            nameRequired: "Şablon adı zorunludur",
            nameInvalidChars: "Yalnızca küçük harf, rakam ve alt çizgi kullanılabilir",
            nameMaxLength: "Şablon adı en fazla 512 karakter olabilir",
            bodyRequired: "Gövde içeriği zorunludur",
            ltoRequiresOneButton: "Sınırlı Süre Teklifi için en az bir buton gerekir",
            ltoRequiresUrlButton: "Sınırlı Süre Teklifi için URL butonu zorunludur",
            carouselRequiresOneCard: "Carousel şablonu için en az bir kart gerekir",
            cardMustHaveButton: "Kart {index} en az bir buton içermelidir",
            cardMustHaveHeaderMedia: "Kart {index} başlık görseli veya videosu içermelidir",
            ltoUrlButtonCannotRemove: "Sınırlı Süre Teklifi için en az bir URL butonu gerekir ve kaldırılamaz",
            ltoRequiresOneButtonWarning: "Sınırlı Süre Teklifi için en az bir buton gerekir",
            copyCodeButtonRequired: "Kupon Kodu şablonları için Kodu Kopyala butonu zorunludur ve kaldırılamaz",
            carouselCardMustHaveButton: "Her carousel kartının en az bir butonu olmalıdır",
            imageMaxSize: "Görsel 5 MB'dan küçük olmalıdır",
            videoMaxSize: "Video 16 MB'dan küçük olmalıdır",
            documentMaxSize: "Belge 100 MB'dan küçük olmalıdır",
            fileUploadFailed: "Dosya yüklemesi başarısız",
            uploadFileLoading: "Dosya yükleniyor...",
            templateTypeDefault: "Varsayılan",
            templateTypeDefaultDesc:
                "Müşterilerinizle etkileşim için medya ve özelleştirilmiş butonlarla mesaj gönderin.",
            templateTypeLimitedTimeOffer: "Sınırlı Süre Teklifi",
            templateTypeLimitedTimeOfferDesc: "Zaman duyarlı kampanyalar ve teklif kodlarıyla aciliyet oluşturun.",
            templateTypeCarousel: "Carousel",
            templateTypeCarouselDesc:
                "Birden fazla ürün veya teklifi göstermek için görseller ve butonlarla kart carousel'i gönderin.",
            templateTypeProductMessage: "Ürün Mesajı",
            templateTypeProductMessageDesc: "Ürün kataloğunuzu bağlayarak satış artıran mesajlar gönderin.",
            templateTypeCallPermission: "Arama izni talebi",
            templateTypeCallPermissionDesc: "Müşterilere WhatsApp'ta aranıp aranılamayacağınızı sorun.",
            templateTypeCouponCode: "Kupon Kodu",
            templateTypeCouponCodeDesc: "Kolay kullanım için kopyala butonu ile promosyon kodları gönderin.",
            templateTypeUtilityDefault: "Varsayılan",
            templateTypeUtilityDefaultDesc: "Mevcut sipariş veya hesap hakkında mesaj gönderin.",
            templateTypeOtp: "Tek kullanımlık şifre",
            templateTypeOtpDesc: "Bir işlemi veya girişi doğrulamak için kod gönderin.",
            catalogueSubtypeCatalogue: "Katalog Mesajı",
            catalogueSubtypeCatalogueDesc: "Katalog görüntüle butonu ile tüm ürün kataloğunuzu gösterin.",
            catalogueSubtypeMultiProduct: "Çoklu Ürün Mesajı",
            catalogueSubtypeMultiProductDesc: "Tek bir mesajda kataloğunuzdan 30'a kadar ürün gösterin.",
            catalogueSubtypeSingleProduct: "Tek Ürün Mesajı",
            catalogueSubtypeSingleProductDesc: "Detaylar ve harekete geçirici butonla tek bir ürünü vurgulayın.",
            catalogueSubtypeProductCardCarousel: "Ürün Kartı Carousel",
            catalogueSubtypeProductCardCarouselDesc: "Carousel görünümünde 10'a kadar ürün kartı gösterin.",
            catalogueSubtypeDisabledReason:
                "Şu anda desteklenmiyor. Bu şablon tipi ürün kataloğu entegrasyonu gerektirir.",
            authSubtypeCopyCode: "Kodu Kopyala",
            authSubtypeCopyCodeDesc: "Kullanıcı kodu manuel kopyalar (standart OTP).",
            authSubtypeOneTap: "Tek Dokunuş",
            authSubtypeOneTapDesc: "Desteklenen Android cihazlarda tek dokunuşla kodu otomatik doldur.",
            authSubtypeZeroTap: "Sıfır Dokunuş",
            authSubtypeZeroTapDesc: "Kullanıcı etkileşimi olmadan kodu otomatik doldurur (kullanıcı onayı gerekir).",
            viewCatalog: "Kataloğu Görüntüle",
            viewProduct: "Ürünü Görüntüle",
            viewProducts: "Ürünleri Görüntüle",
            view: "Görüntüle",
            copyOfferCode: "Teklif Kodunu Kopyala",
            oneTapAutofill: "Tek Dokunuş Otomatik Doldurma",
            zeroTapAutofill: "Sıfır Dokunuş Otomatik Doldurma",
            shopNow: "Şimdi Al",
            viewItems: "Öğeleri Görüntüle",
            autofill: "Otomatik Doldur",
            messageTtlOptional: "Mesaj Time-to-Live (TTL) • İsteğe bağlı",
            selectTtlPlaceholder: "TTL seçin veya varsayılan bırakın",
            ttlDescMarketing: "Pazarlama mesajınızı iletemezsek, belirtilen süre boyunca yeniden deneyeceğiz.",
            ttlDescUtility:
                "Sipariş onayları veya makbuzlar gibi yardımcı mesajları ne kadar süre ileteceğimizi ayarlayın.",
            ttlDescAuthentication: "Doğrulama kodlarının teslimat için ne kadar süre geçerli olacağını tanımlayın.",
            ttlInfoMarketing: "Pazarlama şablonları: 12 saat - 30 gün. Varsayılan sistem tarafından belirlenir.",
            ttlInfoUtility:
                "Yardımcı şablonlar: 30 saniye - 12 saat veya 30 gün için -1. Varsayılan sistem tarafından belirlenir.",
            ttlInfoAuthentication:
                "Doğrulama şablonları: 30 saniye - 15 dakika veya 30 gün için -1. Varsayılan sistem tarafından belirlenir.",
            ttlOption12Hours: "12 saat (43.200 saniye)",
            ttlOption1Day: "1 gün (86.400 saniye)",
            ttlOption3Days: "3 gün (259.200 saniye)",
            ttlOption7Days: "7 gün (604.800 saniye)",
            ttlOption15Days: "15 gün (1.296.000 saniye)",
            ttlOption30Days: "30 gün (2.592.000 saniye)",
            ttlOption30Seconds: "30 saniye",
            ttlOption1Minute: "1 dakika (60 saniye)",
            ttlOption2Minutes: "2 dakika (120 saniye)",
            ttlOption3Minutes: "3 dakika (180 saniye)",
            ttlOption5Minutes: "5 dakika (300 saniye)",
            ttlOption10Minutes: "10 dakika (600 saniye)",
            ttlOption15Minutes: "15 dakika (900 saniye)",
            ttlOption30Minutes: "30 dakika (1.800 saniye)",
            ttlOption1Hour: "1 saat (3.600 saniye)",
            ttlOption2Hours: "2 saat (7.200 saniye)",
            ttlOption4Hours: "4 saat (14.400 saniye)",
            ttlOption6Hours: "6 saat (21.600 saniye)",
            ttlOption30DaysSpecial: "30 gün (özel değer: -1)",
            authSettings: "Doğrulama Ayarları",
            addSecurityRecommendation: "Güvenlik önerisi ekle",
            securityRecommendationHint: '"Güvenliğiniz için bu kodu paylaşmayın" mesajı eklenir.',
            authMessageTtlHint: "Mesaj teslimat süre sınırı (60-600 saniye). Varsayılan için boş bırakın.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "İmza hash",
            messageTtlSecondsOptional: "Mesaj TTL (saniye) • İsteğe bağlı",
            codeExpirationOptional: "Kod son kullanma (dakika) • İsteğe bağlı",
            codeExpirationHint: "OTP kodunun geçerlilik süresi. Alt bilgide gösterilir.",
            zeroTapTerms: "Sıfır dokunuş koşullarını kabul ediyorum",
            zeroTapTermsHint: "Sıfır dokunuş otomatik doldurmanın çalışması için gereklidir.",
            supportedAndroidAppsOptional: "Desteklenen Android uygulamaları • İsteğe bağlı",
            addApp: "Uygulama ekle",
            limitedTimeOfferLabel: "Sınırlı Süre Teklifi",
            ltoDescription:
                "Teklifiniz için aciliyet oluşturacak metin ekleyin. Son kullanma süresi mesaj gönderildiğinde ayarlanacaktır.",
            ltoPlaceholder: "örn. Son teklif!, Fırsat!",
            showExpirationTimer: "Son kullanma sayacını göster",
            ltoExpirationHint:
                "Etkinleştirildiğinde WhatsApp, mesajın gönderildiği zamana göre geri sayım gösterecektir.",
            carouselCards: "Carousel Kartları",
            carouselCardsDescription:
                "Bu kartlar genel gövde metninden sonra ikinci bir mesaj olarak görünür. Her kartın görsel/video başlığı ve en az bir butonu (en fazla 2) olmalıdır. Kart gövde metni isteğe bağlıdır ve değişkenleri destekler. En fazla 10 kart ekleyebilirsiniz.",
            carouselCardN: "Kart {n}",
            carouselButtonsLabel: "Butonlar * (en az 1, en fazla 2)",
            cardHeaderRequired: "Kart Başlığı",
            cardBodyOptional: "Kart Gövdesi • İsteğe bağlı",
            cardBodyPlaceholder: "Kart gövde metnini girin (isteğe bağlı)",
            image: "Görsel",
            video: "Video",
            moveUp: "Yukarı taşı",
            moveDown: "Aşağı taşı",
            remove: "Kaldır",
            dragDropUpload: "Yüklemek için sürükleyip bırakın",
            orChooseFiles: "Veya cihazınızdan dosya seçin",
            uploadingToMeta: "Meta'ya yükleniyor...",
            uploadedSuccessfully: "Başarıyla yüklendi",
            addQuickReplyButton: "Hızlı Yanıt Butonu Ekle",
            addCtaButton: "CTA Butonu Ekle",
            urlButtonRequiredLto: "Sınırlı Süre Teklifi için URL butonu zorunludur",
            copyCodeButtonFixed: "Kupon Kodu şablonlarında kopyala kodu buton metni özelleştirilemez",
            copyCode: "Kodu kopyala",
            fixed: "Sabit",
            buttonsHeading: "Butonlar",
            buttonLabelAutoAdded: "Otomatik eklenir",
            buttonLabelRequiredCopyCode: "Zorunlu (1 Kodu Kopyala + İsteğe bağlı)",
            buttonLabelRequiredUrl: "Zorunlu (1 URL + İsteğe bağlı)",
            buttonLabelOptional: "İsteğe bağlı",
            buttonDescCatalogue: "Ürün butonu otomatik eklenir. Buton metnini özelleştirebilirsiniz.",
            buttonDescCallPermission: "Arama izni butonu otomatik eklenir. Ek buton eklenemez.",
            buttonDescAuth: "Doğrulama butonu otomatik eklenir. Buton metnini özelleştirebilirsiniz.",
            buttonDescCoupon:
                "Bir Kodu Kopyala butonu zorunludur ve metni özelleştirilemez. En fazla 10 toplam olacak şekilde Hızlı Yanıt veya CTA butonları ekleyebilirsiniz.",
            buttonDescLto:
                "Sınırlı süre teklifleri için en az bir URL butonu zorunludur. Ek CTA (Telefon, Teklif Kodunu Kopyala) veya Hızlı Yanıt butonları ekleyebilirsiniz.",
            buttonDescDefault:
                "Hızlı yanıtlar için Hızlı Yanıt veya aksiyonlar için CTA butonları ekleyin. Toplam en fazla 10 buton.",
            buttonPlaceholderText: "Buton metni",
            buttonMax10Warning: "En fazla 10 buton eklenebilir",
            buttonCopyCodeAutoAddedWarning: "Kodu Kopyala butonu otomatik eklenir ve manuel eklenemez",
            exampleValuePlaceholder: "örnek_değer",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "Hızlı Yanıt",
            visitWebsite: "Web Sitesini Ziyaret Et",
            callPhone: "Telefon Ara",
            addCard: "Kart Ekle",
            title: "Whatsapp Business API Kanalları",
            integration: "Entegrasyon",
            detail: "Detay",
            visibility: "Görünürlük",
            templates: "Tüm Şablon Mesajlar",
            settings_group: "Ayar",
            template_message_group: "Şablon Mesajları",
            new_template: "Yeni Şablon Oluştur",
            broadcast_group: "Toplu Mesaj",
            broadcast_requests: "Toplu Mesaj Gönderimleri",
            customer_groups: "Müşteri Grupları",
            chat_initiator_template: "Chat Başlatma Şablonu",
            reports: "Raporlar",
            contacts: "Kişiler",
            numbers: "Numaralar",
            all_contacts: "Tüm Kişiler",
            businessChannelDetail: "Whatsapp Business Kanal Detayı",
            wallet: "Cüzdan",
            postacellMessage: "SMS Gönder",
            postacellAllMessage: "Toplu SMS Gönder",
            message_group: "Mesaj",
            createNewTemplate: "Yeni şablon mesaj oluştur",
            templateName: "Şablon adı",
            templateNameDesc: "Mesaj şablonunuza bir isim verin.",
            templateInfo: "Şablon Bilgileri",
            viewTemplates: "Şablonları gör",
            templateListTitle: "Mesaj şablonları",
            templateListShownTotal: "{shown} şablon gösteriliyor (toplam: {total})",
            templateListCreateButton: "Şablon Oluştur",
            templateListSearchPlaceholder: "Şablonlarda ara...",
            templateListAllCategories: "Tüm Kategoriler",
            templateListAllStatus: "Tüm Durumlar",
            templateListStatusApproved: "Onaylandı",
            templateListStatusPending: "İncelemede",
            templateListRefresh: "Yenile",
            templateListTotalTemplates: "Toplam {count} şablon",
            templateListCopied: "Kopyalandı!",
            templateListCopy: "Kopyala",
            templateListIdLabel: "ID:",
            templateListPreview: "Önizleme",
            templateListEdit: "Düzenle",
            templateListDelete: "Sil",
            templateListPreviewTitle: "Şablon Önizlemesi",
            templateListNameLabel: "Ad:",
            templateListCategoryLabel: "Kategori:",
            templateListLanguageLabel: "Dil:",
            templateListStatusLabel: "Durum:",
            templateListReasonLabel: "Sebep:",
            templateListRecommendationLabel: "Öneri:",
            templateListColumnName: "ŞABLON ADI",
            templateListColumnCategory: "KATEGORİ",
            templateListColumnStatus: "DURUM",
            templateListColumnLastEdited: "SON DÜZENLEME",
            templateListStatusActive: "Aktif",
            templateListStatusInReview: "İncelemede",
            templateListStatusRejected: "Reddedildi",
            templateListStatusFailed: "Başarısız",
            templateListQualityHigh: "Yüksek Kalite",
            templateListQualityMedium: "Orta Kalite",
            templateListQualityLow: "Düşük Kalite",
            templateListDeleteConfirmTitle: "Şablonu Sil",
            templateListDeleteConfirmContent: '"{{name}}" şablonunu silmek istediğinize emin misiniz?',
            templateListDeleteConfirmOk: "Sil",
            templateListDeleteConfirmCancel: "İptal",
            templateListCopyIdError: "ID kopyalanırken bir hata oluştu",
            templateListDeletedSuccess: "{{name}} başarıyla silindi.",
            templateListDeleteFailed: "Şablon silinirken hata oluştu.",
            templateNameRules: "Şablon adı sadece küçük harf, sayı ve alt çizgi içerebilir.",
            category: "Kategori",
            categoryDesc: "Ne tür bir şablon oluşturmak istediğinizi seçin",
            categoryUtility: "Yardımcı",
            categoryUtilityDesc:
                "Hesap güncellemeleri, sipariş güncellemeleri, uyarılar ve daha fazlası gibi yardımcı bilgiler gönderin.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Farkındalığı ve etkileşimi artırmak için promosyon teklifleri, ürün teklifleri ve daha fazlasını gönderin.",
            categoryAuth: "Doğrulama",
            categoryAuthDesc: "Müşterilerinizin hesaplarına erişmesi için kodlar gönderin.",
            optional: "Tercihen",
            languageDesc: "Şablon mesajınızın hangi dilde gönderileceğini seçin",
            header: "Başlık",
            headerRules: "Mesajınıza 60 karakterlik bir başlık ekleyin. Başlıkta yalnızca bir değişken desteklenir.",
            headerOptionMedia: "Medya",
            headerOptionText: "Metin",
            none: "Hiçbiri",
            headerType: "Başlık tipi",
            headerText: "Başlık metni",
            body: "Gövde",
            bodyRules: "Mesajnınız için seçtiğiniz dilde bir metin girin",
            addVariable: "Değişken ekle",
            variables: "Değişkenler",
            variable: "Değişken",
            defaultVariableName: "Varsayılan Değişken Adı",
            defaultVariableToolTip:
                "Değişkeniniz şablonda bu isimle gözükür.<br> Ayrıca aksi durumlarda mesajınızda varsayılan olarak bu değer gönderilir.",
            selectATemplate: "Mesaj Şablonunuzu Seçin",
            variableSettings: "Değişken ayarları",
            example: "Örnek",
            dynamicUrlSampleNote: "Değişkenli dinamik URL örneği (Not: Yukarıdaki mesaj gövdesine URL eklemeyin)",
            footer: "alt bilgi",
            footerDesc: "Mesajınıza 60 karakterlik bir altbilgi ekleyin. Altbilgide değişkenler desteklenmez.",
            buttons: "Butonlar",
            buttonType: "Buton tipi",
            buttonTypeReply: "Cevapla",
            submit: "Kaydet",
            submitting: "Kaydediliyor",
            addButton: "Buton Ekle",
            rejectWhatsapp: "Whatsapp tarafından reddedildi.",
            approvedWhatsapp: "Whatsapp tarafından kabul edildi.",
            pendingWhatsapp: "Onay Bekliyor",
            daily_usages: "Günlük Kullanımlar",
            businessDescription: "وصف نشاطك التجاري.",
            bussinesDescription: "Business description",
            failedUpdateChannel: "Failed to update channel",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            selectBusinessVertical: "Select Business Area",
            stateIfApplicable: "State (if applicable)",
            successDesc: "Your profile information was successfully updated.",
        },
        multi_whatsapp_api: {
            profile: "Profil",
            integration: "Entegrasyon",
            detail: "Detay",
            visibility: "Görünürlük",
            templates: "Tüm Şablon Mesajlar",
            settings_group: "Ayar",
            template_message_group: "Şablon Mesajları",
            new_template: "Yeni Şablon Oluştur",
            broadcast_group: "Toplu Mesaj",
            broadcast_requests: "Toplu Mesaj Gönderimleri",
            customer_groups: "Müşteri Grupları",
            chat_initiator_template: "Chat Başlatma Şablonu",
            contacts: "Kişiler",
            all_contacts: "Tüm Kişiler",
            numbers: "Numaralar",
        },
        archive: {
            destroyedBy: {
                agent: "Temsilci",
                visitor: "Ziyaretçi",
                system: "Sistem",
                chatbot: "Chatbot",
            },
        },
        waba: {
            templateCreationFailed: "Şablon Oluşturulamadı",
            templateError_2388040: "Karakter Sınırı Aşıldı",
            templateErrorDesc_2388040: "Şablonunuzdaki bir alan izin verilen maksimum karakter sınırını aştı.",
            templateError_2388047: "Mesaj Başlığı Formatı Hatalı",
            templateErrorDesc_2388047: "Mesaj başlığınız geçersiz bir format içeriyor.",
            templateError_2388072: "Mesaj Gövdesi Formatı Hatalı",
            templateErrorDesc_2388072: "Mesaj gövdeniz geçersiz bir format içeriyor.",
            templateError_2388073: "Mesaj Alt Bilgisi Formatı Hatalı",
            templateErrorDesc_2388073: "Mesaj alt bilginiz geçersiz bir format içeriyor.",
            templateError_2388293: "Parametre Oranı Sınırı Aşıldı",
            templateErrorDesc_2388293:
                "Bu şablonda uzunluğuna göre çok fazla değişken bulunuyor. Değişken sayısını azaltın veya mesaj uzunluğunu artırın.",
            templateError_2388299: "Başta veya Sonda Parametre Kullanılamaz",
            templateErrorDesc_2388299: "Değişkenler şablonun başında veya sonunda bulunamaz.",
        },
        upgradeMessages: {
            ticket: "Offline olsanız bile, yapay zeka ve chatbot ile talepleriniz anında kaydedilsin. Müşterilerinizi her zaman memnun edin!",
            tasks: "Görevlerinizi ve projelerinizi kolayca yönetin. Ekip üyelerinizle işbirliği yapın ve projelerinizi zamanında teslim edin!",
            calendar:
                "Randevularınızı ve toplantılarınızı kolayca planlayın. Ekip üyelerinizle senkronize olun ve zamanınızı daha verimli kullanın!",
            mail_integration:
                "E-postalarınızı kolayca yönetin. Müşterilerinizle iletişiminizi güçlendirin ve işbirliğinizi artırın!",
            team_integration:
                "Takımınızla daha hızlı ve etkili iletişim kurun. İşbirliğinizi artırın ve projelerinizi zamanında teslim edin!",
            webhook_integration:
                "Webhook entegrasyonu ile uygulamalarınızı birbirine bağlayın ve veri alışverişini kolaylaştırın!",
            whatsapp_v2: "Whatsapp entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            whatsapp: "Whatsapp entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            whatsapp_business_api: "Whatsapp entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            instagram: "Instagram entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            messenger: "Messenger entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            sms_postacell: "SMS entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            ready_contents: "Hazır İçerikler, müşterilerinizle daha hızlı ve etkili iletişim kurmanızı sağlar.",
            automation:
                "Otomasyon ile işlerinizi otomatikleştirin. İşlerinizi daha hızlı ve etkili bir şekilde yönetin!",
            form: "Form Oluşturucu, müşterilerinizle daha hızlı ve etkili iletişim kurmanızı sağlar. Form Oluşturucu ile müşterilerinizden daha fazla bilgi alın ve işbirliğinizi artırın!",
            customer_tables:
                "Müşteri Tabloları ile kendi tablonuzu oluşturun, hızlı ve pratik bir şekilde müşteri bilgilerinizi kaydedin ve yönetin!",
            trendyol: "Trendyol entegrasyonu ile müşterilerinizle daha hızlı ve etkili iletişim kurun!",
            access_control: "Erişim Kontrolü ile kötü niyetli kullanıcıları engelleyin ve verilerinizi güvende tutun!",
            upgrade: "Aboneliğimi Yükselt",
            upgradeFeature: "Ek Paket Al",
            featureNotAvailable: "özelliğiniz mevcut değildir.",
            usageLimitExceeded: "Kullanım Sınırı Aşıldı",
            maxAgentCount: "Daha fazla temilsci alarak daha fazla müşteriye hizmet vermek için paketinizi yükseltin.",
            maxTriggerCount: "Daha fazla tetkileyici alıp daha fazla etkileşim yaratmak için paketinizi yükseltin.",
            visitorStartChat:
                "Daha önce etkileşime girmemiş ziyaretçilerle sohbet başlatmak için paketinizi yükseltin.",
            voiceCalling:
                "Müşterileriniz ile sesli görüşme yaparak daha etkili iletişim kurmak için paketinizi yükseltin.",
            videoCalling:
                "Müşterileriniz ile video görüşme yaparak daha etkili iletişim kurmak için paketinizi yükseltin.",
            fileAndVoiceMessage: "Müşterilerinize dosya ve sesli mesaj göndermek için paketinizi yükseltin.",
            autoTranslation:
                "Mesajları otomatik çevirerek daha fazla müşteriye hizmet vermek için paketinizi yükseltin.",
            telegramEntegration: "Telegram entegrasyonu için paketinizi yükseltin.",
            chatCopilot:
                "Yapay zeka destekli Chat Copilot özelliğini kullanarak daha etkili hizmet vermek için paketinizi yükseltin.",
            calenderEntegration:
                "Takvim entegrasyonu ile diğer uygulamalarınızı senkronize etmek için paketinizi yükseltin.",
            mailEntegration:
                "Mail işlerinizi daha etkili yönetmek ve müşteri iletişimini artırmak için paketinizi yükseltin.",
            smsEntegration: "SMS entegrasyonu ile müşterilerinize daha hızlı ulaşmak için paketinizi yükseltin.",
            ticketSystem: "Ticket sistemi ile müşteri taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            taskManagementEntegration:
                "Görev yönetimi entegrasyonu ile iş akışınızı daha etkili yönetmek için paketinizi yükseltin.",
            webhookEntegration:
                "Webhook entegrasyonu ile diğer uygulamalarınızı senkronize etmek için paketinizi yükseltin.",
            readyContents: "Hazır içerikler ile müşteri iletişimini artırmak için paketinizi yükseltin.",
            automationEntegration:
                "Otomasyon entegrasyonu ile iş akışınızı daha etkili yönetmek için paketinizi yükseltin.",
            customerTablesEntegration:
                "Müşteri tabloları ile müşteri bilgilerini daha etkili yönetmek için paketinizi yükseltin.",
            formEntegration: "Formlar ile müşteri taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            maxFormLimit:
                "Daha fazla form oluşturup müşteri taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            maxFormFieldLimit:
                "Daha fazla form alanıp ekleyip müşterilerin taleplerini daha etkili yönetmek için paketinizi yükseltin.",
            maxCustomerTableCount: "Daha fazla müşteri tablosu eklemek için paketinizi yükseltin.",
            maxCustomerTableFieldCount: "Daha fazla müşteri tablosu alanı eklemek için paketinizi yükseltin.",
            maxCustomerTableViewCount: "Daha fazla müşteri tablosu görünümü kaydetmek için paketinizi yükseltin.",
            maxCustomerTableRecordCount: "Daha fazla müşteri tablosu kaydı eklemek için paketinizi yükseltin.",
            maxAutomationButton: "Daha fazla otomasyon bloğu eklemek için paketinizi yükseltin.",
            automationTimerBase: "Otomasyon zamanlayıcıları kullanmak için paketinizi yükseltin.",
            automationEventBase: "Otomasyon olayları kullanmak için paketinizi yükseltin.",
            automationWebhookBase: "Otomasyon webhookları kullanmak için paketinizi yükseltin.",
            automationButtonBase: "Otomasyon butonları kullanmak için paketinizi yükseltin.",
            liveScore: "Canlı izleme özelliğini kullanmak için paketinizi yükseltin.",
            multipleChatWindow: "Birden fazla sohbet penceresi açmak için paketinizi yükseltin.",
            maxTaskWorkflowLimit: "Daha fazla görev akışı eklemek için paketinizi yükseltin.",
            maxTaskColumnLimit: "Daha fazla görev sütunu eklemek için paketinizi yükseltin.",
            maxTaskRowLimit: "Daha fazla görev satırı eklemek için paketinizi yükseltin.",
            maxDepartmentLimit: "Daha fazla departman eklemek için paketinizi yükseltin.",
            maxRoleLimit: "Daha fazla rol eklemek için paketinizi yükseltin.",
            maxReadyContentsLimit: "Daha fazla hazır içerik eklemek için paketinizi yükseltin.",
            excelDownload: "Excel indirme özelliğini kullanmak için paketinizi yükseltin.",
            customerGroup: "Müşteri grupları özelliğini kullanmak için paketinizi yükseltin.",
            maxMailCount: "Daha fazla mail göndermek için paketinizi yükseltin.",
            maxWhatsappChannel: "Daha fazla Whatsapp kanalı eklemek için paketinizi yükseltin.",
            maxBusinessWhatsappChannel: "Daha fazla Whatsapp Business kanalı eklemek için paketinizi yükseltin.",
            maxInstagramChannel: "Daha fazla Instagram kanalı eklemek için paketinizi yükseltin.",
            maxMessengerChannel: "Daha fazla Messenger kanalı eklemek için paketinizi yükseltin.",
            maxTelegramChannel: "Daha fazla Telegram kanalı eklemek için paketinizi yükseltin.",
            maxTrendyolChannel: "Daha fazla Trendyol kanalı eklemek için paketinizi yükseltin.",
            maxMetaLeadChannel: "Daha fazla Meta Lead kanalı eklemek için paketinizi yükseltin.",
        },
        setupWizard: {
            finishModalVideos: "Eğitim Videoları",
            finishModalDoc: "Dokümantasyon",
            finsihModalLiveSupport: "Canlı Destek",
            completed: "Tamam, anladım",
            completedWarning: "Kurulumu tamamlamak ve rehberi bitirmek için butona tıklayın",
            supsisSetupGuide: "Supsis Kurulum Rehberi",
            supsisSetupGuideDescription: "Supsis'i tam olarak kullanabilmek için lütfen bu adımları tamamlayın",
            goToSetup: "Kuruluma Git",
            completionPercentageDescription: "Supsis'in sunduğu özelliklerin yalnızca % {percentage} kullanıyorsunuz.",
            aiChatbot: {
                title: "Yapay Zeka Chatbot",
                content: "Supsis AI Chatbot ile gelen mesajlara otomatik, anlık ve akıllı yanıtlar verin.",
                steps: {
                    step1: {
                        title: "Chatbot Oluşturun",
                        content:
                            "Yeni bir <b>chatbot senaryosu</b> oluşturmak için bu butonu kullanın. İster sizin için özel olarak hazırlanmış şablonlardan birini seçerek hızlıca başlayabilir, isterseniz de tamamen özgün bir senaryoyu sıfırdan tasarlayarak işletmenizin ihtiyaçlarına tam uyumlu bir chatbot oluşturabilirsiniz.",
                    },
                    step2: {
                        title: "Hazır Senaryolar",
                        content:
                            "Buradaki <b>hazır şablonlar</b> ile chatbot'un temel çalışma mantığını kolayca kavrayın. Bu şablonları kendi ihtiyaçlarınıza göre özelleştirerek zaman kazanın ve size özel çözümler geliştirin. Aşağıda listelenen, farklı kullanım alanlarına uygun şablonlardan dilediğinizi seçerek başlayabilirsiniz.",
                    },
                    step3: {
                        title: "Chatbot Entegrasyonları",
                        content:
                            "Hazırladığınız chatbot'u <b>WhatsApp, Instagram, Facebook gibi popüler sosyal medya platformlarına entegre edin</b>. Bu sayede chatbot'unuzu doğrudan müşterilerinizin kullandığı kanallarda aktif hale getirerek erişilebilirliğinizi ve etkileşim oranlarınızı artırabilirsiniz.",
                    },
                    step4: {
                        title: "Chatbot Analizleri",
                        content:
                            "Chatbot'unuzun <b>performansını detaylı grafikler ve istatistiklerle görüntüleyin ve analiz edin</b>. Belirli zaman aralıklarına veya entegre ettiğiniz platformlara göre filtreleme yaparak chatbot'unuzun etkinliğini ölçebilir, iyileştirme alanlarını belirleyebilir ve stratejilerinizi optimize edebilirsiniz.",
                    },
                },
            },
            aiAssistant: {
                title: "Yapay Zeka Asistan",
                content: "Destek ekibinize yardımcı olacak dijital asistanı devreye alın.",
                steps: {
                    step1: {
                        title: "OpenAI Entegrasyonu",
                        content:
                            "<p>İşletmenizin verimliliğini artırmak için OpenAI ile Supsis AI arasında <b>sorunsuz bir entegrasyon</b> gerçekleştirin. Bu sayede güçlü yapay zeka asistanınız aktif hale gelecek ve süreçlerinizi optimize etmeye başlayacaktır. Entegrasyonu tamamlamak için tek yapmanız gereken OpenAI API anahtarınızı girmektir. <br> <br> <b>OpenAI API anahtarınızı almak için <a href='https://platform.openai.com/account/api-keys' target='_blank'>buraya</a> tıklayınız.</b></p>",
                    },
                },
            },
            aiLiveSupport: {
                title: "Yapay Zeka Canlı Destek",
                content: "Yapay zeka destekli canlı sohbet sistemini aktif hale getirin.",
                steps: {
                    step1: {
                        title: "Görüşmeleri Filtreleyin",
                        content:
                            "Bu alandan gelen <b>tüm müşteri görüşmelerini kolayca yönetin</b>. Görüşmeleri okunmamış, bekleyen veya chatbot ile devam edenler gibi farklı kategorilere göre filtreleyerek önceliklendirebilir ve hiçbir talebin gözden kaçmamasını sağlayabilirsiniz.",
                    },
                    step2: {
                        title: "Daha Detaylı Görüntüleme",
                        content:
                            "Müşteri görüşmelerini daha derinlemesine incelemek için bu seçenekleri kullanın. Dünden cevapsız kalan görüşmeler, sizinle iletişime geçen belirli müşteriler gibi <b>daha detaylı filtrelemeler</b> yapabilir veya kendinize özel filtreler oluşturarak iş akışınızı kişiselleştirebilirsiniz.",
                    },
                    step3: {
                        title: "Canlı Destek Ekranı",
                        content:
                            "Bu görünüme geçerek <b>tüm canlı destek görüşmelerinizi merkezi bir ekran üzerinden etkin bir şekilde yönetin</b>. Görüşmeye ait tüm mesajları, ajan yanıtlarını, güncel durumlarını ve tarih bilgilerini tek bir yerden görüntüleyerek hızlı ve doğru kararlar alabilirsiniz.",
                    },
                    step4: {
                        title: "Test Sayfası",
                        content:
                            "Oluşturduğunuz chatbot'un performansını ve işleyişini gerçek zamanlı olarak test etmek için bu bölüme erişin. Bir ziyaretçi gibi mesajlar göndererek <b>chatbot'unuzun yanıtlarını ve davranışlarını yakından gözlemleyebilir</b>, böylece son kullanıcılara sunmadan önce gerekli tüm iyileştirmeleri yapabilirsiniz.",
                    },
                },
            },
            aiAutomation: {
                title: "Yapay Zeka Otomasyon",
                content: "Destek süreçlerinizi otomatikleştirin, zamandan kazanın.",
                steps: {
                    step1: {
                        title: "Yeni Otomasyon Oluştur",
                        content:
                            "İş süreçlerinizi otomatikleştirmek için bu butonu kullanarak yeni bir otomasyon oluşturun. İster belirli bir olaya bağlı (örneğin, yeni bir mesaj geldiğinde), ister zamana dayalı (örneğin, her sabah belirli bir saatte) ya da <b>Webhook tabanlı</b> otomasyonlar tasarlayarak iş akışlarınızı akıllı hale getirin.",
                    },
                    step2: {
                        title: "Otomasyon Kategorileri",
                        content:
                            "Çok sayıda otomasyonunuz olduğunda yönetimini kolaylaştırmak için bu bölümden <b>otomasyon kategorileri</b> oluşturun. Kategorilendirme sayesinde otomasyonlarınızı daha düzenli tutabilir ve ihtiyaç duyduğunuzda hızlıca bulabilirsiniz. Kategori oluşturmak için bu butonu kullanabilirsiniz.",
                    },
                    step3: {
                        title: "Çalıştırılan Görevler",
                        content:
                            "Otomasyonlarınızı oluşturup yayınladıktan sonra, bu bölümden <b>otomasyonlarınızın kaç görev çalıştırdığını anlık olarak takip edebilirsiniz</b>. Bu sayede otomasyonlarınızın ne kadar aktif olduğunu ve hangi süreçleri etkilediğini gözlemleyebilirsiniz.",
                    },
                    step4: {
                        title: "Otomasyon İstatistikleri",
                        content:
                            "Otomasyonlarınızın <b>kapsamlı performans istatistiklerini</b> bu bölümden inceleyin. Hangi otomasyonların ne sıklıkta çalıştığını, başarılı görev sayısını, başarı oranını ve varsa hata oranlarını görüntüleyerek otomasyon stratejilerinizi optimize edebilirsiniz.",
                    },
                },
            },
            aiDynamicCrm: {
                title: "Yapay Zeka CRM",
                content: "Müşteri etkileşimlerinizi yapay zekayla analiz edip yönetin.",
                steps: {
                    step1: {
                        title: "Ziyaretçileri Filtrele",
                        content:
                            "Müşteri veritabanınızdaki <b>ziyaretçileri kolayca filtreleyin</b>. Ziyaretçileri isim, e-posta adresi, telefon numarası, etiket veya özel profil alanlarına göre arayabilirsiniz. Ayrıca, daha detaylı bir görüntüleme ve analiz için bu bölümden erişim sağlayabilirsiniz.",
                    },
                    step2: {
                        title: "Ziyaretçileri Görüntüle",
                        content:
                            "Tüm ziyaretçileriniz bu tabloda listelenir. Bir ziyaretçi hakkında <b>daha fazla bilgiye erişmek ve işlem yapmak için ilgili satıra çift tıklayın</b>. Açılan pencerede ziyaretçiye ait iletişim geçmişi, notlar ve diğer detaylı bilgilere ulaşabilirsiniz.",
                    },
                    step3: {
                        title: "Manuel Engelleme",
                        content:
                            "İstenmeyen veya uygunsuz davranış sergileyen ziyaretçileri <b>manuel olarak engelleyebilirsiniz</b>. Engellenen ziyaretçiler ayrı bir listede görüntülenir ve gerektiğinde bu bölümden engellemeyi kaldırabilirsiniz.",
                    },
                    step4: {
                        title: "Etiketler",
                        content:
                            "Ziyaretçilerinizi <b>etiketlerle kategorize ederek</b> CRM'nizi daha düzenli ve yönetilebilir hale getirin. Ziyaretçilere etiket atayabilmek için öncelikle kendi etiketlerinizi oluşturmanız gerekmektedir. Yeni etiket oluşturmak için bu butonu kullanabilirsiniz.",
                    },
                    step5: {
                        title: "Profil Alanları",
                        content:
                            "<b>Profil alanları</b>, ziyaretçileriniz hakkında ek bilgiler toplamanızı ve bu bilgileri düzenli bir şekilde yönetmenizi sağlar. Bu sayede, müşteri segmentasyonunuzu derinleştirebilir, kişiselleştirilmiş hizmet sunabilir ve müşteri ilişkilerinizi daha etkili hale getirebilirsiniz.",
                    },
                },
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "WhatsApp Business hesabınızı bağlayarak destek mesajlarını yönetin.",
                steps: {
                    step1: {
                        title: "WhatsApp Business Entegrasyonu",
                        content:
                            "<p><b>WhatsApp Business hesabınızı Supsis'e bağlayarak</b> tüm müşteri destek mesajlarınızı tek bir merkezi panelden yönetin. Bu entegrasyon sayesinde WhatsApp üzerinden anlık mesajlar gönderebilir, toplu duyurular yapabilir, otomatik yanıtlar ayarlayabilir ve müşteri etkileşimlerinizi kapsamlı bir şekilde takip edebilirsiniz.</p>",
                    },
                },
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "WhatsApp Web üzerinden gelen mesajları Supsis AI ile yönetin.",
                steps: {
                    step1: {
                        title: "WhatsApp Web Entegrasyonu",
                        content:
                            "<p><b>WhatsApp Web üzerinden gelen tüm mesajları Supsis AI ile sorunsuz bir şekilde yönetin.</b> Bu entegrasyon sayesinde WhatsApp üzerinden anlık mesajlar gönderebilir, toplu mesajlar oluşturabilir, otomatik yanıtlar ayarlayabilir ve müşteri etkileşimlerinizi kolayca takip edebilirsiniz. Böylece müşteri iletişiminizi daha verimli hale getirirsiniz.</p>",
                    },
                },
            },
            instagram: {
                title: "Instagram",
                content: "Instagram DM'lerini Supsis AI üzerinden yanıtlayın.",
                steps: {
                    step1: {
                        title: "Instagram Entegrasyonu",
                        content:
                            "<p><b>Instagram DM'lerini Supsis AI üzerinden doğrudan yanıtlayarak</b> müşteri iletişiminizi merkezileştirin. Bu entegrasyon sayesinde Instagram üzerinden anlık mesajlar gönderebilir, toplu duyurular yapabilir, otomatik yanıtlar ayarlayabilir ve müşteri etkileşimlerinizi kapsamlı bir şekilde takip edebilirsiniz.</p>",
                    },
                },
            },
            facebook: {
                title: "Facebook",
                content: "Facebook sayfanızdan gelen mesajları tek panelden yönetin.",
                steps: {
                    step1: {
                        title: "Facebook Entegrasyonu",
                        content:
                            "<p><b>Facebook sayfanızdan gelen tüm mesajları Supsis AI ile etkin bir şekilde yönetin.</b> Bu entegrasyon sayesinde Facebook Messenger üzerinden anlık mesajlar gönderebilir, toplu mesajlar oluşturabilir, otomatik yanıtlar ayarlayabilir ve müşteri etkileşimlerinizi takip edebilirsiniz.</p>",
                    },
                },
            },
            telegram: {
                title: "Telegram",
                content: "Telegram mesajlarını Supsis AI ile entegre edin.",
                steps: {
                    step1: {
                        title: "Telegram Entegrasyonu",
                        content:
                            "<p><b>Telegram mesajlarını Supsis AI ile entegre ederek</b> müşteri iletişiminizi tek bir panelden yönetin. Bu entegrasyon sayesinde Telegram üzerinden anlık mesajlar gönderebilir, toplu mesajlar oluşturabilir, otomatik yanıtlar ayarlayabilir ve tüm müşteri etkileşimlerinizi zahmetsizce takip edebilirsiniz.</p>",
                    },
                },
            },
            mail: {
                title: "Mail",
                content: "Destek e-postalarınızı Supsis AI sistemine entegre edin.",
                steps: {
                    step1: {
                        title: "Yeni Bir E-Posta Oluştur",
                        content:
                            "<p>Yeni bir e-posta göndermek için bu butonu kullanın. <b>E-posta içeriğini, alıcıları ve diğer gerekli bilgileri doldurarak</b> hızlıca kişisel veya toplu e-postalarınızı gönderebilirsiniz.</p>",
                    },
                    step2: {
                        title: "E-Posta Şablonları",
                        content:
                            "<p>E-posta şablonlarınızı bu bölümden <b>yönetin</b>. Mevcut şablonlarınızı düzenleyebilir, silebilir veya yeni şablonlar oluşturabilirsiniz. Önceden hazırlanmış şablonları kullanarak e-posta gönderim süreçlerinizi hızlandırabilir ve tutarlı bir iletişim sağlayabilirsiniz.</p>",
                    },
                    step3: {
                        title: "Toplu E-Posta'lar Gönderin",
                        content:
                            "<p>Geniş kitlelere ulaşmak için <b>toplu e-posta gönderimi</b> yapmak üzere bu alanı kullanın. Gerekli alanları doldurarak Supsis'deki müşteri listenize veya belirli gruplara kolayca toplu e-postalar gönderebilirsiniz.</p>",
                    },
                    step4: {
                        title: "Müşteri Gruplarınızı Yönetin",
                        content:
                            "<p>Müşteri gruplarınızı bu bölümden <b>etkin bir şekilde yönetin</b>. Mevcut gruplarınızı düzenleyebilir, silebilir veya yeni gruplar oluşturabilirsiniz. Bu gruplar sayesinde hedefli e-posta kampanyaları düzenleyebilir ve iletişiminizi daha kişiselleştirebilirsiniz.</p>",
                    },
                },
            },
            metaLead: {
                title: "Meta Lead",
                content: "Facebook ve Instagram reklamlarınızdan gelen formları yönetin.",
                steps: {
                    step1: {
                        title: "Meta Lead Entegrasyonu",
                        content:
                            "<p><b>Meta Lead Entegrasyonu</b> ile Facebook ve Instagram reklamlarınızdan gelen potansiyel müşteri formlarını doğrudan Supsis üzerinden yönetin. Bu entegrasyon sayesinde reklam kampanyalarınızdan elde ettiğiniz lead'leri daha verimli bir şekilde takip edebilir, potansiyel müşterilerle iletişiminizi hızlandırabilir ve dönüşüm oranlarınızı artırabilirsiniz.</p>",
                    },
                },
            },
            trendyol: {
                title: "Trendyol",
                content: "Trendyol siparişlerinizi ve müşteri mesajlarınızı yönetin.",
                steps: {
                    step1: {
                        title: "Trendyol Entegrasyonu",
                        content:
                            "<p><b>Trendyol Entegrasyon İşlemleri</b> sayesinde Trendyol üzerinden gelen siparişlerinizi Supsis üzerinden merkezi bir şekilde yönetin. Bu entegrasyonu tamamladıktan sonra, sipariş süreçlerinizi daha verimli hale getirebilir, müşteri iletişiminizi kolaylaştırabilir ve operasyonel yükünüzü azaltabilirsiniz.</p>",
                    },
                },
            },
            formSurvey: {
                title: "Form Anketleri",
                content: "Müşterilerden geri bildirim almak için formlar oluşturun.",
                steps: {
                    step1: {
                        title: "Yeni bir Form Oluşturun",
                        content:
                            "<p>Müşterilerinizden geri bildirim almak için <b>yeni bir form veya anket oluşturmak</b> için bu butonu kullanın. Oluşturduğunuz formlar sayesinde değerli müşteri geri bildirimlerini toplayabilir ve iletişiminizi daha verimli hale getirebilirsiniz.</p>",
                    },
                    step2: {
                        title: "Formlarınızı Yönetin",
                        content:
                            "<p>Bu alandan <b>tüm formlarınızı etkin bir şekilde yönetin</b>. Formlarınızı düzenleyebilir, arşivleyebilir, silebilir veya yeni formlar oluşturabilirsiniz. Ayrıca yayınlanmış formlarınızın performansını takip edebilir, yanıt oranlarını görüntüleyebilir ve gerektiğinde anında düzenlemeler yapabilirsiniz. Form yönetimi sayesinde müşteri geri bildirimlerinizi daha etkili bir şekilde toplayabilir ve analiz edebilirsiniz.</p>",
                    },
                },
            },
            processManagement: {
                title: "Süreç Yönetimi",
                content: "Destek süreçlerinizi adım adım planlayıp yönetin.",
                steps: {
                    step1: {
                        title: "İş süreçlerinizi yönetin",
                        content:
                            "<p>Bu bölüm, işletmenizin tüm iş süreçlerini etkili bir şekilde yönetmenizi sağlar. <b>Görevler oluşturabilir, ekip üyelerinize atayabilir ve iş akışlarınızı optimize edebilirsiniz.</b> Bu sayede, süreçlerinizi daha verimli hale getirebilir, görevlerin durumunu anlık olarak takip edebilir ve ekip performansınızı artırabilirsiniz.</p>",
                    },
                    step2: {
                        title: "Görevleri Listeleyin",
                        content:
                            "<p>Tüm görevlerinizi bu bölümden <b>liste görünümünde görüntüleyin</b>. Görevleri filtreleyebilir, silebilir veya yeni görevler oluşturabilirsiniz. Kapsamlı bir liste görünümü ile iş yükünüzü kolayca takip edin.</p>",
                    },
                    step3: {
                        title: "Görev Etiketleri",
                        content:
                            "<p>Görevlerinizi daha iyi organize etmek ve yönetmek için <b>etiketler oluşturun</b>. Bu etiketleri kullanarak görevleri kolayca kategorize edebilir ve arama süreçlerinizi hızlandırabilirsiniz. Etiket oluşturmak için bu butonu kullanabilirsiniz.</p>",
                    },
                    step4: {
                        title: "Görevleri Arşivleyin",
                        content:
                            "<p>Tamamlanmış veya artık aktif olmayan görevleri <b>arşivleyerek çalışma alanınızı düzenli tutun</b>. Arşivlenen görevler burada listelenir ve gerektiğinde kolayca geri alabilirsiniz.</p>",
                    },
                    step5: {
                        title: "Tamamlanan Görevler",
                        content:
                            "<p><b>Tamamlanan görevlerinizi</b> bu bölümden görüntüleyin. Tamamlanan görevlerin durumunu değiştirebilir ve dilerseniz arşivleyebilirsiniz. Bu sayede tamamlanan işlerinizin kaydını tutabilir ve geçmiş performansı analiz edebilirsiniz.</p>",
                    },
                },
            },
            calendar: {
                title: "Takvim",
                content: "Görüşme ve görev takviminizi yönetin.",
                steps: {
                    step1: {
                        title: "Takvim",
                        content:
                            "<p>Bu etkileşimli <b>takvim</b> ile görüşmelerinizi günlük olarak kolayca planlayın. Yeni rezervasyonlar oluşturabilir, mevcut görüşmeleri takvim üzerinden güncelleyebilir veya iptal edebilirsiniz. Randevu yönetiminizi optimize ederek zaman çizelgenizi etkin bir şekilde kontrol edin.</p>",
                    },
                    step2: {
                        title: "Rezervasyon Web Sitesi",
                        content:
                            "<p>Kendi <b>rezervasyon web sitenizi</b> kullanarak müşterilerinizin kolayca randevu almasını sağlayın. Müşterileriniz bu site üzerinden rezervasyon yapabilir, mevcut randevularını görüntüleyebilir, güncelleyebilir veya iptal edebilirler.</p>",
                    },
                    step3: {
                        title: "Web Sitenizi Görüntüleyin",
                        content:
                            "<p>Oluşturduğunuz rezervasyon web sitesini anında görüntülemek için bu butonu kullanın. <b>Web sitenizin son halini kontrol edebilir</b> ve müşterilerinizin rezervasyonlarını nasıl göreceğini deneyimleyebilirsiniz. Tüm aktif rezervasyonlarınız web sitenizde listelenecektir.</p>",
                    },
                    step4: {
                        title: "Yeni Bir Rezervasyon Oluşturun",
                        content:
                            "<p>Manuel olarak yeni bir <b>rezervasyon oluşturmak</b> için bu butonu kullanın. Gerekli tüm bilgileri doldurarak randevuyu hızla takviminize ekleyebilir ve müşterilerinizle olan görüşmelerinizi planlayabilirsiniz.</p>",
                    },
                },
            },
            websiteAnalysis: {
                title: "Web Site Analizi",
                content: "Ziyaretçi davranışlarını analiz edip içgörü kazanın.",
                steps: {
                    step1: {
                        title: "Toplam Ziyaretçi",
                        content:
                            "<p>Web sitenizi ziyaret eden <b>toplam ziyaretçi sayısını</b> bu alandan görüntüleyin. Bu metrik, belirli bir zaman aralığında sitenize gelen benzersiz ziyaretçilerin genel sayısını gösterir ve sitenizin toplam erişimini anlamanıza yardımcı olur.</p>",
                    },
                    step2: {
                        title: "Ortalama Ziyaretçi",
                        content:
                            "<p>Web sitenizi ziyaret eden <b>ortalama günlük veya belirli dönemdeki ziyaretçi sayısını</b> buradan takip edin. Bu metrik, sitenizin zaman içindeki istikrarlı performansını değerlendirmeniz için kritik bir göstergedir.</p>",
                    },
                    step3: {
                        title: "Maksimum Ziyaretçi",
                        content:
                            "<p>Web sitenizin <b>en yüksek ziyaretçi sayısına ulaştığı zamanları</b> bu metrikle gözlemleyin. Belirli bir zaman aralığında sitenize gelen en yüksek ziyaretçi sayısını göstererek, kampanyaların veya içeriklerin zirve yaptığı dönemleri belirlemenize yardımcı olur.</p>",
                    },
                    step4: {
                        title: "Minimum Ziyaretçi",
                        content:
                            "<p>Web sitenizin <b>en az ziyaretçi aldığı zamanları</b> bu metrikle takip edin. Belirli bir zaman aralığında sitenize gelen en düşük ziyaretçi sayısını göstererek, düşük performans dönemlerini belirlemenize ve gerekli önlemleri almanıza yardımcı olur.</p>",
                    },
                },
            },
            ticketSystem: {
                title: "Destek Talep Sistemi",
                content: "Müşteri taleplerini bilet sistemiyle organize edin.",
                steps: {
                    step1: {
                        title: "Yeni Durum",
                        content:
                            '<p>Destek taleplerinizin yönetimini kolaylaştırmak için <b>yeni durumlar oluşturun</b>. Örneğin, "İşlemde", "Çözüldü", "Beklemede" gibi özelleştirilmiş durumlar tanımlayarak taleplerin akışını daha şeffaf hale getirebilirsiniz.</p>',
                    },
                    step2: {
                        title: "Durumlar",
                        content:
                            '<p>Açılan her bir destek talebi için <b>mevcut durumları buradan görüntüleyin</b>. "Okundu", "Yanıtlandı", "İptal Edildi" gibi durumları takip ederek taleplerin güncel aşamalarını kolayca görebilir ve süreç yönetimini etkinleştirebilirsiniz.</p>',
                    },
                    step3: {
                        title: "Görünüm Modu",
                        content:
                            "<p>Destek taleplerinizi daha etkili bir şekilde yönetmek için <b>liste veya kanban görünümü</b> arasında geçiş yapabilirsiniz. Görünüm modunu değiştirerek taleplerin durumlarını görsel olarak takip edebilir ve iş akışınıza en uygun düzeni seçebilirsiniz.</p>",
                    },
                },
            },
            dynamicTables: {
                title: "Dinamik Tablolar",
                content: "Verilerinizi filtreleyerek özelleştirin ve yönetin.",
                steps: {
                    step1: {
                        title: "Kategori Oluştur",
                        content:
                            "<p>Verilerinizi daha iyi organize etmek ve yönetmek için <b>tablolarınızı kategorilere ayırın</b>. Kategori oluşturma butonu ile yeni kategoriler tanımlayarak tablolarınızı gruplandırabilir ve aradığınız verilere daha hızlı ulaşabilirsiniz.</p>",
                    },
                    step2: {
                        title: "Yeni Tablo Oluştur",
                        content:
                            "<p>İhtiyaçlarınıza özel olarak <b>yeni bir dinamik tablo oluşturmak</b> için bu butonu kullanın. Tablo oluşturma ekranında gerekli bilgileri doldurarak verilerinizi kişiselleştirilmiş bir yapıda saklayabilir ve yönetebilirsiniz.</p>",
                    },
                    step3: {
                        title: "AI ile Tablo Oluştur",
                        content:
                            "<p>Yapay zeka desteğiyle <b>hızla yeni tablolar oluşturmak</b> için bu butonu kullanın. AI ile tablo oluşturmak için ilgili bilgileri girmeniz yeterlidir; sistem size akıllı önerilerle verimli tablolar tasarlamanıza yardımcı olacaktır.</p>",
                    },
                },
            },
            aiVoice: {
                title: "AI Ses Ajanı",
                content: "Ses ajanları ile kullanıcılarınızın konuşmalarını yapay zeka ile yönetin.",
                steps: {
                    step1: {
                        title: "AI Ses Ajanı Entegrasyonu",
                        content:
                            "<p>Müşteri iletişim süreçlerinizi otomatikleştirmek ve iyileştirmek için <b>AI ses ajanınızı Supsis'e entegre edin</b>. Entegrasyon işlemlerini tamamladıktan sonra, sesli etkileşimleri daha verimli bir şekilde yönetebilir ve müşteri memnuniyetini artırabilirsiniz.</p>",
                    },
                },
            },
        },
        sessions: {
            mySessions: "Oturumlarım",
            mySessionsDesc: "Hesabınıza bağlı aktif oturumları buradan görüntüleyebilirsiniz.",
            allSessions: "Tüm Oturumlar",
            sessionManagement: "Oturum Yönetimi",
            allSessionsDesc: "Sistemdeki tüm kullanıcıların aktif oturumlarını görüntüleyin ve yönetin.",
            noActiveSessions: "Aktif oturum bulunamadı",
            currentSession: "Mevcut Oturum",
            lastAccess: "Son Erişim",
            createdAt: "Oluşturulma",
            revoke: "Sonlandır",
            revokeConfirm: "Bu oturumu sonlandırmak istediğinizden emin misiniz?",
            revokeAllConfirm: "Diğer tüm oturumlarınızı sonlandırmak istediğinizden emin misiniz?",
            revokeSuccess: "Oturum başarıyla sonlandırıldı",
            revokeAllSuccess: "Tüm oturumlar başarıyla sonlandırıldı",
            revokeFailed: "Oturum sonlandırılırken bir hata oluştu",
            revokeAllOther: "Diğer Tüm Oturumları Sonlandır",
            unknownLocation: "Bilinmeyen Konum",
            unknownDevice: "Bilinmeyen Cihaz",
            filterByUser: "Kullanıcıya göre filtrele",
            mobile: "Mobil",
            supsisMobileApp: "Supsis Mobil Uygulama",
            httpClient: "HTTP İstemcisi",
            unknown: "Bilinmiyor",
            ios: "iOS",
            android: "Android",
        },
        contactModuleRules: {
            title: "Kişi Modülü Kuralları",
            description: "Müşteri kartı oluşturulduğunda veya chat açıldığında otomatik aksiyonlar tanımlayın",
            active: "Aktif",
            passive: "Pasif",
            when: "Ne Zaman:",
            conditions: "Koşullar:",
            actions: "Aksiyonlar:",
            elseTitle: "Else (Hiçbir Kural Eşleşmezse)",
            noActionsDefined: "Hiçbir aksiyon tanımlanmadı",
            addNewRule: "Yeni Kural Ekle",
            rulesDisabled: "Kişi Modülü Kuralları Pasif",
            enableHint: "Otomatik aksiyonları etkinleştirmek için yukarıdaki anahtarı açın",
            rulesEnabledSuccess: "Kişi modülü kuralları aktif edildi",
            rulesDisabledSuccess: "Kişi modülü kuralları pasif edildi",
            ruleEnabledSuccess: "Kural aktif edildi",
            ruleDisabledSuccess: "Kural pasif edildi",
            ruleUpdateError: "Kural güncellenirken hata oluştu",
            orderUpdatedSuccess: "Kural sıralaması güncellendi",
            orderUpdateError: "Sıralama güncellenirken hata oluştu",
            ruleNameTemplate: "Kural {n}",
            ruleSavedSuccess: "Kural kaydedildi",
            ruleSaveError: "Kural kaydedilirken hata oluştu",
            deleteRuleTitle: "Kuralı Sil",
            deleteRuleConfirm: '"{name}" kuralını silmek istediğinizden emin misiniz?',
            delete: "Sil",
            ruleDeletedSuccess: "Kural silindi",
            ruleDeleteError: "Kural silinirken hata oluştu",
            elseActionsSavedSuccess: "Else aksiyonları kaydedildi",
            actionsSaveError: "Aksiyonlar kaydedilirken hata oluştu",
            whenContactCreated: "Müşteri Kartı Oluştuğunda",
            whenChatOpened: "Chat Açıldığında",
            noCondition: "Koşul yok",
            and: "ve",
            or: "veya",
            AND: "VE",
            OR: "VEYA",
            fieldNotSelected: "Alan seçilmedi",
            noAction: "Aksiyon yok",
            doNothing: "Hiçbir şey yapma",
            assignToOwnerless: "sahipsiz",
            assignOwnerlessAction: "Sahipliği <strong>{ownerless}</strong> yap",
            assignTo: "ata",
            assignToUser: "Sahipliği <strong>{name}</strong>'a ata",
            unknown: "Bilinmeyen",
            leastContact: "En az konuşmalı",
            roundRobin: "Sıralı",
            today: "bugün",
            last7Days: "son 7 gün",
            last30Days: "son 30 gün",
            channelAccessUsers: "kanala erişimi olanlar",
            usersCount: "{n} kullanıcı",
            allUsers: "tüm kullanıcılar",
            random: "Rastgele",
            algorithmic: "Algoritmik",
            addTagNotSelected: "Etiket ekle (seçilmedi)",
            tagsLabel: "etiketlerini",
            tagLabel: "etiketini",
            addDepartmentNotSelected: "Departman ekle (seçilmedi)",
            addDepartmentTo: "departmanını ekle",
            applyToConversation: "(konuşmaya da uygula)",
            updatePropertyNotSelected: "Özellik güncelle (seçilmedi)",
            changeOwner: "Sahiplik Değiştir",
            addTag: "Etiket Ekle",
            addDepartment: "Departman Ekle",
            updateProperty: "Özellik Güncelle",
            yes: "Evet",
            no: "Hayır",
            fields: {
                fullname: "Adı",
                email: "E-postası",
                phone: "Telefonu",
                whatsappNumber: "WhatsApp",
                whatsappCountry: "WhatsApp Ülkesi",
                platform: "Platformu",
                ownerExists: "Sahibi",
                ownerIsOnline: "Sahibi Online",
                ownerStatus: "Sahip Durumu",
                uptime: "Yaşı (dk)",
                tags: "Etiketleri",
                channel: "Kanalı",
                preferredDepartment: "Departmanı",
                hour: "Saat",
                day: "Gün",
                conversationStatus: "Chat Durumu",
                conversationSubject: "Chat Departmanı",
            },
            operators: {
                equals: "eşittir",
                not_equals: "eşit değildir",
                contains: "içerir",
                not_contains: "içermez",
                gt: "büyüktür",
                gte: "≥",
                lt: "küçüktür",
                lte: "≤",
                in: "içerir",
                not_in: "içermez",
                exists: "var",
                not_exists: "yok",
            },
            ruleEditor: {
                editTitle: "Kuralı Düzenle",
                createTitle: "Yeni Kural Oluştur",
                stepWhen: "Ne Zaman?",
                stepConditions: "Koşullar",
                stepActions: "Aksiyonlar",
                whenQuestion: "Kural Ne Zaman Çalışsın?",
                ruleName: "Kural Adı",
                ruleNamePlaceholder: "Kural için bir isim girin",
                contactCreatedTitle: "Müşteri Kartı Oluştuğunda",
                contactCreatedDesc: "Yeni bir müşteri kaydı oluşturulduğunda çalışır",
                chatOpenedTitle: "Chat Açıldığında",
                chatOpenedDesc: "Müşteri yeni bir konuşma başlattığında çalışır",
                conditionsQuestion: "Hangi Koşullar Sağlanmalı?",
                actionsQuestion: "Hangi Aksiyonlar Çalışsın?",
                back: "Geri",
                cancel: "İptal",
                next: "İleri",
                save: "Kaydet",
                newRule: "Yeni Kural",
            },
            elseEditor: {
                title: "Else Aksiyonları Düzenle",
                description: "Hiçbir kural eşleşmediğinde çalışacak varsayılan aksiyonları tanımlayın",
            },
            ruleTester: {
                title: "Kural Test Et",
                description: "Kuralınızın kaç kişi ile eşleşeceğini test edebilirsiniz",
                selectRule: "Kural Seçin",
                selectRulePlaceholder: "Test edilecek kuralı seçin",
                test: "Test Et",
                ruleInfo: "Kural Bilgileri",
                conditionCount: "Koşul Sayısı:",
                actionCount: "Aksiyon Sayısı:",
                ruleNotFound: "Kural bulunamadı",
                testComingSoon: "Test özelliği yakında eklenecek. Şu an sadece kural bilgilerini görebilirsiniz.",
                testError: "Test sırasında hata oluştu",
            },
            filterBuilder: {
                noConditions: "Henüz koşul eklenmedi",
                addFirstCondition: "İlk Koşulu Ekle",
                groupTitle: "Grup {n}",
                deleteGroup: "Grubu Sil",
                if: "Eğer",
                selectField: "alan seçin",
                operator: "operatör",
                select: "seçin",
                selectValue: "değer seçin",
                enterValue: "değer girin",
                addCondition: "Koşul ekle",
                addFilterGroup: "Filtre Grubu Ekle",
                andOption: "ve",
                orOption: "veya",
                fieldLabels: {
                    fullname: "Kişinin Adı",
                    email: "Kişinin E-postası",
                    phone: "Kişinin Telefonu",
                    whatsappNumber: "Kişinin WhatsApp Numarası",
                    whatsappCountry: "Kişinin WhatsApp Ülkesi",
                    platform: "Kişinin Platformu",
                    ownerExists: "Kişinin Sahibi Var mı",
                    ownerIsOnline: "Kişinin Sahibi Online mı",
                    ownerStatus: "Kişinin Sahibi Durumu",
                    uptime: "Kişinin Yaşı (dakika)",
                    tags: "Kişinin Etiketleri",
                    channel: "Kişinin Kanalı",
                    preferredDepartment: "Kişinin Tercih Ettiği Departman",
                    hour: "Şu An Saat",
                    day: "Şu An Gün",
                    conversationStatus: "Konuşmanın Durumu",
                    conversationSubject: "Konuşmanın Departmanı",
                },
                operators: {
                    equals: "eşittir",
                    not_equals: "eşit değildir",
                    contains: "içerir",
                    not_contains: "içermez",
                    gt: "büyüktür",
                    gte: "büyük veya eşittir",
                    lt: "küçüktür",
                    lte: "küçük veya eşittir",
                    between: "arasında",
                    exists: "var",
                    not_exists: "yok",
                    in: "içerir",
                    not_in: "içermez",
                },
            },
            actionsEditor: {
                noActions: "Henüz aksiyon eklenmedi",
                addFirstAction: "İlk Aksiyonu Ekle",
                actionNumber: "Aksiyon {n}",
                actionType: "Aksiyon Tipi",
                addAction: "Aksiyon Ekle",
            },
            changeOwnerConfig: {
                method: "Atama Yöntemi",
                static: "Sabit",
                algorithmic: "Algoritmik",
                random: "Rastgele",
                userSelect: "Kullanıcı Seçimi",
                assignOwnerless: "Sahipsiz olarak ata",
                selectUser: "Kullanıcı seçin",
                userList: "Kullanıcı Listesi",
                channelAccessUsers: "Kanala erişimi olan tüm kullanıcılar",
                selectUsers: "Kullanıcılar seçin",
                algorithm: "Algoritma",
                leastContact: "En Az Konuşmalı",
                roundRobin: "Sıralı Dağıtım",
                dateRange: "Tarih Aralığı",
                today: "Bugün",
                last7Days: "Son 7 Gün",
                last30Days: "Son 30 Gün",
                onlyOnline: "Sadece online kullanıcıları dahil et",
            },
            addTagConfig: {
                tagsToAdd: "Eklenecek Etiketler",
                selectTag: "Etiket seçin",
                selectedTagsHint: "Seçilen etiketler kişiye eklenecektir",
            },
            addDepartmentConfig: {
                departmentSelect: "Departman Seçimi",
                selectDepartment: "Departman seçin",
                departmentHint: "Seçilen departman kişinin ilgili departmanlar listesine eklenecektir",
                applyToConversation: "Konuşmaya da uygula",
                applyToConversationHint:
                    "Aktif edilirse, açılan konuşmanın departmanı da bu departman olarak ayarlanır",
            },
            upsertContactPropertyConfig: {
                propertySelect: "Özellik Seçimi",
                selectProperty: "Özellik seçin",
                propertyHint: "Güncellenecek veya oluşturulacak özellik",
                value: "Değer",
                valuePlaceholder: "Özellik değerini girin",
                valueHint: "Bu değer özelliğe atanacaktır",
            },
        },
        taskModuleRules: {
            title: "Görev Modülü Kuralları",
            description:
                "Görev oluşturulduğunda, güncellendiğinde veya yorum eklendiğinde otomatik aksiyonlar tanımlayın",
            settingsTitle: "Görev Modülü Kuralları",
            settingsDescription: "Her workflow için otomatik görev kuralları tanımlayın",
            selectWorkflow: "Workflow Seçin",
            selectWorkflowPlaceholder: "Workflow seçin",
            selectWorkflowHint: "Görev modülü kurallarını düzenlemek için bir workflow seçin",
            active: "Aktif",
            passive: "Pasif",
            when: "Ne Zaman:",
            conditions: "Koşullar:",
            actions: "Aksiyonlar:",
            elseTitle: "Else (Hiçbir Kural Eşleşmezse)",
            noActionsDefined: "Hiçbir aksiyon tanımlanmadı",
            addNewRule: "Yeni Kural Ekle",
            rulesDisabled: "Görev Modülü Kuralları Pasif",
            enableHint: "Otomatik aksiyonları etkinleştirmek için yukarıdaki anahtarı açın",
            rulesEnabledSuccess: "Görev modülü kuralları aktif edildi",
            rulesDisabledSuccess: "Görev modülü kuralları pasif edildi",
            ruleEnabledSuccess: "Kural aktif edildi",
            ruleDisabledSuccess: "Kural pasif edildi",
            ruleUpdateError: "İşlem sırasında hata oluştu",
            orderUpdatedSuccess: "Kural sıralaması güncellendi",
            orderUpdateError: "Sıralama güncellenirken hata oluştu",
            ruleNameTemplate: "Kural {n}",
            ruleSavedSuccess: "Kural kaydedildi",
            ruleSaveError: "Kural kaydedilirken hata oluştu",
            deleteRuleTitle: "Kuralı Sil",
            deleteRuleConfirm: '"{name}" kuralını silmek istediğinizden emin misiniz?',
            delete: "Sil",
            ruleDeletedSuccess: "Kural silindi",
            ruleDeleteError: "Kural silinirken hata oluştu",
            elseActionsSavedSuccess: "Else aksiyonları kaydedildi",
            actionsSaveError: "Aksiyonlar kaydedilirken hata oluştu",
            noCondition: "Koşul yok",
            and: "ve",
            or: "veya",
            AND: "VE",
            OR: "VEYA",
            fieldNotSelected: "Alan seçilmedi",
            noAction: "Aksiyon yok",
            chainBadge: "Zincirleme",
            chainBadgeTooltip: "Bu kural diğer kuralları tetikleyebilir",
            automationOffBadge: "Otomasyon Kapalı",
            automationOffTooltip: "Supsis Otomasyonlarına bildirilmiyor",
            yes: "Evet",
            no: "Hayır",
            unknown: "Bilinmeyen",
            cancel: "İptal",
        },
        profile: {
            subtitle: "Hesap ayarlarınızı ve oturumlarınızı yönetin",
        },
        integrations: {
            requiredField: "Bu alan zorunludur",
            existingChannels: "Mevcut Kanallar",
            createNewChannel: "Yeni Kanal Oluştur",
            channelName: "Kanal Adı",
            createChannel: "Kanal Oluştur",
            channelCreated: "Kanal başarıyla oluşturuldu",
            channelCreateError: "Kanal oluşturulurken bir hata oluştu",
            channelActivated: "Kanal aktifleştirildi",
            channelDeactivated: "Kanal devre dışı bırakıldı",
            channelUpdateError: "Kanal güncellenirken bir hata oluştu",
            deleteChannelConfirm: "Kanalı Sil",
            deleteChannelConfirmContent: "{name} kanalını silmek istediğinize emin misiniz?",
            channelDeleted: "Kanal başarıyla silindi",
            channelDeleteError: "Kanal silinirken bir hata oluştu",
            slackIntegration: "Slack Entegrasyonu",
            slackDescription: "Slack workspace'inize Supsis otomasyon ve chatbot üzerinden mesaj gönderin.",
            slackSetupTitle: "Kurulum Adımları:",
            slackStep1: "api.slack.com/apps adresine gidin",
            slackStep2: "Mevcut Slack App'inizi seçin veya yeni bir app oluşturun",
            slackStep3: "Sol menüden 'Incoming Webhooks' seçeneğine tıklayın ve 'On' yapın",
            slackStep4: "'Add New Webhook to Workspace' butonuna tıklayarak mesaj göndermek istediğiniz kanalı seçin",
            slackCardDescription: "Slack kanallarınıza otomasyon ve chatbot üzerinden mesaj gönderin",
            slackChannelNamePlaceholder: "Örn: Destek Bildirimleri",
            slackWebhookUrl: "Webhook URL",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper:
                "Slack App > Incoming Webhooks > Add New Webhook to Workspace adımlarını izleyerek alabilirsiniz",
            slackWebhookUrlInvalid: "Geçerli bir Slack webhook URL'i giriniz",
            slackDefaultChannel: "Varsayılan Kanal (Opsiyonel)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "Belirtilmezse webhook'un bağlı olduğu kanal kullanılır",
            pushoverIntegration: "Pushover Entegrasyonu",
            pushoverCardDescription: "Mobil cihazlarınıza otomasyon ve chatbot üzerinden push bildirim gönderin",
            pushoverDescription:
                "Mobil cihazlarınıza Supsis otomasyon ve chatbot üzerinden push bildirim gönderin. pushover.net adresinden hesap oluşturup User Key ve Application Token alabilirsiniz.",
            pushoverChannelNamePlaceholder: "Örn: Mobil Bildirimler",
            pushoverUserKey: "User Key",
            pushoverUserKeyPlaceholder: "Pushover User Key",
            pushoverUserKeyHelper: "pushover.net hesap sayfanızdan alabilirsiniz",
            pushoverAppToken: "App Token",
            pushoverAppTokenPlaceholder: "Pushover Application Token",
            pushoverAppTokenHelper: "pushover.net üzerinden uygulama oluşturup token alabilirsiniz",
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!",
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!",
        },
        "Would you like to make default this story?": "#VALUE!",
        addWebhook: "Webhook Ekle",
        allIntegrations: "Tüm Entegrasyonlar",
        editWebhook: "Webhook'u Düzenle",
        integrateYourCBwithChatGpt3: "Chatbot, GPT-4 ile entegre edilebilir. GPT-4 API anahtarı gereklidir.",
        integrateYourCBwithChatWidget: "Chatbotunuzu sohbet widget'ı ile entegre edin.",
        integrateYourCBwithIntegratable: "Sohbet bilgilerini ChatBot ile {integratable} arasında kolayca aktarın.",
        integrateYourCBwithWebHook: "Sohbet bilgilerini ChatBot ile web servisleriniz arasında kolayca aktarın.",
        newWebhook: "Yeni Webhook",
        shouldAddMethod:
            "Ödeme yöntemi ve fatura adresi alanını doldurmanız gerekmektedir!\nHesabınızdan herhangi bir ücret çekilmeyecektir.\nAy sonunda kullanım tutarınıza göre bir fatura oluşturulacaktır.",
        webhookPassword: "Webhook Şifresi",
        webhookTitle: "Webhook Başlığı",
        webhookToken: "Webhook Tokeni",
        webhookUrl: "Webhook URL Adresi",
        webhookUsername: "Webhook Kullanıcı Adı",
        "{contentOfChatBubble}": "#VALUE!",
        task_reports: {
            title: "Görev Raporları",
            date: "Tarih",
            workflow: "İş Akışı",
            select: "Seçin",
            agent: "Temsilci",
            all: "Tümü",
            select_workflow_to_view_reports: "Raporları görüntülemek için bir iş akışı seçin.",
            created_task: "Oluşturulan Görev",
            updated_task: "Güncellenen Görev",
            assigned_tasks_by_personnel: "Personel Bazında Atanan Görevler",
            assigned_task: "Atanan Görev",
            no_assigned_task_found_in_date_range: "Seçilen tarih aralığında atanan görev bulunamadı.",
            updated_tasks: "Güncellenen Görevler",
            task: "Görev",
            current_stage: "Mevcut Aşama",
            assigned: "Atanan",
            update: "Güncelleme",
            no_updated_task_found_in_date_range: "Seçilen tarih aralığında güncellenen görev bulunamadı.",
            task_distribution_by_agent: "Temsilci Bazında Görev Dağılımı",
            total: "Toplam",
            no_assigned_task_found: "Atanmış görev bulunamadı.",
            timeline: "Zaman Çizelgesi",
            unassigned_tasks: "Atanmamış Görevler",
            transition_process: "Geçiş Süreci",
            no_active_task_found_for_agent: "Bu temsilci için aktif görev bulunamadı.",
            select_agent_to_view_timeline: "Zaman çizelgesini görüntülemek için bir temsilci seçin.",
            entry: "Giriş",
            exit: "Çıkış",
            still_in_this_stage: "Hala bu aşamada",
            duration: "Süre",
            day: "gün",
            hour: "saat",
            max_30_days_range_warning: "En fazla 30 günlük tarih aralığı seçebilirsiniz.",
            today: "Bugün",
            this_week: "Bu Hafta",
            this_month: "Bu Ay",
            last_month: "Geçen Ay",
            unknown: "Bilinmiyor",
            unassigned: "Atanmamış",
            gantt: "Gantt",
            table: "Tablo",
        },
    },
};

export default messagesTR;
